(function webpackUniversalModuleDefinition(root, factory) {
  if(typeof exports === 'object' && typeof module === 'object')
    module.exports = factory(require("vue"));
  else if(typeof define === 'function' && define.amd)
    define([], factory);
  else if(typeof exports === 'object')
    exports["RirLib"] = factory(require("vue"));
  else
    root["RirLib"] = factory(root["Vue"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__7203__) {
  return /******/ (function() { // webpackBootstrap
    /******/ 	var __webpack_modules__ = ({

      /***/ 9662:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var isCallable = __webpack_require__(614);
        var tryToString = __webpack_require__(6330);

        var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
        module.exports = function (argument) {
          if (isCallable(argument)) return argument;
          throw $TypeError(tryToString(argument) + ' is not a function');
        };


        /***/ }),

      /***/ 6077:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var isCallable = __webpack_require__(614);

        var $String = String;
        var $TypeError = TypeError;

        module.exports = function (argument) {
          if (typeof argument == 'object' || isCallable(argument)) return argument;
          throw $TypeError("Can't set " + $String(argument) + ' as a prototype');
        };


        /***/ }),

      /***/ 5787:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var isPrototypeOf = __webpack_require__(7976);

        var $TypeError = TypeError;

        module.exports = function (it, Prototype) {
          if (isPrototypeOf(Prototype, it)) return it;
          throw $TypeError('Incorrect invocation');
        };


        /***/ }),

      /***/ 9670:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var isObject = __webpack_require__(111);

        var $String = String;
        var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
        module.exports = function (argument) {
          if (isObject(argument)) return argument;
          throw $TypeError($String(argument) + ' is not an object');
        };


        /***/ }),

      /***/ 1318:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var toIndexedObject = __webpack_require__(5656);
        var toAbsoluteIndex = __webpack_require__(1400);
        var lengthOfArrayLike = __webpack_require__(6244);

// `Array.prototype.{ indexOf, includes }` methods implementation
        var createMethod = function (IS_INCLUDES) {
          return function ($this, el, fromIndex) {
            var O = toIndexedObject($this);
            var length = lengthOfArrayLike(O);
            var index = toAbsoluteIndex(fromIndex, length);
            var value;
            // Array#includes uses SameValueZero equality algorithm
            // eslint-disable-next-line no-self-compare -- NaN check
            if (IS_INCLUDES && el != el) while (length > index) {
              value = O[index++];
              // eslint-disable-next-line no-self-compare -- NaN check
              if (value != value) return true;
              // Array#indexOf ignores holes, Array#includes - not
            } else for (;length > index; index++) {
              if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
            } return !IS_INCLUDES && -1;
          };
        };

        module.exports = {
          // `Array.prototype.includes` method
          // https://tc39.es/ecma262/#sec-array.prototype.includes
          includes: createMethod(true),
          // `Array.prototype.indexOf` method
          // https://tc39.es/ecma262/#sec-array.prototype.indexof
          indexOf: createMethod(false)
        };


        /***/ }),

      /***/ 3658:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        "use strict";

        var DESCRIPTORS = __webpack_require__(9781);
        var isArray = __webpack_require__(3157);

        var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
        var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS && !function () {
          // makes no sense without proper strict mode support
          if (this !== undefined) return true;
          try {
            // eslint-disable-next-line es/no-object-defineproperty -- safe
            Object.defineProperty([], 'length', { writable: false }).length = 1;
          } catch (error) {
            return error instanceof TypeError;
          }
        }();

        module.exports = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
          if (isArray(O) && !getOwnPropertyDescriptor(O, 'length').writable) {
            throw $TypeError('Cannot set read only .length');
          } return O.length = length;
        } : function (O, length) {
          return O.length = length;
        };


        /***/ }),

      /***/ 4326:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var uncurryThis = __webpack_require__(1702);

        var toString = uncurryThis({}.toString);
        var stringSlice = uncurryThis(''.slice);

        module.exports = function (it) {
          return stringSlice(toString(it), 8, -1);
        };


        /***/ }),

      /***/ 648:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var TO_STRING_TAG_SUPPORT = __webpack_require__(1694);
        var isCallable = __webpack_require__(614);
        var classofRaw = __webpack_require__(4326);
        var wellKnownSymbol = __webpack_require__(5112);

        var TO_STRING_TAG = wellKnownSymbol('toStringTag');
        var $Object = Object;

// ES3 wrong here
        var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
        var tryGet = function (it, key) {
          try {
            return it[key];
          } catch (error) { /* empty */ }
        };

// getting tag from ES6+ `Object.prototype.toString`
        module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
          var O, tag, result;
          return it === undefined ? 'Undefined' : it === null ? 'Null'
            // @@toStringTag case
            : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
              // builtinTag case
              : CORRECT_ARGUMENTS ? classofRaw(O)
                // ES3 arguments fallback
                : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
        };


        /***/ }),

      /***/ 9920:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var hasOwn = __webpack_require__(2597);
        var ownKeys = __webpack_require__(3887);
        var getOwnPropertyDescriptorModule = __webpack_require__(1236);
        var definePropertyModule = __webpack_require__(3070);

        module.exports = function (target, source, exceptions) {
          var keys = ownKeys(source);
          var defineProperty = definePropertyModule.f;
          var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
          for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
              defineProperty(target, key, getOwnPropertyDescriptor(source, key));
            }
          }
        };


        /***/ }),

      /***/ 8880:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var DESCRIPTORS = __webpack_require__(9781);
        var definePropertyModule = __webpack_require__(3070);
        var createPropertyDescriptor = __webpack_require__(9114);

        module.exports = DESCRIPTORS ? function (object, key, value) {
          return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
        } : function (object, key, value) {
          object[key] = value;
          return object;
        };


        /***/ }),

      /***/ 9114:
      /***/ (function(module) {

        module.exports = function (bitmap, value) {
          return {
            enumerable: !(bitmap & 1),
            configurable: !(bitmap & 2),
            writable: !(bitmap & 4),
            value: value
          };
        };


        /***/ }),

      /***/ 8052:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var isCallable = __webpack_require__(614);
        var definePropertyModule = __webpack_require__(3070);
        var makeBuiltIn = __webpack_require__(6339);
        var defineGlobalProperty = __webpack_require__(3072);

        module.exports = function (O, key, value, options) {
          if (!options) options = {};
          var simple = options.enumerable;
          var name = options.name !== undefined ? options.name : key;
          if (isCallable(value)) makeBuiltIn(value, name, options);
          if (options.global) {
            if (simple) O[key] = value;
            else defineGlobalProperty(key, value);
          } else {
            try {
              if (!options.unsafe) delete O[key];
              else if (O[key]) simple = true;
            } catch (error) { /* empty */ }
            if (simple) O[key] = value;
            else definePropertyModule.f(O, key, {
              value: value,
              enumerable: false,
              configurable: !options.nonConfigurable,
              writable: !options.nonWritable
            });
          } return O;
        };


        /***/ }),

      /***/ 3072:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var global = __webpack_require__(7854);

// eslint-disable-next-line es/no-object-defineproperty -- safe
        var defineProperty = Object.defineProperty;

        module.exports = function (key, value) {
          try {
            defineProperty(global, key, { value: value, configurable: true, writable: true });
          } catch (error) {
            global[key] = value;
          } return value;
        };


        /***/ }),

      /***/ 5117:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        "use strict";

        var tryToString = __webpack_require__(6330);

        var $TypeError = TypeError;

        module.exports = function (O, P) {
          if (!delete O[P]) throw $TypeError('Cannot delete property ' + tryToString(P) + ' of ' + tryToString(O));
        };


        /***/ }),

      /***/ 9781:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var fails = __webpack_require__(7293);

// Detect IE8's incomplete defineProperty implementation
        module.exports = !fails(function () {
          // eslint-disable-next-line es/no-object-defineproperty -- required for testing
          return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
        });


        /***/ }),

      /***/ 4154:
      /***/ (function(module) {

        var documentAll = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
        var IS_HTMLDDA = typeof documentAll == 'undefined' && documentAll !== undefined;

        module.exports = {
          all: documentAll,
          IS_HTMLDDA: IS_HTMLDDA
        };


        /***/ }),

      /***/ 317:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var global = __webpack_require__(7854);
        var isObject = __webpack_require__(111);

        var document = global.document;
// typeof document.createElement is 'object' in old IE
        var EXISTS = isObject(document) && isObject(document.createElement);

        module.exports = function (it) {
          return EXISTS ? document.createElement(it) : {};
        };


        /***/ }),

      /***/ 7207:
      /***/ (function(module) {

        var $TypeError = TypeError;
        var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

        module.exports = function (it) {
          if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
          return it;
        };


        /***/ }),

      /***/ 3678:
      /***/ (function(module) {

        module.exports = {
          IndexSizeError: { s: 'INDEX_SIZE_ERR', c: 1, m: 1 },
          DOMStringSizeError: { s: 'DOMSTRING_SIZE_ERR', c: 2, m: 0 },
          HierarchyRequestError: { s: 'HIERARCHY_REQUEST_ERR', c: 3, m: 1 },
          WrongDocumentError: { s: 'WRONG_DOCUMENT_ERR', c: 4, m: 1 },
          InvalidCharacterError: { s: 'INVALID_CHARACTER_ERR', c: 5, m: 1 },
          NoDataAllowedError: { s: 'NO_DATA_ALLOWED_ERR', c: 6, m: 0 },
          NoModificationAllowedError: { s: 'NO_MODIFICATION_ALLOWED_ERR', c: 7, m: 1 },
          NotFoundError: { s: 'NOT_FOUND_ERR', c: 8, m: 1 },
          NotSupportedError: { s: 'NOT_SUPPORTED_ERR', c: 9, m: 1 },
          InUseAttributeError: { s: 'INUSE_ATTRIBUTE_ERR', c: 10, m: 1 },
          InvalidStateError: { s: 'INVALID_STATE_ERR', c: 11, m: 1 },
          SyntaxError: { s: 'SYNTAX_ERR', c: 12, m: 1 },
          InvalidModificationError: { s: 'INVALID_MODIFICATION_ERR', c: 13, m: 1 },
          NamespaceError: { s: 'NAMESPACE_ERR', c: 14, m: 1 },
          InvalidAccessError: { s: 'INVALID_ACCESS_ERR', c: 15, m: 1 },
          ValidationError: { s: 'VALIDATION_ERR', c: 16, m: 0 },
          TypeMismatchError: { s: 'TYPE_MISMATCH_ERR', c: 17, m: 1 },
          SecurityError: { s: 'SECURITY_ERR', c: 18, m: 1 },
          NetworkError: { s: 'NETWORK_ERR', c: 19, m: 1 },
          AbortError: { s: 'ABORT_ERR', c: 20, m: 1 },
          URLMismatchError: { s: 'URL_MISMATCH_ERR', c: 21, m: 1 },
          QuotaExceededError: { s: 'QUOTA_EXCEEDED_ERR', c: 22, m: 1 },
          TimeoutError: { s: 'TIMEOUT_ERR', c: 23, m: 1 },
          InvalidNodeTypeError: { s: 'INVALID_NODE_TYPE_ERR', c: 24, m: 1 },
          DataCloneError: { s: 'DATA_CLONE_ERR', c: 25, m: 1 }
        };


        /***/ }),

      /***/ 8113:
      /***/ (function(module) {

        module.exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';


        /***/ }),

      /***/ 7392:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var global = __webpack_require__(7854);
        var userAgent = __webpack_require__(8113);

        var process = global.process;
        var Deno = global.Deno;
        var versions = process && process.versions || Deno && Deno.version;
        var v8 = versions && versions.v8;
        var match, version;

        if (v8) {
          match = v8.split('.');
          // in old Chrome, versions of V8 isn't V8 = Chrome / 10
          // but their correct versions are not interesting for us
          version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
        }

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
        if (!version && userAgent) {
          match = userAgent.match(/Edge\/(\d+)/);
          if (!match || match[1] >= 74) {
            match = userAgent.match(/Chrome\/(\d+)/);
            if (match) version = +match[1];
          }
        }

        module.exports = version;


        /***/ }),

      /***/ 748:
      /***/ (function(module) {

// IE8- don't enum bug keys
        module.exports = [
          'constructor',
          'hasOwnProperty',
          'isPrototypeOf',
          'propertyIsEnumerable',
          'toLocaleString',
          'toString',
          'valueOf'
        ];


        /***/ }),

      /***/ 1060:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var uncurryThis = __webpack_require__(1702);

        var $Error = Error;
        var replace = uncurryThis(''.replace);

        var TEST = (function (arg) { return String($Error(arg).stack); })('zxcasd');
// eslint-disable-next-line redos/no-vulnerable -- safe
        var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
        var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);

        module.exports = function (stack, dropEntries) {
          if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error.prepareStackTrace) {
            while (dropEntries--) stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
          } return stack;
        };


        /***/ }),

      /***/ 2109:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var global = __webpack_require__(7854);
        var getOwnPropertyDescriptor = (__webpack_require__(1236).f);
        var createNonEnumerableProperty = __webpack_require__(8880);
        var defineBuiltIn = __webpack_require__(8052);
        var defineGlobalProperty = __webpack_require__(3072);
        var copyConstructorProperties = __webpack_require__(9920);
        var isForced = __webpack_require__(4705);

        /*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
        module.exports = function (options, source) {
          var TARGET = options.target;
          var GLOBAL = options.global;
          var STATIC = options.stat;
          var FORCED, target, key, targetProperty, sourceProperty, descriptor;
          if (GLOBAL) {
            target = global;
          } else if (STATIC) {
            target = global[TARGET] || defineGlobalProperty(TARGET, {});
          } else {
            target = (global[TARGET] || {}).prototype;
          }
          if (target) for (key in source) {
            sourceProperty = source[key];
            if (options.dontCallGetSet) {
              descriptor = getOwnPropertyDescriptor(target, key);
              targetProperty = descriptor && descriptor.value;
            } else targetProperty = target[key];
            FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
            // contained in target
            if (!FORCED && targetProperty !== undefined) {
              if (typeof sourceProperty == typeof targetProperty) continue;
              copyConstructorProperties(sourceProperty, targetProperty);
            }
            // add a flag to not completely full polyfills
            if (options.sham || (targetProperty && targetProperty.sham)) {
              createNonEnumerableProperty(sourceProperty, 'sham', true);
            }
            defineBuiltIn(target, key, sourceProperty, options);
          }
        };


        /***/ }),

      /***/ 7293:
      /***/ (function(module) {

        module.exports = function (exec) {
          try {
            return !!exec();
          } catch (error) {
            return true;
          }
        };


        /***/ }),

      /***/ 4374:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var fails = __webpack_require__(7293);

        module.exports = !fails(function () {
          // eslint-disable-next-line es/no-function-prototype-bind -- safe
          var test = (function () { /* empty */ }).bind();
          // eslint-disable-next-line no-prototype-builtins -- safe
          return typeof test != 'function' || test.hasOwnProperty('prototype');
        });


        /***/ }),

      /***/ 6916:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var NATIVE_BIND = __webpack_require__(4374);

        var call = Function.prototype.call;

        module.exports = NATIVE_BIND ? call.bind(call) : function () {
          return call.apply(call, arguments);
        };


        /***/ }),

      /***/ 6530:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var DESCRIPTORS = __webpack_require__(9781);
        var hasOwn = __webpack_require__(2597);

        var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

        var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
        var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
        var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

        module.exports = {
          EXISTS: EXISTS,
          PROPER: PROPER,
          CONFIGURABLE: CONFIGURABLE
        };


        /***/ }),

      /***/ 5668:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var uncurryThis = __webpack_require__(1702);
        var aCallable = __webpack_require__(9662);

        module.exports = function (object, key, method) {
          try {
            // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
            return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
          } catch (error) { /* empty */ }
        };


        /***/ }),

      /***/ 1702:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var NATIVE_BIND = __webpack_require__(4374);

        var FunctionPrototype = Function.prototype;
        var call = FunctionPrototype.call;
        var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

        module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
          return function () {
            return call.apply(fn, arguments);
          };
        };


        /***/ }),

      /***/ 5005:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var global = __webpack_require__(7854);
        var isCallable = __webpack_require__(614);

        var aFunction = function (argument) {
          return isCallable(argument) ? argument : undefined;
        };

        module.exports = function (namespace, method) {
          return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
        };


        /***/ }),

      /***/ 8173:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var aCallable = __webpack_require__(9662);
        var isNullOrUndefined = __webpack_require__(8554);

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
        module.exports = function (V, P) {
          var func = V[P];
          return isNullOrUndefined(func) ? undefined : aCallable(func);
        };


        /***/ }),

      /***/ 7854:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var check = function (it) {
          return it && it.Math == Math && it;
        };

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
        module.exports =
          // eslint-disable-next-line es/no-global-this -- safe
          check(typeof globalThis == 'object' && globalThis) ||
          check(typeof window == 'object' && window) ||
          // eslint-disable-next-line no-restricted-globals -- safe
          check(typeof self == 'object' && self) ||
          check(typeof __webpack_require__.g == 'object' && __webpack_require__.g) ||
          // eslint-disable-next-line no-new-func -- fallback
          (function () { return this; })() || Function('return this')();


        /***/ }),

      /***/ 2597:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var uncurryThis = __webpack_require__(1702);
        var toObject = __webpack_require__(7908);

        var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
        module.exports = Object.hasOwn || function hasOwn(it, key) {
          return hasOwnProperty(toObject(it), key);
        };


        /***/ }),

      /***/ 3501:
      /***/ (function(module) {

        module.exports = {};


        /***/ }),

      /***/ 4664:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var DESCRIPTORS = __webpack_require__(9781);
        var fails = __webpack_require__(7293);
        var createElement = __webpack_require__(317);

// Thanks to IE8 for its funny defineProperty
        module.exports = !DESCRIPTORS && !fails(function () {
          // eslint-disable-next-line es/no-object-defineproperty -- required for testing
          return Object.defineProperty(createElement('div'), 'a', {
            get: function () { return 7; }
          }).a != 7;
        });


        /***/ }),

      /***/ 8361:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var uncurryThis = __webpack_require__(1702);
        var fails = __webpack_require__(7293);
        var classof = __webpack_require__(4326);

        var $Object = Object;
        var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
        module.exports = fails(function () {
          // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
          // eslint-disable-next-line no-prototype-builtins -- safe
          return !$Object('z').propertyIsEnumerable(0);
        }) ? function (it) {
          return classof(it) == 'String' ? split(it, '') : $Object(it);
        } : $Object;


        /***/ }),

      /***/ 9587:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var isCallable = __webpack_require__(614);
        var isObject = __webpack_require__(111);
        var setPrototypeOf = __webpack_require__(7674);

// makes subclassing work correct for wrapped built-ins
        module.exports = function ($this, dummy, Wrapper) {
          var NewTarget, NewTargetPrototype;
          if (
            // it can work only with native `setPrototypeOf`
            setPrototypeOf &&
            // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
            isCallable(NewTarget = dummy.constructor) &&
            NewTarget !== Wrapper &&
            isObject(NewTargetPrototype = NewTarget.prototype) &&
            NewTargetPrototype !== Wrapper.prototype
          ) setPrototypeOf($this, NewTargetPrototype);
          return $this;
        };


        /***/ }),

      /***/ 2788:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var uncurryThis = __webpack_require__(1702);
        var isCallable = __webpack_require__(614);
        var store = __webpack_require__(5465);

        var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
        if (!isCallable(store.inspectSource)) {
          store.inspectSource = function (it) {
            return functionToString(it);
          };
        }

        module.exports = store.inspectSource;


        /***/ }),

      /***/ 9909:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var NATIVE_WEAK_MAP = __webpack_require__(4811);
        var global = __webpack_require__(7854);
        var isObject = __webpack_require__(111);
        var createNonEnumerableProperty = __webpack_require__(8880);
        var hasOwn = __webpack_require__(2597);
        var shared = __webpack_require__(5465);
        var sharedKey = __webpack_require__(6200);
        var hiddenKeys = __webpack_require__(3501);

        var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
        var TypeError = global.TypeError;
        var WeakMap = global.WeakMap;
        var set, get, has;

        var enforce = function (it) {
          return has(it) ? get(it) : set(it, {});
        };

        var getterFor = function (TYPE) {
          return function (it) {
            var state;
            if (!isObject(it) || (state = get(it)).type !== TYPE) {
              throw TypeError('Incompatible receiver, ' + TYPE + ' required');
            } return state;
          };
        };

        if (NATIVE_WEAK_MAP || shared.state) {
          var store = shared.state || (shared.state = new WeakMap());
          /* eslint-disable no-self-assign -- prototype methods protection */
          store.get = store.get;
          store.has = store.has;
          store.set = store.set;
          /* eslint-enable no-self-assign -- prototype methods protection */
          set = function (it, metadata) {
            if (store.has(it)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
            metadata.facade = it;
            store.set(it, metadata);
            return metadata;
          };
          get = function (it) {
            return store.get(it) || {};
          };
          has = function (it) {
            return store.has(it);
          };
        } else {
          var STATE = sharedKey('state');
          hiddenKeys[STATE] = true;
          set = function (it, metadata) {
            if (hasOwn(it, STATE)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
            metadata.facade = it;
            createNonEnumerableProperty(it, STATE, metadata);
            return metadata;
          };
          get = function (it) {
            return hasOwn(it, STATE) ? it[STATE] : {};
          };
          has = function (it) {
            return hasOwn(it, STATE);
          };
        }

        module.exports = {
          set: set,
          get: get,
          has: has,
          enforce: enforce,
          getterFor: getterFor
        };


        /***/ }),

      /***/ 3157:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var classof = __webpack_require__(4326);

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
        module.exports = Array.isArray || function isArray(argument) {
          return classof(argument) == 'Array';
        };


        /***/ }),

      /***/ 614:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var $documentAll = __webpack_require__(4154);

        var documentAll = $documentAll.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
        module.exports = $documentAll.IS_HTMLDDA ? function (argument) {
          return typeof argument == 'function' || argument === documentAll;
        } : function (argument) {
          return typeof argument == 'function';
        };


        /***/ }),

      /***/ 4705:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var fails = __webpack_require__(7293);
        var isCallable = __webpack_require__(614);

        var replacement = /#|\.prototype\./;

        var isForced = function (feature, detection) {
          var value = data[normalize(feature)];
          return value == POLYFILL ? true
            : value == NATIVE ? false
              : isCallable(detection) ? fails(detection)
                : !!detection;
        };

        var normalize = isForced.normalize = function (string) {
          return String(string).replace(replacement, '.').toLowerCase();
        };

        var data = isForced.data = {};
        var NATIVE = isForced.NATIVE = 'N';
        var POLYFILL = isForced.POLYFILL = 'P';

        module.exports = isForced;


        /***/ }),

      /***/ 8554:
      /***/ (function(module) {

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
        module.exports = function (it) {
          return it === null || it === undefined;
        };


        /***/ }),

      /***/ 111:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var isCallable = __webpack_require__(614);
        var $documentAll = __webpack_require__(4154);

        var documentAll = $documentAll.all;

        module.exports = $documentAll.IS_HTMLDDA ? function (it) {
          return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll;
        } : function (it) {
          return typeof it == 'object' ? it !== null : isCallable(it);
        };


        /***/ }),

      /***/ 1913:
      /***/ (function(module) {

        module.exports = false;


        /***/ }),

      /***/ 2190:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var getBuiltIn = __webpack_require__(5005);
        var isCallable = __webpack_require__(614);
        var isPrototypeOf = __webpack_require__(7976);
        var USE_SYMBOL_AS_UID = __webpack_require__(3307);

        var $Object = Object;

        module.exports = USE_SYMBOL_AS_UID ? function (it) {
          return typeof it == 'symbol';
        } : function (it) {
          var $Symbol = getBuiltIn('Symbol');
          return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
        };


        /***/ }),

      /***/ 6244:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var toLength = __webpack_require__(7466);

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
        module.exports = function (obj) {
          return toLength(obj.length);
        };


        /***/ }),

      /***/ 6339:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var uncurryThis = __webpack_require__(1702);
        var fails = __webpack_require__(7293);
        var isCallable = __webpack_require__(614);
        var hasOwn = __webpack_require__(2597);
        var DESCRIPTORS = __webpack_require__(9781);
        var CONFIGURABLE_FUNCTION_NAME = (__webpack_require__(6530).CONFIGURABLE);
        var inspectSource = __webpack_require__(2788);
        var InternalStateModule = __webpack_require__(9909);

        var enforceInternalState = InternalStateModule.enforce;
        var getInternalState = InternalStateModule.get;
        var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
        var defineProperty = Object.defineProperty;
        var stringSlice = uncurryThis(''.slice);
        var replace = uncurryThis(''.replace);
        var join = uncurryThis([].join);

        var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
          return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
        });

        var TEMPLATE = String(String).split('String');

        var makeBuiltIn = module.exports = function (value, name, options) {
          if (stringSlice($String(name), 0, 7) === 'Symbol(') {
            name = '[' + replace($String(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
          }
          if (options && options.getter) name = 'get ' + name;
          if (options && options.setter) name = 'set ' + name;
          if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
            if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
            else value.name = name;
          }
          if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
            defineProperty(value, 'length', { value: options.arity });
          }
          try {
            if (options && hasOwn(options, 'constructor') && options.constructor) {
              if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
              // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
            } else if (value.prototype) value.prototype = undefined;
          } catch (error) { /* empty */ }
          var state = enforceInternalState(value);
          if (!hasOwn(state, 'source')) {
            state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
          } return value;
        };

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
        Function.prototype.toString = makeBuiltIn(function toString() {
          return isCallable(this) && getInternalState(this).source || inspectSource(this);
        }, 'toString');


        /***/ }),

      /***/ 4758:
      /***/ (function(module) {

        var ceil = Math.ceil;
        var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
        module.exports = Math.trunc || function trunc(x) {
          var n = +x;
          return (n > 0 ? floor : ceil)(n);
        };


        /***/ }),

      /***/ 6277:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var toString = __webpack_require__(1340);

        module.exports = function (argument, $default) {
          return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
        };


        /***/ }),

      /***/ 3070:
      /***/ (function(__unused_webpack_module, exports, __webpack_require__) {

        var DESCRIPTORS = __webpack_require__(9781);
        var IE8_DOM_DEFINE = __webpack_require__(4664);
        var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(3353);
        var anObject = __webpack_require__(9670);
        var toPropertyKey = __webpack_require__(4948);

        var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
        var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
        var ENUMERABLE = 'enumerable';
        var CONFIGURABLE = 'configurable';
        var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
        exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
          anObject(O);
          P = toPropertyKey(P);
          anObject(Attributes);
          if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
            var current = $getOwnPropertyDescriptor(O, P);
            if (current && current[WRITABLE]) {
              O[P] = Attributes.value;
              Attributes = {
                configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
                enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
                writable: false
              };
            }
          } return $defineProperty(O, P, Attributes);
        } : $defineProperty : function defineProperty(O, P, Attributes) {
          anObject(O);
          P = toPropertyKey(P);
          anObject(Attributes);
          if (IE8_DOM_DEFINE) try {
            return $defineProperty(O, P, Attributes);
          } catch (error) { /* empty */ }
          if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
          if ('value' in Attributes) O[P] = Attributes.value;
          return O;
        };


        /***/ }),

      /***/ 1236:
      /***/ (function(__unused_webpack_module, exports, __webpack_require__) {

        var DESCRIPTORS = __webpack_require__(9781);
        var call = __webpack_require__(6916);
        var propertyIsEnumerableModule = __webpack_require__(5296);
        var createPropertyDescriptor = __webpack_require__(9114);
        var toIndexedObject = __webpack_require__(5656);
        var toPropertyKey = __webpack_require__(4948);
        var hasOwn = __webpack_require__(2597);
        var IE8_DOM_DEFINE = __webpack_require__(4664);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
        exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
          O = toIndexedObject(O);
          P = toPropertyKey(P);
          if (IE8_DOM_DEFINE) try {
            return $getOwnPropertyDescriptor(O, P);
          } catch (error) { /* empty */ }
          if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
        };


        /***/ }),

      /***/ 8006:
      /***/ (function(__unused_webpack_module, exports, __webpack_require__) {

        var internalObjectKeys = __webpack_require__(6324);
        var enumBugKeys = __webpack_require__(748);

        var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
        exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
          return internalObjectKeys(O, hiddenKeys);
        };


        /***/ }),

      /***/ 5181:
      /***/ (function(__unused_webpack_module, exports) {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
        exports.f = Object.getOwnPropertySymbols;


        /***/ }),

      /***/ 7976:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var uncurryThis = __webpack_require__(1702);

        module.exports = uncurryThis({}.isPrototypeOf);


        /***/ }),

      /***/ 6324:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var uncurryThis = __webpack_require__(1702);
        var hasOwn = __webpack_require__(2597);
        var toIndexedObject = __webpack_require__(5656);
        var indexOf = (__webpack_require__(1318).indexOf);
        var hiddenKeys = __webpack_require__(3501);

        var push = uncurryThis([].push);

        module.exports = function (object, names) {
          var O = toIndexedObject(object);
          var i = 0;
          var result = [];
          var key;
          for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
          // Don't enum bug & hidden keys
          while (names.length > i) if (hasOwn(O, key = names[i++])) {
            ~indexOf(result, key) || push(result, key);
          }
          return result;
        };


        /***/ }),

      /***/ 5296:
      /***/ (function(__unused_webpack_module, exports) {

        "use strict";

        var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
        var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
        exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
          var descriptor = getOwnPropertyDescriptor(this, V);
          return !!descriptor && descriptor.enumerable;
        } : $propertyIsEnumerable;


        /***/ }),

      /***/ 7674:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        /* eslint-disable no-proto -- safe */
        var uncurryThisAccessor = __webpack_require__(5668);
        var anObject = __webpack_require__(9670);
        var aPossiblePrototype = __webpack_require__(6077);

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
        module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
          var CORRECT_SETTER = false;
          var test = {};
          var setter;
          try {
            setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
            setter(test, []);
            CORRECT_SETTER = test instanceof Array;
          } catch (error) { /* empty */ }
          return function setPrototypeOf(O, proto) {
            anObject(O);
            aPossiblePrototype(proto);
            if (CORRECT_SETTER) setter(O, proto);
            else O.__proto__ = proto;
            return O;
          };
        }() : undefined);


        /***/ }),

      /***/ 2140:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var call = __webpack_require__(6916);
        var isCallable = __webpack_require__(614);
        var isObject = __webpack_require__(111);

        var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
        module.exports = function (input, pref) {
          var fn, val;
          if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
          if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
          if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
          throw $TypeError("Can't convert object to primitive value");
        };


        /***/ }),

      /***/ 3887:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var getBuiltIn = __webpack_require__(5005);
        var uncurryThis = __webpack_require__(1702);
        var getOwnPropertyNamesModule = __webpack_require__(8006);
        var getOwnPropertySymbolsModule = __webpack_require__(5181);
        var anObject = __webpack_require__(9670);

        var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
        module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
          var keys = getOwnPropertyNamesModule.f(anObject(it));
          var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
          return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
        };


        /***/ }),

      /***/ 4488:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var isNullOrUndefined = __webpack_require__(8554);

        var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
        module.exports = function (it) {
          if (isNullOrUndefined(it)) throw $TypeError("Can't call method on " + it);
          return it;
        };


        /***/ }),

      /***/ 6200:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var shared = __webpack_require__(2309);
        var uid = __webpack_require__(9711);

        var keys = shared('keys');

        module.exports = function (key) {
          return keys[key] || (keys[key] = uid(key));
        };


        /***/ }),

      /***/ 5465:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var global = __webpack_require__(7854);
        var defineGlobalProperty = __webpack_require__(3072);

        var SHARED = '__core-js_shared__';
        var store = global[SHARED] || defineGlobalProperty(SHARED, {});

        module.exports = store;


        /***/ }),

      /***/ 2309:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var IS_PURE = __webpack_require__(1913);
        var store = __webpack_require__(5465);

        (module.exports = function (key, value) {
          return store[key] || (store[key] = value !== undefined ? value : {});
        })('versions', []).push({
          version: '3.29.1',
          mode: IS_PURE ? 'pure' : 'global',
          copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
          license: 'https://github.com/zloirock/core-js/blob/v3.29.1/LICENSE',
          source: 'https://github.com/zloirock/core-js'
        });


        /***/ }),

      /***/ 6293:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        /* eslint-disable es/no-symbol -- required for testing */
        var V8_VERSION = __webpack_require__(7392);
        var fails = __webpack_require__(7293);

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
        module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
          var symbol = Symbol();
          // Chrome 38 Symbol has incorrect toString conversion
          // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
          return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
            // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
            !Symbol.sham && V8_VERSION && V8_VERSION < 41;
        });


        /***/ }),

      /***/ 1400:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var toIntegerOrInfinity = __webpack_require__(9303);

        var max = Math.max;
        var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
        module.exports = function (index, length) {
          var integer = toIntegerOrInfinity(index);
          return integer < 0 ? max(integer + length, 0) : min(integer, length);
        };


        /***/ }),

      /***/ 5656:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
        var IndexedObject = __webpack_require__(8361);
        var requireObjectCoercible = __webpack_require__(4488);

        module.exports = function (it) {
          return IndexedObject(requireObjectCoercible(it));
        };


        /***/ }),

      /***/ 9303:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var trunc = __webpack_require__(4758);

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
        module.exports = function (argument) {
          var number = +argument;
          // eslint-disable-next-line no-self-compare -- NaN check
          return number !== number || number === 0 ? 0 : trunc(number);
        };


        /***/ }),

      /***/ 7466:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var toIntegerOrInfinity = __webpack_require__(9303);

        var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
        module.exports = function (argument) {
          return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
        };


        /***/ }),

      /***/ 7908:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var requireObjectCoercible = __webpack_require__(4488);

        var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
        module.exports = function (argument) {
          return $Object(requireObjectCoercible(argument));
        };


        /***/ }),

      /***/ 7593:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var call = __webpack_require__(6916);
        var isObject = __webpack_require__(111);
        var isSymbol = __webpack_require__(2190);
        var getMethod = __webpack_require__(8173);
        var ordinaryToPrimitive = __webpack_require__(2140);
        var wellKnownSymbol = __webpack_require__(5112);

        var $TypeError = TypeError;
        var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
        module.exports = function (input, pref) {
          if (!isObject(input) || isSymbol(input)) return input;
          var exoticToPrim = getMethod(input, TO_PRIMITIVE);
          var result;
          if (exoticToPrim) {
            if (pref === undefined) pref = 'default';
            result = call(exoticToPrim, input, pref);
            if (!isObject(result) || isSymbol(result)) return result;
            throw $TypeError("Can't convert object to primitive value");
          }
          if (pref === undefined) pref = 'number';
          return ordinaryToPrimitive(input, pref);
        };


        /***/ }),

      /***/ 4948:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var toPrimitive = __webpack_require__(7593);
        var isSymbol = __webpack_require__(2190);

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
        module.exports = function (argument) {
          var key = toPrimitive(argument, 'string');
          return isSymbol(key) ? key : key + '';
        };


        /***/ }),

      /***/ 1694:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var wellKnownSymbol = __webpack_require__(5112);

        var TO_STRING_TAG = wellKnownSymbol('toStringTag');
        var test = {};

        test[TO_STRING_TAG] = 'z';

        module.exports = String(test) === '[object z]';


        /***/ }),

      /***/ 1340:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var classof = __webpack_require__(648);

        var $String = String;

        module.exports = function (argument) {
          if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
          return $String(argument);
        };


        /***/ }),

      /***/ 6330:
      /***/ (function(module) {

        var $String = String;

        module.exports = function (argument) {
          try {
            return $String(argument);
          } catch (error) {
            return 'Object';
          }
        };


        /***/ }),

      /***/ 9711:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var uncurryThis = __webpack_require__(1702);

        var id = 0;
        var postfix = Math.random();
        var toString = uncurryThis(1.0.toString);

        module.exports = function (key) {
          return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
        };


        /***/ }),

      /***/ 3307:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        /* eslint-disable es/no-symbol -- required for testing */
        var NATIVE_SYMBOL = __webpack_require__(6293);

        module.exports = NATIVE_SYMBOL
          && !Symbol.sham
          && typeof Symbol.iterator == 'symbol';


        /***/ }),

      /***/ 3353:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var DESCRIPTORS = __webpack_require__(9781);
        var fails = __webpack_require__(7293);

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
        module.exports = DESCRIPTORS && fails(function () {
          // eslint-disable-next-line es/no-object-defineproperty -- required for testing
          return Object.defineProperty(function () { /* empty */ }, 'prototype', {
            value: 42,
            writable: false
          }).prototype != 42;
        });


        /***/ }),

      /***/ 4811:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var global = __webpack_require__(7854);
        var isCallable = __webpack_require__(614);

        var WeakMap = global.WeakMap;

        module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));


        /***/ }),

      /***/ 5112:
      /***/ (function(module, __unused_webpack_exports, __webpack_require__) {

        var global = __webpack_require__(7854);
        var shared = __webpack_require__(2309);
        var hasOwn = __webpack_require__(2597);
        var uid = __webpack_require__(9711);
        var NATIVE_SYMBOL = __webpack_require__(6293);
        var USE_SYMBOL_AS_UID = __webpack_require__(3307);

        var Symbol = global.Symbol;
        var WellKnownSymbolsStore = shared('wks');
        var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;

        module.exports = function (name) {
          if (!hasOwn(WellKnownSymbolsStore, name)) {
            WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
              ? Symbol[name]
              : createWellKnownSymbol('Symbol.' + name);
          } return WellKnownSymbolsStore[name];
        };


        /***/ }),

      /***/ 7658:
      /***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

        "use strict";

        var $ = __webpack_require__(2109);
        var toObject = __webpack_require__(7908);
        var lengthOfArrayLike = __webpack_require__(6244);
        var setArrayLength = __webpack_require__(3658);
        var doesNotExceedSafeInteger = __webpack_require__(7207);
        var fails = __webpack_require__(7293);

        var INCORRECT_TO_LENGTH = fails(function () {
          return [].push.call({ length: 0x100000000 }, 1) !== 4294967297;
        });

// V8 and Safari <= 15.4, FF < 23 throws InternalError
// https://bugs.chromium.org/p/v8/issues/detail?id=12681
        var properErrorOnNonWritableLength = function () {
          try {
            // eslint-disable-next-line es/no-object-defineproperty -- safe
            Object.defineProperty([], 'length', { writable: false }).push();
          } catch (error) {
            return error instanceof TypeError;
          }
        };

        var FORCED = INCORRECT_TO_LENGTH || !properErrorOnNonWritableLength();

// `Array.prototype.push` method
// https://tc39.es/ecma262/#sec-array.prototype.push
        $({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
          // eslint-disable-next-line no-unused-vars -- required for `.length`
          push: function push(item) {
            var O = toObject(this);
            var len = lengthOfArrayLike(O);
            var argCount = arguments.length;
            doesNotExceedSafeInteger(len + argCount);
            for (var i = 0; i < argCount; i++) {
              O[len] = arguments[i];
              len++;
            }
            setArrayLength(O, len);
            return len;
          }
        });


        /***/ }),

      /***/ 541:
      /***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

        "use strict";

        var $ = __webpack_require__(2109);
        var toObject = __webpack_require__(7908);
        var lengthOfArrayLike = __webpack_require__(6244);
        var setArrayLength = __webpack_require__(3658);
        var deletePropertyOrThrow = __webpack_require__(5117);
        var doesNotExceedSafeInteger = __webpack_require__(7207);

// IE8-
        var INCORRECT_RESULT = [].unshift(0) !== 1;

// V8 ~ Chrome < 71 and Safari <= 15.4, FF < 23 throws InternalError
        var properErrorOnNonWritableLength = function () {
          try {
            // eslint-disable-next-line es/no-object-defineproperty -- safe
            Object.defineProperty([], 'length', { writable: false }).unshift();
          } catch (error) {
            return error instanceof TypeError;
          }
        };

        var FORCED = INCORRECT_RESULT || !properErrorOnNonWritableLength();

// `Array.prototype.unshift` method
// https://tc39.es/ecma262/#sec-array.prototype.unshift
        $({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
          // eslint-disable-next-line no-unused-vars -- required for `.length`
          unshift: function unshift(item) {
            var O = toObject(this);
            var len = lengthOfArrayLike(O);
            var argCount = arguments.length;
            if (argCount) {
              doesNotExceedSafeInteger(len + argCount);
              var k = len;
              while (k--) {
                var to = k + argCount;
                if (k in O) O[to] = O[k];
                else deletePropertyOrThrow(O, to);
              }
              for (var j = 0; j < argCount; j++) {
                O[j] = arguments[j];
              }
            } return setArrayLength(O, len + argCount);
          }
        });


        /***/ }),

      /***/ 2801:
      /***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

        "use strict";

        var $ = __webpack_require__(2109);
        var global = __webpack_require__(7854);
        var getBuiltIn = __webpack_require__(5005);
        var createPropertyDescriptor = __webpack_require__(9114);
        var defineProperty = (__webpack_require__(3070).f);
        var hasOwn = __webpack_require__(2597);
        var anInstance = __webpack_require__(5787);
        var inheritIfRequired = __webpack_require__(9587);
        var normalizeStringArgument = __webpack_require__(6277);
        var DOMExceptionConstants = __webpack_require__(3678);
        var clearErrorStack = __webpack_require__(1060);
        var DESCRIPTORS = __webpack_require__(9781);
        var IS_PURE = __webpack_require__(1913);

        var DOM_EXCEPTION = 'DOMException';
        var Error = getBuiltIn('Error');
        var NativeDOMException = getBuiltIn(DOM_EXCEPTION);

        var $DOMException = function DOMException() {
          anInstance(this, DOMExceptionPrototype);
          var argumentsLength = arguments.length;
          var message = normalizeStringArgument(argumentsLength < 1 ? undefined : arguments[0]);
          var name = normalizeStringArgument(argumentsLength < 2 ? undefined : arguments[1], 'Error');
          var that = new NativeDOMException(message, name);
          var error = Error(message);
          error.name = DOM_EXCEPTION;
          defineProperty(that, 'stack', createPropertyDescriptor(1, clearErrorStack(error.stack, 1)));
          inheritIfRequired(that, this, $DOMException);
          return that;
        };

        var DOMExceptionPrototype = $DOMException.prototype = NativeDOMException.prototype;

        var ERROR_HAS_STACK = 'stack' in Error(DOM_EXCEPTION);
        var DOM_EXCEPTION_HAS_STACK = 'stack' in new NativeDOMException(1, 2);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        var descriptor = NativeDOMException && DESCRIPTORS && Object.getOwnPropertyDescriptor(global, DOM_EXCEPTION);

// Bun ~ 0.1.1 DOMException have incorrect descriptor and we can't redefine it
// https://github.com/Jarred-Sumner/bun/issues/399
        var BUGGY_DESCRIPTOR = !!descriptor && !(descriptor.writable && descriptor.configurable);

        var FORCED_CONSTRUCTOR = ERROR_HAS_STACK && !BUGGY_DESCRIPTOR && !DOM_EXCEPTION_HAS_STACK;

// `DOMException` constructor patch for `.stack` where it's required
// https://webidl.spec.whatwg.org/#es-DOMException-specialness
        $({ global: true, constructor: true, forced: IS_PURE || FORCED_CONSTRUCTOR }, { // TODO: fix export logic
          DOMException: FORCED_CONSTRUCTOR ? $DOMException : NativeDOMException
        });

        var PolyfilledDOMException = getBuiltIn(DOM_EXCEPTION);
        var PolyfilledDOMExceptionPrototype = PolyfilledDOMException.prototype;

        if (PolyfilledDOMExceptionPrototype.constructor !== PolyfilledDOMException) {
          if (!IS_PURE) {
            defineProperty(PolyfilledDOMExceptionPrototype, 'constructor', createPropertyDescriptor(1, PolyfilledDOMException));
          }

          for (var key in DOMExceptionConstants) if (hasOwn(DOMExceptionConstants, key)) {
            var constant = DOMExceptionConstants[key];
            var constantName = constant.s;
            if (!hasOwn(PolyfilledDOMException, constantName)) {
              defineProperty(PolyfilledDOMException, constantName, createPropertyDescriptor(6, constant.c));
            }
          }
        }


        /***/ }),

      /***/ 3676:
      /***/ (function(module, exports, __webpack_require__) {

        /* module decorator */ module = __webpack_require__.nmd(module);
        __webpack_require__(7658);
        /**
         * Lodash (Custom Build) <https://lodash.com/>
         * Build: `lodash modularize exports="npm" -o ./`
         * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
         * Released under MIT license <https://lodash.com/license>
         * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
         * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
         */

        /** Used as the size to enable large array optimizations. */
        var LARGE_ARRAY_SIZE = 200;

        /** Used to stand-in for `undefined` hash values. */
        var HASH_UNDEFINED = '__lodash_hash_undefined__';

        /** Used to detect hot functions by number of calls within a span of milliseconds. */
        var HOT_COUNT = 800,
          HOT_SPAN = 16;

        /** Used as references for various `Number` constants. */
        var MAX_SAFE_INTEGER = 9007199254740991;

        /** `Object#toString` result references. */
        var argsTag = '[object Arguments]',
          arrayTag = '[object Array]',
          asyncTag = '[object AsyncFunction]',
          boolTag = '[object Boolean]',
          dateTag = '[object Date]',
          errorTag = '[object Error]',
          funcTag = '[object Function]',
          genTag = '[object GeneratorFunction]',
          mapTag = '[object Map]',
          numberTag = '[object Number]',
          nullTag = '[object Null]',
          objectTag = '[object Object]',
          proxyTag = '[object Proxy]',
          regexpTag = '[object RegExp]',
          setTag = '[object Set]',
          stringTag = '[object String]',
          undefinedTag = '[object Undefined]',
          weakMapTag = '[object WeakMap]';
        var arrayBufferTag = '[object ArrayBuffer]',
          dataViewTag = '[object DataView]',
          float32Tag = '[object Float32Array]',
          float64Tag = '[object Float64Array]',
          int8Tag = '[object Int8Array]',
          int16Tag = '[object Int16Array]',
          int32Tag = '[object Int32Array]',
          uint8Tag = '[object Uint8Array]',
          uint8ClampedTag = '[object Uint8ClampedArray]',
          uint16Tag = '[object Uint16Array]',
          uint32Tag = '[object Uint32Array]';

        /**
         * Used to match `RegExp`
         * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
         */
        var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

        /** Used to detect host constructors (Safari). */
        var reIsHostCtor = /^\[object .+?Constructor\]$/;

        /** Used to detect unsigned integer values. */
        var reIsUint = /^(?:0|[1-9]\d*)$/;

        /** Used to identify `toStringTag` values of typed arrays. */
        var typedArrayTags = {};
        typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
        typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

        /** Detect free variable `global` from Node.js. */
        var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

        /** Detect free variable `self`. */
        var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

        /** Used as a reference to the global object. */
        var root = freeGlobal || freeSelf || Function('return this')();

        /** Detect free variable `exports`. */
        var freeExports =  true && exports && !exports.nodeType && exports;

        /** Detect free variable `module`. */
        var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

        /** Detect the popular CommonJS extension `module.exports`. */
        var moduleExports = freeModule && freeModule.exports === freeExports;

        /** Detect free variable `process` from Node.js. */
        var freeProcess = moduleExports && freeGlobal.process;

        /** Used to access faster Node.js helpers. */
        var nodeUtil = function () {
          try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) {
              return types;
            }

            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
          } catch (e) {}
        }();

        /* Node.js helper references. */
        var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

        /**
         * A faster alternative to `Function#apply`, this function invokes `func`
         * with the `this` binding of `thisArg` and the arguments of `args`.
         *
         * @private
         * @param {Function} func The function to invoke.
         * @param {*} thisArg The `this` binding of `func`.
         * @param {Array} args The arguments to invoke `func` with.
         * @returns {*} Returns the result of `func`.
         */
        function apply(func, thisArg, args) {
          switch (args.length) {
            case 0:
              return func.call(thisArg);
            case 1:
              return func.call(thisArg, args[0]);
            case 2:
              return func.call(thisArg, args[0], args[1]);
            case 3:
              return func.call(thisArg, args[0], args[1], args[2]);
          }
          return func.apply(thisArg, args);
        }

        /**
         * The base implementation of `_.times` without support for iteratee shorthands
         * or max array length checks.
         *
         * @private
         * @param {number} n The number of times to invoke `iteratee`.
         * @param {Function} iteratee The function invoked per iteration.
         * @returns {Array} Returns the array of results.
         */
        function baseTimes(n, iteratee) {
          var index = -1,
            result = Array(n);
          while (++index < n) {
            result[index] = iteratee(index);
          }
          return result;
        }

        /**
         * The base implementation of `_.unary` without support for storing metadata.
         *
         * @private
         * @param {Function} func The function to cap arguments for.
         * @returns {Function} Returns the new capped function.
         */
        function baseUnary(func) {
          return function (value) {
            return func(value);
          };
        }

        /**
         * Gets the value at `key` of `object`.
         *
         * @private
         * @param {Object} [object] The object to query.
         * @param {string} key The key of the property to get.
         * @returns {*} Returns the property value.
         */
        function getValue(object, key) {
          return object == null ? undefined : object[key];
        }

        /**
         * Creates a unary function that invokes `func` with its argument transformed.
         *
         * @private
         * @param {Function} func The function to wrap.
         * @param {Function} transform The argument transform.
         * @returns {Function} Returns the new function.
         */
        function overArg(func, transform) {
          return function (arg) {
            return func(transform(arg));
          };
        }

        /** Used for built-in method references. */
        var arrayProto = Array.prototype,
          funcProto = Function.prototype,
          objectProto = Object.prototype;

        /** Used to detect overreaching core-js shims. */
        var coreJsData = root['__core-js_shared__'];

        /** Used to resolve the decompiled source of functions. */
        var funcToString = funcProto.toString;

        /** Used to check objects for own properties. */
        var hasOwnProperty = objectProto.hasOwnProperty;

        /** Used to detect methods masquerading as native. */
        var maskSrcKey = function () {
          var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
          return uid ? 'Symbol(src)_1.' + uid : '';
        }();

        /**
         * Used to resolve the
         * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
         * of values.
         */
        var nativeObjectToString = objectProto.toString;

        /** Used to infer the `Object` constructor. */
        var objectCtorString = funcToString.call(Object);

        /** Used to detect if a method is native. */
        var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

        /** Built-in value references. */
        var Buffer = moduleExports ? root.Buffer : undefined,
          Symbol = root.Symbol,
          Uint8Array = root.Uint8Array,
          allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
          getPrototype = overArg(Object.getPrototypeOf, Object),
          objectCreate = Object.create,
          propertyIsEnumerable = objectProto.propertyIsEnumerable,
          splice = arrayProto.splice,
          symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function () {
          try {
            var func = getNative(Object, 'defineProperty');
            func({}, '', {});
            return func;
          } catch (e) {}
        }();

        /* Built-in method references for those with the same name as other `lodash` methods. */
        var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
          nativeMax = Math.max,
          nativeNow = Date.now;

        /* Built-in method references that are verified to be native. */
        var Map = getNative(root, 'Map'),
          nativeCreate = getNative(Object, 'create');

        /**
         * The base implementation of `_.create` without support for assigning
         * properties to the created object.
         *
         * @private
         * @param {Object} proto The object to inherit from.
         * @returns {Object} Returns the new object.
         */
        var baseCreate = function () {
          function object() {}
          return function (proto) {
            if (!isObject(proto)) {
              return {};
            }
            if (objectCreate) {
              return objectCreate(proto);
            }
            object.prototype = proto;
            var result = new object();
            object.prototype = undefined;
            return result;
          };
        }();

        /**
         * Creates a hash object.
         *
         * @private
         * @constructor
         * @param {Array} [entries] The key-value pairs to cache.
         */
        function Hash(entries) {
          var index = -1,
            length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }

        /**
         * Removes all key-value entries from the hash.
         *
         * @private
         * @name clear
         * @memberOf Hash
         */
        function hashClear() {
          this.__data__ = nativeCreate ? nativeCreate(null) : {};
          this.size = 0;
        }

        /**
         * Removes `key` and its value from the hash.
         *
         * @private
         * @name delete
         * @memberOf Hash
         * @param {Object} hash The hash to modify.
         * @param {string} key The key of the value to remove.
         * @returns {boolean} Returns `true` if the entry was removed, else `false`.
         */
        function hashDelete(key) {
          var result = this.has(key) && delete this.__data__[key];
          this.size -= result ? 1 : 0;
          return result;
        }

        /**
         * Gets the hash value for `key`.
         *
         * @private
         * @name get
         * @memberOf Hash
         * @param {string} key The key of the value to get.
         * @returns {*} Returns the entry value.
         */
        function hashGet(key) {
          var data = this.__data__;
          if (nativeCreate) {
            var result = data[key];
            return result === HASH_UNDEFINED ? undefined : result;
          }
          return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }

        /**
         * Checks if a hash value for `key` exists.
         *
         * @private
         * @name has
         * @memberOf Hash
         * @param {string} key The key of the entry to check.
         * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
         */
        function hashHas(key) {
          var data = this.__data__;
          return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }

        /**
         * Sets the hash `key` to `value`.
         *
         * @private
         * @name set
         * @memberOf Hash
         * @param {string} key The key of the value to set.
         * @param {*} value The value to set.
         * @returns {Object} Returns the hash instance.
         */
        function hashSet(key, value) {
          var data = this.__data__;
          this.size += this.has(key) ? 0 : 1;
          data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
          return this;
        }

// Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;

        /**
         * Creates an list cache object.
         *
         * @private
         * @constructor
         * @param {Array} [entries] The key-value pairs to cache.
         */
        function ListCache(entries) {
          var index = -1,
            length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }

        /**
         * Removes all key-value entries from the list cache.
         *
         * @private
         * @name clear
         * @memberOf ListCache
         */
        function listCacheClear() {
          this.__data__ = [];
          this.size = 0;
        }

        /**
         * Removes `key` and its value from the list cache.
         *
         * @private
         * @name delete
         * @memberOf ListCache
         * @param {string} key The key of the value to remove.
         * @returns {boolean} Returns `true` if the entry was removed, else `false`.
         */
        function listCacheDelete(key) {
          var data = this.__data__,
            index = assocIndexOf(data, key);
          if (index < 0) {
            return false;
          }
          var lastIndex = data.length - 1;
          if (index == lastIndex) {
            data.pop();
          } else {
            splice.call(data, index, 1);
          }
          --this.size;
          return true;
        }

        /**
         * Gets the list cache value for `key`.
         *
         * @private
         * @name get
         * @memberOf ListCache
         * @param {string} key The key of the value to get.
         * @returns {*} Returns the entry value.
         */
        function listCacheGet(key) {
          var data = this.__data__,
            index = assocIndexOf(data, key);
          return index < 0 ? undefined : data[index][1];
        }

        /**
         * Checks if a list cache value for `key` exists.
         *
         * @private
         * @name has
         * @memberOf ListCache
         * @param {string} key The key of the entry to check.
         * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
         */
        function listCacheHas(key) {
          return assocIndexOf(this.__data__, key) > -1;
        }

        /**
         * Sets the list cache `key` to `value`.
         *
         * @private
         * @name set
         * @memberOf ListCache
         * @param {string} key The key of the value to set.
         * @param {*} value The value to set.
         * @returns {Object} Returns the list cache instance.
         */
        function listCacheSet(key, value) {
          var data = this.__data__,
            index = assocIndexOf(data, key);
          if (index < 0) {
            ++this.size;
            data.push([key, value]);
          } else {
            data[index][1] = value;
          }
          return this;
        }

// Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;

        /**
         * Creates a map cache object to store key-value pairs.
         *
         * @private
         * @constructor
         * @param {Array} [entries] The key-value pairs to cache.
         */
        function MapCache(entries) {
          var index = -1,
            length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }

        /**
         * Removes all key-value entries from the map.
         *
         * @private
         * @name clear
         * @memberOf MapCache
         */
        function mapCacheClear() {
          this.size = 0;
          this.__data__ = {
            'hash': new Hash(),
            'map': new (Map || ListCache)(),
            'string': new Hash()
          };
        }

        /**
         * Removes `key` and its value from the map.
         *
         * @private
         * @name delete
         * @memberOf MapCache
         * @param {string} key The key of the value to remove.
         * @returns {boolean} Returns `true` if the entry was removed, else `false`.
         */
        function mapCacheDelete(key) {
          var result = getMapData(this, key)['delete'](key);
          this.size -= result ? 1 : 0;
          return result;
        }

        /**
         * Gets the map value for `key`.
         *
         * @private
         * @name get
         * @memberOf MapCache
         * @param {string} key The key of the value to get.
         * @returns {*} Returns the entry value.
         */
        function mapCacheGet(key) {
          return getMapData(this, key).get(key);
        }

        /**
         * Checks if a map value for `key` exists.
         *
         * @private
         * @name has
         * @memberOf MapCache
         * @param {string} key The key of the entry to check.
         * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
         */
        function mapCacheHas(key) {
          return getMapData(this, key).has(key);
        }

        /**
         * Sets the map `key` to `value`.
         *
         * @private
         * @name set
         * @memberOf MapCache
         * @param {string} key The key of the value to set.
         * @param {*} value The value to set.
         * @returns {Object} Returns the map cache instance.
         */
        function mapCacheSet(key, value) {
          var data = getMapData(this, key),
            size = data.size;
          data.set(key, value);
          this.size += data.size == size ? 0 : 1;
          return this;
        }

// Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;

        /**
         * Creates a stack cache object to store key-value pairs.
         *
         * @private
         * @constructor
         * @param {Array} [entries] The key-value pairs to cache.
         */
        function Stack(entries) {
          var data = this.__data__ = new ListCache(entries);
          this.size = data.size;
        }

        /**
         * Removes all key-value entries from the stack.
         *
         * @private
         * @name clear
         * @memberOf Stack
         */
        function stackClear() {
          this.__data__ = new ListCache();
          this.size = 0;
        }

        /**
         * Removes `key` and its value from the stack.
         *
         * @private
         * @name delete
         * @memberOf Stack
         * @param {string} key The key of the value to remove.
         * @returns {boolean} Returns `true` if the entry was removed, else `false`.
         */
        function stackDelete(key) {
          var data = this.__data__,
            result = data['delete'](key);
          this.size = data.size;
          return result;
        }

        /**
         * Gets the stack value for `key`.
         *
         * @private
         * @name get
         * @memberOf Stack
         * @param {string} key The key of the value to get.
         * @returns {*} Returns the entry value.
         */
        function stackGet(key) {
          return this.__data__.get(key);
        }

        /**
         * Checks if a stack value for `key` exists.
         *
         * @private
         * @name has
         * @memberOf Stack
         * @param {string} key The key of the entry to check.
         * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
         */
        function stackHas(key) {
          return this.__data__.has(key);
        }

        /**
         * Sets the stack `key` to `value`.
         *
         * @private
         * @name set
         * @memberOf Stack
         * @param {string} key The key of the value to set.
         * @param {*} value The value to set.
         * @returns {Object} Returns the stack cache instance.
         */
        function stackSet(key, value) {
          var data = this.__data__;
          if (data instanceof ListCache) {
            var pairs = data.__data__;
            if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
              pairs.push([key, value]);
              this.size = ++data.size;
              return this;
            }
            data = this.__data__ = new MapCache(pairs);
          }
          data.set(key, value);
          this.size = data.size;
          return this;
        }

// Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;

        /**
         * Creates an array of the enumerable property names of the array-like `value`.
         *
         * @private
         * @param {*} value The value to query.
         * @param {boolean} inherited Specify returning inherited property names.
         * @returns {Array} Returns the array of property names.
         */
        function arrayLikeKeys(value, inherited) {
          var isArr = isArray(value),
            isArg = !isArr && isArguments(value),
            isBuff = !isArr && !isArg && isBuffer(value),
            isType = !isArr && !isArg && !isBuff && isTypedArray(value),
            skipIndexes = isArr || isArg || isBuff || isType,
            result = skipIndexes ? baseTimes(value.length, String) : [],
            length = result.length;
          for (var key in value) {
            if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (
              // Safari 9 has enumerable `arguments.length` in strict mode.
              key == 'length' ||
              // Node.js 0.10 has enumerable non-index properties on buffers.
              isBuff && (key == 'offset' || key == 'parent') ||
              // PhantomJS 2 has enumerable non-index properties on typed arrays.
              isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
              // Skip index properties.
              isIndex(key, length)))) {
              result.push(key);
            }
          }
          return result;
        }

        /**
         * This function is like `assignValue` except that it doesn't assign
         * `undefined` values.
         *
         * @private
         * @param {Object} object The object to modify.
         * @param {string} key The key of the property to assign.
         * @param {*} value The value to assign.
         */
        function assignMergeValue(object, key, value) {
          if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) {
            baseAssignValue(object, key, value);
          }
        }

        /**
         * Assigns `value` to `key` of `object` if the existing value is not equivalent
         * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * for equality comparisons.
         *
         * @private
         * @param {Object} object The object to modify.
         * @param {string} key The key of the property to assign.
         * @param {*} value The value to assign.
         */
        function assignValue(object, key, value) {
          var objValue = object[key];
          if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
            baseAssignValue(object, key, value);
          }
        }

        /**
         * Gets the index at which the `key` is found in `array` of key-value pairs.
         *
         * @private
         * @param {Array} array The array to inspect.
         * @param {*} key The key to search for.
         * @returns {number} Returns the index of the matched value, else `-1`.
         */
        function assocIndexOf(array, key) {
          var length = array.length;
          while (length--) {
            if (eq(array[length][0], key)) {
              return length;
            }
          }
          return -1;
        }

        /**
         * The base implementation of `assignValue` and `assignMergeValue` without
         * value checks.
         *
         * @private
         * @param {Object} object The object to modify.
         * @param {string} key The key of the property to assign.
         * @param {*} value The value to assign.
         */
        function baseAssignValue(object, key, value) {
          if (key == '__proto__' && defineProperty) {
            defineProperty(object, key, {
              'configurable': true,
              'enumerable': true,
              'value': value,
              'writable': true
            });
          } else {
            object[key] = value;
          }
        }

        /**
         * The base implementation of `baseForOwn` which iterates over `object`
         * properties returned by `keysFunc` and invokes `iteratee` for each property.
         * Iteratee functions may exit iteration early by explicitly returning `false`.
         *
         * @private
         * @param {Object} object The object to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @param {Function} keysFunc The function to get the keys of `object`.
         * @returns {Object} Returns `object`.
         */
        var baseFor = createBaseFor();

        /**
         * The base implementation of `getTag` without fallbacks for buggy environments.
         *
         * @private
         * @param {*} value The value to query.
         * @returns {string} Returns the `toStringTag`.
         */
        function baseGetTag(value) {
          if (value == null) {
            return value === undefined ? undefinedTag : nullTag;
          }
          return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
        }

        /**
         * The base implementation of `_.isArguments`.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an `arguments` object,
         */
        function baseIsArguments(value) {
          return isObjectLike(value) && baseGetTag(value) == argsTag;
        }

        /**
         * The base implementation of `_.isNative` without bad shim checks.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a native function,
         *  else `false`.
         */
        function baseIsNative(value) {
          if (!isObject(value) || isMasked(value)) {
            return false;
          }
          var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
          return pattern.test(toSource(value));
        }

        /**
         * The base implementation of `_.isTypedArray` without Node.js optimizations.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
         */
        function baseIsTypedArray(value) {
          return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }

        /**
         * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names.
         */
        function baseKeysIn(object) {
          if (!isObject(object)) {
            return nativeKeysIn(object);
          }
          var isProto = isPrototype(object),
            result = [];
          for (var key in object) {
            if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
              result.push(key);
            }
          }
          return result;
        }

        /**
         * The base implementation of `_.merge` without support for multiple sources.
         *
         * @private
         * @param {Object} object The destination object.
         * @param {Object} source The source object.
         * @param {number} srcIndex The index of `source`.
         * @param {Function} [customizer] The function to customize merged values.
         * @param {Object} [stack] Tracks traversed source values and their merged
         *  counterparts.
         */
        function baseMerge(object, source, srcIndex, customizer, stack) {
          if (object === source) {
            return;
          }
          baseFor(source, function (srcValue, key) {
            stack || (stack = new Stack());
            if (isObject(srcValue)) {
              baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
            } else {
              var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
              if (newValue === undefined) {
                newValue = srcValue;
              }
              assignMergeValue(object, key, newValue);
            }
          }, keysIn);
        }

        /**
         * A specialized version of `baseMerge` for arrays and objects which performs
         * deep merges and tracks traversed objects enabling objects with circular
         * references to be merged.
         *
         * @private
         * @param {Object} object The destination object.
         * @param {Object} source The source object.
         * @param {string} key The key of the value to merge.
         * @param {number} srcIndex The index of `source`.
         * @param {Function} mergeFunc The function to merge values.
         * @param {Function} [customizer] The function to customize assigned values.
         * @param {Object} [stack] Tracks traversed source values and their merged
         *  counterparts.
         */
        function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
          var objValue = safeGet(object, key),
            srcValue = safeGet(source, key),
            stacked = stack.get(srcValue);
          if (stacked) {
            assignMergeValue(object, key, stacked);
            return;
          }
          var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
          var isCommon = newValue === undefined;
          if (isCommon) {
            var isArr = isArray(srcValue),
              isBuff = !isArr && isBuffer(srcValue),
              isTyped = !isArr && !isBuff && isTypedArray(srcValue);
            newValue = srcValue;
            if (isArr || isBuff || isTyped) {
              if (isArray(objValue)) {
                newValue = objValue;
              } else if (isArrayLikeObject(objValue)) {
                newValue = copyArray(objValue);
              } else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
              } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
              } else {
                newValue = [];
              }
            } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
              newValue = objValue;
              if (isArguments(objValue)) {
                newValue = toPlainObject(objValue);
              } else if (!isObject(objValue) || isFunction(objValue)) {
                newValue = initCloneObject(srcValue);
              }
            } else {
              isCommon = false;
            }
          }
          if (isCommon) {
            // Recursively merge objects and arrays (susceptible to call stack limits).
            stack.set(srcValue, newValue);
            mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
            stack['delete'](srcValue);
          }
          assignMergeValue(object, key, newValue);
        }

        /**
         * The base implementation of `_.rest` which doesn't validate or coerce arguments.
         *
         * @private
         * @param {Function} func The function to apply a rest parameter to.
         * @param {number} [start=func.length-1] The start position of the rest parameter.
         * @returns {Function} Returns the new function.
         */
        function baseRest(func, start) {
          return setToString(overRest(func, start, identity), func + '');
        }

        /**
         * The base implementation of `setToString` without support for hot loop shorting.
         *
         * @private
         * @param {Function} func The function to modify.
         * @param {Function} string The `toString` result.
         * @returns {Function} Returns `func`.
         */
        var baseSetToString = !defineProperty ? identity : function (func, string) {
          return defineProperty(func, 'toString', {
            'configurable': true,
            'enumerable': false,
            'value': constant(string),
            'writable': true
          });
        };

        /**
         * Creates a clone of  `buffer`.
         *
         * @private
         * @param {Buffer} buffer The buffer to clone.
         * @param {boolean} [isDeep] Specify a deep clone.
         * @returns {Buffer} Returns the cloned buffer.
         */
        function cloneBuffer(buffer, isDeep) {
          if (isDeep) {
            return buffer.slice();
          }
          var length = buffer.length,
            result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
          buffer.copy(result);
          return result;
        }

        /**
         * Creates a clone of `arrayBuffer`.
         *
         * @private
         * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
         * @returns {ArrayBuffer} Returns the cloned array buffer.
         */
        function cloneArrayBuffer(arrayBuffer) {
          var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
          new Uint8Array(result).set(new Uint8Array(arrayBuffer));
          return result;
        }

        /**
         * Creates a clone of `typedArray`.
         *
         * @private
         * @param {Object} typedArray The typed array to clone.
         * @param {boolean} [isDeep] Specify a deep clone.
         * @returns {Object} Returns the cloned typed array.
         */
        function cloneTypedArray(typedArray, isDeep) {
          var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
          return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }

        /**
         * Copies the values of `source` to `array`.
         *
         * @private
         * @param {Array} source The array to copy values from.
         * @param {Array} [array=[]] The array to copy values to.
         * @returns {Array} Returns `array`.
         */
        function copyArray(source, array) {
          var index = -1,
            length = source.length;
          array || (array = Array(length));
          while (++index < length) {
            array[index] = source[index];
          }
          return array;
        }

        /**
         * Copies properties of `source` to `object`.
         *
         * @private
         * @param {Object} source The object to copy properties from.
         * @param {Array} props The property identifiers to copy.
         * @param {Object} [object={}] The object to copy properties to.
         * @param {Function} [customizer] The function to customize copied values.
         * @returns {Object} Returns `object`.
         */
        function copyObject(source, props, object, customizer) {
          var isNew = !object;
          object || (object = {});
          var index = -1,
            length = props.length;
          while (++index < length) {
            var key = props[index];
            var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
            if (newValue === undefined) {
              newValue = source[key];
            }
            if (isNew) {
              baseAssignValue(object, key, newValue);
            } else {
              assignValue(object, key, newValue);
            }
          }
          return object;
        }

        /**
         * Creates a function like `_.assign`.
         *
         * @private
         * @param {Function} assigner The function to assign values.
         * @returns {Function} Returns the new assigner function.
         */
        function createAssigner(assigner) {
          return baseRest(function (object, sources) {
            var index = -1,
              length = sources.length,
              customizer = length > 1 ? sources[length - 1] : undefined,
              guard = length > 2 ? sources[2] : undefined;
            customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) {
              customizer = length < 3 ? undefined : customizer;
              length = 1;
            }
            object = Object(object);
            while (++index < length) {
              var source = sources[index];
              if (source) {
                assigner(object, source, index, customizer);
              }
            }
            return object;
          });
        }

        /**
         * Creates a base function for methods like `_.forIn` and `_.forOwn`.
         *
         * @private
         * @param {boolean} [fromRight] Specify iterating from right to left.
         * @returns {Function} Returns the new base function.
         */
        function createBaseFor(fromRight) {
          return function (object, iteratee, keysFunc) {
            var index = -1,
              iterable = Object(object),
              props = keysFunc(object),
              length = props.length;
            while (length--) {
              var key = props[fromRight ? length : ++index];
              if (iteratee(iterable[key], key, iterable) === false) {
                break;
              }
            }
            return object;
          };
        }

        /**
         * Gets the data for `map`.
         *
         * @private
         * @param {Object} map The map to query.
         * @param {string} key The reference key.
         * @returns {*} Returns the map data.
         */
        function getMapData(map, key) {
          var data = map.__data__;
          return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }

        /**
         * Gets the native function at `key` of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @param {string} key The key of the method to get.
         * @returns {*} Returns the function if it's native, else `undefined`.
         */
        function getNative(object, key) {
          var value = getValue(object, key);
          return baseIsNative(value) ? value : undefined;
        }

        /**
         * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
         *
         * @private
         * @param {*} value The value to query.
         * @returns {string} Returns the raw `toStringTag`.
         */
        function getRawTag(value) {
          var isOwn = hasOwnProperty.call(value, symToStringTag),
            tag = value[symToStringTag];
          try {
            value[symToStringTag] = undefined;
            var unmasked = true;
          } catch (e) {}
          var result = nativeObjectToString.call(value);
          if (unmasked) {
            if (isOwn) {
              value[symToStringTag] = tag;
            } else {
              delete value[symToStringTag];
            }
          }
          return result;
        }

        /**
         * Initializes an object clone.
         *
         * @private
         * @param {Object} object The object to clone.
         * @returns {Object} Returns the initialized clone.
         */
        function initCloneObject(object) {
          return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }

        /**
         * Checks if `value` is a valid array-like index.
         *
         * @private
         * @param {*} value The value to check.
         * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
         * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
         */
        function isIndex(value, length) {
          var type = typeof value;
          length = length == null ? MAX_SAFE_INTEGER : length;
          return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }

        /**
         * Checks if the given arguments are from an iteratee call.
         *
         * @private
         * @param {*} value The potential iteratee value argument.
         * @param {*} index The potential iteratee index or key argument.
         * @param {*} object The potential iteratee object argument.
         * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
         *  else `false`.
         */
        function isIterateeCall(value, index, object) {
          if (!isObject(object)) {
            return false;
          }
          var type = typeof index;
          if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
            return eq(object[index], value);
          }
          return false;
        }

        /**
         * Checks if `value` is suitable for use as unique object key.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
         */
        function isKeyable(value) {
          var type = typeof value;
          return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }

        /**
         * Checks if `func` has its source masked.
         *
         * @private
         * @param {Function} func The function to check.
         * @returns {boolean} Returns `true` if `func` is masked, else `false`.
         */
        function isMasked(func) {
          return !!maskSrcKey && maskSrcKey in func;
        }

        /**
         * Checks if `value` is likely a prototype object.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
         */
        function isPrototype(value) {
          var Ctor = value && value.constructor,
            proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
          return value === proto;
        }

        /**
         * This function is like
         * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
         * except that it includes inherited enumerable properties.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names.
         */
        function nativeKeysIn(object) {
          var result = [];
          if (object != null) {
            for (var key in Object(object)) {
              result.push(key);
            }
          }
          return result;
        }

        /**
         * Converts `value` to a string using `Object.prototype.toString`.
         *
         * @private
         * @param {*} value The value to convert.
         * @returns {string} Returns the converted string.
         */
        function objectToString(value) {
          return nativeObjectToString.call(value);
        }

        /**
         * A specialized version of `baseRest` which transforms the rest array.
         *
         * @private
         * @param {Function} func The function to apply a rest parameter to.
         * @param {number} [start=func.length-1] The start position of the rest parameter.
         * @param {Function} transform The rest array transform.
         * @returns {Function} Returns the new function.
         */
        function overRest(func, start, transform) {
          start = nativeMax(start === undefined ? func.length - 1 : start, 0);
          return function () {
            var args = arguments,
              index = -1,
              length = nativeMax(args.length - start, 0),
              array = Array(length);
            while (++index < length) {
              array[index] = args[start + index];
            }
            index = -1;
            var otherArgs = Array(start + 1);
            while (++index < start) {
              otherArgs[index] = args[index];
            }
            otherArgs[start] = transform(array);
            return apply(func, this, otherArgs);
          };
        }

        /**
         * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
         *
         * @private
         * @param {Object} object The object to query.
         * @param {string} key The key of the property to get.
         * @returns {*} Returns the property value.
         */
        function safeGet(object, key) {
          if (key === 'constructor' && typeof object[key] === 'function') {
            return;
          }
          if (key == '__proto__') {
            return;
          }
          return object[key];
        }

        /**
         * Sets the `toString` method of `func` to return `string`.
         *
         * @private
         * @param {Function} func The function to modify.
         * @param {Function} string The `toString` result.
         * @returns {Function} Returns `func`.
         */
        var setToString = shortOut(baseSetToString);

        /**
         * Creates a function that'll short out and invoke `identity` instead
         * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
         * milliseconds.
         *
         * @private
         * @param {Function} func The function to restrict.
         * @returns {Function} Returns the new shortable function.
         */
        function shortOut(func) {
          var count = 0,
            lastCalled = 0;
          return function () {
            var stamp = nativeNow(),
              remaining = HOT_SPAN - (stamp - lastCalled);
            lastCalled = stamp;
            if (remaining > 0) {
              if (++count >= HOT_COUNT) {
                return arguments[0];
              }
            } else {
              count = 0;
            }
            return func.apply(undefined, arguments);
          };
        }

        /**
         * Converts `func` to its source code.
         *
         * @private
         * @param {Function} func The function to convert.
         * @returns {string} Returns the source code.
         */
        function toSource(func) {
          if (func != null) {
            try {
              return funcToString.call(func);
            } catch (e) {}
            try {
              return func + '';
            } catch (e) {}
          }
          return '';
        }

        /**
         * Performs a
         * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * comparison between two values to determine if they are equivalent.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
         * @example
         *
         * var object = { 'a': 1 };
         * var other = { 'a': 1 };
         *
         * _.eq(object, object);
         * // => true
         *
         * _.eq(object, other);
         * // => false
         *
         * _.eq('a', 'a');
         * // => true
         *
         * _.eq('a', Object('a'));
         * // => false
         *
         * _.eq(NaN, NaN);
         * // => true
         */
        function eq(value, other) {
          return value === other || value !== value && other !== other;
        }

        /**
         * Checks if `value` is likely an `arguments` object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an `arguments` object,
         *  else `false`.
         * @example
         *
         * _.isArguments(function() { return arguments; }());
         * // => true
         *
         * _.isArguments([1, 2, 3]);
         * // => false
         */
        var isArguments = baseIsArguments(function () {
          return arguments;
        }()) ? baseIsArguments : function (value) {
          return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };

        /**
         * Checks if `value` is classified as an `Array` object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an array, else `false`.
         * @example
         *
         * _.isArray([1, 2, 3]);
         * // => true
         *
         * _.isArray(document.body.children);
         * // => false
         *
         * _.isArray('abc');
         * // => false
         *
         * _.isArray(_.noop);
         * // => false
         */
        var isArray = Array.isArray;

        /**
         * Checks if `value` is array-like. A value is considered array-like if it's
         * not a function and has a `value.length` that's an integer greater than or
         * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
         * @example
         *
         * _.isArrayLike([1, 2, 3]);
         * // => true
         *
         * _.isArrayLike(document.body.children);
         * // => true
         *
         * _.isArrayLike('abc');
         * // => true
         *
         * _.isArrayLike(_.noop);
         * // => false
         */
        function isArrayLike(value) {
          return value != null && isLength(value.length) && !isFunction(value);
        }

        /**
         * This method is like `_.isArrayLike` except that it also checks if `value`
         * is an object.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an array-like object,
         *  else `false`.
         * @example
         *
         * _.isArrayLikeObject([1, 2, 3]);
         * // => true
         *
         * _.isArrayLikeObject(document.body.children);
         * // => true
         *
         * _.isArrayLikeObject('abc');
         * // => false
         *
         * _.isArrayLikeObject(_.noop);
         * // => false
         */
        function isArrayLikeObject(value) {
          return isObjectLike(value) && isArrayLike(value);
        }

        /**
         * Checks if `value` is a buffer.
         *
         * @static
         * @memberOf _
         * @since 4.3.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
         * @example
         *
         * _.isBuffer(new Buffer(2));
         * // => true
         *
         * _.isBuffer(new Uint8Array(2));
         * // => false
         */
        var isBuffer = nativeIsBuffer || stubFalse;

        /**
         * Checks if `value` is classified as a `Function` object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a function, else `false`.
         * @example
         *
         * _.isFunction(_);
         * // => true
         *
         * _.isFunction(/abc/);
         * // => false
         */
        function isFunction(value) {
          if (!isObject(value)) {
            return false;
          }
          // The use of `Object#toString` avoids issues with the `typeof` operator
          // in Safari 9 which returns 'object' for typed arrays and other constructors.
          var tag = baseGetTag(value);
          return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }

        /**
         * Checks if `value` is a valid array-like length.
         *
         * **Note:** This method is loosely based on
         * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
         * @example
         *
         * _.isLength(3);
         * // => true
         *
         * _.isLength(Number.MIN_VALUE);
         * // => false
         *
         * _.isLength(Infinity);
         * // => false
         *
         * _.isLength('3');
         * // => false
         */
        function isLength(value) {
          return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }

        /**
         * Checks if `value` is the
         * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
         * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an object, else `false`.
         * @example
         *
         * _.isObject({});
         * // => true
         *
         * _.isObject([1, 2, 3]);
         * // => true
         *
         * _.isObject(_.noop);
         * // => true
         *
         * _.isObject(null);
         * // => false
         */
        function isObject(value) {
          var type = typeof value;
          return value != null && (type == 'object' || type == 'function');
        }

        /**
         * Checks if `value` is object-like. A value is object-like if it's not `null`
         * and has a `typeof` result of "object".
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
         * @example
         *
         * _.isObjectLike({});
         * // => true
         *
         * _.isObjectLike([1, 2, 3]);
         * // => true
         *
         * _.isObjectLike(_.noop);
         * // => false
         *
         * _.isObjectLike(null);
         * // => false
         */
        function isObjectLike(value) {
          return value != null && typeof value == 'object';
        }

        /**
         * Checks if `value` is a plain object, that is, an object created by the
         * `Object` constructor or one with a `[[Prototype]]` of `null`.
         *
         * @static
         * @memberOf _
         * @since 0.8.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         * }
         *
         * _.isPlainObject(new Foo);
         * // => false
         *
         * _.isPlainObject([1, 2, 3]);
         * // => false
         *
         * _.isPlainObject({ 'x': 0, 'y': 0 });
         * // => true
         *
         * _.isPlainObject(Object.create(null));
         * // => true
         */
        function isPlainObject(value) {
          if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
            return false;
          }
          var proto = getPrototype(value);
          if (proto === null) {
            return true;
          }
          var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
          return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }

        /**
         * Checks if `value` is classified as a typed array.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
         * @example
         *
         * _.isTypedArray(new Uint8Array);
         * // => true
         *
         * _.isTypedArray([]);
         * // => false
         */
        var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

        /**
         * Converts `value` to a plain object flattening inherited enumerable string
         * keyed properties of `value` to own properties of the plain object.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Lang
         * @param {*} value The value to convert.
         * @returns {Object} Returns the converted plain object.
         * @example
         *
         * function Foo() {
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.assign({ 'a': 1 }, new Foo);
         * // => { 'a': 1, 'b': 2 }
         *
         * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
         * // => { 'a': 1, 'b': 2, 'c': 3 }
         */
        function toPlainObject(value) {
          return copyObject(value, keysIn(value));
        }

        /**
         * Creates an array of the own and inherited enumerable property names of `object`.
         *
         * **Note:** Non-object values are coerced to objects.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Object
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names.
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.keysIn(new Foo);
         * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
         */
        function keysIn(object) {
          return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }

        /**
         * This method is like `_.assign` except that it recursively merges own and
         * inherited enumerable string keyed properties of source objects into the
         * destination object. Source properties that resolve to `undefined` are
         * skipped if a destination value exists. Array and plain object properties
         * are merged recursively. Other objects and value types are overridden by
         * assignment. Source objects are applied from left to right. Subsequent
         * sources overwrite property assignments of previous sources.
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 0.5.0
         * @category Object
         * @param {Object} object The destination object.
         * @param {...Object} [sources] The source objects.
         * @returns {Object} Returns `object`.
         * @example
         *
         * var object = {
         *   'a': [{ 'b': 2 }, { 'd': 4 }]
         * };
         *
         * var other = {
         *   'a': [{ 'c': 3 }, { 'e': 5 }]
         * };
         *
         * _.merge(object, other);
         * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
         */
        var merge = createAssigner(function (object, source, srcIndex) {
          baseMerge(object, source, srcIndex);
        });

        /**
         * Creates a function that returns `value`.
         *
         * @static
         * @memberOf _
         * @since 2.4.0
         * @category Util
         * @param {*} value The value to return from the new function.
         * @returns {Function} Returns the new constant function.
         * @example
         *
         * var objects = _.times(2, _.constant({ 'a': 1 }));
         *
         * console.log(objects);
         * // => [{ 'a': 1 }, { 'a': 1 }]
         *
         * console.log(objects[0] === objects[1]);
         * // => true
         */
        function constant(value) {
          return function () {
            return value;
          };
        }

        /**
         * This method returns the first argument it receives.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Util
         * @param {*} value Any value.
         * @returns {*} Returns `value`.
         * @example
         *
         * var object = { 'a': 1 };
         *
         * console.log(_.identity(object) === object);
         * // => true
         */
        function identity(value) {
          return value;
        }

        /**
         * This method returns `false`.
         *
         * @static
         * @memberOf _
         * @since 4.13.0
         * @category Util
         * @returns {boolean} Returns `false`.
         * @example
         *
         * _.times(2, _.stubFalse);
         * // => [false, false]
         */
        function stubFalse() {
          return false;
        }
        module.exports = merge;

        /***/ }),

      /***/ 7203:
      /***/ (function(module) {

        "use strict";
        module.exports = __WEBPACK_EXTERNAL_MODULE__7203__;

        /***/ })

      /******/ 	});
    /************************************************************************/
    /******/ 	// The module cache
    /******/ 	var __webpack_module_cache__ = {};
    /******/
    /******/ 	// The require function
    /******/ 	function __webpack_require__(moduleId) {
      /******/ 		// Check if module is in cache
      /******/ 		var cachedModule = __webpack_module_cache__[moduleId];
      /******/ 		if (cachedModule !== undefined) {
        /******/ 			return cachedModule.exports;
        /******/ 		}
      /******/ 		// Create a new module (and put it into the cache)
      /******/ 		var module = __webpack_module_cache__[moduleId] = {
        /******/ 			id: moduleId,
        /******/ 			loaded: false,
        /******/ 			exports: {}
        /******/ 		};
      /******/
      /******/ 		// Execute the module function
      /******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
      /******/
      /******/ 		// Flag the module as loaded
      /******/ 		module.loaded = true;
      /******/
      /******/ 		// Return the exports of the module
      /******/ 		return module.exports;
      /******/ 	}
    /******/
    /************************************************************************/
    /******/ 	/* webpack/runtime/compat get default export */
    /******/ 	!function() {
      /******/ 		// getDefaultExport function for compatibility with non-harmony modules
      /******/ 		__webpack_require__.n = function(module) {
        /******/ 			var getter = module && module.__esModule ?
          /******/ 				function() { return module['default']; } :
          /******/ 				function() { return module; };
        /******/ 			__webpack_require__.d(getter, { a: getter });
        /******/ 			return getter;
        /******/ 		};
      /******/ 	}();
    /******/
    /******/ 	/* webpack/runtime/define property getters */
    /******/ 	!function() {
      /******/ 		// define getter functions for harmony exports
      /******/ 		__webpack_require__.d = function(exports, definition) {
        /******/ 			for(var key in definition) {
          /******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
            /******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
            /******/ 				}
          /******/ 			}
        /******/ 		};
      /******/ 	}();
    /******/
    /******/ 	/* webpack/runtime/global */
    /******/ 	!function() {
      /******/ 		__webpack_require__.g = (function() {
        /******/ 			if (typeof globalThis === 'object') return globalThis;
        /******/ 			try {
          /******/ 				return this || new Function('return this')();
          /******/ 			} catch (e) {
          /******/ 				if (typeof window === 'object') return window;
          /******/ 			}
        /******/ 		})();
      /******/ 	}();
    /******/
    /******/ 	/* webpack/runtime/hasOwnProperty shorthand */
    /******/ 	!function() {
      /******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
      /******/ 	}();
    /******/
    /******/ 	/* webpack/runtime/make namespace object */
    /******/ 	!function() {
      /******/ 		// define __esModule on exports
      /******/ 		__webpack_require__.r = function(exports) {
        /******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
          /******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
          /******/ 			}
        /******/ 			Object.defineProperty(exports, '__esModule', { value: true });
        /******/ 		};
      /******/ 	}();
    /******/
    /******/ 	/* webpack/runtime/node module decorator */
    /******/ 	!function() {
      /******/ 		__webpack_require__.nmd = function(module) {
        /******/ 			module.paths = [];
        /******/ 			if (!module.children) module.children = [];
        /******/ 			return module;
        /******/ 		};
      /******/ 	}();
    /******/
    /******/ 	/* webpack/runtime/publicPath */
    /******/ 	!function() {
      /******/ 		__webpack_require__.p = "";
      /******/ 	}();
    /******/
    /************************************************************************/
    var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
    !function() {
      "use strict";
// ESM COMPAT FLAG
      __webpack_require__.r(__webpack_exports__);

// EXPORTS
      __webpack_require__.d(__webpack_exports__, {
        "default": function() { return /* binding */ entry_lib; }
      });

// NAMESPACE OBJECT: ./src/components/index.ts
      var components_namespaceObject = {};
      __webpack_require__.r(components_namespaceObject);
      __webpack_require__.d(components_namespaceObject, {
        "RAccordion": function() { return components_RAccordion; },
        "RAnnouncement": function() { return components_RAnnouncement; },
        "RAutocomplete": function() { return components_RAutocomplete; },
        "RAvatar": function() { return components_RAvatar; },
        "RBadge": function() { return components_RBadge; },
        "RBreadCrumbs": function() { return components_RBreadCrumbs; },
        "RBulb": function() { return components_RBulb; },
        "RButton": function() { return components_RButton; },
        "RButtonAction": function() { return components_RButtonAction; },
        "RButtonArrow": function() { return components_RButtonArrow; },
        "RButtonGallery": function() { return components_RButtonGallery; },
        "RButtonLink": function() { return components_RButtonLink; },
        "RButtonNavigation": function() { return components_RButtonNavigation; },
        "RButtonPlayer": function() { return components_RButtonPlayer; },
        "RButtonSimple": function() { return components_RButtonSimple; },
        "RButtonTag": function() { return components_RButtonTag; },
        "RCheckbox": function() { return components_RCheckbox; },
        "RCol": function() { return components_RCol; },
        "RDatePicker": function() { return components_RDatePicker; },
        "RFader": function() { return components_RFader; },
        "RFile": function() { return components_RFile; },
        "RIcon": function() { return components_RIcon; },
        "RImage": function() { return components_RImage; },
        "RInput": function() { return components_RInput; },
        "RInputNumber": function() { return components_RInputNumber; },
        "RKanban": function() { return components_RKanban; },
        "RLayoutDashboard": function() { return components_RLayoutDashboard; },
        "RLayoutSite": function() { return components_RLayoutSite; },
        "RLightBox": function() { return components_RLightBox; },
        "RListGroup": function() { return components_RListGroup; },
        "RListItem": function() { return components_RListItem; },
        "RMediaGallery": function() { return components_RMediaGallery; },
        "RMenu": function() { return components_RMenu; },
        "RModal": function() { return components_RModal; },
        "RNavigationTile": function() { return components_RNavigationTile; },
        "RNotification": function() { return components_RNotification; },
        "RPaginator": function() { return components_RPaginator; },
        "RPlank": function() { return components_RPlank; },
        "RPlayerAudio": function() { return components_RPlayerAudio; },
        "RPlayerVideo": function() { return components_RPlayerVideo; },
        "RPopover": function() { return components_RPopover; },
        "RRadioButton": function() { return components_RRadioButton; },
        "RRow": function() { return components_RRow; },
        "RSelect": function() { return components_RSelect; },
        "RShorter": function() { return components_RShorter; },
        "RSlideshow": function() { return components_RSlideshow; },
        "RSpinner": function() { return components_RSpinner; },
        "RStory": function() { return components_RStory; },
        "RSwitcher": function() { return components_RSwitcher; },
        "RTable": function() { return components_RTable; },
        "RTabs": function() { return components_RTabs; },
        "RTextarea": function() { return components_RTextarea; },
        "RTimePicker": function() { return components_RTimePicker; },
        "RTimer": function() { return components_RTimer; },
        "RTooltip": function() { return components_RTooltip; },
        "RUploader": function() { return components_RUploader; }
      });

      ;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
      /* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

      if (typeof window !== 'undefined') {
        var currentScript = window.document.currentScript
        if (false) { var getCurrentScript; }

        var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
        if (src) {
          __webpack_require__.p = src[1] // eslint-disable-line
        }
      }

// Indicate to webpack that this file can be concatenated
      /* harmony default export */ var setPublicPath = (null);

      ;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
      function _typeof(obj) {
        "@babel/helpers - typeof";

        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
          return typeof obj;
        } : function (obj) {
          return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
      }
      ;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js

      function _toPrimitive(input, hint) {
        if (_typeof(input) !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
          var res = prim.call(input, hint || "default");
          if (_typeof(res) !== "object") return res;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
      }
      ;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


      function _toPropertyKey(arg) {
        var key = _toPrimitive(arg, "string");
        return _typeof(key) === "symbol" ? key : String(key);
      }
      ;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js

      function _defineProperty(obj, key, value) {
        key = _toPropertyKey(key);
        if (key in obj) {
          Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
          });
        } else {
          obj[key] = value;
        }
        return obj;
      }
// EXTERNAL MODULE: ./node_modules/lodash.merge/index.js
      var lodash_merge = __webpack_require__(3676);
      var lodash_merge_default = /*#__PURE__*/__webpack_require__.n(lodash_merge);
      ;// CONCATENATED MODULE: ./src/util/defaultOptions.ts
      const defaultOptions = {
        gridsName: 'default',
        points: {
          widest: 1360,
          wide: 1024,
          middle: 600,
          narrow: 0
        }
      };
      /* harmony default export */ var util_defaultOptions = (defaultOptions);
      ;// CONCATENATED MODULE: ./src/util/grid.ts


      class Grid {
        constructor(name) {
          _defineProperty(this, "name", void 0);
          this.name = name || util_defaultOptions.gridsName;
        }
      }
      ;// CONCATENATED MODULE: ./src/util/themes.ts
      const initTheme = themeName => {
        document.documentElement.setAttribute('theme', themeName);
      };
      ;// CONCATENATED MODULE: ./src/util/breakpoint.ts


      class Breakpoint {
        constructor(points, fixPointGrid) {
          _defineProperty(this, "name", void 0);
          _defineProperty(this, "fixedPoint", false);
          _defineProperty(this, "width", 0);
          _defineProperty(this, "height", 0);
          _defineProperty(this, "points", void 0);
          _defineProperty(this, "resizeTimeout", 0);
          this.points = points || util_defaultOptions.points;
          if (fixPointGrid) {
            this.name = fixPointGrid;
            this.fixedPoint = !!fixPointGrid;
          } else {
            this.name = 'widest';
          }
        }
        init() {
          this.update();
          if (typeof window === 'undefined') return;
          window.addEventListener('resize', this.onResize.bind(this), {
            passive: true
          });
        }
        update() {
          const width = Breakpoint.getClientWidth();
          const height = Breakpoint.getClientHeight();
          let isPoint = false;
          Object.keys(this.points).forEach(key => {
            if (typeof document !== 'undefined') {
              document.body.classList.remove(key);
            }
            this.width = width;
            this.height = height;
            if (this.fixedPoint) {
              document.body.classList.add(this.name);
              return;
            }
            if (isPoint) {
              return;
            }
            if (this.points[key] <= width) {
              this.name = key;
              if (typeof document !== 'undefined') {
                document.body.classList.add(key);
              }
              isPoint = true;
            }
          });
        }
        onResize() {
          clearTimeout(this.resizeTimeout);
          this.resizeTimeout = window.setTimeout(this.update.bind(this), 200);
        }
        static getClientWidth() {
          if (typeof document === 'undefined') return 0;
          return Math.max(document.documentElement?.clientWidth, window.innerWidth || 0);
        }
        static getClientHeight() {
          if (typeof document === 'undefined') return 0;
          return Math.max(document.documentElement?.clientHeight, window.innerHeight || 0);
        }
      }
// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
      var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(7203);
      var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_);
      ;// CONCATENATED MODULE: ./src/util/deprecated.ts
      /* harmony default export */ function deprecated(component) {
        if (!component.$vnode) return;
        const {
          options
        } = component.$vnode.componentOptions?.Ctor;
        if (options && options.deprecated) {
          console.error('DEPRECATED COMPONENT', options.name, options.deprecated);
        }
        const propsData = component.$options.propsData;
        if (propsData) {
          Object.keys(options.props).forEach(key => {
            const value = options.props[key];
            if (!propsData[key] || !value.deprecated) {
              return;
            }
            console.error('DEPRECATED PROPS', options.name, key, value.deprecated);
          });
        }
      }
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.push.js
      var es_array_push = __webpack_require__(7658);
      ;// CONCATENATED MODULE: ./node_modules/vue-class-component/dist/vue-class-component.esm.js

      /**
       * vue-class-component v7.2.6
       * (c) 2015-present Evan You
       * @license MIT
       */

      function vue_class_component_esm_typeof(obj) {
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
          vue_class_component_esm_typeof = function (obj) {
            return typeof obj;
          };
        } else {
          vue_class_component_esm_typeof = function (obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
          };
        }
        return vue_class_component_esm_typeof(obj);
      }
      function vue_class_component_esm_defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
          });
        } else {
          obj[key] = value;
        }
        return obj;
      }
      function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
      }
      function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) {
          for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
          return arr2;
        }
      }
      function _iterableToArray(iter) {
        if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
      }
      function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      }

// The rational behind the verbose Reflect-feature check below is the fact that there are polyfills
// which add an implementation for Reflect.defineMetadata but not for Reflect.getOwnMetadataKeys.
// Without this check consumers will encounter hard to track down runtime errors.
      function reflectionIsSupported() {
        return typeof Reflect !== 'undefined' && Reflect.defineMetadata && Reflect.getOwnMetadataKeys;
      }
      function copyReflectionMetadata(to, from) {
        forwardMetadata(to, from);
        Object.getOwnPropertyNames(from.prototype).forEach(function (key) {
          forwardMetadata(to.prototype, from.prototype, key);
        });
        Object.getOwnPropertyNames(from).forEach(function (key) {
          forwardMetadata(to, from, key);
        });
      }
      function forwardMetadata(to, from, propertyKey) {
        var metaKeys = propertyKey ? Reflect.getOwnMetadataKeys(from, propertyKey) : Reflect.getOwnMetadataKeys(from);
        metaKeys.forEach(function (metaKey) {
          var metadata = propertyKey ? Reflect.getOwnMetadata(metaKey, from, propertyKey) : Reflect.getOwnMetadata(metaKey, from);
          if (propertyKey) {
            Reflect.defineMetadata(metaKey, metadata, to, propertyKey);
          } else {
            Reflect.defineMetadata(metaKey, metadata, to);
          }
        });
      }
      var fakeArray = {
        __proto__: []
      };
      var hasProto = fakeArray instanceof Array;
      function vue_class_component_esm_createDecorator(factory) {
        return function (target, key, index) {
          var Ctor = typeof target === 'function' ? target : target.constructor;
          if (!Ctor.__decorators__) {
            Ctor.__decorators__ = [];
          }
          if (typeof index !== 'number') {
            index = undefined;
          }
          Ctor.__decorators__.push(function (options) {
            return factory(options, key, index);
          });
        };
      }
      function mixins() {
        for (var _len = arguments.length, Ctors = new Array(_len), _key = 0; _key < _len; _key++) {
          Ctors[_key] = arguments[_key];
        }
        return Vue.extend({
          mixins: Ctors
        });
      }
      function isPrimitive(value) {
        var type = vue_class_component_esm_typeof(value);
        return value == null || type !== 'object' && type !== 'function';
      }
      function warn(message) {
        if (typeof console !== 'undefined') {
          console.warn('[vue-class-component] ' + message);
        }
      }
      function collectDataFromConstructor(vm, Component) {
        // override _init to prevent to init as Vue instance
        var originalInit = Component.prototype._init;
        Component.prototype._init = function () {
          var _this = this;

          // proxy to actual vm
          var keys = Object.getOwnPropertyNames(vm); // 2.2.0 compat (props are no longer exposed as self properties)

          if (vm.$options.props) {
            for (var key in vm.$options.props) {
              if (!vm.hasOwnProperty(key)) {
                keys.push(key);
              }
            }
          }
          keys.forEach(function (key) {
            Object.defineProperty(_this, key, {
              get: function get() {
                return vm[key];
              },
              set: function set(value) {
                vm[key] = value;
              },
              configurable: true
            });
          });
        }; // should be acquired class property values

        var data = new Component(); // restore original _init to avoid memory leak (#209)

        Component.prototype._init = originalInit; // create plain data object

        var plainData = {};
        Object.keys(data).forEach(function (key) {
          if (data[key] !== undefined) {
            plainData[key] = data[key];
          }
        });
        if (false) {}
        return plainData;
      }
      var $internalHooks = ['data', 'beforeCreate', 'created', 'beforeMount', 'mounted', 'beforeDestroy', 'destroyed', 'beforeUpdate', 'updated', 'activated', 'deactivated', 'render', 'errorCaptured', 'serverPrefetch' // 2.6
      ];

      function componentFactory(Component) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        options.name = options.name || Component._componentTag || Component.name; // prototype props.

        var proto = Component.prototype;
        Object.getOwnPropertyNames(proto).forEach(function (key) {
          if (key === 'constructor') {
            return;
          } // hooks

          if ($internalHooks.indexOf(key) > -1) {
            options[key] = proto[key];
            return;
          }
          var descriptor = Object.getOwnPropertyDescriptor(proto, key);
          if (descriptor.value !== void 0) {
            // methods
            if (typeof descriptor.value === 'function') {
              (options.methods || (options.methods = {}))[key] = descriptor.value;
            } else {
              // typescript decorated data
              (options.mixins || (options.mixins = [])).push({
                data: function data() {
                  return vue_class_component_esm_defineProperty({}, key, descriptor.value);
                }
              });
            }
          } else if (descriptor.get || descriptor.set) {
            // computed properties
            (options.computed || (options.computed = {}))[key] = {
              get: descriptor.get,
              set: descriptor.set
            };
          }
        });
        (options.mixins || (options.mixins = [])).push({
          data: function data() {
            return collectDataFromConstructor(this, Component);
          }
        }); // decorate options

        var decorators = Component.__decorators__;
        if (decorators) {
          decorators.forEach(function (fn) {
            return fn(options);
          });
          delete Component.__decorators__;
        } // find super

        var superProto = Object.getPrototypeOf(Component.prototype);
        var Super = superProto instanceof (external_commonjs_vue_commonjs2_vue_root_Vue_default()) ? superProto.constructor : (external_commonjs_vue_commonjs2_vue_root_Vue_default());
        var Extended = Super.extend(options);
        forwardStaticMembers(Extended, Component, Super);
        if (reflectionIsSupported()) {
          copyReflectionMetadata(Extended, Component);
        }
        return Extended;
      }
      var reservedPropertyNames = (/* unused pure expression or super */ null && ([
// Unique id
        'cid',
// Super Vue constructor
        'super',
// Component options that will be used by the component
        'options', 'superOptions', 'extendOptions', 'sealedOptions',
// Private assets
        'component', 'directive', 'filter']));
      var shouldIgnore = {
        prototype: true,
        arguments: true,
        callee: true,
        caller: true
      };
      function forwardStaticMembers(Extended, Original, Super) {
        // We have to use getOwnPropertyNames since Babel registers methods as non-enumerable
        Object.getOwnPropertyNames(Original).forEach(function (key) {
          // Skip the properties that should not be overwritten
          if (shouldIgnore[key]) {
            return;
          } // Some browsers does not allow reconfigure built-in properties

          var extendedDescriptor = Object.getOwnPropertyDescriptor(Extended, key);
          if (extendedDescriptor && !extendedDescriptor.configurable) {
            return;
          }
          var descriptor = Object.getOwnPropertyDescriptor(Original, key); // If the user agent does not support `__proto__` or its family (IE <= 10),
          // the sub class properties may be inherited properties from the super class in TypeScript.
          // We need to exclude such properties to prevent to overwrite
          // the component options object which stored on the extended constructor (See #192).
          // If the value is a referenced value (object or function),
          // we can check equality of them and exclude it if they have the same reference.
          // If it is a primitive value, it will be forwarded for safety.

          if (!hasProto) {
            // Only `cid` is explicitly exluded from property forwarding
            // because we cannot detect whether it is a inherited property or not
            // on the no `__proto__` environment even though the property is reserved.
            if (key === 'cid') {
              return;
            }
            var superDescriptor = Object.getOwnPropertyDescriptor(Super, key);
            if (!isPrimitive(descriptor.value) && superDescriptor && superDescriptor.value === descriptor.value) {
              return;
            }
          } // Warn if the users manually declare reserved properties

          if (false) {}
          Object.defineProperty(Extended, key, descriptor);
        });
      }
      function Component(options) {
        if (typeof options === 'function') {
          return componentFactory(options);
        }
        return function (Component) {
          return componentFactory(Component, options);
        };
      }
      Component.registerHooks = function registerHooks(keys) {
        $internalHooks.push.apply($internalHooks, _toConsumableArray(keys));
      };
      /* harmony default export */ var vue_class_component_esm = (Component);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.unshift.js
      var es_array_unshift = __webpack_require__(541);
      ;// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/Emit.js

      var __spreadArrays = undefined && undefined.__spreadArrays || function () {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
        return r;
      };
// Code copied from Vue/src/shared/util.js
      var hyphenateRE = /\B([A-Z])/g;
      var hyphenate = function (str) {
        return str.replace(hyphenateRE, '-$1').toLowerCase();
      };
      /**
       * decorator of an event-emitter function
       * @param  event The name of the event
       * @return MethodDecorator
       */
      function Emit(event) {
        return function (_target, propertyKey, descriptor) {
          var key = hyphenate(propertyKey);
          var original = descriptor.value;
          descriptor.value = function emitter() {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              args[_i] = arguments[_i];
            }
            var emit = function (returnValue) {
              var emitName = event || key;
              if (returnValue === undefined) {
                if (args.length === 0) {
                  _this.$emit(emitName);
                } else if (args.length === 1) {
                  _this.$emit(emitName, args[0]);
                } else {
                  _this.$emit.apply(_this, __spreadArrays([emitName], args));
                }
              } else {
                args.unshift(returnValue);
                _this.$emit.apply(_this, __spreadArrays([emitName], args));
              }
            };
            var returnValue = original.apply(this, args);
            if (isPromise(returnValue)) {
              returnValue.then(emit);
            } else {
              emit(returnValue);
            }
            return returnValue;
          };
        };
      }
      function isPromise(obj) {
        return obj instanceof Promise || obj && typeof obj.then === 'function';
      }
      ;// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/helpers/metadata.js
      /** @see {@link https://github.com/vuejs/vue-class-component/blob/master/src/reflect.ts} */
      var reflectMetadataIsSupported = typeof Reflect !== 'undefined' && typeof Reflect.getMetadata !== 'undefined';
      function metadata_applyMetadata(options, target, key) {
        if (reflectMetadataIsSupported) {
          if (!Array.isArray(options) && typeof options !== 'function' && !options.hasOwnProperty('type') && typeof options.type === 'undefined') {
            var type = Reflect.getMetadata('design:type', target, key);
            if (type !== Object) {
              options.type = type;
            }
          }
        }
      }
      ;// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/Model.js


      /**
       * decorator of model
       * @param  event event name
       * @param options options
       * @return PropertyDecorator
       */
      function Model(event, options) {
        if (options === void 0) {
          options = {};
        }
        return function (target, key) {
          metadata_applyMetadata(options, target, key);
          vue_class_component_esm_createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
            componentOptions.model = {
              prop: k,
              event: event || k
            };
          })(target, key);
        };
      }
      ;// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/ModelSync.js


      /**
       * decorator of synced model and prop
       * @param propName the name to interface with from outside, must be different from decorated property
       * @param  event event name
       * @param options options
       * @return PropertyDecorator
       */
      function ModelSync(propName, event, options) {
        if (options === void 0) {
          options = {};
        }
        return function (target, key) {
          applyMetadata(options, target, key);
          createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[propName] = options;
            componentOptions.model = {
              prop: propName,
              event: event || k
            };
            (componentOptions.computed || (componentOptions.computed = {}))[k] = {
              get: function () {
                return this[propName];
              },
              set: function (value) {
                // @ts-ignore
                this.$emit(event, value);
              }
            };
          })(target, key);
        };
      }
      ;// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/Prop.js


      /**
       * decorator of a prop
       * @param  options the options for the prop
       * @return PropertyDecorator | void
       */
      function Prop(options) {
        if (options === void 0) {
          options = {};
        }
        return function (target, key) {
          metadata_applyMetadata(options, target, key);
          vue_class_component_esm_createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
          })(target, key);
        };
      }
      ;// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/PropSync.js


      /**
       * decorator of a synced prop
       * @param propName the name to interface with from outside, must be different from decorated property
       * @param options the options for the synced prop
       * @return PropertyDecorator | void
       */
      function PropSync(propName, options) {
        if (options === void 0) {
          options = {};
        }
        return function (target, key) {
          applyMetadata(options, target, key);
          createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[propName] = options;
            (componentOptions.computed || (componentOptions.computed = {}))[k] = {
              get: function () {
                return this[propName];
              },
              set: function (value) {
                this.$emit("update:" + propName, value);
              }
            };
          })(target, key);
        };
      }
      ;// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/Ref.js

      /**
       * decorator of a ref prop
       * @param refKey the ref key defined in template
       */
      function Ref(refKey) {
        return vue_class_component_esm_createDecorator(function (options, key) {
          options.computed = options.computed || {};
          options.computed[key] = {
            cache: false,
            get: function () {
              return this.$refs[refKey || key];
            }
          };
        });
      }
      ;// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/VModel.js

      /**
       * decorator for capturings v-model binding to component
       * @param options the options for the prop
       */
      function VModel(options) {
        if (options === void 0) {
          options = {};
        }
        var valueKey = 'value';
        return vue_class_component_esm_createDecorator(function (componentOptions, key) {
          ;
          (componentOptions.props || (componentOptions.props = {}))[valueKey] = options;
          (componentOptions.computed || (componentOptions.computed = {}))[key] = {
            get: function () {
              return this[valueKey];
            },
            set: function (value) {
              this.$emit('input', value);
            }
          };
        });
      }
      ;// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/Watch.js


      /**
       * decorator of a watch function
       * @param  path the path or the expression to observe
       * @param  WatchOption
       * @return MethodDecorator
       */
      function Watch(path, options) {
        if (options === void 0) {
          options = {};
        }
        var _a = options.deep,
          deep = _a === void 0 ? false : _a,
          _b = options.immediate,
          immediate = _b === void 0 ? false : _b;
        return vue_class_component_esm_createDecorator(function (componentOptions, handler) {
          if (typeof componentOptions.watch !== 'object') {
            componentOptions.watch = Object.create(null);
          }
          var watch = componentOptions.watch;
          if (typeof watch[path] === 'object' && !Array.isArray(watch[path])) {
            watch[path] = [watch[path]];
          } else if (typeof watch[path] === 'undefined') {
            watch[path] = [];
          }
          watch[path].push({
            handler: handler,
            deep: deep,
            immediate: immediate
          });
        });
      }
      ;// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/index.js
      /** vue-property-decorator verson 9.1.2 MIT LICENSE copyright 2020 kaorun343 */
/// <reference types='reflect-metadata'/>















      ;// CONCATENATED MODULE: ./src/mixins/component.ts

      var _class;
      var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };


      let RirComponent = (_class = class RirComponent extends (external_commonjs_vue_commonjs2_vue_root_Vue_default()) {}, _defineProperty(_class, "install", void 0), _class);
      RirComponent = __decorate([vue_class_component_esm], RirComponent);
      /* harmony default export */ var component = (RirComponent);
      ;// CONCATENATED MODULE: ./src/components/RIcon/RIcon.ts

      var RIcon_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };


      let RIcon = class RIcon extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "sizeIcon", null);
          _defineProperty(this, "icon", void 0);
          _defineProperty(this, "fill", void 0);
          _defineProperty(this, "size", void 0);
        }
        mounted() {
          this.$nextTick(() => {
            this.getSize();
          });
        }
        // @TODO продумать как иконка будет меться в рамках стилей по брекпоинтам
        updated() {
          this.$nextTick(() => {
            this.getSize();
          });
        }
        sizeChange() {
          this.getSize();
        }
        widthChange() {
          this.getSize();
        }
        getSize() {
          const style = getComputedStyle(this.$el);
          this.sizeIcon = `${this.size || parseInt(style.fontSize, 10)}`;
        }
        render(h) {
          if (!this.sizeIcon) {
            this.sizeIcon = `${this.size}`;
          }
          const style = {
            color: this.fill && `var(--rir-${this.fill})`
          };
          return h('i', {
            style,
            staticClass: 'RIcon',
            class: [`rir-${this.icon}_${this.sizeIcon}`]
          });
        }
      };
      RIcon_decorate([Prop({
        type: String,
        required: true
      })], RIcon.prototype, "icon", void 0);
      RIcon_decorate([Prop({
        type: String,
        default: null
      })], RIcon.prototype, "fill", void 0);
      RIcon_decorate([Prop({
        type: [String, Number],
        default: null
      })], RIcon.prototype, "size", void 0);
      RIcon_decorate([Watch('size')], RIcon.prototype, "sizeChange", null);
      RIcon_decorate([Watch('$rir.breakpoints.width')], RIcon.prototype, "widthChange", null);
      RIcon = RIcon_decorate([vue_class_component_esm], RIcon);
      /* harmony default export */ var RIcon_RIcon = (RIcon);
      ;// CONCATENATED MODULE: ./src/components/RIcon/index.ts


      RIcon_RIcon.install = vue => {
        vue.component('r-icon', RIcon_RIcon);
      };
      /* harmony default export */ var components_RIcon = (RIcon_RIcon);
      ;// CONCATENATED MODULE: ./src/components/RSpinner/RSpinner.ts

      var RSpinner_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };


      let RSpinner = class RSpinner extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "polygonView", []);
          _defineProperty(this, "size", void 0);
          _defineProperty(this, "color", void 0);
          _defineProperty(this, "spinnerBlock", void 0);
        }
        genPolygonView() {
          const blocSize = parseInt(getComputedStyle(this.spinnerBlock).getPropertyValue('width'), 10);
          const lineSize = parseInt(getComputedStyle(this.spinnerBlock).getPropertyValue('--line-size'), 10);
          const precision = 100;
          const radius = (blocSize - lineSize * 2) / blocSize * 100 / 2;
          this.polygonView = [...Array(precision)].map((_, i) => {
            const a = -i / (precision - 1) * Math.PI * 2;
            const x = Math.cos(a) * radius + 50;
            const y = Math.sin(a) * radius + 50;
            return `${x}% ${y}%`;
          });
        }
        mounted() {
          this.genPolygonView();
        }
        render(h) {
          return h('div', {
            style: {
              clipPath: `polygon(100% 50%, 100% 100%, 0 100%, 0 0, 100% 0, 100% 50%, ${this.polygonView.join(',')})`
            },
            ref: 'spinner-block',
            class: ['RSpinner', this.color, this.size]
          });
        }
      };
      RSpinner_decorate([Prop({
        type: String,
        validator: val => ['synallis', 'diomis', 'nelida', 'phonia', 'melaenia'].includes(val),
        default: 'nelida'
      })], RSpinner.prototype, "size", void 0);
      RSpinner_decorate([Prop({
        type: String,
        validator: val => ['rocky', 'white'].includes(val),
        default: 'rocky'
      })], RSpinner.prototype, "color", void 0);
      RSpinner_decorate([Ref('spinner-block')], RSpinner.prototype, "spinnerBlock", void 0);
      RSpinner = RSpinner_decorate([vue_class_component_esm], RSpinner);
      /* harmony default export */ var RSpinner_RSpinner = (RSpinner);
      ;// CONCATENATED MODULE: ./src/components/RSpinner/index.ts


      RSpinner_RSpinner.install = vue => {
        vue.component('r-spinner', RSpinner_RSpinner);
      };
      /* harmony default export */ var components_RSpinner = (RSpinner_RSpinner);
      ;// CONCATENATED MODULE: ./src/components/RButton/RButton.ts

      var RButton_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };




      let RButton = class RButton extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "icon", void 0);
          _defineProperty(this, "typeButton", void 0);
          _defineProperty(this, "disabled", void 0);
          _defineProperty(this, "isLoading", void 0);
          _defineProperty(this, "size", void 0);
          _defineProperty(this, "width", void 0);
          _defineProperty(this, "type", void 0);
          _defineProperty(this, "color", void 0);
          _defineProperty(this, "title", void 0);
          _defineProperty(this, "rounded", void 0);
        }
        get classes() {
          return ['RButton', this.size, this.colorData, this.width, {
            loading: this.isLoading,
            rounded: this.rounded
          }];
        }
        // @TODO: CSS VAR COLOR SPINNER
        get colorSpinner() {
          switch (this.type) {
            case 'primary':
              return 'white';
            case 'secondary':
              return 'rocky';
            default:
              return 'white';
          }
        }
        get genLoading() {
          if (!this.isLoading) return null;
          const data = {
            props: {
              color: this.colorSpinner
            }
          };
          return this.$createElement(components_RSpinner, data);
        }
        get genIcon() {
          if (!this.icon) return null;
          const data = {
            props: {
              icon: this.icon
            },
            class: ['RButton__icon']
          };
          return this.$createElement(components_RIcon, data);
        }
        get eventsBtn() {
          return {
            ...this.$listeners
          };
        }
        get colorData() {
          if (this.type === 'secondary') {
            return 'secondary';
          }
          return `primary ${String(this.color)}`;
        }
        render(h) {
          return h('button', {
            domProps: {
              disabled: this.disabled,
              type: this.typeButton
            },
            class: this.classes,
            on: this.eventsBtn
          }, [h('div', {
            class: ['RButton__content']
          }, [this.genIcon, h('div', {
            class: 'RButton__title'
          }, this.title)]), this.genLoading]);
        }
      };
      RButton_decorate([Prop({
        type: String,
        default: null
      })], RButton.prototype, "icon", void 0);
      RButton_decorate([Prop({
        type: String,
        default: 'button'
      })], RButton.prototype, "typeButton", void 0);
      RButton_decorate([Prop({
        type: Boolean,
        default: false
      })], RButton.prototype, "disabled", void 0);
      RButton_decorate([Prop({
        type: Boolean,
        default: false
      })], RButton.prototype, "isLoading", void 0);
      RButton_decorate([Prop({
        type: String,
        default: 'helike',
        validator: val => ['laripha', 'helike', 'polyxo'].includes(val)
      })], RButton.prototype, "size", void 0);
      RButton_decorate([Prop({
        type: String,
        default: 'content',
        validator: val => ['content', 'wide'].includes(val)
      })], RButton.prototype, "width", void 0);
      RButton_decorate([Prop({
        type: String,
        default: 'primary',
        validator: val => ['primary', 'secondary'].includes(val)
      })], RButton.prototype, "type", void 0);
      RButton_decorate([Prop({
        type: String,
        default: 'rocky',
        validator: val => ['rocky', 'matrix', 'lebowski', 'fargo', 'gentlemen', 'metropolis', 'fightclub', 'aquaman', 'goodfellas'].includes(val)
      })], RButton.prototype, "color", void 0);
      RButton_decorate([Prop({
        type: String,
        required: true
      })], RButton.prototype, "title", void 0);
      RButton_decorate([Prop({
        type: Boolean
      })], RButton.prototype, "rounded", void 0);
      RButton = RButton_decorate([vue_class_component_esm({
        components: {
          RIcon: components_RIcon,
          RSpinner: components_RSpinner
        }
      })], RButton);
      /* harmony default export */ var RButton_RButton = (RButton);
      ;// CONCATENATED MODULE: ./src/components/RButton/index.ts


      RButton_RButton.install = vue => {
        vue.component('r-button', RButton_RButton);
      };
      /* harmony default export */ var components_RButton = (RButton_RButton);
      ;// CONCATENATED MODULE: ./src/components/RButtonSimple/RButtonSimple.ts

      var RButtonSimple_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };



      let RButtonSimple = class RButtonSimple extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "size", void 0);
          _defineProperty(this, "type", void 0);
          _defineProperty(this, "color", void 0);
          _defineProperty(this, "rounded", void 0);
          _defineProperty(this, "disabled", void 0);
          _defineProperty(this, "icon", void 0);
        }
        get genClass() {
          return [this.size, this.type, ['transparent', 'primary'].includes(this.type) && this.color, {
            rounding: this.rounded
          }];
        }
        // @TODO перенести размер иконки в стили
        get getIconProp() {
          let size = '16';
          if (this.size === 'larishae') {
            size = '20';
          }
          return {
            icon: this.icon,
            size
          };
        }
        click(e) {
          this.$emit('click', e);
        }
        render(h) {
          return h('button', {
            domProps: {
              disabled: this.disabled
            },
            staticClass: 'RButtonSimple',
            class: this.genClass,
            on: {
              click: this.click
            }
          }, [h(components_RIcon, {
            props: this.getIconProp
          })]);
        }
      };
      RButtonSimple_decorate([Prop({
        type: String,
        default: 'monithei',
        validator: val => ['larishae', 'monithei', 'spelino'].includes(val)
      })], RButtonSimple.prototype, "size", void 0);
      RButtonSimple_decorate([Prop({
        type: String,
        default: 'primary',
        validator: val => ['primary', 'secondary', 'light', 'transparent'].includes(val)
      })], RButtonSimple.prototype, "type", void 0);
      RButtonSimple_decorate([Prop({
        type: String,
        default: 'rocky',
        validator: val => ['harakiri', 'rocky', 'matrix', 'lebowski', 'fargo', 'gentlemen', 'metropolis', 'fightclub', 'aquaman', 'goodfellas'].includes(val)
      })], RButtonSimple.prototype, "color", void 0);
      RButtonSimple_decorate([Prop({
        type: Boolean
      })], RButtonSimple.prototype, "rounded", void 0);
      RButtonSimple_decorate([Prop({
        type: Boolean
      })], RButtonSimple.prototype, "disabled", void 0);
      RButtonSimple_decorate([Prop({
        type: String,
        required: true
      })], RButtonSimple.prototype, "icon", void 0);
      RButtonSimple = RButtonSimple_decorate([vue_class_component_esm({
        components: {
          RIcon: components_RIcon
        }
      })], RButtonSimple);
      /* harmony default export */ var RButtonSimple_RButtonSimple = (RButtonSimple);
      ;// CONCATENATED MODULE: ./src/components/RButtonSimple/index.ts


      RButtonSimple_RButtonSimple.install = vue => {
        vue.component('r-button-simple', RButtonSimple_RButtonSimple);
      };
      /* harmony default export */ var components_RButtonSimple = (RButtonSimple_RButtonSimple);
      ;// CONCATENATED MODULE: ./src/components/RRow/RRow.ts

      var RRow_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };


      let RRow = class RRow extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "type", void 0);
          _defineProperty(this, "wrap", void 0);
          _defineProperty(this, "snap", void 0);
          _defineProperty(this, "gapHidden", void 0);
        }
        get gridType() {
          return this.type || this.$rir.grids.name;
        }
        mounted() {
          if (!this.wrap) {
            this.$el.scrollLeft = 0;
          }
        }
        render(h) {
          return h('div', {
            staticClass: 'RRow',
            class: [this.gridType, {
              gapHidden: this.gapHidden,
              wrap: this.wrap,
              snap: this.snap
            }]
          }, this.$slots.default);
        }
      };
      RRow_decorate([Prop({
        type: String
      })], RRow.prototype, "type", void 0);
      RRow_decorate([Prop({
        type: Boolean,
        default: true
      })], RRow.prototype, "wrap", void 0);
      RRow_decorate([Prop({
        type: Boolean
      })], RRow.prototype, "snap", void 0);
      RRow_decorate([Prop({
        type: Boolean
      })], RRow.prototype, "gapHidden", void 0);
      RRow = RRow_decorate([vue_class_component_esm], RRow);
      /* harmony default export */ var RRow_RRow = (RRow);
      ;// CONCATENATED MODULE: ./src/components/RRow/index.ts


      RRow_RRow.install = vue => {
        vue.component('r-row', RRow_RRow);
      };
      /* harmony default export */ var components_RRow = (RRow_RRow);
      ;// CONCATENATED MODULE: ./src/components/RCol/RCol.ts


      var RCol_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };


      let RCol = class RCol extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "cols", void 0);
          _defineProperty(this, "offset", void 0);
          _defineProperty(this, "isWidthContent", void 0);
          _defineProperty(this, "isFullWidth", void 0);
        }
        classesCol() {
          if (this.isWidthContent || this.isFullWidth) {
            return [];
          }
          return ['widest', 'wide', 'middle', 'narrow'].reduce((acc, breakpoint) => {
            acc.push(`cols-${breakpoint}-${this.cols[breakpoint]}`);
            if (this.offset[breakpoint]) {
              acc.push(`offset-${breakpoint}-${this.offset[breakpoint]}`);
            }
            return acc;
          }, []);
        }
        colParamsStyle() {
          if (this.isFullWidth) {
            return {
              flex: '1 1 0%',
              width: '0%'
            };
          }
          return {
            flexGrow: 0
          };
        }
        render(h) {
          return h('div', {
            staticClass: 'RCol',
            class: this.classesCol(),
            style: this.colParamsStyle()
          }, this.$slots.default);
        }
      };
      RCol_decorate([Prop({
        type: Object,
        default: () => ({
          widest: 1,
          wide: 1,
          middle: 1,
          narrow: 1
        })
      })], RCol.prototype, "cols", void 0);
      RCol_decorate([Prop({
        type: Object,
        default: () => ({
          widest: 0,
          wide: 0,
          middle: 0,
          narrow: 0
        })
      })], RCol.prototype, "offset", void 0);
      RCol_decorate([Prop({
        type: Boolean
      })], RCol.prototype, "isWidthContent", void 0);
      RCol_decorate([Prop({
        type: Boolean
      })], RCol.prototype, "isFullWidth", void 0);
      RCol = RCol_decorate([vue_class_component_esm], RCol);
      /* harmony default export */ var RCol_RCol = (RCol);
      ;// CONCATENATED MODULE: ./src/components/RCol/index.ts

      RCol_RCol.install = vue => {
        vue.component('r-col', RCol_RCol);
      };
      /* harmony default export */ var components_RCol = (RCol_RCol);
      ;// CONCATENATED MODULE: ./src/components/RImage/RImage.ts

      var RImage_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };


      let RImage = class RImage extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "blob", void 0);
          _defineProperty(this, "isLoad", true);
          _defineProperty(this, "url", void 0);
          _defineProperty(this, "ratio", void 0);
          _defineProperty(this, "rounded", void 0);
          _defineProperty(this, "isLoading", void 0);
          _defineProperty(this, "isFill", void 0);
        }
        onUrlChange() {
          this.loadImage();
        }
        mounted() {
          if (this.url) this.loadImage();
        }
        loadImage() {
          this.isLoad = true;
          fetch(this.url, {
            method: 'GET'
          }).then(response => response.blob()).then(blob => {
            this.blob = URL.createObjectURL(blob);
          }).finally(() => {
            this.isLoad = false;
          });
        }
        get backgroundData() {
          if (!this.isLoadingState) {
            return {
              backgroundImage: `url(${this.blob})`,
              backgroundSize: this.isFill ? 'contain' : 'cover'
            };
          }
          return {};
        }
        get isLoadingState() {
          return this.isLoad || this.isLoading;
        }
        render(h) {
          return h('div', {
            staticClass: 'RImage',
            class: [this.rounded, this.ratio, {
              loading: this.isLoadingState
            }]
          }, [h('div', {
            staticClass: 'RImage__image',
            class: [this.rounded, this.ratio],
            style: {
              ...this.backgroundData
            }
          })]);
        }
      };
      RImage_decorate([Prop({
        type: String,
        default: null
      })], RImage.prototype, "url", void 0);
      RImage_decorate([Prop({
        type: String,
        default: 'kano',
        validator: val => ['kemto', 'odro', 'rada', 'tako', 'kano', 'tira'].includes(val)
      })], RImage.prototype, "ratio", void 0);
      RImage_decorate([Prop({
        type: String,
        default: 'kurza',
        validator: val => ['jade', 'akbu', 'rajol', 'theku', 'bana', 'sylilis', 'kurza', 'eluno', 'geban', 'nemea'].includes(val)
      })], RImage.prototype, "rounded", void 0);
      RImage_decorate([Prop({
        type: Boolean
      })], RImage.prototype, "isLoading", void 0);
      RImage_decorate([Prop({
        type: Boolean
      })], RImage.prototype, "isFill", void 0);
      RImage_decorate([Watch('url')], RImage.prototype, "onUrlChange", null);
      RImage = RImage_decorate([vue_class_component_esm], RImage);
      /* harmony default export */ var RImage_RImage = (RImage);
      ;// CONCATENATED MODULE: ./src/components/RImage/index.ts


      RImage_RImage.install = vue => {
        vue.component('r-image', RImage_RImage);
      };
      /* harmony default export */ var components_RImage = (RImage_RImage);
      ;// CONCATENATED MODULE: ./src/components/RInput/RInput.ts

      var RInput_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };



      let RInput = class RInput extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "isFocusInput", false);
          _defineProperty(this, "val", void 0);
          _defineProperty(this, "type", void 0);
          _defineProperty(this, "label", void 0);
          _defineProperty(this, "typeInput", void 0);
          _defineProperty(this, "autocompleteInput", void 0);
          _defineProperty(this, "readonly", void 0);
          _defineProperty(this, "isClear", void 0);
          _defineProperty(this, "beforeIcon", void 0);
          _defineProperty(this, "afterIcon", void 0);
          _defineProperty(this, "error", void 0);
          _defineProperty(this, "errorMessage", void 0);
          _defineProperty(this, "rounded", void 0);
          _defineProperty(this, "size", void 0);
          _defineProperty(this, "focusLabel", void 0);
          _defineProperty(this, "isClearModelString", void 0);
          _defineProperty(this, "isTabIndex", void 0);
          _defineProperty(this, "input", void 0);
        }
        get inputEvents() {
          return {
            ...this.$listeners,
            input: event => {
              this.$emit('input', this.returnValue(event), event);
            }
          };
        }
        get isVal() {
          return this.val !== null && this.val !== '';
        }
        get isModel() {
          return this.isVal || this.isFocusInput;
        }
        get labelView() {
          if (!this.label) {
            return null;
          }
          return this.$createElement('label', {
            staticClass: 'RInput__label',
            class: [{
              active: this.isModel
            }]
          }, this.label);
        }
        get afterIconView() {
          if (!this.afterIcon) {
            return null;
          }
          let isEvent = false;
          if (!!this.afterIcon && !!this.$listeners.eventAfterIcon) {
            isEvent = true;
          }
          return this.$createElement('a', {
            staticClass: 'RInput__after',
            on: {
              click: event => {
                event.stopPropagation();
                this.$emit('eventAfterIcon');
              }
            },
            class: {
              events: isEvent
            }
          }, [this.$createElement(components_RIcon, {
            props: {
              icon: this.afterIcon,
              size: 16
            }
          })]);
        }
        get clearView() {
          if (!this.isClear) {
            return null;
          }
          return this.$createElement('a', {
            staticClass: 'RInput__clear',
            on: {
              click: event => {
                event.stopPropagation();
                this.$emit('input', null);
                this.$emit('clearModel');
              }
            },
            class: ['events'],
            style: {
              visibility: this.isVal ? 'visible' : 'hidden'
            }
          }, [this.$createElement(components_RIcon, {
            props: {
              icon: 'close',
              size: 8
            }
          })]);
        }
        get beforeIconView() {
          if (!this.beforeIcon) {
            return null;
          }
          return this.$createElement('a', {
            staticClass: 'RInput__before',
            class: {
              events: !!this.$listeners.eventBeforeIcon
            },
            on: {
              click: event => {
                event.stopPropagation();
                this.$emit('eventBeforeIcon');
              }
            }
          }, [this.$createElement(components_RIcon, {
            props: {
              icon: this.beforeIcon
            }
          })]);
        }
        get isLabel() {
          return !!this.label;
        }
        get errorText() {
          if (!this.error) {
            return null;
          }
          return this.$createElement('span', {
            staticClass: 'RInput__error'
          }, this.errorMessage);
        }
        focusInput(isFocus) {
          if (this.readonly) return;
          this.isFocusInput = true;
          this.input.focus();
          if (isFocus) {
            this.$emit('focus');
          }
        }
        returnValue(event) {
          const val = event.target.value || null;
          if (this.typeInput === 'number' && val !== null) {
            return parseFloat(val);
          }
          return !this.isClearModelString ? val : val || '';
        }
        mounted() {
          this.$nextTick(() => {
            if (this.focusLabel) {
              this.focusInput(false);
            }
          });
        }
        get attrsInput() {
          const attrs = {};
          if (this.isTabIndex && !this.readonly) {
            attrs.tabIndex = 0;
          }
          return attrs;
        }
        render(h) {
          return h('label', {
            staticClass: 'RInput',
            class: [this.type, this.size, {
              readonly: this.readonly,
              active: this.isModel,
              error: this.error,
              rounded: this.rounded
            }],
            on: {
              click: () => this.focusInput(false)
            }
          }, [h('div', {
            staticClass: 'RInput__body',
            class: [{
              'is-label': this.isLabel
            }]
          }, [h('label', {
            staticClass: 'RInput__input',
            attrs: this.attrsInput,
            on: {
              focus: () => {
                this.input.focus();
              }
            }
          }, [h('input', {
            domProps: {
              value: this.val,
              autocomplete: this.autocompleteInput
            },
            attrs: {
              type: this.typeInput,
              disabled: this.readonly
            },
            ref: 'rInput',
            on: {
              ...this.inputEvents,
              animationstart: event => {
                this.$nextTick(() => {
                  this.isFocusInput = event.animationName !== 'keyframes-onAutoFillCancel';
                });
              },
              focus: () => {
                this.focusInput(true);
              },
              blur: () => {
                this.isFocusInput = false;
                this.$emit('blur');
              }
            }
          }), this.labelView])]), this.clearView, this.afterIconView, this.beforeIconView, this.errorText]);
        }
      };
      RInput_decorate([VModel({
        type: [String, Number],
        default: null
      })], RInput.prototype, "val", void 0);
      RInput_decorate([Prop({
        type: String,
        validator: prop => ['default', 'map'].includes(prop),
        default: 'default'
      })], RInput.prototype, "type", void 0);
      RInput_decorate([Prop({
        type: String,
        default: null
      })], RInput.prototype, "label", void 0);
      RInput_decorate([Prop({
        type: String,
        validator: prop => ['text', 'password', 'number'].includes(prop),
        default: 'text'
      })], RInput.prototype, "typeInput", void 0);
      RInput_decorate([Prop({
        type: String,
        default: 'new-password'
      })], RInput.prototype, "autocompleteInput", void 0);
      RInput_decorate([Prop({
        type: Boolean
      })], RInput.prototype, "readonly", void 0);
      RInput_decorate([Prop({
        type: Boolean,
        default: true
      })], RInput.prototype, "isClear", void 0);
      RInput_decorate([Prop({
        type: String,
        default: null
      })], RInput.prototype, "beforeIcon", void 0);
      RInput_decorate([Prop({
        type: String,
        default: null
      })], RInput.prototype, "afterIcon", void 0);
      RInput_decorate([Prop({
        type: Boolean
      })], RInput.prototype, "error", void 0);
      RInput_decorate([Prop({
        type: String,
        default: null
      })], RInput.prototype, "errorMessage", void 0);
      RInput_decorate([Prop({
        type: Boolean
      })], RInput.prototype, "rounded", void 0);
      RInput_decorate([Prop({
        type: String,
        default: 'eluno'
      })], RInput.prototype, "size", void 0);
      RInput_decorate([Prop({
        type: Boolean
      })], RInput.prototype, "focusLabel", void 0);
      RInput_decorate([Prop({
        type: Boolean
      })], RInput.prototype, "isClearModelString", void 0);
      RInput_decorate([Prop({
        type: Boolean,
        default: true
      })], RInput.prototype, "isTabIndex", void 0);
      RInput_decorate([Ref('rInput')], RInput.prototype, "input", void 0);
      RInput = RInput_decorate([vue_class_component_esm({
        components: {
          RIcon: components_RIcon
        }
      })], RInput);
      /* harmony default export */ var RInput_RInput = (RInput);
      ;// CONCATENATED MODULE: ./src/components/RInput/index.ts


      RInput_RInput.install = vue => {
        vue.component('r-input', RInput_RInput);
      };
      /* harmony default export */ var components_RInput = (RInput_RInput);
      ;// CONCATENATED MODULE: ./src/components/RTextarea/RTextarea.ts

      var RTextarea_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };


      let RTextarea = class RTextarea extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "val", void 0);
          _defineProperty(this, "label", void 0);
          _defineProperty(this, "rows", void 0);
          _defineProperty(this, "maxRows", void 0);
          _defineProperty(this, "readonly", void 0);
          _defineProperty(this, "error", void 0);
          _defineProperty(this, "errorMessage", void 0);
          _defineProperty(this, "textarea", void 0);
        }
        get isModel() {
          return !!this.val;
        }
        autoSize() {
          this.$nextTick(() => {
            const tx = this.textarea;
            const minHeight = this.rows * 20;
            const maxHeight = (this.maxRows || this.rows) * 20;
            tx.style.overflowY = 'hidden';
            if (!this.val) {
              tx.style.height = `${minHeight}px`;
            } else {
              if (maxHeight <= tx.scrollHeight) {
                tx.style.overflowY = 'auto';
              }
              tx.style.height = `${maxHeight < tx.scrollHeight ? maxHeight : tx.scrollHeight}px`;
            }
          });
        }
        OnInput(event) {
          this.$emit('input', event.target.value);
          this.autoSize();
        }
        focusInput() {
          if (this.readonly) return;
          this.textarea.focus();
        }
        get errorText() {
          if (!this.error) {
            return null;
          }
          return this.$createElement('span', {
            staticClass: 'RTextarea__error'
          }, this.errorMessage);
        }
        get attrsInput() {
          const attrs = {
            readonly: this.readonly,
            rows: this.rows,
            tabIndex: !this.readonly ? 0 : -1
          };
          return attrs;
        }
        render(h) {
          return h('section', {
            staticClass: 'RTextarea',
            class: [{
              readonly: this.readonly,
              active: this.isModel,
              error: this.error
            }],
            on: {
              click: this.focusInput
            }
          }, [h('textarea', {
            domProps: {
              value: this.val
            },
            attrs: this.attrsInput,
            on: {
              ...this.$listeners,
              input: this.OnInput
            },
            staticClass: 'RTextarea__textarea',
            ref: 'rTextarea'
          }), h('label', {
            staticClass: 'RTextarea__label'
          }, this.label), this.errorText]);
        }
      };
      RTextarea_decorate([VModel({
        type: String,
        default: null
      })], RTextarea.prototype, "val", void 0);
      RTextarea_decorate([Prop({
        type: String
      })], RTextarea.prototype, "label", void 0);
      RTextarea_decorate([Prop({
        type: Number,
        default: 3
      })], RTextarea.prototype, "rows", void 0);
      RTextarea_decorate([Prop({
        type: Number
      })], RTextarea.prototype, "maxRows", void 0);
      RTextarea_decorate([Prop({
        type: Boolean
      })], RTextarea.prototype, "readonly", void 0);
      RTextarea_decorate([Prop({
        type: Boolean
      })], RTextarea.prototype, "error", void 0);
      RTextarea_decorate([Prop({
        type: String,
        default: null
      })], RTextarea.prototype, "errorMessage", void 0);
      RTextarea_decorate([Ref('rTextarea')], RTextarea.prototype, "textarea", void 0);
      RTextarea = RTextarea_decorate([vue_class_component_esm], RTextarea);
      /* harmony default export */ var RTextarea_RTextarea = (RTextarea);
      ;// CONCATENATED MODULE: ./src/components/RTextarea/index.ts


      RTextarea_RTextarea.install = vue => {
        vue.component('r-textarea', RTextarea_RTextarea);
      };
      /* harmony default export */ var components_RTextarea = (RTextarea_RTextarea);
      ;// CONCATENATED MODULE: ./src/util/library/index.ts
      const getPositionActivator = (activator, block) => {
        const element = activator.firstElementChild || activator;
        const relativePos = {
          x: 0,
          y: 0,
          height: 0,
          width: 0,
          right: 0,
          left: 0,
          bottom: 0,
          top: 0,
          toJSON: () => {}
        };
        if (element) {
          const parentPos = block.getBoundingClientRect();
          const childPos = element.getBoundingClientRect();
          relativePos.width = childPos.width;
          relativePos.height = childPos.height;
          relativePos.top = childPos.top - parentPos.top;
          relativePos.y = childPos.top - parentPos.top;
          relativePos.right = childPos.right - parentPos.right;
          relativePos.bottom = childPos.bottom - parentPos.bottom;
          relativePos.left = childPos.left - parentPos.left;
          relativePos.x = childPos.left - parentPos.left;
          return relativePos;
        }
        console.warn('Неопределен HTMLElement внутри слота активатора');
        return relativePos;
      };
      const setPositionContent = (activator, content, position, fixed = false, offset = 0, block = document.body, alignTitle, arrow) => {
        const pos = position.split('-');
        const scrollY = fixed ? 0 : block.scrollTop;
        // const scrollX = fixed ? 0 : block.scrollLeft;
        const innerWidth = block.tagName === 'BODY' ? window.innerWidth + window.scrollX : block.clientWidth;
        const innerHeight = block.tagName === 'BODY' ? window.innerHeight + window.scrollY : block.clientHeight;
        let top;
        switch (pos[0]) {
          case 'top':
            top = activator.y + scrollY - content.height - offset;
            if (activator.y - content.height < 0) {
              top -= activator.y - content.height - 16;
            }
            break;
          case 'bottom':
            top = activator.y + scrollY + activator.height + offset;
            if (innerHeight < top - scrollY + content.height - 20) {
              top -= top + content.height - innerHeight - scrollY + 20;
            }
            break;
          // pos = center
          default:
            top = activator.y + scrollY + activator.height / 2 - content.height / 2;
            break;
        }
        let left;
        switch (pos[1]) {
          case 'left':
            left = activator.x - content.width - offset;
            break;
          case 'right':
            left = activator.x + activator.width + offset;
            break;
          // pos = center
          default:
            left = activator.x - (content.width - activator.width) / 2;
            break;
        }
        if (innerHeight < top - scrollY + content.height) {
          top -= top + content.height - innerHeight - scrollY + 20;
        }
        // обработка позиции стрелки
        let right = null;
        if (arrow) {
          left = left + content.width / 2;
          if (alignTitle === 'start') {
            if (innerWidth - 17 < left + content.width) {
              const offsetLeft = left + content.width - innerWidth + 20 + parseInt(window.getComputedStyle(arrow).borderLeftWidth, 10);
              arrow.style.left = `${offsetLeft - parseInt(window.getComputedStyle(arrow).borderLeftWidth, 10)}px`;
              left -= offsetLeft;
            } else {
              left -= 12 + parseInt(window.getComputedStyle(arrow).borderLeftWidth, 10);
            }
          } else {
            // console.log(left - content.width)
            if (left - content.width < 0) {
              arrow.style.right += `${parseInt(window.getComputedStyle(arrow).right, 10) + (left - content.width + 12 + parseInt(window.getComputedStyle(arrow).borderLeftWidth)) * -1}px`;
            } else {
              right = `calc(100% - ${left + 12 + parseInt(window.getComputedStyle(arrow).borderLeftWidth, 10)}px)`;
            }
            left = null;
          }
        } else {
          if (innerWidth - 17 < left + content.width) {
            left -= left + content.width - innerWidth + 20;
          } else if (left < 0) {
            left = 8;
          }
        }
        return {
          top: `${top}px`,
          left: left ? `${left}px` : null,
          right: right
        };
      };
      const setPositionContentPopover = (activator, content, position, fixed = false, block = document.body) => {
        const scrollY = fixed ? 0 : block.scrollTop;
        const scrollX = fixed ? 0 : block.scrollLeft;
        const innerWidth = block.tagName === 'BODY' ? window.innerWidth + window.scrollX : block.clientWidth;
        const innerHeight = block.tagName === 'BODY' ? window.innerHeight + window.scrollY : block.clientHeight;
        // console.log(block.scrollHeight, window.innerHeight, window.scrollY);
        const pos = position.split('-');
        let left = 0;
        let right = 0;
        let top = 0;
        let bottom = 0;
        switch (pos[0]) {
          case 'left':
            left = activator.x;
            break;
          case 'right':
            left = activator.x + activator.width - content.width;
            break;
          case 'top':
            top = activator.y + scrollY - 4;
            break;
          case 'bottom':
            bottom = innerHeight - (activator.y + activator.height + 4) - scrollY;
            break;
          // pos = center
          default:
            left = activator.x - (content.width - activator.width) / 2;
            break;
        }
        switch (pos[1]) {
          case 'top':
            top = activator.y + scrollY - content.height - 8;
            break;
          case 'bottom':
            top = activator.y + scrollY + activator.height + 8;
            break;
          case 'left':
            right = activator.x - 8;
            break;
          case 'right':
            left = activator.x + scrollX + activator.width + 8;
            break;
          // pos = center
          default:
            top = activator.y + scrollY + activator.height / 2 - content.height / 2;
            break;
        }
        if (innerHeight < top - scrollY + content.height) {
          top -= top + content.height - innerHeight - scrollY + 20;
        }
        if (innerWidth < left + content.width) {
          left -= left + content.width - innerWidth + 20;
        } else if (left < 0) {
          left = 8;
        }
        if (innerWidth < right) {
          right -= right - 17;
        } else if (right < 0) {
          right = 8;
        }
        return {
          top: top ? `${top}px` : 'none',
          bottom: bottom ? `${bottom}px` : 'none',
          left: left ? `${left}px` : 'none',
          right: right ? `calc(100% - ${right}px)` : 'none'
        };
      };
      function debounce(func, wait, immediate = false) {
        let timeout;
        return function executedFunction() {
          // @ts-ignore
          const _this = this;
          const args = arguments;
          function later() {
            timeout = null;
            if (!immediate) {
              // @ts-ignore
              func.apply(_this, args);
            }
          }
          const callNow = immediate && !timeout;
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
          if (callNow) {
            // @ts-ignore
            func.apply(_this, args);
          }
        };
      }
      function uniqueID() {
        function chr4() {
          return Math.random().toString(16).slice(-4);
        }
        return `${chr4() + chr4()}-${chr4()}-${chr4()}-${chr4()}-${chr4()}${chr4()}${chr4()}`;
      }

      ;// CONCATENATED MODULE: ./src/directives/ClickOutside.ts
// @TODO описать интерфейсы
      const HANDLERS_PROPERTY = '__v-click-outside';
      const HAS_WINDOWS = typeof window !== 'undefined';
      const HAS_NAVIGATOR = typeof navigator !== 'undefined';
      const IS_TOUCH = HAS_WINDOWS && ('ontouchstart' in window
        // @ts-ignore
        || HAS_NAVIGATOR && navigator.msMaxTouchPoints > 0);
      const EVENTS = IS_TOUCH ? ['touchstart'] : ['click'];
      function processDirectiveArguments(bindingValue) {
        const isFunction = typeof bindingValue === 'function';
        if (!isFunction && typeof bindingValue !== 'object') {
          throw new Error('v-click-outside: Binding value must be a function or an object');
        }
        return {
          handler: isFunction ? bindingValue : bindingValue.handler,
          middleware: bindingValue.middleware || (item => item),
          events: bindingValue.events || EVENTS,
          isActive: !bindingValue.isActive,
          detectIframe: !bindingValue.detectIframe,
          capture: !!bindingValue.capture
        };
      }
      function execHandler({
                             event,
                             handler,
                             middleware
                           }) {
        if (middleware(event)) {
          handler(event);
        }
      }
      function onFauxIframeClick({
                                   el,
                                   event,
                                   handler,
                                   middleware
                                 }) {
        setTimeout(() => {
          const {
            activeElement
          } = document;
          if (activeElement && activeElement.tagName === 'IFRAME' && !el.contains(activeElement)) {
            execHandler({
              event,
              handler,
              middleware
            });
          }
        }, 0);
      }
      function onEvent({
                         el,
                         event,
                         handler,
                         middleware
                       }) {
        // Note: composedPath is not supported on IE and Edge, more information here:
        //       https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath
        //       In the meanwhile, we are using el.contains for those browsers, not
        //       the ideal solution, but using IE or EDGE is not ideal either.
        const path = event.path || event.composedPath && event.composedPath();
        const isClickOutside = path ? path.indexOf(el) < 0 : !el.contains(event.target);
        if (!isClickOutside) {
          return;
        }
        execHandler({
          event,
          handler,
          middleware
        });
      }
      function bind(el, {
        value
      }) {
        const {
          events,
          handler,
          middleware,
          isActive,
          detectIframe,
          capture
        } = processDirectiveArguments(value);
        if (!isActive) {
          return;
        }
        el[HANDLERS_PROPERTY] = events.map(eventName => ({
          event: eventName,
          srcTarget: document.documentElement,
          handler: event => onEvent({
            el,
            event,
            handler,
            middleware
          }),
          capture
        }));
        if (detectIframe) {
          const detectIframeEvent = {
            event: 'blur',
            srcTarget: window,
            handler: event => onFauxIframeClick({
              el,
              event,
              handler,
              middleware
            }),
            capture
          };
          el[HANDLERS_PROPERTY] = [...el[HANDLERS_PROPERTY], detectIframeEvent];
        }
        el[HANDLERS_PROPERTY].forEach(({
                                         event,
                                         srcTarget,
                                         handler
                                       }) => setTimeout(() => {
          // Note: More info about this implementation can be found here:
          //       https://github.com/ndelvalle/v-click-outside/issues/137
          if (!el[HANDLERS_PROPERTY]) {
            return;
          }
          srcTarget.addEventListener(event, handler, capture);
        }, 0));
      }
      function unbind(el) {
        const handlers = el[HANDLERS_PROPERTY] || [];
        handlers.forEach(({
                            event,
                            srcTarget,
                            handler,
                            capture
                          }) => srcTarget.removeEventListener(event, handler, capture));
        delete el[HANDLERS_PROPERTY];
      }
      function update(el, {
        value,
        oldValue
      }) {
        if (JSON.stringify(value) === JSON.stringify(oldValue)) {
          return;
        }
        unbind(el);
        bind(el, {
          value
        });
      }
      const directive = {
        bind,
        update,
        unbind
      };
      /* harmony default export */ var ClickOutside = (HAS_WINDOWS ? directive : {});
      ;// CONCATENATED MODULE: ./src/components/RPopover/RPopover.ts

      var RPopover_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };




      let RPopover = class RPopover extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "uid", void 0);
          _defineProperty(this, "isContent", false);
          _defineProperty(this, "styleContent", {});
          _defineProperty(this, "val", void 0);
          _defineProperty(this, "disabled", void 0);
          _defineProperty(this, "fixed", void 0);
          _defineProperty(this, "clickClose", void 0);
          _defineProperty(this, "isClickOutside", void 0);
          _defineProperty(this, "isCheckAutoScrollBlock", void 0);
          _defineProperty(this, "contentWidthActivator", void 0);
          _defineProperty(this, "contentClass", void 0);
          _defineProperty(this, "contentCoefficientWidth", void 0);
          _defineProperty(this, "position", void 0);
          _defineProperty(this, "content", void 0);
          _defineProperty(this, "activator", void 0);
        }
        onModelChanged(val) {
          if (this.disabled) return;
          this.isContent = val;
          if (val) {
            const activatorElement = '$el' in this.activator ? this.activator.$el : this.activator;
            let contentScroll;
            if (this.isCheckAutoScrollBlock) {
              contentScroll = this.getScrollParent(activatorElement);
            }
            this.$nextTick(() => {
              if (activatorElement && this.content) {
                this.getPosition(activatorElement, contentScroll);
              }
            });
          }
        }
        slotScopedView() {
          if (!this.$scopedSlots.activator) return null;
          return this.$scopedSlots.activator({
            on: {
              click: this.changeContent
            }
          });
        }
        viewContent() {
          const activator = this.$el.getBoundingClientRect();
          let contentCoefficientWidth = 1;
          if (['wide', 'widest'].includes(this.$rir.breakpoints.name)) {
            contentCoefficientWidth = this.contentCoefficientWidth;
          }
          return this.$createElement('div', {
            ref: 'content',
            domProps: {
              id: `content-${this.uid}`
            },
            directives: [{
              name: 'click-outside',
              value: this.clickOutside
            }],
            staticClass: 'RPopover__content',
            class: [this.position, this.contentClass],
            style: {
              ...this.styleContent,
              width: this.contentWidthActivator ? `${activator.width * contentCoefficientWidth}px` : 'max-content'
            },
            on: {
              click: () => {
                if (this.clickClose) {
                  this.isContent = false;
                  this.$emit('input', this.isContent);
                  this.$emit('close');
                }
              }
            }
          }, [this.$slots.content]);
        }
        changeContent(val) {
          if (this.disabled) return;
          const activatorElement = '$el' in this.activator ? this.activator.$el : this.activator;
          let contentScroll;
          if (this.isCheckAutoScrollBlock) {
            contentScroll = this.getScrollParent(activatorElement);
          }
          this.isContent = typeof val === 'boolean' ? val : !this.isContent;
          this.$emit('input', this.isContent);
          if (this.val === null) {
            this.$nextTick(() => {
              if (activatorElement && this.content) {
                this.getPosition(activatorElement, contentScroll);
              }
            });
          }
        }
        getPosition(activator, contentScroll) {
          const content = '$el' in this.content ? this.content.$el : this.content;
          const contentData = content.getBoundingClientRect();
          const contentParentPopover = activator.closest('.RPopover__content') || activator.closest('.RModal__content') || contentScroll || document.body;
          contentParentPopover.insertBefore(content, contentParentPopover.firstChild);
          this.$nextTick(() => {
            const activatorData = getPositionActivator(activator, contentParentPopover);
            const styles = setPositionContentPopover(activatorData, contentData, this.position, this.fixed, contentParentPopover);
            this.styleContent = {
              ...styles,
              position: this.fixed ? 'fixed' : 'absolute'
            };
          });
        }
        // @ts-ignore
        getScrollParent(node) {
          if (node === null) {
            return null;
          }
          if (node.scrollHeight > node.clientHeight) {
            return node;
          }
          return this.getScrollParent(node.parentElement);
        }
        clickOutside(e) {
          if (!this.isClickOutside) return;
          const path = e.path || e.composedPath && e.composedPath();
          // path.length > 4 - определенное правило для отработки кликов на MacOS
          if (path.length > 4 && path.indexOf(this.activator) < 0) {
            this.isContent = false;
            this.$emit('input', this.isContent);
            this.$emit('close');
          }
        }
        destroyed() {
          document?.getElementById(`content-${this.uid}`)?.remove();
        }
        mounted() {
          this.uid = uniqueID();
        }
        render(h) {
          return h('section', {
            staticClass: 'RPopover'
          }, [h('div', {
            ref: 'activator',
            staticClass: 'RPopover__activator',
            class: {
              disabled: this.disabled
            },
            domProps: {
              id: `activator-${this.uid}`
            }
          }, [this.slotScopedView()]), this.isContent && this.viewContent()]);
        }
      };
      RPopover_decorate([VModel({
        type: Boolean,
        default: null
      })], RPopover.prototype, "val", void 0);
      RPopover_decorate([Prop({
        type: Boolean
      })], RPopover.prototype, "disabled", void 0);
      RPopover_decorate([Prop({
        type: Boolean
      })], RPopover.prototype, "fixed", void 0);
      RPopover_decorate([Prop({
        type: Boolean
      })], RPopover.prototype, "clickClose", void 0);
      RPopover_decorate([Prop({
        type: Boolean,
        default: true
      })], RPopover.prototype, "isClickOutside", void 0);
      RPopover_decorate([Prop({
        type: Boolean
      })], RPopover.prototype, "isCheckAutoScrollBlock", void 0);
      RPopover_decorate([Prop({
        type: Boolean
      })], RPopover.prototype, "contentWidthActivator", void 0);
      RPopover_decorate([Prop({
        type: String,
        default: ''
      })], RPopover.prototype, "contentClass", void 0);
      RPopover_decorate([Prop({
        type: Number,
        default: 1
      })], RPopover.prototype, "contentCoefficientWidth", void 0);
      RPopover_decorate([Prop({
        type: String,
        default: 'center-bottom',
        validator: val => ['center-bottom', 'center-top', 'left-bottom', 'left-top', 'right-bottom', 'right-top', 'bottom-left', 'bottom-right', 'top-left', 'top-right'].includes(val)
      })], RPopover.prototype, "position", void 0);
      RPopover_decorate([Ref('content')], RPopover.prototype, "content", void 0);
      RPopover_decorate([Ref('activator')], RPopover.prototype, "activator", void 0);
      RPopover_decorate([Watch('val')], RPopover.prototype, "onModelChanged", null);
      RPopover = RPopover_decorate([vue_class_component_esm({
        directives: {
          ClickOutside: ClickOutside
        }
      })], RPopover);
      /* harmony default export */ var RPopover_RPopover = (RPopover);
      ;// CONCATENATED MODULE: ./src/components/RPopover/index.ts


      RPopover_RPopover.install = vue => {
        vue.component('r-popover', RPopover_RPopover);
      };
      /* harmony default export */ var components_RPopover = (RPopover_RPopover);
      ;// CONCATENATED MODULE: ./src/components/RAnnouncement/RAnnouncement.ts


      var RAnnouncement_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };



      let RAnnouncement = class RAnnouncement extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "disabled", void 0);
          _defineProperty(this, "isLoading", void 0);
          _defineProperty(this, "image", void 0);
          _defineProperty(this, "title", void 0);
          _defineProperty(this, "subTitle", void 0);
          _defineProperty(this, "href", void 0);
          _defineProperty(this, "to", void 0);
          _defineProperty(this, "size", void 0);
        }
        get titleView() {
          return [this.$createElement('span', {
            staticClass: 'RAnnouncement__title',
            class: [{
              loading: this.isLoading
            }]
          }, !this.isLoading ? this.title : null), (this.isLoading || this.subTitle) && this.$createElement('span', {
            staticClass: 'RAnnouncement__sub-title',
            class: [{
              loading: this.isLoading
            }]
          }, !this.isLoading ? this.subTitle : null)];
        }
        get isLink() {
          return !!this.href || !!this.to;
        }
        render(h) {
          return h(this.isLink ? 'a' : 'section', {
            staticClass: 'RAnnouncement',
            class: [this.size, {
              disabled: this.disabled,
              link: this.isLink,
              loading: this.isLoading
            }],
            on: {
              click: async () => {
                this.$emit('click');
                if (!!this.to && !!this.$router) {
                  await this.$router.push(this.to);
                } else if (this.href) {
                  window.open(this.href, '_blank');
                }
              }
            }
          }, [h('section', {
            staticClass: 'RAnnouncement__image'
          }, [h(components_RImage, {
            props: {
              isLoading: this.isLoading,
              url: this.image
            }
          }), this.$slots.imageContent && h('section', {
            staticClass: 'RAnnouncement__image-content'
          }, this.$slots.imageContent)]), ...this.titleView]);
        }
      };
      RAnnouncement_decorate([Prop({
        type: Boolean
      })], RAnnouncement.prototype, "disabled", void 0);
      RAnnouncement_decorate([Prop({
        type: Boolean
      })], RAnnouncement.prototype, "isLoading", void 0);
      RAnnouncement_decorate([Prop({
        type: String,
        required: true
      })], RAnnouncement.prototype, "image", void 0);
      RAnnouncement_decorate([Prop({
        type: String,
        required: true
      })], RAnnouncement.prototype, "title", void 0);
      RAnnouncement_decorate([Prop({
        type: String,
        default: null
      })], RAnnouncement.prototype, "subTitle", void 0);
      RAnnouncement_decorate([Prop({
        type: String,
        default: null
      })], RAnnouncement.prototype, "href", void 0);
      RAnnouncement_decorate([Prop({
        type: String,
        default: null
      })], RAnnouncement.prototype, "to", void 0);
      RAnnouncement_decorate([Prop({
        type: String,
        default: 'polydora',
        validator: val => ['polydora', 'rhaenise'].includes(val)
      })], RAnnouncement.prototype, "size", void 0);
      RAnnouncement = RAnnouncement_decorate([vue_class_component_esm], RAnnouncement);
      /* harmony default export */ var RAnnouncement_RAnnouncement = (RAnnouncement);
      ;// CONCATENATED MODULE: ./src/components/RAnnouncement/index.ts


      RAnnouncement_RAnnouncement.install = vue => {
        vue.component('r-announcement', RAnnouncement_RAnnouncement);
      };
      /* harmony default export */ var components_RAnnouncement = (RAnnouncement_RAnnouncement);
      ;// CONCATENATED MODULE: ./src/mixins/checked.ts


      var checked_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };


      let RirChecked = class RirChecked extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "value", void 0);
          _defineProperty(this, "val", void 0);
          _defineProperty(this, "returnObject", void 0);
          _defineProperty(this, "idValue", void 0);
        }
        get isMulti() {
          return Array.isArray(this.value);
        }
        get isChecked() {
          let isChecked;
          if (this.value !== null) {
            if (typeof this.value === 'boolean') {
              isChecked = this.value;
            } else if (Array.isArray(this.value) && !!this.value.length) {
              let val;
              if (this.returnObject) {
                val = this.val;
              } else {
                val = typeof this.val === 'object' ? this.val[this.idValue] : this.val;
              }
              isChecked = this.value.some(el => {
                if (this.returnObject && el !== null) {
                  return el[this.idValue] === val[this.idValue];
                }
                return el === val;
              });
            } else if (this.returnObject) {
              isChecked = !!this.value && this.value[this.idValue] === this.val[this.idValue];
            } else {
              isChecked = (typeof this.val === 'object' ? this.val[this.idValue] : this.val) === this.value;
            }
          } else {
            isChecked = (typeof this.val === 'object' && this.val[this.idValue]) === this.value;
          }
          return isChecked;
        }
        emitModel() {
          let {
            value
          } = this;
          if (!this.checkTypesModel(value)) {
            return;
          }
          if (typeof value === 'boolean') {
            // Если модель булевое
            value = !this.value;
          } else if (Array.isArray(value)) {
            // Если модель массив
            let val;
            const values = [...value];
            if (this.returnObject) {
              val = this.val;
            } else {
              val = typeof this.val === 'object' ? this.val[this.idValue] : this.val;
            }
            const indexVal = values.findIndex(el => {
              if (this.returnObject && el !== null) {
                return el[this.idValue] === val[this.idValue];
              }
              return (typeof el === 'object' ? el[this.idValue] : el) === val;
            });
            if (indexVal !== -1) {
              values.splice(indexVal, 1);
            } else {
              // @ts-ignore
              values.push(val);
            }
            this.$emit('input', values);
            return;
          } else if (this.returnObject) {
            // Если возвращаем объект, проверяем на совпадение объета
            value = !!this.value && this.value[this.idValue] === this.val[this.idValue] ? null : this.val;
          } else if (this.val !== value) {
            // В любой другом случае возвращает значение val, если строка или id объекта
            value = typeof this.val === 'object' ? this.val[this.idValue] : this.val;
          } else {
            value = null;
          }
          this.$emit('input', value);
        }
        checkTypesModel(value) {
          const {
            options
          } = this.$vnode.componentOptions?.Ctor;
          const typesModel = options.props.value.type.map(el => el.name.toLowerCase());
          if (Array.isArray(value)) {
            return typesModel.includes('array');
          }
          return typesModel.includes(typeof value);
        }
      };
      checked_decorate([Prop({
        type: [Boolean, Object, Array, String, Number],
        default: null
      })], RirChecked.prototype, "value", void 0);
      checked_decorate([Prop({
        type: [Boolean, Object, String, Number],
        default: false
      })], RirChecked.prototype, "val", void 0);
      checked_decorate([Prop({
        type: Boolean,
        default: false
      })], RirChecked.prototype, "returnObject", void 0);
      checked_decorate([Prop({
        type: String,
        default: 'id'
      })], RirChecked.prototype, "idValue", void 0);
      RirChecked = checked_decorate([vue_class_component_esm], RirChecked);
      /* harmony default export */ var checked = (RirChecked);
      ;// CONCATENATED MODULE: ./src/components/RCheckbox/RCheckbox.ts

      var RCheckbox_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };




      let RCheckbox = class RCheckbox extends checked {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "uid", void 0);
          _defineProperty(this, "disabled", void 0);
          _defineProperty(this, "isPartial", void 0);
          _defineProperty(this, "error", void 0);
          _defineProperty(this, "isTabIndex", void 0);
          _defineProperty(this, "errorMessage", void 0);
          _defineProperty(this, "title", void 0);
          _defineProperty(this, "subTitle", void 0);
        }
        get eventsListener() {
          return {
            input: this.emitModel
          };
        }
        get subTitleView() {
          if (!this.subTitle) return null;
          return this.$createElement('div', {
            staticClass: 'RCheckbox__sub-title',
            class: {
              error: this.error
            }
          }, this.error ? this.errorMessage || this.subTitle : this.subTitle);
        }
        mounted() {
          this.uid = uniqueID();
        }
        get attrsInput() {
          const attrs = {
            for: this.uid
          };
          if (this.isTabIndex && !this.disabled) {
            attrs.tabIndex = 0;
          }
          return attrs;
        }
        render(h) {
          return h('label', {
            attrs: this.attrsInput,
            staticClass: 'RCheckbox',
            class: [{
              disabled: this.disabled
            }],
            on: {
              keydown: event => {
                if (event.code === 'Space') {
                  event.preventDefault();
                  this.emitModel();
                }
              }
            }
          }, [h('input', {
            domProps: {
              checked: this.isChecked
            },
            attrs: {
              disabled: this.disabled,
              id: this.uid,
              type: 'checkbox',
              tabIndex: -1
            },
            on: this.eventsListener
          }), h('span', {
            class: ['RCheckbox__input', {
              partial: this.isPartial
            }]
          }, [this.isChecked && h(components_RIcon, {
            props: {
              icon: 'bullit-ok',
              size: '12',
              fill: 'white'
            },
            staticClass: 'RCheckbox__selected'
          }), this.isPartial && !this.isChecked && h(components_RIcon, {
            props: {
              icon: 'partial',
              size: '12',
              fill: 'white'
            },
            staticClass: 'RCheckbox__selected'
          })]), (!!this.$slots.title || !!this.title) && h('div', {
            staticClass: 'RCheckbox__content'
          }, [h('div', {
            staticClass: 'RCheckbox__title',
            class: {
              error: !this.subTitle && this.error
            }
          }, this.$slots.title || this.title), this.subTitleView])]);
        }
      };
      RCheckbox_decorate([Prop({
        type: [Array, Boolean],
        default: false
      })], RCheckbox.prototype, "value", void 0);
      RCheckbox_decorate([Prop({
        type: Boolean,
        default: false
      })], RCheckbox.prototype, "disabled", void 0);
      RCheckbox_decorate([Prop({
        type: Boolean,
        default: false
      })], RCheckbox.prototype, "isPartial", void 0);
      RCheckbox_decorate([Prop({
        type: Boolean,
        default: false
      })], RCheckbox.prototype, "error", void 0);
      RCheckbox_decorate([Prop({
        type: Boolean,
        default: true
      })], RCheckbox.prototype, "isTabIndex", void 0);
      RCheckbox_decorate([Prop({
        type: String,
        default: null
      })], RCheckbox.prototype, "errorMessage", void 0);
      RCheckbox_decorate([Prop({
        type: String,
        default: null
      })], RCheckbox.prototype, "title", void 0);
      RCheckbox_decorate([Prop({
        type: String,
        default: null
      })], RCheckbox.prototype, "subTitle", void 0);
      RCheckbox = RCheckbox_decorate([vue_class_component_esm({
        components: {
          RIcon: components_RIcon
        }
      })], RCheckbox);
      /* harmony default export */ var RCheckbox_RCheckbox = (RCheckbox);
      ;// CONCATENATED MODULE: ./src/components/RCheckbox/index.ts


      RCheckbox_RCheckbox.install = vue => {
        vue.component('r-checkbox', RCheckbox_RCheckbox);
      };
      /* harmony default export */ var components_RCheckbox = (RCheckbox_RCheckbox);
      ;// CONCATENATED MODULE: ./src/components/RListItem/RListItem.ts

      var RListItem_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };




      let RListItem = class RListItem extends checked {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "title", void 0);
          _defineProperty(this, "subTitle", void 0);
          _defineProperty(this, "icon", void 0);
          _defineProperty(this, "iconFill", void 0);
          _defineProperty(this, "disabled", void 0);
          _defineProperty(this, "group", void 0);
          _defineProperty(this, "checkbox", void 0);
        }
        get viewIconOrCheckbox() {
          if (!this.icon && !this.isMulti) return null;
          const data = {
            staticClass: 'RListItem__icon',
            class: [{
              'not-sub-title': !this.subTitle
            }]
          };
          if (this.isMulti) {
            return this.$createElement(components_RCheckbox, {
              ...data,
              ref: 'rCheckbox',
              props: {
                returnObject: this.returnObject,
                val: this.val,
                value: this.value,
                idValue: this.idValue,
                isTabIndex: false
              }
            });
          }
          return this.$createElement(components_RIcon, {
            ...data,
            props: {
              icon: this.icon,
              fill: this.iconFill
            }
          });
        }
        toggleHover() {
          this.checkbox.$el.classList.toggle('hover');
        }
        get attrsInput() {
          const attrs = {};
          if (!this.disabled) {
            attrs.tabIndex = 0;
          }
          return attrs;
        }
        render(h) {
          let events = {};
          if (this.isMulti) {
            events = {
              mouseover: this.toggleHover,
              mouseout: this.toggleHover
            };
          }
          return h('section', {
            staticClass: 'RListItem',
            class: [{
              disabled: this.disabled,
              active: this.isChecked
            }],
            attrs: this.attrsInput,
            on: {
              click: () => {
                this.emitModel();
                this.$emit('click', this.value);
              },
              keydown: event => {
                if (event.code === 'Space') {
                  event.preventDefault();
                  this.emitModel();
                  this.$emit('click', this.value);
                }
              },
              ...events
            }
          }, [this.viewIconOrCheckbox, h('section', {
            staticClass: 'RListItem__content'
          }, [h('span', {
            domProps: {
              innerHTML: this.title
            },
            staticClass: 'RListItem__title'
          }), !!this.subTitle && h('span', {
            staticClass: 'RListItem__sub-title'
          }, `${this.subTitle}`)])]);
        }
      };
      RListItem_decorate([Prop({
        type: [Object, Array, String, Number]
      })], RListItem.prototype, "value", void 0);
      RListItem_decorate([Prop({
        type: [String, Number],
        required: true
      })], RListItem.prototype, "title", void 0);
      RListItem_decorate([Prop({
        type: [String, Number],
        default: null
      })], RListItem.prototype, "subTitle", void 0);
      RListItem_decorate([Prop({
        type: String,
        default: null
      })], RListItem.prototype, "icon", void 0);
      RListItem_decorate([Prop({
        type: String,
        default: 'harakiri',
        validator: val => ['harakiri', 'rocky', 'matrix', 'lebowski', 'fargo', 'gentlemen', 'fightclub', 'aquaman', 'goodfellas'].includes(val)
      })], RListItem.prototype, "iconFill", void 0);
      RListItem_decorate([Prop({
        type: Boolean,
        default: null
      })], RListItem.prototype, "disabled", void 0);
      RListItem_decorate([Prop({
        type: String,
        default: null
      })], RListItem.prototype, "group", void 0);
      RListItem_decorate([Ref('rCheckbox')], RListItem.prototype, "checkbox", void 0);
      RListItem = RListItem_decorate([vue_class_component_esm({
        components: {
          RIcon: components_RIcon,
          RCheckbox: components_RCheckbox
        }
      })], RListItem);
      /* harmony default export */ var RListItem_RListItem = (RListItem);
      ;// CONCATENATED MODULE: ./src/components/RListItem/index.ts


      RListItem_RListItem.install = vue => {
        vue.component('r-list-item', RListItem_RListItem);
      };
      /* harmony default export */ var components_RListItem = (RListItem_RListItem);
      ;// CONCATENATED MODULE: ./src/components/RListGroup/RListGroup.ts


      var RListGroup_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };


      let RListGroup = class RListGroup extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "groups", void 0);
        }
        render(h) {
          if (this.groups && this.groups.length) {
            const groups = [...this.groups, {
              name: 'Без группировки'
            }];
            let nodes = [];
            if (this.$slots.content) {
              nodes = [...this.$slots.content];
            }
            const content = groups.map(group => {
              const items = [];
              for (let i = 0; i < nodes.length; i++) {
                // @ts-ignore
                const groupElement = nodes[i].componentOptions?.propsData?.group;
                if (!group.id) {
                  items.push(nodes[i]);
                } else if (groupElement === group.id) {
                  items.push(nodes[i]);
                  nodes.splice(i, 1);
                  i -= 1;
                }
              }
              return items.length ? [this.$createElement('div', {
                staticClass: 'RListGroup__header'
              }, group.name), ...items] : null;
            });
            return h('section', {
              staticClass: 'RListGroup'
            }, content);
          }
          return h('section', {
            staticClass: 'RListGroup'
          }, [this.$slots.content]);
        }
      };
      RListGroup_decorate([Prop({
        type: Array
      })], RListGroup.prototype, "groups", void 0);
      RListGroup = RListGroup_decorate([vue_class_component_esm], RListGroup);
      /* harmony default export */ var RListGroup_RListGroup = (RListGroup);
      ;// CONCATENATED MODULE: ./src/components/RListGroup/index.ts


      RListGroup_RListGroup.install = vue => {
        vue.component('r-list-group', RListGroup_RListGroup);
      };
      /* harmony default export */ var components_RListGroup = (RListGroup_RListGroup);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-exception.stack.js
      var web_dom_exception_stack = __webpack_require__(2801);
      ;// CONCATENATED MODULE: ./src/util/library/tabsLogic.ts
// eslint-disable-next-line consistent-return
      function tabChangeElementSelect(event, content, focusContent) {
        if (event.relatedTarget) {
          // @ts-ignore
          if (!content.contains(event.relatedTarget)) {
            const tabbables = document.querySelectorAll('[tabindex]');
            for (let index = 0; index < tabbables.length; index++) {
              if (tabbables[index] === focusContent) {
                if (index + 1 <= tabbables.length) {
                  tabbables[index + 1].focus();
                  return true;
                }
                break;
              }
            }
          }
        }
      }
      function findPopoverFocus(uid) {
        if (uid) {
          setTimeout(() => {
            const content = document.getElementById(`content-${uid}`);
            if (content) {
              const tabIndex = content.querySelectorAll('[tabindex]');
              if (tabIndex.length > 0) {
                tabIndex[0].focus();
              }
            }
          }, 0);
        }
      }
      ;// CONCATENATED MODULE: ./src/components/RSelect/RSelect.ts



      var RSelect_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };









      let RSelect = class RSelect extends checked {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "abortController", new AbortController());
          _defineProperty(this, "isOpen", false);
          _defineProperty(this, "isFocusOut", false);
          _defineProperty(this, "isLoadData", false);
          _defineProperty(this, "isLoadDataScroll", false);
          _defineProperty(this, "query", null);
          _defineProperty(this, "localList", []);
          _defineProperty(this, "items", void 0);
          _defineProperty(this, "titleValue", void 0);
          _defineProperty(this, "subTitleValue", void 0);
          _defineProperty(this, "iconValue", void 0);
          _defineProperty(this, "icon", void 0);
          _defineProperty(this, "label", void 0);
          _defineProperty(this, "disabled", void 0);
          _defineProperty(this, "isSearch", void 0);
          _defineProperty(this, "popoverOptions", void 0);
          _defineProperty(this, "callSearch", void 0);
          _defineProperty(this, "callScroll", void 0);
          _defineProperty(this, "type", void 0);
          _defineProperty(this, "error", void 0);
          _defineProperty(this, "errorMessage", void 0);
          _defineProperty(this, "groupsList", void 0);
          _defineProperty(this, "inputContent", void 0);
          _defineProperty(this, "popoverContent", void 0);
        }
        isOpenChange(val) {
          if (val) {
            this.$nextTick(() => {
              const listElement = document.getElementById('select-list');
              if (listElement && this.callScroll && !this.groupsList.length) {
                listElement.addEventListener('scroll', this.checkScrollList);
              }
            });
          } else {
            // this.query = null;
            const listElement = document.getElementById('select-list');
            if (listElement && this.callScroll && !this.groupsList.length) {
              listElement.removeEventListener('scroll', this.checkScrollList);
            }
          }
        }
        itemsChange(val) {
          this.$set(this.$data, 'localList', val);
        }
        get input() {
          let value = [];
          if (this.value !== null) {
            if (this.isMulti && !this.returnObject) {
              // Если массив у нас объектный и нет флага возврата объекта.
              // То надо найти строки для input из items
              if (typeof this.localList[0] === 'object') {
                value = [];
                this.localList.forEach(el => {
                  const elem = el;
                  if (this.isMulti) {
                    // @ts-ignore
                    this.value.forEach(v => {
                      if (v === elem[this.idValue]) {
                        value.push(elem[this.titleValue]);
                      }
                    });
                  } else if (elem[this.idValue] === this.value) {
                    value.push(elem[this.titleValue]);
                  }
                });
              } else {
                value = this.value;
              }
            } else if (this.isMulti) {
              value = this.value
                // @ts-ignore
                .map(el => el[this.titleValue]);
            } else if (this.returnObject) {
              value.push(this.value[this.titleValue]);
            } else if (typeof this.localList[0] === 'object') {
              // @ts-ignore
              const item = this.localList.find(el => el[this.idValue] === this.value);
              item && value.push(item[this.titleValue]);
            } else {
              // @ts-ignore
              value.push(this.value);
            }
          } else {
            // @ts-ignore
            const item = this.localList.find(el => el[this.idValue] === this.value);
            item && value.push(item[this.titleValue]);
          }
          return value.join('; ');
        }
        get listView() {
          // if (this.itemsList.length && !this.isLoadData) {
          const children = this.itemsList.map(el => this.$createElement(components_RListItem, {
            slot: 'content',
            props: {
              // @ts-ignore
              ...el,
              isClick: true,
              value: this.value,
              returnObject: this.returnObject,
              idValue: this.idValue
            },
            on: {
              input: this.changeVal
            }
          }));
          const list = this.$createElement(components_RListGroup, {
            domProps: {
              id: 'select-list'
            },
            style: {
              display: this.itemsList.length && !this.isLoadData ? 'flex' : 'none'
            },
            staticClass: 'RSelect__list',
            props: {
              groups: this.groupsList
            }
          }, [children]);
          // }
          let load = null;
          if (this.isLoadData) {
            load = this.$createElement('div', {
              staticClass: 'RSelect__not-list'
            }, [this.$createElement(components_RSpinner, {
              props: {
                size: 'phonia'
              }
            })]);
          }
          const noData = this.$createElement('div', {
            staticClass: 'RSelect__not-list',
            style: {
              display: this.itemsList.length || this.isLoadData ? 'none' : 'flex'
            }
          }, 'Ничего не найдено');
          return [load, noData, list];
        }
        get itemsList() {
          let items;
          if (this.query && !this.callSearch) {
            items = this.localList
              // @ts-ignore
              .filter(el => el[this.titleValue].toLowerCase().includes(this.query.toLowerCase()));
          }
          items = (items || this.localList
            // @ts-ignore
          ).map(el => {
            let text;
            if (this.query && !this.isLoadData) {
              text = typeof el === 'object' ? el[this.titleValue] : el;
              if (text) {
                const reg = new RegExp(`(${this.query})`, 'ig');
                text = text.replace(reg, '<span class="RSelect__query">$1</span>');
              }
            }
            if (typeof el === 'object') {
              return {
                icon: el[this.iconValue] || null,
                title: text || el[this.titleValue] || null,
                subTitle: el[this.subTitleValue] || null,
                group: el.group || undefined,
                val: el
              };
            }
            return {
              title: text || el,
              val: el
            };
          });
          return items;
        }
        searchView() {
          if (!this.isSearch) {
            return null;
          }
          const deb = debounce(this.searchChange, 500);
          return this.$createElement('div', {
            staticClass: 'RSelect__search'
          }, [this.$createElement(components_RInput, {
            props: {
              value: this.query,
              label: 'Поиск',
              beforeIcon: 'search',
              focusLabel: true
            },
            on: {
              input: val => {
                this.query = val;
                // @ts-ignore
                deb(val);
              },
              clearModel: () => {
                this.query = null;
              }
            }
          })]);
        }
        async searchChange() {
          // @ts-ignore
          if (this.callSearch) {
            this.isLoadData = true;
            this.abortController.abort();
            this.abortController = new AbortController();
            const {
              signal
            } = this.abortController;
            try {
              const res = await this.somethingAsync({
                signal
              });
              // @TODO удалить возврат от промиса
              if (res) {
                this.$set(this.$data, 'localList', res);
                this.$emit('update:items', res);
              }
              this.isLoadData = false;
              // eslint-disable-next-line no-empty
            } catch {}
          }
        }
        // @ts-ignore
        somethingAsync({
                         signal
                       }) {
          if (signal?.aborted) {
            return Promise.reject(new DOMException('Aborted', 'AbortError'));
          }
          // eslint-disable-next-line no-async-promise-executor
          return new Promise(async (resolve, reject) => {
            const abortHandler = () => {
              reject(new DOMException('Aborted abortHandler', 'AbortError'));
            };
            signal?.addEventListener('abort', abortHandler);
            const res = await this.callSearch(this.query, {
              signal
            });
            resolve(res);
            signal?.removeEventListener('abort', abortHandler);
          });
        }
        changeVal(val) {
          if (!this.isMulti) {
            const input = this.popoverContent.$el.getElementsByClassName('RSelect__input');
            // @ts-ignore
            input[0].focus();
            this.isOpen = false;
          }
          this.$emit('input', val);
          this.$emit('change', val);
        }
        checkScrollList(event) {
          if (!this.isLoadDataScroll) {
            const element = event.target;
            if (element.scrollHeight - element.scrollTop === element.clientHeight) {
              this.isLoadDataScroll = true;
              this.callScroll(this.query).finally(() => {
                this.$nextTick(() => {
                  this.isLoadDataScroll = false;
                });
              });
            }
          }
        }
        get popoverOptionsSelect() {
          const {
            position = 'left-bottom',
            contentCoefficientWidth = 1,
            isCheckAutoScrollBlock = false
          } = this.popoverOptions;
          return {
            position,
            contentCoefficientWidth,
            isCheckAutoScrollBlock
          };
        }
        mounted() {
          this.$set(this.$data, 'localList', this.items);
        }
        toggleHover(event) {
          const isHover = this.inputContent.$el.classList.contains('hover');
          if (isHover && event.type === 'mouseleave') {
            this.inputContent.$el.classList.remove('hover');
          } else if (event.type === 'mouseenter') {
            this.inputContent.$el.classList.add('hover');
          }
        }
        get attrsInput() {
          const attrs = {};
          if (!this.disabled) {
            attrs.tabIndex = 0;
          }
          return attrs;
        }
        render(h) {
          return h(components_RPopover, {
            ref: 'popover',
            props: {
              value: this.isOpen,
              contentWidthActivator: true,
              contentClass: 'RSelect__content',
              ...this.popoverOptionsSelect
            },
            on: {
              input: val => {
                this.isOpen = val;
                if (!val) {
                  this.$emit('focusout');
                }
              }
            },
            scopedSlots: {
              activator: scoped => h('label', {
                staticClass: 'RSelect__input',
                attrs: this.attrsInput,
                class: {
                  disabled: this.disabled
                },
                on: {
                  click: () => {
                    scoped.on.click();
                  },
                  keydown: event => {
                    if (event.code === 'Space') {
                      scoped.on.click();
                      // @ts-ignore
                      const {
                        uid
                      } = this.popoverContent;
                      findPopoverFocus(uid);
                      // @ts-ignore
                      event.target.blur();
                    }
                  },
                  mouseenter: this.toggleHover,
                  mouseleave: this.toggleHover
                }
              }, [h('div', {
                class: ['RSelect__backdoor']
              }), h(components_RInput, {
                ref: 'RInput',
                class: {
                  isOpen: this.isOpen
                },
                props: {
                  beforeIcon: this.icon,
                  type: this.type,
                  label: this.label,
                  value: this.input,
                  readonly: true,
                  afterIcon: 'arrow-down',
                  error: this.error,
                  errorMessage: this.errorMessage,
                  isClear: false,
                  isTabIndex: false
                }
              })])
            }
          }, [h('template', {
            slot: 'content'
          }, [h('div', {
            on: {
              keydown: event => {
                if (event.code === 'Tab') {
                  this.isFocusOut = true;
                }
                if (event.code === 'Escape') {
                  this.isOpen = false;
                  const input = this.popoverContent.$el.getElementsByClassName('RSelect__input');
                  // @ts-ignore
                  input[0].focus();
                }
              },
              focusout: event => {
                if (this.isFocusOut) {
                  // @ts-ignore
                  const {
                    uid
                  } = this.popoverContent;
                  const content = document.getElementById(`content-${uid}`);
                  const input = this.popoverContent.$el.getElementsByClassName('RSelect__input');
                  // @ts-ignore
                  if (content && input.length > 0) {
                    const data = tabChangeElementSelect(event, content, input[0]);
                    if (data) {
                      this.isOpen = false;
                    }
                  }
                }
                this.isFocusOut = false;
              }
            }
          }, [this.$slots.header, this.searchView(), this.$scopedSlots?.body ? this.$scopedSlots.body({
            close: () => {
              this.isOpen = false;
            }
          }) : null, this.listView, this.isLoadDataScroll && this.$createElement('div', {
            slot: 'content',
            staticClass: 'RSelect__load-scroll'
          }, [this.$createElement(components_RSpinner, {
            props: {
              size: 'phonia'
            }
          })])])])]);
        }
      };
      RSelect_decorate([Prop({
        type: Array,
        default: () => []
      })], RSelect.prototype, "items", void 0);
      RSelect_decorate([Prop({
        type: String,
        default: 'title'
      })], RSelect.prototype, "titleValue", void 0);
      RSelect_decorate([Prop({
        type: String,
        default: 'subTitle'
      })], RSelect.prototype, "subTitleValue", void 0);
      RSelect_decorate([Prop({
        type: String,
        default: 'icon'
      })], RSelect.prototype, "iconValue", void 0);
      RSelect_decorate([Prop({
        type: String,
        default: null
      })], RSelect.prototype, "icon", void 0);
      RSelect_decorate([Prop({
        type: String
      })], RSelect.prototype, "label", void 0);
      RSelect_decorate([Prop({
        type: Boolean
      })], RSelect.prototype, "disabled", void 0);
      RSelect_decorate([Prop({
        type: Boolean
      })], RSelect.prototype, "isSearch", void 0);
      RSelect_decorate([Prop({
        type: Object,
        default: () => ({
          position: 'left-bottom',
          contentCoefficientWidth: 1,
          isCheckAutoScrollBlock: false
        })
      })], RSelect.prototype, "popoverOptions", void 0);
      RSelect_decorate([Prop({
        type: Function
      })], RSelect.prototype, "callSearch", void 0);
      RSelect_decorate([Prop({
        type: Function
      })], RSelect.prototype, "callScroll", void 0);
      RSelect_decorate([Prop({
        type: String,
        validator: prop => ['default', 'map'].includes(prop),
        default: 'default'
      })], RSelect.prototype, "type", void 0);
      RSelect_decorate([Prop({
        type: Boolean
      })], RSelect.prototype, "error", void 0);
      RSelect_decorate([Prop({
        type: String,
        default: null
      })], RSelect.prototype, "errorMessage", void 0);
      RSelect_decorate([Prop({
        type: Array,
        default: () => []
      })], RSelect.prototype, "groupsList", void 0);
      RSelect_decorate([Ref('RInput')], RSelect.prototype, "inputContent", void 0);
      RSelect_decorate([Ref('popover')], RSelect.prototype, "popoverContent", void 0);
      RSelect_decorate([Watch('isOpen')], RSelect.prototype, "isOpenChange", null);
      RSelect_decorate([Watch('items')], RSelect.prototype, "itemsChange", null);
      RSelect = RSelect_decorate([vue_class_component_esm], RSelect);
      /* harmony default export */ var RSelect_RSelect = (RSelect);
      ;// CONCATENATED MODULE: ./src/components/RSelect/index.ts


      RSelect_RSelect.install = vue => {
        vue.component('r-select', RSelect_RSelect);
      };
      /* harmony default export */ var components_RSelect = (RSelect_RSelect);
      ;// CONCATENATED MODULE: ./src/components/RRadioButton/RRadioButton.ts

      var RRadioButton_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };



      let RRadioButton = class RRadioButton extends checked {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "uid", void 0);
          _defineProperty(this, "error", void 0);
          _defineProperty(this, "errorMessage", void 0);
          _defineProperty(this, "disabled", void 0);
          _defineProperty(this, "title", void 0);
          _defineProperty(this, "subTitle", void 0);
        }
        get eventsListener() {
          return {
            input: this.emitModel
          };
        }
        get subTitleView() {
          if (!this.subTitle) return null;
          return this.$createElement('div', {
            staticClass: 'RSwitcher__sub-title',
            class: {
              error: this.error
            }
          }, this.error ? this.errorMessage || this.subTitle : this.subTitle);
        }
        mounted() {
          this.uid = uniqueID();
        }
        get attrsInput() {
          const attrs = {
            for: this.uid
          };
          if (!this.disabled) {
            attrs.tabIndex = 0;
          }
          return attrs;
        }
        render(h) {
          return h('label', {
            attrs: this.attrsInput,
            staticClass: 'RRadioButton',
            class: [{
              disabled: this.disabled
            }],
            on: {
              keydown: event => {
                if (event.code === 'Space') {
                  event.preventDefault();
                  this.emitModel();
                }
              }
            }
          }, [h('input', {
            domProps: {
              checked: this.isChecked
            },
            attrs: {
              'data-active': this.isChecked.toString(),
              id: this.uid,
              type: 'radio',
              disabled: this.disabled,
              tabIndex: -1
            },
            on: this.eventsListener
          }), h('span', {
            class: ['RRadioButton__input']
          }), !!this.title && h('div', {
            staticClass: 'RRadioButton__content'
          }, [h('div', {
            staticClass: 'RRadioButton__title',
            class: {
              error: !this.subTitle && this.error
            }
          }, this.title), this.subTitleView])]);
        }
      };
      RRadioButton_decorate([Prop({
        type: [Object, String, Number, Boolean],
        default: false
      })], RRadioButton.prototype, "value", void 0);
      RRadioButton_decorate([Prop({
        type: Boolean,
        default: false
      })], RRadioButton.prototype, "error", void 0);
      RRadioButton_decorate([Prop({
        type: String,
        default: null
      })], RRadioButton.prototype, "errorMessage", void 0);
      RRadioButton_decorate([Prop({
        type: Boolean,
        default: false
      })], RRadioButton.prototype, "disabled", void 0);
      RRadioButton_decorate([Prop({
        type: String,
        required: true
      })], RRadioButton.prototype, "title", void 0);
      RRadioButton_decorate([Prop({
        type: String,
        default: null
      })], RRadioButton.prototype, "subTitle", void 0);
      RRadioButton = RRadioButton_decorate([vue_class_component_esm], RRadioButton);
      /* harmony default export */ var RRadioButton_RRadioButton = (RRadioButton);
      ;// CONCATENATED MODULE: ./src/components/RRadioButton/index.ts


      RRadioButton_RRadioButton.install = vue => {
        vue.component('r-radio-button', RRadioButton_RRadioButton);
      };
      /* harmony default export */ var components_RRadioButton = (RRadioButton_RRadioButton);
      ;// CONCATENATED MODULE: ./src/components/RButtonNavigation/RButtonNavigation.ts


      var RButtonNavigation_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };



      let RButtonNavigation = class RButtonNavigation extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "title", void 0);
          _defineProperty(this, "size", void 0);
          _defineProperty(this, "color", void 0);
          _defineProperty(this, "href", void 0);
          _defineProperty(this, "to", void 0);
          _defineProperty(this, "active", void 0);
        }
        render(h) {
          return h('a', {
            staticClass: 'RButtonNavigation',
            class: [this.size, this.color, {
              active: this.active
            }],
            on: {
              click: async () => {
                if (!!this.to && !!this.$router) {
                  await this.$router.push(this.to);
                } else if (this.href) {
                  window.open(this.href, '_blank');
                }
                this.$emit('click');
              }
            }
          }, [h('span', {
            staticClass: 'RButtonNavigation__title'
          }, this.title), h(components_RIcon, {
            staticClass: 'RButtonNavigation__icon',
            props: {
              icon: 'arrow-bold-right'
            }
          })]);
        }
      };
      RButtonNavigation_decorate([Prop({
        type: String,
        required: true
      })], RButtonNavigation.prototype, "title", void 0);
      RButtonNavigation_decorate([Prop({
        type: String,
        default: 'gouda',
        validator: val => ['gouda', 'cheddar', 'camembert', 'ricotta', 'burrata', 'taleggio', 'calligenia'].includes(val)
      })], RButtonNavigation.prototype, "size", void 0);
      RButtonNavigation_decorate([Prop({
        type: String,
        default: 'harakiri',
        validator: val => ['harakiri', 'metropolis'].includes(val)
      })], RButtonNavigation.prototype, "color", void 0);
      RButtonNavigation_decorate([Prop({
        type: String,
        default: null
      })], RButtonNavigation.prototype, "href", void 0);
      RButtonNavigation_decorate([Prop({
        type: String,
        default: null
      })], RButtonNavigation.prototype, "to", void 0);
      RButtonNavigation_decorate([Prop({
        type: Boolean,
        default: true
      })], RButtonNavigation.prototype, "active", void 0);
      RButtonNavigation = RButtonNavigation_decorate([vue_class_component_esm({
        components: {
          RIcon: components_RIcon
        }
      })], RButtonNavigation);
      /* harmony default export */ var RButtonNavigation_RButtonNavigation = (RButtonNavigation);
      ;// CONCATENATED MODULE: ./src/components/RButtonNavigation/index.ts


      RButtonNavigation_RButtonNavigation.install = vue => {
        vue.component('r-button-navigation', RButtonNavigation_RButtonNavigation);
      };
      /* harmony default export */ var components_RButtonNavigation = (RButtonNavigation_RButtonNavigation);
      ;// CONCATENATED MODULE: ./src/components/RButtonTag/RButtonTag.ts

      var RButtonTag_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };


      let RButtonTag = class RButtonTag extends checked {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "color", void 0);
          _defineProperty(this, "title", void 0);
          _defineProperty(this, "disabled", void 0);
          _defineProperty(this, "nowrap", void 0);
          _defineProperty(this, "resetModel", void 0);
        }
        get viewBullite() {
          return this.$createElement('div', {
            staticClass: 'RButtonTag__bullit'
          });
        }
        get isResetModel() {
          return !this.isChecked || this.resetModel;
        }
        render(h) {
          return h('button', {
            staticClass: 'RButtonTag',
            class: [this.color, {
              active: this.isChecked,
              reset: this.isResetModel
            }],
            domProps: {
              disabled: this.disabled
            },
            on: {
              click: () => this.isResetModel && this.emitModel()
            }
          }, [this.viewBullite, h('span', {
            staticClass: 'RButtonTag__title',
            class: [{
              nowrap: this.nowrap
            }]
          }, this.title)]);
        }
      };
      RButtonTag_decorate([Prop({
        type: [Array, Boolean, String, Object, Number],
        default: false
      })], RButtonTag.prototype, "value", void 0);
      RButtonTag_decorate([Prop({
        type: String,
        default: 'rocky',
        validator: val => ['rocky', 'matrix', 'lebowski', 'fargo', 'gentlemen', 'metropolis', 'fightclub', 'aquaman', 'goodfellas'].includes(val)
      })], RButtonTag.prototype, "color", void 0);
      RButtonTag_decorate([Prop({
        type: String,
        required: true
      })], RButtonTag.prototype, "title", void 0);
      RButtonTag_decorate([Prop({
        type: Boolean
      })], RButtonTag.prototype, "disabled", void 0);
      RButtonTag_decorate([Prop({
        type: Boolean
      })], RButtonTag.prototype, "nowrap", void 0);
      RButtonTag_decorate([Prop({
        type: Boolean
      })], RButtonTag.prototype, "resetModel", void 0);
      RButtonTag = RButtonTag_decorate([vue_class_component_esm], RButtonTag);
      /* harmony default export */ var RButtonTag_RButtonTag = (RButtonTag);
      ;// CONCATENATED MODULE: ./src/components/RButtonTag/index.ts


      RButtonTag_RButtonTag.install = vue => {
        vue.component('r-button-tag', RButtonTag_RButtonTag);
      };
      /* harmony default export */ var components_RButtonTag = (RButtonTag_RButtonTag);
      ;// CONCATENATED MODULE: ./src/components/RFader/RFader.ts
      var RFader_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };


      let RFader = class RFader extends component {
        render(h) {
          return h('section', {
            staticClass: 'RFader',
            // @TODO с появлением новых теней, переделать в type
            class: ['default']
          });
        }
      };
      RFader = RFader_decorate([vue_class_component_esm], RFader);
      /* harmony default export */ var RFader_RFader = (RFader);
      ;// CONCATENATED MODULE: ./src/components/RFader/index.ts


      RFader_RFader.install = vue => {
        vue.component('r-fader', RFader_RFader);
      };
      /* harmony default export */ var components_RFader = (RFader_RFader);
      ;// CONCATENATED MODULE: ./src/components/RStory/RStory.ts


      var RStory_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };



      let RStory = class RStory extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "disabled", void 0);
          _defineProperty(this, "isLoading", void 0);
          _defineProperty(this, "image", void 0);
          _defineProperty(this, "title", void 0);
          _defineProperty(this, "href", void 0);
          _defineProperty(this, "to", void 0);
        }
        get isLink() {
          return !!this.href || !!this.to;
        }
        get titleView() {
          return this.$createElement('span', {
            staticClass: 'RStory__title'
          }, !this.isLoading ? this.title : null);
        }
        render(h) {
          return h(this.isLink ? 'a' : 'section', {
            staticClass: 'RStory',
            class: [{
              disabled: this.disabled,
              loading: this.isLoading
            }],
            on: {
              click: async () => {
                this.$emit('click');
                if (!!this.to && !!this.$router) {
                  await this.$router.push(this.to);
                } else if (this.href) {
                  window.open(this.href, '_blank');
                }
              }
            }
          }, [h('section', {
            staticClass: 'RStory__image'
          }, [h(components_RImage, {
            props: {
              isLoading: this.isLoading,
              ratio: 'rada',
              url: this.image
            }
          })]), this.titleView]);
        }
      };
      RStory_decorate([Prop({
        type: Boolean
      })], RStory.prototype, "disabled", void 0);
      RStory_decorate([Prop({
        type: Boolean
      })], RStory.prototype, "isLoading", void 0);
      RStory_decorate([Prop({
        type: String,
        required: true
      })], RStory.prototype, "image", void 0);
      RStory_decorate([Prop({
        type: String,
        required: true
      })], RStory.prototype, "title", void 0);
      RStory_decorate([Prop({
        type: String,
        default: null
      })], RStory.prototype, "href", void 0);
      RStory_decorate([Prop({
        type: String,
        default: null
      })], RStory.prototype, "to", void 0);
      RStory = RStory_decorate([vue_class_component_esm({
        components: {
          RImage: components_RImage
        }
      })], RStory);
      /* harmony default export */ var RStory_RStory = (RStory);
      ;// CONCATENATED MODULE: ./src/components/RStory/index.ts


      RStory_RStory.install = vue => {
        vue.component('r-story', RStory_RStory);
      };
      /* harmony default export */ var components_RStory = (RStory_RStory);
      ;// CONCATENATED MODULE: ./src/components/RInputNumber/RInputNumber.ts

      var RInputNumber_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };



      let RInputNumber = class RInputNumber extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "oldVal", 0);
          _defineProperty(this, "model", void 0);
          _defineProperty(this, "min", void 0);
          _defineProperty(this, "max", void 0);
          _defineProperty(this, "step", void 0);
        }
        checkVal() {
          const input = this.model;
          let value = this.min;
          // eslint-disable-next-line no-restricted-globals
          if (!isNaN(input)) {
            // eslint-disable-next-line no-nested-ternary
            value = input > this.max ? this.max % this.step === 0 ? this.max : this.oldVal : input <= this.min ? this.min : input;
          }
          this.$emit('input', value);
        }
        decrease() {
          this.oldVal = this.model;
          this.model -= this.step;
          this.$nextTick(() => {
            this.checkVal();
          });
        }
        increase() {
          this.oldVal = this.model;
          this.model += this.step;
          this.$nextTick(() => {
            this.checkVal();
          });
        }
        render(h) {
          return h('section', {
            class: ['RInputNumber']
          }, [h(components_RButtonSimple, {
            props: {
              icon: 'remove',
              type: 'transparent',
              disabled: this.min === this.model || !this.model
            },
            on: {
              click: this.decrease
            }
          }), h('input', {
            attrs: {
              value: this.model || this.min,
              readonly: true,
              type: 'number'
            },
            on: {
              change: this.checkVal
            },
            class: ['RInputNumber__input']
          }), h(components_RButtonSimple, {
            props: {
              icon: 'add',
              type: 'transparent',
              disabled: this.max === this.model
            },
            on: {
              click: this.increase
            }
          })]);
        }
      };
      RInputNumber_decorate([VModel({
        type: Number,
        default: 0
      })], RInputNumber.prototype, "model", void 0);
      RInputNumber_decorate([Prop({
        type: Number,
        default: 0
      })], RInputNumber.prototype, "min", void 0);
      RInputNumber_decorate([Prop({
        type: Number,
        default: 99
      })], RInputNumber.prototype, "max", void 0);
      RInputNumber_decorate([Prop({
        type: Number,
        default: 1
      })], RInputNumber.prototype, "step", void 0);
      RInputNumber = RInputNumber_decorate([vue_class_component_esm({
        components: {
          RButtonSimple: components_RButtonSimple
        }
      })], RInputNumber);
      /* harmony default export */ var RInputNumber_RInputNumber = (RInputNumber);
      ;// CONCATENATED MODULE: ./src/components/RInputNumber/index.ts


      RInputNumber_RInputNumber.install = vue => {
        vue.component('r-input-number', RInputNumber_RInputNumber);
      };
      /* harmony default export */ var components_RInputNumber = (RInputNumber_RInputNumber);
      ;// CONCATENATED MODULE: ./src/components/RNavigationTile/RNavigationTile.ts


      var RNavigationTile_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };




      let RNavigationTile = class RNavigationTile extends component {
        constructor(...args) {
          super(...args);
          // Заготовка для разных размеров карточки
          _defineProperty(this, "size", 'default');
          _defineProperty(this, "image", void 0);
          _defineProperty(this, "title", void 0);
          _defineProperty(this, "href", void 0);
          _defineProperty(this, "to", void 0);
          _defineProperty(this, "isLoading", void 0);
          _defineProperty(this, "disabled", void 0);
        }
        get isLink() {
          return !!this.href || !!this.to;
        }
        render(h) {
          return h(this.isLink ? 'a' : 'section', {
            staticClass: 'RNavigationTile',
            class: [this.size, {
              disabled: this.disabled
            }],
            on: {
              click: async () => {
                this.$emit('click');
                if (!!this.to && !!this.$router) {
                  await this.$router.push(this.to);
                } else if (this.href) {
                  window.open(this.href, '_blank');
                }
              }
            }
          }, [h(components_RImage, {
            staticClass: 'RNavigationTile__image',
            props: {
              isLoading: this.isLoading,
              ratio: 'odro',
              url: this.image
            }
          }), !this.isLoading && h(components_RFader, {
            staticClass: 'RNavigationTile__fader'
          }), !this.isLoading && h('span', {
            staticClass: 'RNavigationTile__title'
          }, this.title)]);
        }
      };
      RNavigationTile_decorate([Prop({
        type: String,
        required: true
      })], RNavigationTile.prototype, "image", void 0);
      RNavigationTile_decorate([Prop({
        type: String,
        required: true
      })], RNavigationTile.prototype, "title", void 0);
      RNavigationTile_decorate([Prop({
        type: String,
        default: null
      })], RNavigationTile.prototype, "href", void 0);
      RNavigationTile_decorate([Prop({
        type: String,
        default: null
      })], RNavigationTile.prototype, "to", void 0);
      RNavigationTile_decorate([Prop({
        type: Boolean
      })], RNavigationTile.prototype, "isLoading", void 0);
      RNavigationTile_decorate([Prop({
        type: Boolean
      })], RNavigationTile.prototype, "disabled", void 0);
      RNavigationTile = RNavigationTile_decorate([vue_class_component_esm({
        components: {
          RImage: components_RImage,
          RFader: components_RFader
        }
      })], RNavigationTile);
      /* harmony default export */ var RNavigationTile_RNavigationTile = (RNavigationTile);
      ;// CONCATENATED MODULE: ./src/components/RNavigationTile/index.ts


      RNavigationTile_RNavigationTile.install = vue => {
        vue.component('r-navigation-tile', RNavigationTile_RNavigationTile);
      };
      /* harmony default export */ var components_RNavigationTile = (RNavigationTile_RNavigationTile);
      ;// CONCATENATED MODULE: ./src/components/RButtonGallery/RButtonGallery.ts


      var RButtonGallery_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };


      let RButtonGallery = class RButtonGallery extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "rounded", void 0);
          _defineProperty(this, "ratio", void 0);
          _defineProperty(this, "height", void 0);
          _defineProperty(this, "width", void 0);
          _defineProperty(this, "title", void 0);
          _defineProperty(this, "href", void 0);
          _defineProperty(this, "to", void 0);
          _defineProperty(this, "disabled", void 0);
        }
        render(h) {
          return h('a', {
            staticClass: 'RButtonGallery',
            class: [this.ratio, {
              disabled: this.disabled
            }],
            style: {
              height: this.height,
              // aspectRatio: this.ratio,
              width: this.width,
              borderRadius: this.rounded
            },
            on: {
              click: async () => {
                this.$emit('click');
                if (!!this.to && !!this.$router) {
                  await this.$router.push(this.to);
                } else if (this.href) {
                  window.open(this.href, '_blank');
                }
              }
            }
          }, [h('span', {
            staticClass: 'RButtonGallery__title'
          }, this.title)]);
        }
      };
      RButtonGallery_decorate([Prop({
        type: String,
        default: '16px'
      })], RButtonGallery.prototype, "rounded", void 0);
      RButtonGallery_decorate([Prop({
        type: String,
        default: 'kano',
        validator: val => ['kemto', 'odro', 'rada', 'tako', 'kano', 'tira'].includes(val)
      })], RButtonGallery.prototype, "ratio", void 0);
      RButtonGallery_decorate([Prop({
        type: String,
        default: 'inherit'
      })], RButtonGallery.prototype, "height", void 0);
      RButtonGallery_decorate([Prop({
        type: String,
        default: '100%'
      })], RButtonGallery.prototype, "width", void 0);
      RButtonGallery_decorate([Prop({
        type: String,
        required: true
      })], RButtonGallery.prototype, "title", void 0);
      RButtonGallery_decorate([Prop({
        type: String,
        default: null
      })], RButtonGallery.prototype, "href", void 0);
      RButtonGallery_decorate([Prop({
        type: String,
        default: null
      })], RButtonGallery.prototype, "to", void 0);
      RButtonGallery_decorate([Prop({
        type: Boolean
      })], RButtonGallery.prototype, "disabled", void 0);
      RButtonGallery = RButtonGallery_decorate([vue_class_component_esm], RButtonGallery);
      /* harmony default export */ var RButtonGallery_RButtonGallery = (RButtonGallery);
      ;// CONCATENATED MODULE: ./src/components/RButtonGallery/index.ts


      RButtonGallery_RButtonGallery.install = vue => {
        vue.component('r-button-gallery', RButtonGallery_RButtonGallery);
      };
      /* harmony default export */ var components_RButtonGallery = (RButtonGallery_RButtonGallery);
      ;// CONCATENATED MODULE: ./src/components/RBadge/RBadge.ts

      var RBadge_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };


      let RBadge = class RBadge extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "title", void 0);
          _defineProperty(this, "color", void 0);
          _defineProperty(this, "inversion", void 0);
          _defineProperty(this, "size", void 0);
        }
        render(h) {
          return h('section', {
            staticClass: 'RBadge',
            class: [this.size, this.color, {
              inversion: this.inversion
            }]
          }, this.title);
        }
      };
      RBadge_decorate([Prop({
        type: String,
        default: null
      })], RBadge.prototype, "title", void 0);
      RBadge_decorate([Prop({
        type: String,
        default: 'rocky',
        validator: val => ['rocky', 'matrix', 'lebowski', 'fargo', 'gentlemen', 'metropolis', 'fightclub', 'aquaman', 'goodfellas', 'troy', 'amelie'].includes(val)
      })], RBadge.prototype, "color", void 0);
      RBadge_decorate([Prop({
        type: Boolean
      })], RBadge.prototype, "inversion", void 0);
      RBadge_decorate([Prop({
        type: String,
        default: 'psamiaphe',
        validator: val => ['psamiaphe', 'arasine'].includes(val)
      })], RBadge.prototype, "size", void 0);
      RBadge = RBadge_decorate([vue_class_component_esm], RBadge);
      /* harmony default export */ var RBadge_RBadge = (RBadge);
      ;// CONCATENATED MODULE: ./src/components/RBadge/index.ts


      RBadge_RBadge.install = vue => {
        vue.component('r-badge', RBadge_RBadge);
      };
      /* harmony default export */ var components_RBadge = (RBadge_RBadge);
      ;// CONCATENATED MODULE: ./src/components/RSwitcher/RSwitcher.ts

      var RSwitcher_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };



      let RSwitcher = class RSwitcher extends checked {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "uid", void 0);
          _defineProperty(this, "disabled", void 0);
          _defineProperty(this, "error", void 0);
          _defineProperty(this, "errorMessage", void 0);
          _defineProperty(this, "title", void 0);
          _defineProperty(this, "subTitle", void 0);
        }
        get eventsListener() {
          return {
            input: this.emitModel
          };
        }
        get subTitleView() {
          if (!this.subTitle) return null;
          return this.$createElement('div', {
            staticClass: 'RSwitcher__sub-title',
            class: {
              error: this.error
            }
          }, this.error ? this.errorMessage || this.subTitle : this.subTitle);
        }
        mounted() {
          this.uid = uniqueID();
        }
        get attrsInput() {
          const attrs = {
            for: this.uid
          };
          if (!this.disabled) {
            attrs.tabIndex = 0;
          }
          return attrs;
        }
        render(h) {
          return h('label', {
            attrs: this.attrsInput,
            staticClass: 'RSwitcher',
            class: [{
              disabled: this.disabled
            }],
            on: {
              keydown: event => {
                if (event.code === 'Space') {
                  event.preventDefault();
                  this.emitModel();
                }
              }
            }
          }, [h('input', {
            domProps: {
              checked: this.isChecked
            },
            attrs: {
              disabled: this.disabled,
              id: this.uid,
              type: 'checkbox'
            },
            on: this.eventsListener
          }), h('i'), !!this.title && h('div', {
            staticClass: 'RSwitcher__content'
          }, [h('div', {
            staticClass: 'RSwitcher__title',
            class: {
              error: !this.subTitle && this.error
            }
          }, this.title), this.subTitleView])]);
        }
      };
      RSwitcher_decorate([Prop({
        type: [Array, Boolean],
        default: false
      })], RSwitcher.prototype, "value", void 0);
      RSwitcher_decorate([Prop({
        type: Boolean,
        default: false
      })], RSwitcher.prototype, "disabled", void 0);
      RSwitcher_decorate([Prop({
        type: Boolean,
        default: false
      })], RSwitcher.prototype, "error", void 0);
      RSwitcher_decorate([Prop({
        type: String,
        default: null
      })], RSwitcher.prototype, "errorMessage", void 0);
      RSwitcher_decorate([Prop({
        type: String,
        default: null
      })], RSwitcher.prototype, "title", void 0);
      RSwitcher_decorate([Prop({
        type: String,
        default: null
      })], RSwitcher.prototype, "subTitle", void 0);
      RSwitcher = RSwitcher_decorate([vue_class_component_esm], RSwitcher);
      /* harmony default export */ var RSwitcher_RSwitcher = (RSwitcher);
      ;// CONCATENATED MODULE: ./src/components/RSwitcher/index.ts


      RSwitcher_RSwitcher.install = vue => {
        vue.component('r-switcher', RSwitcher_RSwitcher);
      };
      /* harmony default export */ var components_RSwitcher = (RSwitcher_RSwitcher);
      ;// CONCATENATED MODULE: ./src/components/RButtonAction/RButtonAction.ts

      var RButtonAction_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };



      let RButtonAction = class RButtonAction extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "val", void 0);
          _defineProperty(this, "title", void 0);
          _defineProperty(this, "icon", void 0);
          _defineProperty(this, "isArrow", void 0);
          _defineProperty(this, "disabled", void 0);
          _defineProperty(this, "color", void 0);
          _defineProperty(this, "size", void 0);
        }
        get eventsComponent() {
          if (this.disabled) {
            return {};
          }
          return {
            ...this.$listeners,
            click: event => {
              this.isArrow && this.$emit('input', !this.val);
              this.$emit('click', event);
            }
          };
        }
        render(h) {
          return h('button', {
            staticClass: 'RButtonAction',
            on: this.eventsComponent,
            class: [this.color, this.size, {
              active: this.val,
              disabled: this.disabled
            }]
          }, [!!this.icon && h(components_RIcon, {
            staticClass: 'RButtonAction__icon',
            props: {
              icon: this.icon
            }
          }), !!this.title && h('div', {
            staticClass: 'RButtonAction__title'
          }, this.title), this.isArrow && h(components_RIcon, {
            staticClass: 'RButtonAction__arrow',
            props: {
              icon: 'arrow-down'
            }
          })]);
        }
      };
      RButtonAction_decorate([VModel({
        type: Boolean
      })], RButtonAction.prototype, "val", void 0);
      RButtonAction_decorate([Prop({
        type: String
      })], RButtonAction.prototype, "title", void 0);
      RButtonAction_decorate([Prop({
        type: String
      })], RButtonAction.prototype, "icon", void 0);
      RButtonAction_decorate([Prop({
        type: Boolean
      })], RButtonAction.prototype, "isArrow", void 0);
      RButtonAction_decorate([Prop({
        type: Boolean
      })], RButtonAction.prototype, "disabled", void 0);
      RButtonAction_decorate([Prop({
        type: String,
        default: 'rocky',
        validator: val => ['rocky', 'matrix', 'lebowski', 'fargo', 'gentlemen', 'fightclub', 'aquaman', 'goodfellas', 'troy', 'harakiri', 'metropolis'].includes(val)
      })], RButtonAction.prototype, "color", void 0);
      RButtonAction_decorate([Prop({
        type: String,
        default: 'sulguni',
        validator: val => ['sulguni', 'briscola'].includes(val)
      })], RButtonAction.prototype, "size", void 0);
      RButtonAction = RButtonAction_decorate([vue_class_component_esm({
        components: {
          RIcon: components_RIcon
        }
      })], RButtonAction);
      /* harmony default export */ var RButtonAction_RButtonAction = (RButtonAction);
      ;// CONCATENATED MODULE: ./src/components/RButtonAction/index.ts


      RButtonAction_RButtonAction.install = vue => {
        vue.component('r-button-action', RButtonAction_RButtonAction);
      };
      /* harmony default export */ var components_RButtonAction = (RButtonAction_RButtonAction);
      ;// CONCATENATED MODULE: ./src/components/RModal/RModal.ts


      var RModal_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };




      const defaultOptionModal = {
        isClose: true
      };
      let RModal = class RModal extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "isOpen", false);
          // @ts-ignore
          _defineProperty(this, "resizeObserver", new ResizeObserver(this.onResize));
          _defineProperty(this, "componentsList", []);
          _defineProperty(this, "optionsModal", defaultOptionModal);
        }
        openModal(component, props, optionsModal) {
          document.body.style.overflow = 'hidden';
          // document.body.style.position = 'fixed';
          this.isOpen = true;
          return new Promise((resolve, reject) => {
            const dataComponent = this.initComponent(component, props);
            const popovers = document.body.getElementsByClassName('RPopover__content');
            while (popovers.length > 0) {
              popovers[0].parentNode?.removeChild(popovers[0]);
            }
            this.optionsModal = {
              ...defaultOptionModal,
              ...(optionsModal || {})
            };
            this.componentsList.push({
              ...dataComponent,
              resolve,
              reject,
              optionsModal
            });
            this.onResize(['']);
          });
        }
        initComponent(component, props) {
          return {
            component,
            value: {
              props
            }
          };
        }
        closeModal(promiseReturn = null, destroyFull = false) {
          let dataComponent;
          if (destroyFull || this.componentsList.length === 1) {
            dataComponent = this.componentsList.shift();
            this.isOpen = false;
            document.body.style.overflow = 'auto';
            // document.body.style.position = 'static';
            this.componentsList = [];
          } else {
            dataComponent = this.componentsList.pop();
          }
          if (dataComponent) {
            this.optionsModal = {
              ...defaultOptionModal,
              ...(this.componentsList[this.componentsList.length - 1]?.optionsModal || {})
            };
            dataComponent.resolve(promiseReturn);
          }
        }
        async closeModalActions(type, promiseReturn = null, destroyFull = false) {
          if (this.optionsModal.isCloseEventInitComponent) {
            const component = this.$refs[`modal-${this.componentsList.length - 1}`];
            if (component?.closeModal && typeof component?.closeModal === 'function') {
              component?.closeModal(type);
            }
          } else if (this.optionsModal.isCallbackAfterClose) {
            const res = await this.optionsModal.isCallbackAfterClose(type);
            if (res) {
              this.closeModal(promiseReturn, destroyFull);
            }
          } else {
            this.closeModal(promiseReturn, destroyFull);
          }
        }
        get componentView() {
          const {
            length
          } = this.componentsList;
          return this.componentsList.map((el, index) => this.$createElement(el.component, {
            props: el.value.props,
            ref: `modal-${index}`,
            attrs: {
              'data-hidden': length !== index + 1 ? 'true' : 'false'
            },
            style: [{
              display: length !== index + 1 ? 'none' : ''
            }]
          }));
        }
        onResize(entries) {
          window.requestAnimationFrame(() => {
            if (!Array.isArray(entries) || !entries.length) {
              return;
            }
            // your code
            this.$refs.content.scrollTop = 0;
            const {
              scrollHeight,
              offsetHeight
            } = this.$refs.content;
            this.$nextTick(() => {
              const visibleContent = document.querySelector('[data-hidden="false"]');
              const actions = visibleContent?.querySelector('#RModal--actions');
              if (actions) {
                const block = actions;
                block.classList.add('RModal__actions');
                if (this.optionsModal.isFixedActionsBlock) {
                  block.classList.add('sticky');
                  this.$refs.RModal.style.paddingBottom = `${block.clientHeight}px`;
                } else if (scrollHeight > offsetHeight) {
                  block.classList.add('sticky');
                  this.$refs.RModal.style.paddingBottom = `${block.clientHeight}px`;
                } else if (block.classList.contains('sticky') && scrollHeight <= offsetHeight) {
                  block.classList.remove('sticky');
                  this.$refs.RModal.style.paddingBottom = '';
                }
              }
            });
          });
        }
        mounted() {
          if (this.$rir) {
            this.$rir.modal = {
              open: this.openModal,
              close: this.closeModal
            };
            this.resizeObserver.observe(this.$refs.content);
          }
        }
        render(h) {
          return h('section', {
            ref: 'RModal',
            staticClass: 'RModal',
            class: ['default'],
            style: {
              display: !this.isOpen ? 'none' : 'inline'
            }
          }, [!!this.optionsModal.backText && h(components_RButtonAction, {
            props: {
              icon: 'arrow-left',
              title: this.optionsModal.backText
            },
            staticClass: 'RModal__back',
            nativeOn: {
              click: () => this.closeModalActions('BACK_MODAL', null)
            }
          }), this.optionsModal.isClose && h(components_RButtonSimple, {
            props: {
              icon: 'close',
              type: 'transparent',
              size: 'larishae'
            },
            staticClass: 'RModal__close',
            on: {
              click: () => this.closeModalActions('CLOSE_MODAL', null, true)
            }
          }), h('section', {
            staticClass: 'RModal__content',
            ref: 'content'
          }, this.componentView)]);
        }
      };
      RModal = RModal_decorate([vue_class_component_esm], RModal);
      /* harmony default export */ var RModal_RModal = (RModal);
      ;// CONCATENATED MODULE: ./src/components/RModal/index.ts


      RModal_RModal.install = vue => {
        vue.component('r-modal', RModal_RModal);
      };
      /* harmony default export */ var components_RModal = (RModal_RModal);
      ;// CONCATENATED MODULE: ./src/util/library/maskInput.ts
      function initChangeMask(mask, val, position, period) {
        const numKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
        const regex = /[^\\._\-\\/\\*\\\\–\\(\\)]/g;
        const symbol = mask.join().replace(regex, '');
        const numberVal = val.replace(/[^\d]/g, '');
        let str = '';
        if (period) {
          str = numberVal.replace(/(\d{0,2})(\d{0,2})(\d{0,4})(\d{0,2})(\d{0,2})(\d{0,4})/, '$1.$2.$3–$4.$5.$6');
        } else {
          str = numberVal.replace(/(\d{0,2})(\d{0,2})(\d{0,4})/, '$1.$2.$3');
        }
        const resVal = str.split('').reverse();
        for (let i = 0; i < resVal.length; i++) {
          if (symbol.includes(resVal[i])) {
            resVal.shift();
            i--;
          } else {
            break;
          }
        }
        resVal.reverse();
        let newPosition = position;
        if (!numKeys.includes(resVal[newPosition])) {
          newPosition++;
        }
        return {
          val: resVal.join(''),
          position: newPosition
        };
      }
      function maskInput(event, period) {
        const numKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
        const mask = (period ? '##.##.####–##.##.####' : '##.##.####').split('');
        // @ts-ignore
        const startPos = event.target.selectionStart;
        // @ts-ignore
        const endPos = event.target.selectionEnd;
        // @ts-ignore
        const {
          selectionStart
        } = event.target;
        if (!event.data) {
          setTimeout(() => {
            const valData = (event.target.value || '').replace(/[^\d]/g, '');
            // @ts-ignore
            const data = initChangeMask(mask, valData, startPos, period);
            // @ts-ignore
            event.target.value = data.val;
            // @ts-ignore
            event.target.setSelectionRange(selectionStart, selectionStart);
          }, 0);
        } else if (!!event.data && !numKeys.includes(event.data)
          // @ts-ignore
          || mask.length < (event.target.value || '').length + 1 && startPos === endPos) {
          event.preventDefault();
        } else {
          setTimeout(() => {
            const valData = (event.target.value || '').replace(/[^\d]/g, '');
            // @ts-ignore
            const data = initChangeMask(mask, valData, startPos, period);
            // @ts-ignore
            event.target.value = data.val;
            // @ts-ignore
            event.target.setSelectionRange(data.position + 1, data.position + 1);
          }, 0);
        }
      }
      ;// CONCATENATED MODULE: ./src/components/RDatePicker/components/RDatePickerDay.ts

      var RDatePickerDay_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };


      let RDatePickerDay = class RDatePickerDay extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "model", void 0);
          _defineProperty(this, "item", void 0);
          _defineProperty(this, "year", void 0);
          _defineProperty(this, "month", void 0);
          _defineProperty(this, "period", void 0);
          _defineProperty(this, "startDate", void 0);
          _defineProperty(this, "endDate", void 0);
        }
        get isActive() {
          // @TODO dateCalendar перенести в геттер
          const dateCalendar = new Date(this.item.year, this.item.month - 1, this.item.day, 0, 0, 0, 0).getTime();
          let result = {
            isActive: false,
            isStart: false,
            isFinish: false
          };
          if (this.period && Array.isArray(this.model)) {
            const start = +new Date(this.model[0]).setHours(0, 0, 0, 0);
            const finish = +new Date(this.model[1]).setHours(0, 0, 0, 0);
            result = {
              isActive: start <= dateCalendar && finish >= dateCalendar,
              isStart: start === dateCalendar,
              isFinish: finish === dateCalendar
            };
          } else if (!Array.isArray(this.model)) {
            const nowDay = new Date(this.model);
            result = {
              isActive: nowDay && +nowDay.setHours(0, 0, 0, 0) === dateCalendar,
              isStart: false,
              isFinish: false
            };
          }
          return result;
        }
        get isBlock() {
          // @TODO dateCalendar перенести в геттер
          const dateCalendar = Date.UTC(this.item.year, this.item.month - 1, this.item.day, 0, 0, 0, 0);
          if (this.startDate || this.endDate) {
            const start = !!this.startDate && +new Date(this.startDate).setHours(0, 0, 0, 0) > dateCalendar;
            const end = !!this.endDate && +new Date(this.endDate).setHours(0, 0, 0, 0) < dateCalendar;
            return start || end;
          }
          return false;
        }
        get nowDate() {
          const nowDate = new Date().toDateString();
          // @TODO dateCalendar перенести в геттер
          const dateCalendar = new Date(this.year, this.item.month - 1, this.item.day).toDateString();
          return nowDate === dateCalendar;
        }
        get otherMonth() {
          return this.item.month !== this.month;
        }
        render(h) {
          const attrs = {};
          if (!this.otherMonth && !this.isBlock) {
            attrs.tabIndex = 0;
          }
          return h('a', {
            attrs,
            staticClass: 'RDatePicker__column',
            class: [{
              now: this.nowDate,
              active: this.isActive.isActive,
              start: this.isActive.isStart,
              finish: this.isActive.isFinish,
              period: this.period,
              block: this.otherMonth || this.isBlock
            }],
            on: {
              click: () => this.$emit('selectDate', this.item),
              keydown: event => {
                if (!this.isBlock && event.code === 'Space') {
                  this.$emit('selectDate', this.item);
                }
              }
            }
          }, this.item.day);
        }
      };
      RDatePickerDay_decorate([VModel({
        type: [String, Number, Array]
      })], RDatePickerDay.prototype, "model", void 0);
      RDatePickerDay_decorate([Prop({
        type: Object
      })], RDatePickerDay.prototype, "item", void 0);
      RDatePickerDay_decorate([Prop({
        type: Number
      })], RDatePickerDay.prototype, "year", void 0);
      RDatePickerDay_decorate([Prop({
        type: Number
      })], RDatePickerDay.prototype, "month", void 0);
      RDatePickerDay_decorate([Prop({
        type: Boolean
      })], RDatePickerDay.prototype, "period", void 0);
      RDatePickerDay_decorate([Prop({
        type: String
      })], RDatePickerDay.prototype, "startDate", void 0);
      RDatePickerDay_decorate([Prop({
        type: String
      })], RDatePickerDay.prototype, "endDate", void 0);
      RDatePickerDay = RDatePickerDay_decorate([vue_class_component_esm], RDatePickerDay);
      /* harmony default export */ var components_RDatePickerDay = (RDatePickerDay);
      ;// CONCATENATED MODULE: ./src/components/RDatePicker/RDatePicker.ts


      var RDatePicker_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };








      let RDatePicker = class RDatePicker extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "isOpen", false);
          _defineProperty(this, "isFocusOut", false);
          _defineProperty(this, "positionContent", 'center-bottom');
          // countDayMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
          //
          // countDayMonthLeapYear = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
          _defineProperty(this, "year", new Date().getFullYear());
          _defineProperty(this, "month", new Date().getMonth() + 1);
          _defineProperty(this, "listWeek", ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс']);
          _defineProperty(this, "listMonth", ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь']);
          _defineProperty(this, "model", void 0);
          _defineProperty(this, "disabled", void 0);
          _defineProperty(this, "inline", void 0);
          _defineProperty(this, "clickClose", void 0);
          _defineProperty(this, "period", void 0);
          _defineProperty(this, "label", void 0);
          _defineProperty(this, "startDate", void 0);
          _defineProperty(this, "endDate", void 0);
          _defineProperty(this, "isClearModel", void 0);
          _defineProperty(this, "error", void 0);
          _defineProperty(this, "isTimestamp", void 0);
          _defineProperty(this, "isSetInput", void 0);
          _defineProperty(this, "errorMessage", void 0);
          _defineProperty(this, "popoverOptions", void 0);
          _defineProperty(this, "inputContent", void 0);
          _defineProperty(this, "popoverContent", void 0);
        }
        get modificationModel() {
          if (this.isTimestamp && !!this.model) {
            if (Array.isArray(this.model)) {
              return this.model
                // @ts-ignore
                .map(el => this.changeIntToStrDate(el));
            }
            return this.changeIntToStrDate(this.model);
          }
          return this.model;
        }
        modelEmitFormat(date) {
          if (this.isTimestamp) {
            return new Date(date).valueOf();
          }
          return date;
        }
        changeIntToStrDate(dateData) {
          const date = new Date(dateData);
          const d = {
            year: date.getFullYear(),
            day: '0',
            month: '0'
          };
          d.day = date.getDate().toString().padStart(2, '0');
          d.month = (date.getMonth() + 1).toString().padStart(2, '0');
          return `${d.year}-${d.month}-${d.day}`;
        }
        get popoverOptionsSelect() {
          const {
            isCheckAutoScrollBlock = false
          } = this.popoverOptions;
          return {
            isCheckAutoScrollBlock
          };
        }
        get input() {
          if (this.modificationModel) {
            if (this.period && Array.isArray(this.modificationModel)) {
              const start = this.toLocaleUTCDateString(this.modificationModel[0], 'ru-Ru');
              const finish = this.modificationModel[1] ? this.toLocaleUTCDateString(this.modificationModel[1], 'ru-Ru') : null;
              return `${start || ''}–${finish || ''}`;
            }
            return this.toLocaleUTCDateString(this.modificationModel, 'ru-Ru');
          }
          return null;
        }
        toLocaleUTCDateString(date, locales, options) {
          let d = date;
          if (date) {
            // eslint-disable-next-line prefer-regex-literals
            const regexp = new RegExp('(\\d{4}-\\d{2}-\\d{2})', 'gm');
            d = date.match(regexp);
          }
          const adjustedDate = new Date(d);
          return adjustedDate.toLocaleDateString(locales, options);
        }
        get daysCountInPrevMonth() {
          return new Date(this.year, this.month - 1, 0).getDate();
        }
        get daysCountInMonth() {
          return new Date(this.year, this.month, 0).getDate();
        }
        get startDayInMonth() {
          let day = new Date(this.year, this.month - 1, 1).getDay();
          // eslint-disable-next-line no-nested-ternary
          day = [0, 1].includes(day) ? day === 0 ? 6 : 0 : day - 1;
          return day;
        }
        get arrayDayInMonth() {
          const arrData = [];
          let lastDays = 1;
          let {
            month
          } = this;
          let {
            year
          } = this;
          let type = null;
          for (let w = 0; w < 6; w++) {
            // arrData.push([]);
            const rowView = [];
            let daysWeek = 0;
            if (w === 0) {
              for (let d = 1; d <= this.startDayInMonth; d++) {
                rowView.push(this.$createElement(components_RDatePickerDay, {
                  props: {
                    item: {
                      month: month - 1 > 0 ? month - 1 : 12,
                      year: month - 1 > 0 ? year : year - 1,
                      day: this.daysCountInPrevMonth - this.startDayInMonth + d,
                      type: 'DOWN'
                    },
                    year: this.year,
                    month: this.month,
                    value: this.modificationModel,
                    period: this.period,
                    startDate: this.startDate,
                    endDate: this.endDate
                  },
                  on: {
                    selectDate: this.selectDate
                  }
                }));
                // arrData[w].push({
                //   month: month - 1 > 0 ? month - 1 : 12,
                //   year: month - 1 > 0 ? year : year - 1,
                //   day: this.daysCountInPrevMonth - this.startDayInMonth + d,
                //   type: 'DOWN',
                // });
              }

              daysWeek = this.startDayInMonth;
            }
            for (let d = lastDays; d <= this.daysCountInMonth; d++) {
              daysWeek++;
              rowView.push(this.$createElement(components_RDatePickerDay, {
                props: {
                  item: {
                    month,
                    day: d,
                    year,
                    type
                  },
                  year: this.year,
                  month: this.month,
                  value: this.modificationModel,
                  period: this.period,
                  startDate: this.startDate,
                  endDate: this.endDate
                },
                on: {
                  selectDate: this.selectDate
                }
              }));
              if (daysWeek === 7) {
                if (this.daysCountInMonth === d) {
                  lastDays = 1;
                  d = 0;
                  type = 'UP';
                  year = month + 1 <= 12 ? year : year + 1;
                  month = month + 1 <= 12 ? month + 1 : 1;
                  break;
                } else {
                  lastDays = ++d;
                  break;
                }
              } else if (this.daysCountInMonth === d && daysWeek < 7) {
                d = 0;
                type = 'UP';
                year = month + 1 <= 12 ? year : year + 1;
                month = month + 1 <= 12 ? month + 1 : 1;
              }
            }
            arrData.push(this.$createElement('div', {
              staticClass: 'RDatePicker__row'
            }, rowView));
          }
          return arrData;
        }
        get viewCalendar() {
          return this.$createElement('div', {
              staticClass: 'RDatePicker__calendar'
            },
            // @ts-ignore
            this.arrayDayInMonth);
        }
        selectDate(d) {
          const selectDay = new Date(d.year, d.month - 1, d.day, 0,
            // this.isTime ? new Date(this.model || now).getHours() : 0,
            0,
            // this.isTime ? new Date(this.model || now).getMinutes() : 0,
            0, 0);
          d.day = d.day.toString().padStart(2, '0');
          d.month = d.month.toString().padStart(2, '0');
          const setDate = `${d.year}-${d.month}-${d.day}`;
          if (this.month !== d.month) this.month = d.month;
          if (this.year !== d.year) this.year = d.year;
          if (this.period) {
            let val = Array.isArray(this.modificationModel) ? [...this.modificationModel] : [];
            if (!this.modificationModel || Array.isArray(this.modificationModel) && this.modificationModel.length > 1 && val[0] !== val[1]) {
              val = [];
              val[0] = setDate;
              // val[1] = setDate;
            } else if (+new Date(val[0]) < +selectDay) {
              val[1] = setDate;
            } else {
              // eslint-disable-next-line prefer-destructuring
              val[1] = val[0];
              val[0] = setDate;
            }
            // this.model = val;
            const valEmit = val.map(el => this.modelEmitFormat(el));
            this.$emit('input', valEmit);
            if (val.length > 1) {
              this.$emit('change', valEmit);
              if (this.clickClose) this.isOpen = false;
            }
          } else {
            // this.model = setDate;
            this.$emit('input', this.modelEmitFormat(setDate));
            this.$emit('change', this.modelEmitFormat(setDate));
            if (this.clickClose) this.isOpen = false;
          }
        }
        get viewNavigator() {
          return this.$createElement('div', {
            staticClass: 'RDatePicker__navigation'
          }, [this.$createElement(components_RButtonAction, {
            attrs: {
              tabIndex: 0
            },
            props: {
              icon: 'rewind'
            },
            on: {
              click: () => this.changeYear('DOWN')
            }
          }), this.$createElement(components_RButtonAction, {
            attrs: {
              tabIndex: 0
            },
            props: {
              icon: 'arrow-left'
            },
            on: {
              click: () => this.changeMonth('DOWN')
            }
          }), this.$createElement(components_RButtonAction, {
            attrs: {
              tabIndex: 0
            },
            props: {
              icon: 'arrow-right'
            },
            on: {
              click: () => this.changeMonth('UP')
            }
          }), this.$createElement(components_RButtonAction, {
            attrs: {
              tabIndex: 0
            },
            props: {
              icon: 'forward'
            },
            on: {
              click: () => this.changeYear('UP')
            }
          }), this.$createElement('span', {
            staticClass: 'RDatePicker__title',
            class: ['month']
          }, this.listMonth[this.month - 1]), this.$createElement('span', {
            staticClass: 'RDatePicker__title',
            class: ['year']
          }, String(this.year))]);
        }
        changeMonth(type) {
          switch (type) {
            case 'UP':
              if (this.month + 1 <= 12) {
                this.month++;
              } else {
                this.month = 1;
                this.year++;
              }
              break;
            // case 'DOWN'
            default:
              if (this.month - 1 >= 1) {
                this.month--;
              } else {
                this.month = 12;
                this.year--;
              }
              break;
          }
        }
        changeYear(type) {
          switch (type) {
            case 'UP':
              this.year++;
              break;
            // case 'DOWN'
            default:
              this.year--;
              break;
          }
        }
        viewWeekName() {
          const week = this.listWeek.map(el => this.$createElement('span', {
            staticClass: 'RDatePicker__day'
          }, el));
          return this.$createElement('div', {
            staticClass: 'RDatePicker__week'
          }, week);
        }
        get viewRenderCalendar() {
          return this.$createElement('div', {
            slot: 'content',
            staticClass: 'RDatePicker',
            class: [{
              inline: this.inline
            }],
            on: {
              keydown: event => {
                if (event.code === 'Tab') {
                  this.isFocusOut = true;
                }
                if (event.code === 'Escape') {
                  this.isOpen = false;
                  const input = this.popoverContent.$el.getElementsByClassName('RDatePicker__input');
                  // @ts-ignore
                  input[0].focus();
                }
              },
              focusout: event => {
                if (this.isFocusOut) {
                  // @ts-ignore
                  const {
                    uid
                  } = this.popoverContent;
                  const content = document.getElementById(`content-${uid}`);
                  const input = this.popoverContent.$el.getElementsByClassName('RDatePicker__input');
                  if (content && input.length > 0) {
                    const data = tabChangeElementSelect(event, content, input[0]);
                    if (data) {
                      this.isOpen = false;
                    }
                  }
                }
                this.isFocusOut = false;
              }
            }
          }, [this.$slots.header && this.$createElement('div', {
            staticClass: 'RDatePicker__header'
          }, this.$slots.header), this.viewNavigator, this.viewWeekName(), this.viewCalendar, this.$slots.footer && this.$createElement('div', {
            staticClass: 'RDatePicker__footer'
          }, this.$slots.footer)]);
        }
        getPositionOnClick(event) {
          const position = this.inputContent.getBoundingClientRect();
          if (position.width > 480 && !this.isOpen) {
            const clickPosition = event.clientX - position.x;
            const selfWidth = position.width / 2;
            const partWidth = selfWidth / 2;
            if (clickPosition > selfWidth + partWidth) {
              this.positionContent = 'right-bottom';
            } else if (clickPosition < selfWidth - partWidth) {
              this.positionContent = 'left-bottom';
            } else {
              this.positionContent = 'center-bottom';
            }
          } else {
            this.positionContent = 'center-bottom';
          }
        }
        changeDateFormatInput(date) {
          const arrDate = date.split('.');
          if (arrDate.length === 3) {
            const dateVal = new Date(arrDate.reverse().join('-'));
            // @ts-ignore
            if (dateVal instanceof Date && !isNaN(dateVal)) {
              const dateFormat = this.changeIntToStrDate(dateVal.valueOf());
              return this.modelEmitFormat(dateFormat);
            }
          }
          return '';
        }
        changeModel(val) {
          if (val) {
            const value = Array.isArray(val) ? val[0] : val;
            this.month = new Date(value).getMonth() + 1;
            this.year = new Date(value).getFullYear();
          }
        }
        mounted() {
          if (this.modificationModel) {
            const value = Array.isArray(this.modificationModel) ? this.modificationModel[0] : this.modificationModel;
            this.month = new Date(value).getMonth() + 1;
            this.year = new Date(value).getFullYear();
          }
          if (this.isSetInput) {
            const input = this.inputContent.getElementsByTagName('input');
            // @ts-ignore
            input[0].addEventListener('beforeinput', event => {
              maskInput(event, this.period);
            });
          }
        }
        toggleHover(event) {
          const input = this.inputContent.getElementsByClassName('RInput');
          const isHover = input[0].classList.contains('hover');
          if (isHover && event.type === 'mouseleave') {
            input[0].classList.remove('hover');
          } else if (event.type === 'mouseenter') {
            input[0].classList.add('hover');
          }
        }
        get attrsInput() {
          const attrs = {};
          if (!this.disabled) {
            attrs.tabIndex = 0;
          }
          return attrs;
        }
        render(h) {
          if (this.inline) {
            return this.viewRenderCalendar;
          }
          return h(components_RPopover, {
            ref: 'popover',
            props: {
              contentOffsetActivator: 8,
              value: this.isOpen,
              ...this.popoverOptionsSelect,
              position: this.positionContent
            },
            on: {
              input: val => {
                this.isOpen = val;
                if (!val) {
                  this.$emit('focusout');
                }
              }
            },
            scopedSlots: {
              activator: scoped => h('label', {
                ref: 'input',
                attrs: this.attrsInput,
                staticClass: 'RDatePicker__input',
                class: {
                  disabled: this.disabled
                },
                on: {
                  click: () => {
                    scoped.on.click();
                  },
                  keydown: event => {
                    if (!this.isSetInput) {
                      if (event.code === 'Space') {
                        scoped.on.click();
                        // @ts-ignore
                        const {
                          uid
                        } = this.popoverContent;
                        findPopoverFocus(uid);
                        // @ts-ignore
                        event.target.blur();
                      }
                    }
                  },
                  mouseenter: this.toggleHover,
                  mouseleave: this.toggleHover
                }
              }, [!this.isSetInput && h('div', {
                class: ['RSelect__backdoor']
              }), h(components_RInput, {
                props: {
                  label: this.label,
                  value: this.input,
                  readonly: !this.isSetInput,
                  afterIcon: 'calendar',
                  error: this.error,
                  errorMessage: this.errorMessage,
                  isClear: this.isClearModel,
                  isTabIndex: false
                },
                on: {
                  clearModel: () => {
                    this.$emit('input', null);
                  },
                  eventAfterIcon: () => {
                    scoped.on.click();
                  },
                  focus: () => {
                    this.isSetInput && scoped.on.click();
                  },
                  blur: () => {
                    const input = this.inputContent.getElementsByTagName('input');
                    const date = input[0].value;
                    if (this.period) {
                      const arrDate = date.split('–');
                      if (arrDate.length === 2) {
                        const d1 = this.changeDateFormatInput(arrDate[0]);
                        const d2 = this.changeDateFormatInput(arrDate[1]);
                        if (d1 && d2) {
                          this.$emit('input', [d1, d2]);
                        }
                      } else {
                        this.$emit('input', []);
                      }
                    } else {
                      const d = this.changeDateFormatInput(date);
                      if (d) {
                        this.$emit('input', d);
                      } else {
                        this.$emit('input', null);
                      }
                    }
                  }
                }
              })])
            }
          }, [this.viewRenderCalendar]);
        }
      };
      RDatePicker_decorate([VModel({
        type: [String, Number, Array]
      })], RDatePicker.prototype, "model", void 0);
      RDatePicker_decorate([Prop({
        type: Boolean
      })], RDatePicker.prototype, "disabled", void 0);
      RDatePicker_decorate([Prop({
        type: Boolean
      })], RDatePicker.prototype, "inline", void 0);
      RDatePicker_decorate([Prop({
        type: Boolean
      })], RDatePicker.prototype, "clickClose", void 0);
      RDatePicker_decorate([Prop({
        type: Boolean
      })], RDatePicker.prototype, "period", void 0);
      RDatePicker_decorate([Prop({
        type: String,
        default: null
      })], RDatePicker.prototype, "label", void 0);
      RDatePicker_decorate([Prop({
        type: String,
        default: null
      })], RDatePicker.prototype, "startDate", void 0);
      RDatePicker_decorate([Prop({
        type: String,
        default: null
      })], RDatePicker.prototype, "endDate", void 0);
      RDatePicker_decorate([Prop({
        type: Boolean
      })], RDatePicker.prototype, "isClearModel", void 0);
      RDatePicker_decorate([Prop({
        type: Boolean
      })], RDatePicker.prototype, "error", void 0);
      RDatePicker_decorate([Prop({
        type: Boolean
      })], RDatePicker.prototype, "isTimestamp", void 0);
      RDatePicker_decorate([Prop({
        type: Boolean
      })], RDatePicker.prototype, "isSetInput", void 0);
      RDatePicker_decorate([Prop({
        type: String,
        default: null
      })], RDatePicker.prototype, "errorMessage", void 0);
      RDatePicker_decorate([Prop({
        type: Object,
        default: () => ({
          isCheckAutoScrollBlock: false
        })
      })], RDatePicker.prototype, "popoverOptions", void 0);
      RDatePicker_decorate([Ref('input')], RDatePicker.prototype, "inputContent", void 0);
      RDatePicker_decorate([Ref('popover')], RDatePicker.prototype, "popoverContent", void 0);
      RDatePicker_decorate([Watch('model')], RDatePicker.prototype, "changeModel", null);
      RDatePicker = RDatePicker_decorate([vue_class_component_esm({
        components: {
          RPopover: components_RPopover,
          RInput: components_RInput,
          RDatePickerDay: components_RDatePickerDay,
          RButtonAction: components_RButtonAction
        }
      })], RDatePicker);
      /* harmony default export */ var RDatePicker_RDatePicker = (RDatePicker);
      ;// CONCATENATED MODULE: ./src/components/RDatePicker/index.ts


      RDatePicker_RDatePicker.install = vue => {
        vue.component('r-date-picker', RDatePicker_RDatePicker);
      };
      /* harmony default export */ var components_RDatePicker = (RDatePicker_RDatePicker);
      ;// CONCATENATED MODULE: ./src/components/RTimePicker/RTimePicker.ts


      var RTimePicker_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };





      let RTimePicker = class RTimePicker extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "isOpen", false);
          _defineProperty(this, "isFocusOut", false);
          _defineProperty(this, "positionContent", 'center-bottom');
          _defineProperty(this, "value", void 0);
          _defineProperty(this, "disabled", void 0);
          _defineProperty(this, "stepMinutes", void 0);
          _defineProperty(this, "isSeconds", void 0);
          _defineProperty(this, "startTime", void 0);
          _defineProperty(this, "endTime", void 0);
          _defineProperty(this, "label", void 0);
          _defineProperty(this, "isClearModel", void 0);
          _defineProperty(this, "error", void 0);
          _defineProperty(this, "errorMessage", void 0);
          _defineProperty(this, "popoverOptions", void 0);
          _defineProperty(this, "inputContent", void 0);
          _defineProperty(this, "popoverContent", void 0);
        }
        get popoverOptionsSelect() {
          const {
            isCheckAutoScrollBlock = false
          } = this.popoverOptions;
          return {
            isCheckAutoScrollBlock
          };
        }
        get isRange() {
          return Array.isArray(this.value);
        }
        get blockTime() {
          const data = {
            start: ['00', '00', '00'],
            end: ['23', '59', '59']
          };
          if (this.startTime && this.startTime.indexOf(':') > -1) {
            data.start = this.startTime.split(':');
          }
          if (this.endTime && this.endTime.indexOf(':') > -1) {
            data.end = this.endTime.split(':');
          }
          return data;
        }
        get setStepMinutes() {
          return this.stepMinutes || (this.isRange ? 60 : 1);
        }
        get hoursList() {
          return this.$createElement('div', {
            staticClass: 'RTimePicker__liner'
          }, new Array(24).fill(1).map((el, index) => {
            const input = `${index}`.padStart(2, '0');
            const isDisabledBlock = !!this.blockTime.start && !!this.blockTime.start[0] && parseInt(input, 10) < parseInt(this.blockTime.start[0], 10) || !!this.blockTime.end && !!this.blockTime.end[0] && parseInt(input, 10) > parseInt(this.blockTime.end[0], 10);
            return this.$createElement('a', {
              attrs: {
                tabIndex: isDisabledBlock ? -1 : 0
              },
              staticClass: 'RTimePicker__item',
              class: [{
                active: input === this.valueModel[0],
                disabled: isDisabledBlock
              }],
              on: {
                click: () => {
                  this.setData(0, input);
                },
                keydown: event => {
                  if (event.code === 'Space') {
                    event.preventDefault();
                    this.setData(0, input);
                  }
                }
              }
            }, input);
          }));
        }
        get minutesList() {
          let countStep = Math.trunc(60 / this.setStepMinutes);
          if (countStep * this.setStepMinutes < 60) {
            countStep++;
          }
          return this.$createElement('div', {
            staticClass: 'RTimePicker__liner'
          }, new Array(countStep).fill(1).map((el, index) => {
            const input = `${index * this.setStepMinutes}`.padStart(2, '0');
            /*
        1. Проверяем часы на выбор
        2. сравниваем выбранный час для блокировки минут
       */
            const isDisabledBlock = !this.valueModel[0] || parseInt(this.valueModel[0], 10) === parseInt(this.blockTime.start[0], 10) && parseInt(input, 10) < parseInt(this.blockTime.start[1], 10) || parseInt(this.valueModel[0], 10) === parseInt(this.blockTime.end[0], 10) && parseInt(input, 10) > parseInt(this.blockTime.end[1], 10);
            return this.$createElement('a', {
              attrs: {
                tabIndex: isDisabledBlock ? -1 : 0
              },
              staticClass: 'RTimePicker__item',
              class: [{
                active: input === this.valueModel[1],
                disabled: isDisabledBlock
              }],
              on: {
                click: () => {
                  this.setData(1, input);
                },
                keydown: event => {
                  if (event.code === 'Space') {
                    event.preventDefault();
                    this.setData(1, input);
                  }
                }
              }
            }, input);
          }));
        }
        get secondsList() {
          return this.$createElement('div', {
            staticClass: 'RTimePicker__liner'
          }, new Array(60).fill(1).map((el, index) => {
            const input = `${index}`.padStart(2, '0');
            const isDisabledBlock = !this.valueModel[1] || parseInt(this.valueModel[0], 10) === parseInt(this.blockTime.start[0], 10) && parseInt(this.valueModel[1], 10) === parseInt(this.blockTime.start[1], 10) && parseInt(input, 10) < parseInt(this.blockTime.start[2], 10) || parseInt(this.valueModel[0], 10) === parseInt(this.blockTime.end[0], 10) && parseInt(this.valueModel[1], 10) === parseInt(this.blockTime.end[1], 10) && parseInt(input, 10) > parseInt(this.blockTime.end[2], 10);
            return this.$createElement('a', {
              attrs: {
                tabIndex: isDisabledBlock ? -1 : 0
              },
              staticClass: 'RTimePicker__item',
              class: [{
                active: input === this.valueModel[2],
                disabled: isDisabledBlock
              }],
              on: {
                click: () => {
                  this.setData(2, input);
                },
                keydown: event => {
                  if (event.code === 'Space') {
                    event.preventDefault();
                    this.setData(2, input);
                  }
                }
              }
            }, input);
          }));
        }
        get viewRenderPicker() {
          let content;
          if (this.isRange) {
            // @TODO подумать как оптимизировать рендеринг двух зон
            let lastIndex = false;
            const timeContentLeft = this.stepRangeTime.map((el, index) => {
              lastIndex = lastIndex || el.endActive;
              const arrTime = el.val.split(':');
              const isDisabled = parseInt(arrTime[0], 10) < parseInt(this.blockTime.start[0], 10) || parseInt(arrTime[0], 10) === parseInt(this.blockTime.start[0], 10) && parseInt(arrTime[1], 10) < parseInt(this.blockTime.start[1], 10) || parseInt(arrTime[0], 10) > parseInt(this.blockTime.end[0], 10) || parseInt(arrTime[0], 10) === parseInt(this.blockTime.end[0], 10) && parseInt(arrTime[1], 10) > parseInt(this.blockTime.end[1], 10);
              return this.$createElement('a', {
                attrs: {
                  tabIndex: lastIndex || isDisabled ? -1 : 0
                },
                staticClass: 'RTimePicker__item',
                class: ['range', {
                  active: el.startActive,
                  disabled: lastIndex || isDisabled,
                  hover: el.hover,
                  last: this.stepRangeTime[index + 1]?.endActive
                }],
                on: {
                  click: () => {
                    this.setData(0, el.val);
                  },
                  keydown: event => {
                    if (event.code === 'Space') {
                      event.preventDefault();
                      this.setData(0, el.val);
                    }
                  }
                }
              }, el.val);
            });
            let firstIndex = false;
            const timeContentRight = this.stepRangeTime.map((el, index) => {
              if (index !== 0 && !firstIndex) {
                firstIndex = this.stepRangeTime[index - 1].val === this.valueModel[0];
              }
              const arrTime = el.val.split(':');
              const isDisabled = parseInt(arrTime[0], 10) < parseInt(this.blockTime.start[0], 10) || parseInt(arrTime[0], 10) === parseInt(this.blockTime.start[0], 10) && parseInt(arrTime[1], 10) < parseInt(this.blockTime.start[1], 10) || parseInt(arrTime[0], 10) > parseInt(this.blockTime.end[0], 10) || parseInt(arrTime[0], 10) === parseInt(this.blockTime.end[0], 10) && parseInt(arrTime[1], 10) > parseInt(this.blockTime.end[1], 10);
              return this.$createElement('a', {
                attrs: {
                  tabIndex: this.valueModel[0] && !firstIndex || isDisabled ? -1 : 0
                },
                staticClass: 'RTimePicker__item',
                class: ['range', {
                  disabled: this.valueModel[0] && !firstIndex || isDisabled,
                  active: el.endActive,
                  hover: el.hover
                }],
                on: {
                  click: () => {
                    this.setData(1, el.val);
                  },
                  keydown: event => {
                    if (event.code === 'Space') {
                      event.preventDefault();
                      this.setData(1, el.val);
                    }
                  }
                }
              }, el.val);
            });
            content = [this.$createElement('div', {
              staticClass: 'RTimePicker__liner',
              class: [{
                range: this.isRange
              }]
            }, timeContentLeft), this.$createElement('div', {
              staticClass: 'RTimePicker__liner',
              class: [{
                range: this.isRange
              }]
            }, timeContentRight)];
          } else {
            content = [this.hoursList, this.minutesList, this.isSeconds ? this.secondsList : null];
          }
          return this.$createElement('div', {
            slot: 'content',
            staticClass: 'RTimePicker',
            style: {
              width: this.isRange ? 'auto' : `${this.valueModel.length * 52}px`
            },
            on: {
              keydown: event => {
                if (event.code === 'Tab') {
                  this.isFocusOut = true;
                }
                if (event.code === 'Escape') {
                  this.isOpen = false;
                  const input = this.popoverContent.$el.getElementsByClassName('RTimePicker__input');
                  // @ts-ignore
                  input[0].focus();
                }
              },
              focusout: event => {
                if (this.isFocusOut) {
                  // @ts-ignore
                  const {
                    uid
                  } = this.popoverContent;
                  const content = document.getElementById(`content-${uid}`);
                  const input = this.popoverContent.$el.getElementsByClassName('RTimePicker__input');
                  if (content && input.length > 0) {
                    const data = tabChangeElementSelect(event, content, input[0]);
                    if (data) {
                      this.isOpen = false;
                    }
                  }
                }
                this.isFocusOut = false;
              }
            }
          }, [this.$slots.header && this.$createElement('div', {
            staticClass: 'RTimePicker__header'
          }, this.$slots.header), this.$createElement('div', {
            staticClass: 'RTimePicker__content'
          }, content)]);
        }
        get stepRangeTime() {
          const timeList = [];
          for (let i = 0; i < 1440; i += this.setStepMinutes) {
            const hours = Math.trunc(i / 60);
            const minutes = i % 60;
            const time = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
            timeList.push({
              val: time,
              startActive: this.valueModel[0] === time,
              hover: this.valueModel.length === 2 ? this.valueModel[0] < time && this.valueModel[1] > time : false,
              endActive: this.valueModel[1] === time
            });
          }
          return timeList;
        }
        get valueModel() {
          if (this.isRange) {
            return this.value;
          }
          let val;
          if (this.value) {
            val = this.value.split(':');
            if (this.isSeconds) {
              if (val.length === 2) {
                val.push('00');
              }
            } else if (val.length === 3) {
              val.pop();
            }
          } else {
            val = ['', ''];
            if (this.isSeconds) {
              val.push('');
            }
          }
          return val;
        }
        setData(index, val) {
          const valueModels = [...this.valueModel];
          valueModels[index] = val;
          this.$emit('input', this.isRange ? valueModels : valueModels.join(':'));
        }
        getPositionOnClick(event) {
          const position = this.inputContent.getBoundingClientRect();
          if (position.width > 260 && !this.isOpen) {
            const clickPosition = event.clientX - position.x;
            const selfWidth = position.width / 2;
            const partWidth = selfWidth / 2;
            if (clickPosition > selfWidth + partWidth) {
              this.positionContent = 'right-bottom';
            } else if (clickPosition < selfWidth - partWidth) {
              this.positionContent = 'left-bottom';
            } else {
              this.positionContent = 'center-bottom';
            }
          } else {
            this.positionContent = 'center-bottom';
          }
        }
        get InputViewString() {
          if (this.isRange) {
            if (!this.value.length) return null;
            return this.value.join('–');
          }
          return this.value;
        }
        toggleHover(event) {
          const input = this.inputContent.getElementsByClassName('RInput');
          const isHover = input[0].classList.contains('hover');
          if (isHover && event.type === 'mouseleave') {
            input[0].classList.remove('hover');
          } else if (event.type === 'mouseenter') {
            input[0].classList.add('hover');
          }
        }
        get attrsInput() {
          const attrs = {};
          if (!this.disabled) {
            attrs.tabIndex = 0;
          }
          return attrs;
        }
        render(h) {
          return h(components_RPopover, {
            ref: 'popover',
            props: {
              position: this.positionContent,
              value: this.isOpen,
              ...this.popoverOptionsSelect
            },
            on: {
              input: val => {
                this.isOpen = val;
                if (!val) {
                  this.$emit('focusout');
                }
              }
            },
            scopedSlots: {
              activator: scoped => h('label', {
                ref: 'input',
                staticClass: 'RTimePicker__input',
                class: {
                  disabled: this.disabled
                },
                attrs: this.attrsInput,
                on: {
                  click: () => {
                    scoped.on.click();
                  },
                  keydown: event => {
                    if (event.code === 'Space') {
                      scoped.on.click();
                      // @ts-ignore
                      const {
                        uid
                      } = this.popoverContent;
                      findPopoverFocus(uid);
                      // @ts-ignore
                      event.target.blur();
                    }
                  },
                  mouseenter: this.toggleHover,
                  mouseleave: this.toggleHover
                }
              }, [h('div', {
                class: ['RSelect__backdoor']
              }), h(components_RInput, {
                props: {
                  label: this.label,
                  value: this.InputViewString,
                  readonly: true,
                  afterIcon: 'clock',
                  error: this.error,
                  errorMessage: this.errorMessage,
                  isClear: this.isClearModel,
                  isTabIndex: false
                },
                on: {
                  clearModel: () => {
                    this.$emit('input', null);
                  }
                }
              })])
            }
          }, [this.viewRenderPicker]);
        }
      };
      RTimePicker_decorate([Model('input', {
        type: [String, Array]
      })], RTimePicker.prototype, "value", void 0);
      RTimePicker_decorate([Prop({
        type: Boolean
      })], RTimePicker.prototype, "disabled", void 0);
      RTimePicker_decorate([Prop({
        type: Number
      })], RTimePicker.prototype, "stepMinutes", void 0);
      RTimePicker_decorate([Prop({
        type: Boolean
      })], RTimePicker.prototype, "isSeconds", void 0);
      RTimePicker_decorate([Prop({
        type: String
      })], RTimePicker.prototype, "startTime", void 0);
      RTimePicker_decorate([Prop({
        type: String
      })], RTimePicker.prototype, "endTime", void 0);
      RTimePicker_decorate([Prop({
        type: String
      })], RTimePicker.prototype, "label", void 0);
      RTimePicker_decorate([Prop({
        type: Boolean,
        default: null
      })], RTimePicker.prototype, "isClearModel", void 0);
      RTimePicker_decorate([Prop({
        type: Boolean,
        default: null
      })], RTimePicker.prototype, "error", void 0);
      RTimePicker_decorate([Prop({
        type: String,
        default: null
      })], RTimePicker.prototype, "errorMessage", void 0);
      RTimePicker_decorate([Prop({
        type: Object,
        default: () => ({
          isCheckAutoScrollBlock: false
        })
      })], RTimePicker.prototype, "popoverOptions", void 0);
      RTimePicker_decorate([Ref('input')], RTimePicker.prototype, "inputContent", void 0);
      RTimePicker_decorate([Ref('popover')], RTimePicker.prototype, "popoverContent", void 0);
      RTimePicker = RTimePicker_decorate([vue_class_component_esm({
        components: {
          RPopover: components_RPopover,
          RInput: components_RInput
        }
      })], RTimePicker);
      /* harmony default export */ var RTimePicker_RTimePicker = (RTimePicker);
      ;// CONCATENATED MODULE: ./src/components/RTimePicker/index.ts


      RTimePicker_RTimePicker.install = vue => {
        vue.component('r-time-picker', RTimePicker_RTimePicker);
      };
      /* harmony default export */ var components_RTimePicker = (RTimePicker_RTimePicker);
      ;// CONCATENATED MODULE: ./src/components/RBulb/RBulb.ts

      var RBulb_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };


      let RBulb = class RBulb extends component {
        constructor(...args) {
          super(...args);
          // пропа для типа relative или absolute - block = relative
          _defineProperty(this, "isBlock", void 0);
          _defineProperty(this, "isShape", void 0);
          _defineProperty(this, "color", void 0);
          _defineProperty(this, "size", void 0);
          _defineProperty(this, "title", void 0);
          /*
    1) по верхнему углу прижат к контенту - eluno
    2) ниже на 2px верхнего угла прижат к контенту - polyxo
    3) отступ от края на 8px верхний угол - celano
    4) отступ от края на 4px верхний угол - salamis
    4) ниже на 8px верхнего угла и -8px внутрь контента - nikaia
     */
          _defineProperty(this, "position", void 0);
        }
        render(h) {
          return h('div', {
            staticClass: 'RBulb'
          }, [this.$slots.content, h('div', {
            staticClass: 'RBulb__badge',
            class: [this.color, this.size, this.position, {
              title: !!this.title,
              block: this.isBlock,
              shape: this.isShape
            }]
          }, this.title)]);
        }
      };
      RBulb_decorate([Prop({
        type: Boolean
      })], RBulb.prototype, "isBlock", void 0);
      RBulb_decorate([Prop({
        type: Boolean
      })], RBulb.prototype, "isShape", void 0);
      RBulb_decorate([Prop({
        type: String,
        default: 'rocky'
      })], RBulb.prototype, "color", void 0);
      RBulb_decorate([Prop({
        type: String,
        default: 'marina'
      })], RBulb.prototype, "size", void 0);
      RBulb_decorate([Prop({
        type: String
      })], RBulb.prototype, "title", void 0);
      RBulb_decorate([Prop({
        type: String,
        default: 'eluno'
      })], RBulb.prototype, "position", void 0);
      RBulb = RBulb_decorate([vue_class_component_esm], RBulb);
      /* harmony default export */ var RBulb_RBulb = (RBulb);
      ;// CONCATENATED MODULE: ./src/components/RBulb/index.ts


      RBulb_RBulb.install = vue => {
        vue.component('r-bulb', RBulb_RBulb);
      };
      /* harmony default export */ var components_RBulb = (RBulb_RBulb);
      ;// CONCATENATED MODULE: ./src/components/RTabs/RTabs.ts

      var RTabs_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };




      let RTabs = class RTabs extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "tabActive", null);
          _defineProperty(this, "isArrow", false);
          _defineProperty(this, "isArrowLeftDisabled", true);
          _defineProperty(this, "isArrowRightDisabled", false);
          _defineProperty(this, "val", void 0);
          _defineProperty(this, "items", void 0);
          _defineProperty(this, "type", void 0);
          _defineProperty(this, "idValue", void 0);
          _defineProperty(this, "titleValue", void 0);
          _defineProperty(this, "content", void 0);
        }
        colorBulb(tabId, colorBulb = 'rocky') {
          return this.itemActive && this.itemActive[this.idValue] === tabId && this.type === 'rounded' ? 'white' : colorBulb;
        }
        get tabsView() {
          if (!this.items) {
            return [];
          }
          this.$nextTick(() => {
            this.checkArrowView();
          });
          return this.items.map(tab => {
            const isOptionsBulb = !!tab.optionsBulb;
            const optionsBulb = tab.optionsBulb || {};
            const viewContent = this.$createElement(components_RBulb, {
              props: {
                isBlock: isOptionsBulb,
                position: 'salamis',
                size: 'strophia',
                title: optionsBulb.title,
                color: this.colorBulb(tab[this.idValue], optionsBulb.color)
              }
            }, [this.$createElement('span', {
              staticClass: 'RTabs__title',
              class: [{
                active: this.itemActive && this.itemActive[this.idValue] === tab[this.idValue]
              }],
              slot: 'content'
            }, tab[this.titleValue])]);
            return this.$createElement('div', {
              staticClass: 'RTabs__tab',
              class: [{
                active: this.itemActive && this.itemActive[this.idValue] === tab[this.idValue],
                disabled: tab.disabled
              }],
              on: {
                click: event => {
                  this.selectTab(tab, event);
                }
              }
            }, [viewContent]);
          });
        }
        checkArrowView() {
          if (this.$refs.tabs) {
            setTimeout(() => {
              if (this.content) {
                this.isArrow = this.content.scrollWidth > this.content.clientWidth;
              }
            });
          }
        }
        selectTab(tab, event) {
          const tabsContent = this.$refs.tabs;
          const el = event.target;
          if (el.offsetLeft + el.clientWidth > tabsContent.clientWidth + tabsContent.scrollLeft) {
            this.changeScrollPosition('right');
          } else if (el.offsetLeft < tabsContent.scrollLeft) {
            this.changeScrollPosition('left');
          }
          this.tabActive = tab;
          this.$emit('input', tab);
        }
        changeScrollPosition(type) {
          const tabsContent = this.$refs.tabs;
          let children = [...tabsContent.childNodes];
          if (type === 'left') {
            children = children.reverse();
          }
          let offsetLeft = 0;
          // eslint-disable-next-line guard-for-in,no-restricted-syntax
          block: for (const index in children) {
            const el = children[index];
            if (!el.classList.contains('RTabs__arrow')) {
              switch (type) {
                case 'left':
                  if (el.offsetLeft < tabsContent.scrollLeft) {
                    offsetLeft = el.offsetLeft + el.clientWidth - tabsContent.clientWidth;
                    break block;
                  }
                  break;
                default:
                  if (el.offsetLeft + el.clientWidth > tabsContent.clientWidth + tabsContent.scrollLeft) {
                    offsetLeft = el.offsetLeft;
                    break block;
                  }
              }
            }
          }
          tabsContent.scroll({
            left: offsetLeft,
            behavior: 'smooth'
          });
          this.isArrowLeftDisabled = offsetLeft <= 0;
          this.isArrowRightDisabled = offsetLeft + tabsContent.clientWidth >= tabsContent.scrollWidth;
        }
        get itemActive() {
          return this.val || this.tabActive;
        }
        mounted() {
          this.tabActive = this.val;
        }
        widthChange() {
          this.checkArrowView();
        }
        render(h) {
          return h('section', {
            staticClass: 'RTabs',
            class: [this.type, {
              arrow: this.isArrow
            }]
          }, [this.isArrow && h('div', {
            staticClass: 'RTabs__arrow',
            class: {
              disabled: this.isArrowLeftDisabled
            },
            on: {
              click: () => this.changeScrollPosition('left')
            }
          }, [h(components_RIcon, {
            props: {
              icon: 'arrow-left'
            }
          })]), h('div', {
            ref: 'tabs',
            staticClass: 'RTabs__content'
          }, this.tabsView), this.isArrow && h('div', {
            staticClass: 'RTabs__arrow',
            class: {
              disabled: this.isArrowRightDisabled
            },
            on: {
              click: () => this.changeScrollPosition('right')
            }
          }, [h(components_RIcon, {
            props: {
              icon: 'arrow-right'
            }
          })])]);
        }
      };
      RTabs_decorate([VModel({
        type: Object
      })], RTabs.prototype, "val", void 0);
      RTabs_decorate([Prop({
        type: Array,
        default: []
      })], RTabs.prototype, "items", void 0);
      RTabs_decorate([Prop({
        type: String,
        default: 'default'
      })], RTabs.prototype, "type", void 0);
      RTabs_decorate([Prop({
        type: String,
        default: 'id'
      })], RTabs.prototype, "idValue", void 0);
      RTabs_decorate([Prop({
        type: String,
        default: 'title'
      })], RTabs.prototype, "titleValue", void 0);
      RTabs_decorate([Ref('tabs')], RTabs.prototype, "content", void 0);
      RTabs_decorate([Watch('$rir.breakpoints.width')], RTabs.prototype, "widthChange", null);
      RTabs = RTabs_decorate([vue_class_component_esm({
        components: {
          RIcon: components_RIcon,
          RBulb: components_RBulb
        }
      })], RTabs);
      /* harmony default export */ var RTabs_RTabs = (RTabs);
      ;// CONCATENATED MODULE: ./src/components/RTabs/index.ts


      RTabs_RTabs.install = vue => {
        vue.component('r-tabs', RTabs_RTabs);
      };
      /* harmony default export */ var components_RTabs = (RTabs_RTabs);
      ;// CONCATENATED MODULE: ./src/components/RTooltip/RTooltip.ts

      var RTooltip_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };



      let RTooltip = class RTooltip extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "uid", void 0);
          _defineProperty(this, "isOpen", false);
          _defineProperty(this, "isView", false);
          _defineProperty(this, "styleContent", {});
          _defineProperty(this, "title", void 0);
          _defineProperty(this, "position", void 0);
          _defineProperty(this, "isArrow", void 0);
          _defineProperty(this, "disabled", void 0);
          _defineProperty(this, "alignTitle", void 0);
          _defineProperty(this, "maxWidth", void 0);
          _defineProperty(this, "content", void 0);
          _defineProperty(this, "activator", void 0);
          _defineProperty(this, "arrow", void 0);
        }
        slotScopedView() {
          if (!this.$scopedSlots.activator) return null;
          // @TODO Доработать открытие по клику
          return this.$scopedSlots.activator({});
        }
        getPosition() {
          if (this.isOpen) return;
          this.isOpen = true;
          this.$nextTick(() => {
            const activator = '$el' in this.activator ? this.activator.$el : this.activator;
            const content = '$el' in this.content ? this.content.$el : this.content;
            const offsetContent = parseInt(window.getComputedStyle(content).margin, 10) || 0;
            Object.assign(content.style, {
              margin: 0,
              maxWidth: this.maxWidth
            });
            const contentParentPopover = activator.closest('.RPopover__content') || activator.closest('.RModal__content') || document.body;
            contentParentPopover.insertBefore(content, contentParentPopover.firstChild);
            const activatorData = getPositionActivator(activator, contentParentPopover);
            const contentData = content.getBoundingClientRect();
            const styles = setPositionContent(activatorData, contentData, this.position, false, offsetContent, contentParentPopover, this.alignTitle, this.arrow);
            if (this.isArrow && this.position.indexOf('center') >= 0) {
              //  - parseInt(window.getComputedStyle(this.arrow).borderTopWidth, 10)
              const top = parseInt(styles.top, 10) + content.clientHeight / 2;
              styles.top = `${top - 12}px`;
            }
            this.styleContent = styles;
            this.isView = true;
          });
        }
        destroyed() {
          document?.getElementById(`content-${this.uid}`)?.remove();
        }
        mounted() {
          this.uid = uniqueID();
        }
        render(h) {
          return h('div', {
            staticClass: 'RTooltip'
          }, [h('div', {
            ref: 'activator',
            staticClass: 'RTooltip__activator',
            on: {
              mouseenter: this.getPosition,
              mouseleave: () => {
                this.isView = false;
                // @TODO timeout перенести в CSS var
                setTimeout(() => {
                  this.isOpen = false;
                }, 300);
              }
            }
          }, [this.slotScopedView()]), this.isOpen && h('div', {
            ref: 'content',
            domProps: {
              id: `content-${this.uid}`
            },
            staticClass: 'RTooltip__content',
            class: [this.position, this.isArrow && this.alignTitle, {
              arrow: this.isArrow,
              view: this.isView,
              disabled: this.disabled
            }],
            style: {
              ...this.styleContent
            }
          }, [this.title, this.isArrow && h('div', {
            ref: 'arrow',
            staticClass: 'RTooltip__arrow',
            class: [this.position, this.alignTitle]
          })])]);
        }
      };
      RTooltip_decorate([Prop({
        type: String,
        required: true
      })], RTooltip.prototype, "title", void 0);
      RTooltip_decorate([Prop({
        type: String,
        default: 'bottom-center'
      })], RTooltip.prototype, "position", void 0);
      RTooltip_decorate([Prop({
        type: Boolean
      })], RTooltip.prototype, "isArrow", void 0);
      RTooltip_decorate([Prop({
        type: Boolean
      })], RTooltip.prototype, "disabled", void 0);
      RTooltip_decorate([Prop({
        type: String,
        default: 'start'
      })], RTooltip.prototype, "alignTitle", void 0);
      RTooltip_decorate([Prop({
        type: String,
        default: '150px'
      })], RTooltip.prototype, "maxWidth", void 0);
      RTooltip_decorate([Ref('content')], RTooltip.prototype, "content", void 0);
      RTooltip_decorate([Ref('activator')], RTooltip.prototype, "activator", void 0);
      RTooltip_decorate([Ref('arrow')], RTooltip.prototype, "arrow", void 0);
      RTooltip = RTooltip_decorate([vue_class_component_esm], RTooltip);
      /* harmony default export */ var RTooltip_RTooltip = (RTooltip);
      ;// CONCATENATED MODULE: ./src/components/RTooltip/index.ts


      RTooltip_RTooltip.install = vue => {
        vue.component('r-tooltip', RTooltip_RTooltip);
      };
      /* harmony default export */ var components_RTooltip = (RTooltip_RTooltip);
      ;// CONCATENATED MODULE: ./src/components/RUploader/ConfirmModal/index.ts

      var ConfirmModal_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };






      let ConfirmModal = class ConfirmModal extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "errorList", void 0);
          _defineProperty(this, "countFiles", void 0);
        }
        get countTextFiles() {
          const countErr = this.errorList.length;
          return countErr < 2 ? 'Файл не был загружен' : `Не было загружено ${countErr} из ${this.countFiles} файлов`;
        }
        get sizeIcon() {
          return this.$rir.breakpoints.name === 'narrow' ? 32 : 56;
        }
        render(h) {
          return h('div', [h(RRow_RRow, {
            props: {
              wrap: true,
              type: 'default'
            },
            class: ['mb-4']
          }, [h(RCol_RCol, {
            props: {
              cols: {
                widest: 8,
                wide: 8,
                middle: 6,
                narrow: 6
              },
              offset: {
                widest: 2,
                wide: 2,
                middle: 0,
                narrow: 0
              }
            }
          }, [h(RIcon_RIcon, {
            props: {
              icon: 'close',
              fill: 'fargo',
              size: this.sizeIcon,
              class: ['RUploaderModal__icon']
            }
          })])]), h(RRow_RRow, {
            props: {
              wrap: true,
              type: 'default'
            },
            class: ['mb-4 mb-2--narrow']
          }, [h(RCol_RCol, {
            props: {
              cols: {
                widest: 8,
                wide: 8,
                middle: 6,
                narrow: 6
              },
              offset: {
                widest: 2,
                wide: 2,
                middle: 0,
                narrow: 0
              }
            }
          }, [h('h2', {
            class: ['camembert', 'burrata--narrow']
          }, 'Ошибка загрузки')])]), h(RRow_RRow, {
            props: {
              wrap: true,
              type: 'default'
            },
            class: ['mb-4 mb-3--narrow']
          }, [h(RCol_RCol, {
            props: {
              cols: {
                widest: 8,
                wide: 8,
                middle: 6,
                narrow: 6
              },
              offset: {
                widest: 2,
                wide: 2,
                middle: 0,
                narrow: 0
              }
            }
          }, [h('h2', {
            class: ['parmigiano']
          }, this.countTextFiles)])]), h(RRow_RRow, {
            props: {
              wrap: true,
              type: 'default'
            },
            class: ['mb-4 mb-3--narrow']
          }, [h(RCol_RCol, {
            props: {
              cols: {
                widest: 8,
                wide: 8,
                middle: 6,
                narrow: 6
              },
              offset: {
                widest: 2,
                wide: 2,
                middle: 0,
                narrow: 0
              }
            }
          }, this.errorList.map(el => h('div', {
            class: ['parmigiano', 'fargo--text']
          }, el.file.name)))]), h(RRow_RRow, {
            props: {
              wrap: true,
              type: 'default'
            },
            class: ['mb-4 mb-3--narrow']
          }, [h(RCol_RCol, {
            props: {
              cols: {
                widest: 8,
                wide: 8,
                middle: 6,
                narrow: 6
              },
              offset: {
                widest: 2,
                wide: 2,
                middle: 0,
                narrow: 0
              }
            }
          }, this.errorList.map(el => h('div', {
            class: ['parmigiano', 'troy--text']
          }, el.errorMessage)))]), h('div', {
            domProps: {
              id: 'RModal--actions'
            },
            class: ['mt-8', 'mt-6--narrow']
          }, [h(RRow_RRow, {
            props: {
              wrap: true,
              type: 'default'
            }
          }, [h(RCol_RCol, {
            props: {
              cols: {
                widest: 8,
                wide: 8,
                middle: 6,
                narrow: 6
              },
              offset: {
                widest: 2,
                wide: 2,
                middle: 0,
                narrow: 0
              }
            },
            class: ['py-3']
          }, [h(RButton_RButton, {
            props: {
              type: 'secondary',
              width: 'wide',
              title: 'Понятно'
            },
            on: {
              click: this.$rir.modal.close
            }
          })])])])]);
        }
      };
      ConfirmModal_decorate([Prop({
        type: Array,
        default: () => []
      })], ConfirmModal.prototype, "errorList", void 0);
      ConfirmModal_decorate([Prop({
        type: Number,
        default: 0
      })], ConfirmModal.prototype, "countFiles", void 0);
      ConfirmModal = ConfirmModal_decorate([vue_class_component_esm], ConfirmModal);
      /* harmony default export */ var RUploader_ConfirmModal = (ConfirmModal);
      ;// CONCATENATED MODULE: ./src/components/RUploader/RUploader.ts


      var RUploader_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };





      /*
  @TODO реализовать возможность передачи файлов через value и убрать возврат ответа
    в функции callback
 */
      let RUploader = class RUploader extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "uid", void 0);
          _defineProperty(this, "isUpload", false);
          _defineProperty(this, "loadProgress", 0);
          _defineProperty(this, "errorList", []);
          _defineProperty(this, "val", void 0);
          _defineProperty(this, "disabled", void 0);
          _defineProperty(this, "title", void 0);
          _defineProperty(this, "subTitle", void 0);
          _defineProperty(this, "maxFiles", void 0);
          _defineProperty(this, "maxSize", void 0);
          _defineProperty(this, "accept", void 0);
          _defineProperty(this, "callback", void 0);
          _defineProperty(this, "callbackError", void 0);
          _defineProperty(this, "attach", void 0);
        }
        get viewUploading() {
          if (!this.isUpload) return null;
          return this.$createElement('div', {
            staticClass: 'RUploader__uploading'
          }, [this.$createElement('span', 'Загрузка...'), this.viewSubTitle, this.$createElement('div', {
            staticClass: 'RUploader__line',
            style: {
              width: `${this.loadProgress}%`
            }
          })]);
        }
        get viewSubTitle() {
          if (!this.subTitle) {
            return null;
          }
          return this.$createElement('div', {
            staticClass: 'RUploader__sub-title',
            class: [{
              limit: this.isFullLimit
            }]
          }, !this.isFullLimit ? this.subTitle : 'Вы уже загрузили максимум файлов');
        }
        get viewAttach() {
          if (this.isUpload) return null;
          return this.$createElement('label', {
            staticClass: 'RUploader__attach',
            class: [{
              disabled: this.disabled || this.isFullLimit
            }],
            ref: 'attach',
            attrs: {
              for: this.uid
            },
            on: {
              dragenter: e => {
                e.preventDefault();
                e.stopPropagation();
                this.attach.classList.add('hover');
              },
              dragover: e => {
                e.preventDefault();
                e.stopPropagation();
                this.attach.classList.add('hover');
              },
              dragleave: e => {
                e.preventDefault();
                e.stopPropagation();
                this.attach.classList.remove('hover');
              },
              drop: e => {
                e.preventDefault();
                e.stopPropagation();
                this.attach.classList.remove('hover');
                const dt = e.dataTransfer;
                if (dt) {
                  this.handleFiles(dt);
                }
              }
            }
          }, [this.$createElement('div', {
            staticClass: 'RUploader__content'
          }, [this.$createElement('div', {
            staticClass: 'RUploader__title'
          }, [this.$createElement(components_RIcon, {
            props: {
              icon: 'attach'
            }
          }), this.$createElement('span', this.title)]), this.viewSubTitle]), this.$createElement('input', {
            attrs: {
              id: this.uid,
              type: 'file',
              multiple: this.maxFiles !== 1,
              accept: this.accept.join(', ')
            },
            on: {
              change: this.handleFiles
            }
          })]);
        }
        get isCheckFiles() {
          return !!this.maxFiles || !!this.maxSize || !!this.accept;
        }
        get isFullLimit() {
          return !!this.maxFiles && this.val.length >= this.maxFiles;
        }
        get filesSize() {
          return this.val.reduce((acc, el) => {
            // eslint-disable-next-line no-param-reassign
            acc += el.size;
            return acc;
          }, 0);
        }
        async handleFiles(event) {
          const {
            files
          } = event.target || event;
          // console.log(files);
          this.isUpload = true;
          if (files) {
            const maxSize = this.maxSize * 1024 * 1024;
            const oneStepLoad = 100 / files.length;
            const itemsFile = [...this.val];
            for (const file of files) {
              const fileData = {
                success: false,
                error: false,
                errorMessage: null,
                file
              };
              if (this.isCheckFiles) {
                if (this.isFullLimit) {
                  fileData.error = true;
                  fileData.errorMessage = 'Превышен максимальный лимит файлов';
                }
                if (!!maxSize && this.filesSize + file.size > maxSize) {
                  fileData.error = true;
                  fileData.errorMessage = 'Превышен максимальный объем файлов';
                }
                if (!!this.accept.length && !this.accept.includes(file.type)) {
                  fileData.error = true;
                  fileData.errorMessage = 'Не верный формат файла';
                }
                if (fileData.error) {
                  this.errorList.push(fileData);
                  this.loadProgress += oneStepLoad;
                  continue;
                }
              }
              if (this.callback) {
                const data = await this.callback(fileData);
                this.loadProgress += oneStepLoad;
                if (data) {
                  if (data.success) {
                    itemsFile.push(data.file);
                  } else {
                    this.errorList.push(data);
                  }
                }
              } else {
                // @ts-ignore
                const url = URL.createObjectURL(fileData.file);
                itemsFile.push({
                  type: fileData.file.type,
                  size: fileData.file.size,
                  name: fileData.file.name,
                  url,
                  file
                });
              }
            }
            if (this.errorList.length) {
              if (this.callbackError) {
                this.callbackError(this.errorList);
              } else {
                await this.$rir.modal.open(RUploader_ConfirmModal, {
                  errorList: this.errorList,
                  countFiles: files.length
                });
              }
            }
            if (itemsFile.length > this.val.length) {
              this.$emit('input', itemsFile);
            }
          }
          if (event instanceof Event) {
            event.srcElement && (event.srcElement.value = '');
          }
          this.errorList = [];
          this.loadProgress = 0;
          this.isUpload = false;
        }
        mounted() {
          this.uid = uniqueID();
        }
        render(h) {
          return h('section', {
            staticClass: 'RUploader',
            class: [{
              disabled: this.disabled || this.isFullLimit
            }]
          }, [this.viewUploading, this.viewAttach]);
        }
      };
      RUploader_decorate([VModel({
        type: Array,
        default: () => []
      })], RUploader.prototype, "val", void 0);
      RUploader_decorate([Prop({
        type: Boolean
      })], RUploader.prototype, "disabled", void 0);
      RUploader_decorate([Prop({
        type: String,
        required: true
      })], RUploader.prototype, "title", void 0);
      RUploader_decorate([Prop({
        type: String,
        required: true
      })], RUploader.prototype, "subTitle", void 0);
      RUploader_decorate([Prop({
        type: Number,
        default: 0
      })], RUploader.prototype, "maxFiles", void 0);
      RUploader_decorate([Prop({
        type: Number,
        default: 0
      })], RUploader.prototype, "maxSize", void 0);
      RUploader_decorate([Prop({
        type: Array,
        default: () => []
      })], RUploader.prototype, "accept", void 0);
      RUploader_decorate([Prop({
        type: Function
      })], RUploader.prototype, "callback", void 0);
      RUploader_decorate([Prop({
        type: Function
      })], RUploader.prototype, "callbackError", void 0);
      RUploader_decorate([Ref('attach')], RUploader.prototype, "attach", void 0);
      RUploader = RUploader_decorate([vue_class_component_esm({
        components: {
          RIcon: components_RIcon
        }
      })], RUploader);
      /* harmony default export */ var RUploader_RUploader = (RUploader);
      ;// CONCATENATED MODULE: ./src/components/RUploader/index.ts


      RUploader_RUploader.install = vue => {
        vue.component('r-uploader', RUploader_RUploader);
      };
      /* harmony default export */ var components_RUploader = (RUploader_RUploader);
      ;// CONCATENATED MODULE: ./src/components/RFile/RFile.ts

      var RFile_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };





      let RFile = class RFile extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "type", void 0);
          _defineProperty(this, "file", void 0);
          _defineProperty(this, "iconPreview", void 0);
          _defineProperty(this, "title", void 0);
          _defineProperty(this, "subTitle", void 0);
          _defineProperty(this, "buttonSimpleOption", void 0);
        }
        get isFileImage() {
          return this.file && this.file.type.split('/')[0] === 'image';
        }
        get viewPreview() {
          let preview;
          if (this.isFileImage) {
            preview = this.$createElement(components_RImage, {
              props: {
                rounded: 'bana',
                url: this.file.url,
                ratio: this.type === 'default' ? 'kano' : 'rada'
              }
            });
          } else {
            preview = this.$createElement(components_RIcon, {
              props: {
                icon: this.iconPreview
              }
            });
          }
          return this.$createElement('section', {
            staticClass: 'RFile__preview',
            class: {
              event: this.$listeners.clickPreview
            },
            on: {
              click: event => {
                event.stopPropagation();
                this.$emit('clickPreview', this.file);
              }
            }
          }, [preview]);
        }
        render(h) {
          return h('section', {
            staticClass: 'RFile',
            class: [this.type, {
              event: this.$listeners.click
            }],
            on: {
              click: () => this.$emit('click', this.file)
            }
          }, [this.viewPreview, h('div', {
            staticClass: 'RFile__content'
          }, [h('div', {
            staticClass: 'RFile__title'
          }, this.title), this.subTitle && h('div', {
            staticClass: 'RFile__sub-title'
          }, this.subTitle)]), this.buttonSimpleOption && h(components_RButtonSimple, {
            staticClass: 'RFile__actions',
            props: {
              ...this.buttonSimpleOption,
              type: 'transparent',
              size: this.type === 'default' ? 'monithei' : 'spelino'
            },
            on: {
              click: event => {
                event.stopPropagation();
                this.$emit('actions', this.file);
              }
            }
          })]);
        }
      };
      RFile_decorate([Prop({
        type: String,
        default: 'default'
      })], RFile.prototype, "type", void 0);
      RFile_decorate([Prop({
        type: Object,
        required: true
      })], RFile.prototype, "file", void 0);
      RFile_decorate([Prop({
        type: String,
        default: 'file'
      })], RFile.prototype, "iconPreview", void 0);
      RFile_decorate([Prop({
        type: String,
        required: true
      })], RFile.prototype, "title", void 0);
      RFile_decorate([Prop({
        type: String,
        default: null
      })], RFile.prototype, "subTitle", void 0);
      RFile_decorate([Prop({
        type: Object
      })], RFile.prototype, "buttonSimpleOption", void 0);
      RFile = RFile_decorate([vue_class_component_esm({
        components: {
          RIcon: components_RIcon,
          RImage: components_RImage,
          RButtonSimple: components_RButtonSimple
        }
      })], RFile);
      /* harmony default export */ var RFile_RFile = (RFile);
      ;// CONCATENATED MODULE: ./src/components/RFile/index.ts


      RFile_RFile.install = vue => {
        vue.component('r-file', RFile_RFile);
      };
      /* harmony default export */ var components_RFile = (RFile_RFile);
      ;// CONCATENATED MODULE: ./src/components/RButtonArrow/RButtonArrow.ts

      var RButtonArrow_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };



      let RButtonArrow = class RButtonArrow extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "type", void 0);
          _defineProperty(this, "direction", void 0);
          _defineProperty(this, "size", void 0);
          _defineProperty(this, "disabled", void 0);
        }
        render(h) {
          return h('button', {
            staticClass: 'RButtonArrow',
            class: [this.size, this.type, {
              disabled: this.disabled
            }],
            on: {
              click: () => this.$emit('click')
            }
          }, [h(components_RIcon, {
            props: {
              icon: `arrow-${this.direction}`
            }
          })]);
        }
      };
      RButtonArrow_decorate([Prop({
        type: String,
        default: 'default'
      })], RButtonArrow.prototype, "type", void 0);
      RButtonArrow_decorate([Prop({
        type: String,
        default: 'left'
      })], RButtonArrow.prototype, "direction", void 0);
      RButtonArrow_decorate([Prop({
        type: String,
        default: 'klymentise'
      })], RButtonArrow.prototype, "size", void 0);
      RButtonArrow_decorate([Prop({
        type: Boolean
      })], RButtonArrow.prototype, "disabled", void 0);
      RButtonArrow = RButtonArrow_decorate([vue_class_component_esm({
        components: {
          RIcon: components_RIcon
        }
      })], RButtonArrow);
      /* harmony default export */ var RButtonArrow_RButtonArrow = (RButtonArrow);
      ;// CONCATENATED MODULE: ./src/components/RButtonArrow/index.ts


      RButtonArrow_RButtonArrow.install = vue => {
        vue.component('r-button-arrow', RButtonArrow_RButtonArrow);
      };
      /* harmony default export */ var components_RButtonArrow = (RButtonArrow_RButtonArrow);
      ;// CONCATENATED MODULE: ./src/components/RMenu/components/RMenuItem.ts


      var RMenuItem_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };




      let RMenuItem = class RMenuItem extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "openChild", false);
          _defineProperty(this, "pathRoute", '');
          _defineProperty(this, "item", void 0);
          _defineProperty(this, "isCompact", void 0);
          _defineProperty(this, "isParent", void 0);
          _defineProperty(this, "isIconChild", void 0);
          _defineProperty(this, "isIconParent", void 0);
          _defineProperty(this, "isChild", void 0);
        }
        async clickEvent(event) {
          event.preventDefault();
          if (this.item.router && !this.checkLinkPathExact) {
            await this.$router.push(this.item.router);
            this.$emit('changePath');
          } else if (this.isParent) {
            this.openChild = !this.openChild;
            if (!this.isCompact && this.$el.parentNode?.lastElementChild) {
              this.$el.parentNode.lastElementChild.style.display = this.openChild ? 'flex' : 'none';
            }
          }
        }
        get checkLinkPathExact() {
          return this.item?.router?.path === this.pathRoute;
        }
        get checkLinkPath() {
          if (this.item?.router?.exact) {
            return this.item?.router?.path === this.pathRoute;
          }
          return `${this.pathRoute}/`.indexOf(`${this.item?.router?.path}/`) === 0;
        }
        widthChange() {
          this.openChild = false;
        }
        routeChange() {
          this.pathRoute = window.location.pathname;
        }
        mounted() {
          this.pathRoute = window.location.pathname;
          this.checkOpenMenu();
        }
        checkOpenMenu() {
          if (this.isParent && this.item.children && !this.isCompact) {
            const isOpen = this.item.children.some(el => el?.router && this.pathRoute.indexOf(el.router.path) === 0);
            if (isOpen) {
              this.openChild = true;
              if (!this.isCompact && this.$el.parentNode?.lastElementChild) {
                this.$el.parentNode.lastElementChild.style.display = this.openChild ? 'flex' : 'none';
              }
            }
          }
        }
        get isChildrenActive() {
          if (this.isParent && this.item.children) {
            return this.item.children.some(el => el?.router && this.pathRoute.indexOf(el.router.path) === 0);
          }
          return false;
        }
        render(h) {
          const isIconBlock = this.isChild && this.isIconChild || !this.isChild && this.isIconParent;
          let contentIcon = null;
          let contentTitle = !this.isCompact ? h('span', {
            staticClass: 'RMenu__title'
          }, this.item.title) : null;
          if (isIconBlock) {
            contentIcon = this.item.icon ? h(components_RIcon, {
              props: {
                icon: this.item.icon
              },
              class: ['RMenu__icon']
            }) : h('span', {
              class: ['RMenu__char']
            }, this.item.title.charAt(0).toUpperCase());
          }
          if (this.item.bulbOptions) {
            if (this.isCompact) {
              contentIcon = h(components_RBulb, {
                props: {
                  color: this.item.bulbOptions.color,
                  position: 'polyxo',
                  size: 'strophia',
                  isShape: true
                }
              }, [h('template', {
                slot: 'content'
              }, [contentIcon])]);
            } else {
              contentTitle = h(components_RBulb, {
                staticClass: 'RMenu__title-bulb',
                props: {
                  ...this.item.bulbOptions,
                  position: 'celano',
                  isBlock: true
                }
              }, [h('template', {
                slot: 'content'
              }, [contentTitle])]);
            }
          }
          return h('a', {
            attrs: {
              href: this.item?.router?.path || '',
              tabIndex: -1
            },
            staticClass: 'RMenu__body',
            class: [{
              disabled: !!this.item.disabled,
              activeLink: this.checkLinkPath,
              activeChildren: this.isChildrenActive
            }],
            on: {
              click: this.clickEvent
            }
          }, [contentIcon, contentTitle, this.isParent ? h('span', {
            class: ['RMenu__arrow', {
              active: this.openChild
            }]
          }, [h(components_RIcon, {
            props: {
              icon: 'arrow-down',
              size: this.isCompact ? 8 : 16
            }
          })]) : null]);
        }
      };
      RMenuItem_decorate([Prop({
        type: Object,
        required: true
      })], RMenuItem.prototype, "item", void 0);
      RMenuItem_decorate([Prop({
        type: Boolean
      })], RMenuItem.prototype, "isCompact", void 0);
      RMenuItem_decorate([Prop({
        type: Boolean
      })], RMenuItem.prototype, "isParent", void 0);
      RMenuItem_decorate([Prop({
        type: Boolean
      })], RMenuItem.prototype, "isIconChild", void 0);
      RMenuItem_decorate([Prop({
        type: Boolean
      })], RMenuItem.prototype, "isIconParent", void 0);
      RMenuItem_decorate([Prop({
        type: Boolean
      })], RMenuItem.prototype, "isChild", void 0);
      RMenuItem_decorate([Watch('isCompact')], RMenuItem.prototype, "widthChange", null);
      RMenuItem_decorate([Watch('$route')], RMenuItem.prototype, "routeChange", null);
      RMenuItem = RMenuItem_decorate([vue_class_component_esm], RMenuItem);
      /* harmony default export */ var components_RMenuItem = (RMenuItem);
      ;// CONCATENATED MODULE: ./src/components/RMenu/RMenu.ts


      var RMenu_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };
      var RMenu_1;







      let RMenu = RMenu_1 = class RMenu extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "items", void 0);
          _defineProperty(this, "isCompact", void 0);
          _defineProperty(this, "isIconChild", void 0);
          _defineProperty(this, "isIconParent", void 0);
          _defineProperty(this, "isChild", void 0);
        }
        get viewItem() {
          if (this.items.length) {
            return this.items.map(item => {
              const isParent = !!item.children && !!item.children.length;
              const content = [this.$createElement(components_RMenuItem, {
                props: {
                  item,
                  isCompact: this.isCompact,
                  isIconChild: this.isIconChild,
                  isIconParent: this.isIconParent,
                  isChild: this.isChild,
                  isParent
                },
                on: {
                  changePath: () => {
                    this.$emit('click');
                  }
                }
              })];
              if (isParent) {
                content.push(this.$createElement(RMenu_1, {
                  props: {
                    isIconChild: this.isIconChild,
                    items: item.children,
                    isIconParent: this.isIconParent,
                    isChild: true
                  },
                  on: {
                    click: () => {
                      this.$emit('click');
                    }
                  },
                  class: ['parent']
                }));
              }
              return this.$createElement('div', {
                staticClass: 'RMenu__item'
              }, [content]);
            });
          }
          return null;
        }
        get viewItemCompact() {
          if (this.items.length) {
            return this.items.map(item => {
              const isParent = !!item.children && !!item.children.length;
              const activator = this.$createElement(components_RMenuItem, {
                props: {
                  item,
                  isCompact: this.isCompact,
                  isIconChild: this.isIconChild,
                  isChild: this.isChild,
                  isIconParent: this.isIconParent,
                  isParent
                },
                on: {
                  changePath: () => {
                    this.$emit('click');
                  }
                }
              });
              let content = [activator];
              if (isParent) {
                const parent = this.$createElement(RMenu_1, {
                  props: {
                    isIconChild: this.isIconChild,
                    items: item.children,
                    isIconParent: this.isIconParent,
                    isChild: true
                  }
                });
                content = [this.$createElement(components_RPopover, {
                  props: {
                    position: 'top-right',
                    clickClose: true,
                    isCheckAutoScrollBlock: false,
                    fixed: true
                  },
                  scopedSlots: {
                    activator: scoped => this.$createElement('div', {
                      on: scoped.on
                    }, [activator])
                  },
                  on: {
                    close: () => {
                      if (activator?.componentInstance?.openChild) {
                        activator.componentInstance.openChild = false;
                      }
                    }
                  }
                }, [this.$createElement('div', {
                  slot: 'content',
                  class: ['RMenu__popup']
                }, [parent])])];
              }
              if (this.isCompact) {
                return this.$createElement(components_RTooltip, {
                  props: {
                    title: item.title,
                    position: 'center-right'
                  },
                  scopedSlots: {
                    activator: scoped => this.$createElement('div', {
                      staticClass: 'RMenu__item',
                      on: scoped.on
                    }, [content])
                  }
                });
              }
              return this.$createElement('div', {
                staticClass: 'RMenu__item'
              }, content);
            });
          }
          return null;
        }
        render(h) {
          return h('section', {
            staticClass: 'RMenu',
            class: [{
              compact: this.isCompact
            }]
          }, this.isCompact ? this.viewItemCompact : this.viewItem);
        }
      };
      RMenu_decorate([Prop({
        type: Array,
        required: true,
        default: () => []
      })], RMenu.prototype, "items", void 0);
      RMenu_decorate([Prop({
        type: Boolean
      })], RMenu.prototype, "isCompact", void 0);
      RMenu_decorate([Prop({
        type: Boolean
      })], RMenu.prototype, "isIconChild", void 0);
      RMenu_decorate([Prop({
        type: Boolean,
        default: true
      })], RMenu.prototype, "isIconParent", void 0);
      RMenu_decorate([Prop({
        type: Boolean
      })], RMenu.prototype, "isChild", void 0);
      RMenu = RMenu_1 = RMenu_decorate([vue_class_component_esm({
        components: {
          RIcon: components_RIcon,
          RBulb: components_RBulb,
          RPopover: components_RPopover,
          RTooltip: components_RTooltip,
          RMenuItem: components_RMenuItem
        }
      })], RMenu);
      /* harmony default export */ var RMenu_RMenu = (RMenu);
      ;// CONCATENATED MODULE: ./src/components/RMenu/index.ts


      RMenu_RMenu.install = vue => {
        vue.component('r-menu', RMenu_RMenu);
      };
      /* harmony default export */ var components_RMenu = (RMenu_RMenu);
      ;// CONCATENATED MODULE: ./src/components/RLayoutDashboard/RLayoutDashboard.ts

      var RLayoutDashboard_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };






      let RLayoutDashboard = class RLayoutDashboard extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "isCompactMenu", false);
          _defineProperty(this, "isOpenMenu", false);
          _defineProperty(this, "isCompact", void 0);
          _defineProperty(this, "isOffsetContent", void 0);
          _defineProperty(this, "title", void 0);
          _defineProperty(this, "menuOptions", void 0);
          _defineProperty(this, "rMenu", void 0);
        }
        changeCompact() {
          this.isCompactMenu = !this.isCompactMenu;
          localStorage.setItem('rir-menu-compact', (+this.isCompactMenu).toString());
        }
        changeOpen() {
          this.isOpenMenu = !this.isOpenMenu;
        }
        mounted() {
          if (this.$rir.breakpoints.name === 'widest') {
            const valCompact = localStorage.getItem('rir-menu-compact');
            this.isOpenMenu = false;
            this.isCompactMenu = valCompact ? Boolean(parseInt(valCompact, 10)) : this.menuOptions.isCompact;
          } else {
            this.isCompactMenu = false;
          }
        }
        get sizeHamburger() {
          return this.$rir.breakpoints.name !== 'narrow' ? 'larishae' : 'monithei';
        }
        clickOutside(e) {
          const path = e.path || e.composedPath && e.composedPath();
          if (path.indexOf(document.getElementsByClassName('RLayoutDashboard__hamburger')[0]) < 0) {
            this.isOpenMenu = false;
          }
        }
        widthChange(val) {
          if (val === 'widest') {
            const valCompact = localStorage.getItem('rir-menu-compact');
            this.isOpenMenu = false;
            this.isCompactMenu = valCompact ? Boolean(parseInt(valCompact, 10)) : this.menuOptions.isCompact;
          } else {
            this.isCompactMenu = false;
          }
        }
        render(h) {
          return h('section', {
            staticClass: 'RLayoutDashboard'
          }, [h('div', {
            staticClass: 'RLayoutDashboard__menu',
            class: [{
              compact: this.isCompactMenu,
              open: this.isOpenMenu
            }],
            directives: [{
              name: 'click-outside',
              value: this.clickOutside
            }]
          }, [h(components_RButtonSimple, {
            staticClass: 'RLayoutDashboard__close',
            props: {
              size: this.sizeHamburger,
              icon: 'close',
              type: 'transparent',
              color: 'harakiri'
            },
            on: {
              click: this.changeOpen
            }
          }), h('div', {
            staticClass: 'RLayoutDashboard__menu-content'
          }, [this.$slots.header && h('div', {
            staticClass: 'RLayoutDashboard__header'
          }, this.$slots.header), h('div', {
            staticClass: 'RLayoutDashboard__list',
            on: {
              scroll: () => {
                // @TODO понять как закрывать поповер открытого меню при скролинге
                // console.log(this.rMenu);
                // (document as HTMLDocument)?.get('content-*')?.remove();
                // const firstP = document.evaluate(
                //   '//*[contains(@class, \'RPopover__content\')]',
                //   document,
                //   null,
                //   XPathResult.FIRST_ORDERED_NODE_TYPE,
                //   null,
                // ).singleNodeValue;
                // (firstP as HTMLElement)?.remove();
              }
            }
          }, [h(components_RMenu, {
            ref: 'rMenu',
            props: {
              ...this.menuOptions,
              isCompact: this.isCompactMenu
            },
            on: {
              click: () => {
                this.isOpenMenu = false;
              }
            }
          }), this.$slots.footer && h('div', {
            staticClass: 'RLayoutDashboard__footer'
          }, this.$slots.footer)])]), this.isCompact && h(components_RButtonArrow, {
            staticClass: 'RLayoutDashboard__compact',
            props: {
              size: 'ileneira',
              direction: 'left'
            },
            on: {
              click: this.changeCompact
            }
          })]), h('div', {
            attrs: {
              id: 'layout-main'
            },
            staticClass: 'RLayoutDashboard__body'
          }, [h('div', {
            staticClass: 'RLayoutDashboard__head'
          }, [h(components_RButtonSimple, {
            staticClass: 'RLayoutDashboard__hamburger',
            props: {
              size: this.sizeHamburger,
              icon: 'menu',
              type: 'transparent',
              color: 'harakiri'
            },
            on: {
              click: this.changeOpen
            }
          }), h('div', {
            staticClass: 'RLayoutDashboard__meta'
          }, [this.$slots.navigation && h('div', {
            staticClass: 'RLayoutDashboard__navigation'
          }, this.$slots.navigation), h('div', {
            staticClass: 'RLayoutDashboard__title'
          }, this.title)]), this.$slots.actions && h('div', {
            staticClass: 'RLayoutDashboard__actions'
          }, this.$slots.actions)]), h('div', {
            staticClass: 'RLayoutDashboard__content',
            class: {
              offset: this.isOffsetContent
            }
          }, this.$slots.content)])]);
        }
      };
      RLayoutDashboard_decorate([Prop({
        type: Boolean,
        default: null
      })], RLayoutDashboard.prototype, "isCompact", void 0);
      RLayoutDashboard_decorate([Prop({
        type: Boolean,
        default: true
      })], RLayoutDashboard.prototype, "isOffsetContent", void 0);
      RLayoutDashboard_decorate([Prop({
        type: String,
        default: null
      })], RLayoutDashboard.prototype, "title", void 0);
      RLayoutDashboard_decorate([Prop({
        type: Object,
        default: null,
        required: true
      })], RLayoutDashboard.prototype, "menuOptions", void 0);
      RLayoutDashboard_decorate([Ref('rMenu')], RLayoutDashboard.prototype, "rMenu", void 0);
      RLayoutDashboard_decorate([Watch('$rir.breakpoints.name')], RLayoutDashboard.prototype, "widthChange", null);
      RLayoutDashboard = RLayoutDashboard_decorate([vue_class_component_esm({
        directives: {
          ClickOutside: ClickOutside
        }
      })], RLayoutDashboard);
      /* harmony default export */ var RLayoutDashboard_RLayoutDashboard = (RLayoutDashboard);
      ;// CONCATENATED MODULE: ./src/components/RLayoutDashboard/index.ts


      RLayoutDashboard_RLayoutDashboard.install = vue => {
        vue.component('r-layout-dashboard', RLayoutDashboard_RLayoutDashboard);
      };
      /* harmony default export */ var components_RLayoutDashboard = (RLayoutDashboard_RLayoutDashboard);
      ;// CONCATENATED MODULE: ./src/components/RAutocomplete/RAutocomplete.ts

      var RAutocomplete_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };








      let RAutocomplete = class RAutocomplete extends checked {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "isOpen", false);
          _defineProperty(this, "isSearch", false);
          _defineProperty(this, "input", null);
          _defineProperty(this, "localItems", []);
          _defineProperty(this, "searchInput", void 0);
          _defineProperty(this, "disabled", void 0);
          _defineProperty(this, "type", void 0);
          _defineProperty(this, "isClear", void 0);
          _defineProperty(this, "error", void 0);
          _defineProperty(this, "errorMessage", void 0);
          _defineProperty(this, "label", void 0);
          _defineProperty(this, "icon", void 0);
          _defineProperty(this, "titleValue", void 0);
          _defineProperty(this, "subTitleValue", void 0);
          _defineProperty(this, "iconValue", void 0);
          _defineProperty(this, "callSearch", void 0);
          _defineProperty(this, "groupsList", void 0);
          _defineProperty(this, "popoverOptions", void 0);
        }
        get itemsList() {
          return this.localItems
            // @ts-ignore
            .map(el => {
              if (typeof el === 'object') {
                return {
                  icon: el[this.iconValue] || null,
                  title: el[this.titleValue] || null,
                  subTitle: el[this.subTitleValue] || null,
                  group: el.group || undefined,
                  val: {
                    ...el
                  }
                };
              }
              return {
                title: el,
                val: el
              };
            });
        }
        get listView() {
          if (this.itemsList.length && !this.isSearch) {
            const children = this.itemsList.map(el => this.$createElement(components_RListItem, {
              slot: 'content',
              props: {
                // @ts-ignore
                ...el,
                isClick: true,
                value: this.value,
                returnObject: this.returnObject,
                idValue: this.idValue
              },
              on: {
                input: this.changeVal
              }
            }));
            return this.$createElement(components_RListGroup, {
              staticClass: 'RAutocomplete__list',
              props: {
                groups: this.groupsList
              }
            }, [children]);
          }
          return [this.$createElement(components_RSpinner, {
            style: {
              display: this.isSearch ? 'flex' : 'none'
            },
            props: {
              size: 'phonia'
            }
          }), this.$createElement('div', {
            staticClass: 'RAutocomplete__not-list',
            style: {
              display: this.isSearch ? 'none' : 'inline'
            }
          }, 'Ничего не найдено')];
        }
        changeVal(val) {
          this.$emit('input', val);
          // this.getInputValue(val);
        }

        getInputValue(val) {
          if (val === null) {
            return;
          }
          const element = this.itemsList
            // @ts-ignore
            .find(el => {
              if (typeof el.val === 'object') {
                return el.val[this.idValue] === (typeof val === 'object' ? val[this.idValue] : val);
              }
              return el.val === val;
            });
          this.input = element?.title || null;
        }
        get popoverOptionsSelect() {
          const {
            position = 'left-bottom',
            contentCoefficientWidth = 1,
            isCheckAutoScrollBlock = false
          } = this.popoverOptions;
          return {
            position,
            contentCoefficientWidth,
            isCheckAutoScrollBlock
          };
        }
        mounted() {
          this.input = this.searchInput;
        }
        render(h) {
          const deb = debounce(() => {
            if (this.input && this.input.length > 2) {
              this.isOpen = true;
              this.$nextTick(() => {
                this.isSearch = true;
              });
              this.callSearch(this.input).then(res => {
                this.localItems = res;
                this.isSearch = false;
              });
            }
          }, 500);
          return h(components_RPopover, {
            props: {
              value: this.isOpen,
              contentWidthActivator: true,
              clickClose: true,
              contentClass: 'RAutocomplete__content',
              ...this.popoverOptionsSelect
            },
            on: {
              input: val => {
                this.isOpen = val;
                // eslint-disable-next-line no-nested-ternary
                this.getInputValue(this.value);
                this.localItems = [];
                if (!val) {
                  this.$emit('focusout');
                }
              }
            },
            scopedSlots: {
              activator: () => h('div', {
                staticClass: 'RAutocomplete__input',
                class: {
                  disabled: this.disabled
                }
              }, [h(components_RInput, {
                class: {
                  isOpen: this.isOpen
                },
                props: {
                  value: this.input,
                  readonly: this.disabled,
                  error: this.error,
                  errorMessage: this.errorMessage,
                  beforeIcon: this.icon,
                  type: this.type,
                  label: this.label,
                  isClear: this.isClear
                },
                on: {
                  input: val => {
                    this.input = val;
                    deb();
                  },
                  clearModel: () => {
                    this.$emit('input', null);
                    this.isOpen = false;
                  },
                  focusout: () => {
                    this.$emit('focusout');
                  },
                  focus: () => {
                    this.$emit('focus');
                  },
                  blur: () => {
                    this.$emit('blur');
                  }
                }
              })])
            }
          }, [h('template', {
            slot: 'content'
          }, [this.listView])]);
        }
      };
      RAutocomplete_decorate([Prop({
        type: String,
        default: null
      })], RAutocomplete.prototype, "searchInput", void 0);
      RAutocomplete_decorate([Prop({
        type: [Object, String, Number],
        default: null
      })], RAutocomplete.prototype, "value", void 0);
      RAutocomplete_decorate([Prop({
        type: Boolean,
        default: false
      })], RAutocomplete.prototype, "disabled", void 0);
      RAutocomplete_decorate([Prop({
        type: String,
        validator: prop => ['default', 'map'].includes(prop),
        default: 'default'
      })], RAutocomplete.prototype, "type", void 0);
      RAutocomplete_decorate([Prop({
        type: Boolean,
        default: true
      })], RAutocomplete.prototype, "isClear", void 0);
      RAutocomplete_decorate([Prop({
        type: Boolean
      })], RAutocomplete.prototype, "error", void 0);
      RAutocomplete_decorate([Prop({
        type: String,
        default: null
      })], RAutocomplete.prototype, "errorMessage", void 0);
      RAutocomplete_decorate([Prop({
        type: String,
        default: null
      })], RAutocomplete.prototype, "label", void 0);
      RAutocomplete_decorate([Prop({
        type: String,
        default: null
      })], RAutocomplete.prototype, "icon", void 0);
      RAutocomplete_decorate([Prop({
        type: String,
        default: 'title'
      })], RAutocomplete.prototype, "titleValue", void 0);
      RAutocomplete_decorate([Prop({
        type: String,
        default: 'subTitle'
      })], RAutocomplete.prototype, "subTitleValue", void 0);
      RAutocomplete_decorate([Prop({
        type: String,
        default: 'icon'
      })], RAutocomplete.prototype, "iconValue", void 0);
      RAutocomplete_decorate([Prop({
        type: Function,
        default: () => {}
      })], RAutocomplete.prototype, "callSearch", void 0);
      RAutocomplete_decorate([Prop({
        type: Array,
        default: () => []
      })], RAutocomplete.prototype, "groupsList", void 0);
      RAutocomplete_decorate([Prop({
        type: Object,
        default: () => ({
          position: 'left-bottom',
          contentCoefficientWidth: 1,
          isCheckAutoScrollBlock: false
        })
      })], RAutocomplete.prototype, "popoverOptions", void 0);
      RAutocomplete = RAutocomplete_decorate([vue_class_component_esm({
        components: {
          RPopover: components_RPopover,
          RInput: components_RInput,
          RListGroup: components_RListGroup,
          RListItem: components_RListItem,
          RSpinner: components_RSpinner
        }
      })], RAutocomplete);
      /* harmony default export */ var RAutocomplete_RAutocomplete = (RAutocomplete);
      ;// CONCATENATED MODULE: ./src/components/RAutocomplete/index.ts


      RAutocomplete_RAutocomplete.install = vue => {
        vue.component('r-autocomplete', RAutocomplete_RAutocomplete);
      };
      /* harmony default export */ var components_RAutocomplete = (RAutocomplete_RAutocomplete);
      ;// CONCATENATED MODULE: ./src/components/RShorter/RShorter.ts

      var RShorter_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };



      let RShorter = class RShorter extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "shorter", false);
          _defineProperty(this, "context", null);
          _defineProperty(this, "text", void 0);
          _defineProperty(this, "description", void 0);
          _defineProperty(this, "contentClass", void 0);
          _defineProperty(this, "countRow", void 0);
          _defineProperty(this, "tooltipOptions", void 0);
          _defineProperty(this, "contentBlock", void 0);
        }
        mounted() {
          if (this.description) {
            this.shorter = true;
          } else {
            this.$nextTick(() => {
              const style = getComputedStyle(this.contentBlock);
              const font = `${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
              const canvas = document.createElement('canvas');
              this.context = canvas.getContext('2d');
              if (this.context) {
                this.context.font = font;
              }
            });
          }
        }
        checkShorter() {
          if (this.context) {
            const {
              text
            } = this;
            const {
              width
            } = this.context.measureText(text);
            const contentData = this.contentBlock.getBoundingClientRect();
            this.shorter = width > this.countRow * contentData.width;
          }
        }
        get checkDisabled() {
          return !this.tooltipOptions || !this.shorter;
        }
        render(h) {
          return h('div', {
            staticClass: 'RShorter',
            on: {
              mouseover: this.checkShorter
            }
          }, [h(components_RTooltip, {
            props: {
              ...this.tooltipOptions,
              disabled: this.checkDisabled,
              title: this.description || this.text
            },
            scopedSlots: {
              activator: () => this.$createElement('div', {
                ref: 'content',
                style: {
                  '-webkit-line-clamp': this.countRow
                },
                staticClass: 'RShorter__content',
                class: [this.contentClass]
              }, this.text)
            }
          })]);
        }
      };
      RShorter_decorate([Prop({
        type: String,
        required: true
      })], RShorter.prototype, "text", void 0);
      RShorter_decorate([Prop({
        type: String
      })], RShorter.prototype, "description", void 0);
      RShorter_decorate([Prop({
        type: String
      })], RShorter.prototype, "contentClass", void 0);
      RShorter_decorate([Prop({
        type: Number,
        default: 1
      })], RShorter.prototype, "countRow", void 0);
      RShorter_decorate([Prop({
        type: Object,
        default: null
      })], RShorter.prototype, "tooltipOptions", void 0);
      RShorter_decorate([Ref('content')], RShorter.prototype, "contentBlock", void 0);
      RShorter = RShorter_decorate([vue_class_component_esm], RShorter);
      /* harmony default export */ var RShorter_RShorter = (RShorter);
      ;// CONCATENATED MODULE: ./src/components/RShorter/index.ts


      RShorter_RShorter.install = vue => {
        vue.component('r-shorter', RShorter_RShorter);
      };
      /* harmony default export */ var components_RShorter = (RShorter_RShorter);
      ;// CONCATENATED MODULE: ./src/components/RTable/RTable.ts


      var RTable_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };







      let RTable = class RTable extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "selectAll", false);
          _defineProperty(this, "selectList", []);
          _defineProperty(this, "openCollapse", []);
          _defineProperty(this, "size", void 0);
          _defineProperty(this, "value", void 0);
          _defineProperty(this, "sort", void 0);
          _defineProperty(this, "headers", void 0);
          _defineProperty(this, "items", void 0);
          _defineProperty(this, "noData", void 0);
          _defineProperty(this, "idValue", void 0);
          _defineProperty(this, "isMultiSort", void 0);
          _defineProperty(this, "isLoading", void 0);
          _defineProperty(this, "isPreview", void 0);
          _defineProperty(this, "isSelectChildren", void 0);
          _defineProperty(this, "colorHeader", void 0);
          _defineProperty(this, "isFixedHeader", void 0);
          _defineProperty(this, "topOffsetFixed", void 0);
        }
        get headersList() {
          return this.headers.reduce((acc, h) => {
            if ('children' in h) {
              h.children.forEach(h => {
                acc.push(h);
              });
            } else {
              acc.push(h);
            }
            return acc;
          }, []);
        }
        get isFixedLayout() {
          return this.headersList.some(el => !!el.style?.width);
        }
        get countColumn() {
          return this.headersList.length;
        }
        get countColsLength() {
          let countCols = this.countColumn + +this.isCollapse;
          if (this.idValue) {
            countCols++;
          }
          return countCols;
        }
        get isClickRow() {
          return !!this.$listeners.clickRow;
        }
        get isPartial() {
          return this.selectList.length !== 0 && this.selectList.length !== this.selectItemsCount.length;
        }
        get isCollapse() {
          return this.isListView && this.items.some(el => !!el.children?.length || el.slotCollapse);
        }
        get isCollapseAllView() {
          return this.openCollapse.length === this.ItemsCollapse.length;
        }
        get isListView() {
          return !this.isLoading && !!this.items.length;
        }
        get viewPreview() {
          const td = new Array(this.countColsLength).fill(this.$createElement('td', [this.$createElement('div', {
            staticClass: 'RTable__preview'
          })]));
          return this.$createElement('tr', td);
        }
        get viewLoading() {
          return this.$createElement('tr', {
            staticClass: 'RTable__loading'
          }, [this.$createElement('td', {
            attrs: {
              align: 'center',
              valign: 'center',
              colspan: this.countColsLength
            }
          }, [this.$createElement(components_RSpinner)])]);
        }
        get viewNoData() {
          return this.$createElement('tr', {
            staticClass: 'RTable__loading'
          }, [this.$createElement('td', {
            attrs: {
              align: 'center',
              valign: 'center',
              colspan: this.countColsLength
            }
          }, [this.$createElement('span', {
            staticClass: 'RTable__no-data'
          }, this.noData)])]);
        }
        viewHeader() {
          let selectableAll = null;
          let collapseAll = null;
          if (this.idValue) {
            selectableAll = this.genSelectableColumn('selectAll');
          }
          if (this.isCollapse) {
            collapseAll = this.$createElement('div', {
              class: 'RTable__collapseAll'
            }, [this.$createElement(components_RButtonAction, {
              props: {
                icon: this.isCollapseAllView ? 'remove' : 'add'
              },
              on: {
                click: () => {
                  if (this.isCollapseAllView) {
                    this.openCollapse = [];
                  } else {
                    this.openCollapse = [...this.ItemsCollapse];
                  }
                }
              }
            })]);
          }
          const headerGroup = [];
          const headers = [];
          this.headers.forEach((h, index) => {
            if ('children' in h) {
              headerGroup.push(this.$createElement('th', {
                attrs: {
                  colspan: h.children.length
                }
              }, [this.$createElement('div', {
                class: ['RTable__name', 'RTable__th']
              }, h.headerName)]));
              h.children.forEach((header, indexChild) => {
                const isCollapse = indexChild === 0 && index === 0;
                headers.push(this.genRowHead(header, isCollapse, collapseAll));
              });
            } else {
              const isCollapse = index === 0;
              headers.push(this.genRowHead(h, isCollapse, collapseAll));
            }
          });
          return [headerGroup.length ? this.$createElement('tr', [this.idValue ? this.$createElement('th', {
            staticClass: 'RTable__select'
          }) : null, headerGroup]) : null, this.$createElement('tr', [selectableAll, headers]), this.$slots.headers && this.$createElement('tr', [this.$createElement('td', {
            class: ['RTable__headers'],
            attrs: {
              colspan: headers.length + (this.isCollapse ? 1 : 0) + (this.idValue ? 1 : 0)
            }
          }, this.$slots.headers)])];
        }
        get ItemsCollapse() {
          return this.findCollapseElements(this.items);
        }
        findCollapseElements(itemsList) {
          const items = [...itemsList];
          let values = [];
          for (const item of items) {
            if (item.children) {
              values.push(JSON.stringify(item));
              values = values.concat(this.findCollapseElements(item.children));
            }
          }
          return values;
        }
        viewRow() {
          let selectableAll = () => null;
          if (this.idValue) {
            selectableAll = val => this.genSelectableColumn('selectList', val);
          }
          return this.items.map(i => {
            const collapseView = this.genCollapse(i, 0);
            const parent = this.$createElement('tr', {
              class: [{
                // @ts-ignore
                selected: this.idValue && this.value.includes(i[this.idValue]),
                parent: this.isOpenElement(i),
                hover: !!this.idValue || collapseView && collapseView.tag !== 'div',
                click: this.isClickRow
                // prev: this.isOpenElement(this.items[index - 1]),
              }],

              on: {
                click: e => {
                  if (e.target && !e.target.closest('.ignoreClickRow')) {
                    this.$emit('clickRow', i);
                  }
                }
              }
            }, [selectableAll(i), ...this.headersList.map((h, index) => this.$createElement('td', {
              // style: <any>h.style,
              class: {
                ignoreClickRow: h.ignoreClickRow
              }
            }, [this.$createElement('div', {
              staticClass: 'RTable__row'
            }, [!index && collapseView, !h.slot ? i[h.field] : this.genScopedSlot(h.field, i)])]))]);
            let children = null;
            if (this.isCollapse && this.isOpenElement(i)) {
              if (i.slotCollapse) {
                children = this.$createElement('tr', {
                  staticClass: 'RTable__children',
                  class: ['last']
                }, [this.$createElement('td', {
                  class: 'RTable__slot',
                  attrs: {
                    colspan: this.countColumn + 1
                  }
                }, this.slotScopedView(this.headers, i))]);
              } else {
                children = this.genRowChildren(i.children, 1);
              }
            }
            return [parent, children];
          });
        }
        genRowChildren(children, level) {
          let selectableAll = () => null;
          if (this.idValue) {
            if (this.isSelectChildren) {
              selectableAll = val => this.genSelectableColumn('selectList', val);
            } else {
              selectableAll = () => this.$createElement('td');
            }
          }
          return children.map((c, indexRow) => {
            const collapseView = this.genCollapse(c, level);
            const isLast = indexRow === children.length - 1;
            const parent = this.$createElement('tr', {
              staticClass: 'RTable__children',
              class: [{
                last: isLast,
                click: this.isClickRow
                // next: isLast && this.isOpenElement(this.items[index + 1]),
              }],

              on: {
                click: e => {
                  if (e.target && !e.target.closest('.ignoreClickRow')) {
                    this.$emit('clickRow', c);
                  }
                }
              }
            }, [selectableAll(c),
              // this.isCollapse && this.$createElement('td'),
              ...this.headersList.map((h, index) => this.$createElement('td', {
                // style: <any>h.style,
                class: {
                  ignoreClickRow: h.ignoreClickRow
                }
              }, [this.$createElement('div', {
                staticClass: 'RTable__row'
              }, [!index && collapseView, !h.slot ? c[h.field] : this.genScopedSlot(h.field, c)])]))]);
            let childrenRow = null;
            if (this.isCollapse && this.isOpenElement(c)) {
              if (c.slotCollapse) {
                childrenRow = this.$createElement('tr', {
                  staticClass: 'RTable__children',
                  class: ['last']
                }, [this.$createElement('td', {
                  class: 'RTable__slot',
                  attrs: {
                    colspan: this.countColumn + 1
                  }
                }, this.slotScopedView(this.headers, c))]);
              } else {
                childrenRow = this.genRowChildren(c.children, level + 1);
              }
            }
            return [parent, childrenRow];
          });
        }
        genRowHead(h, isCollapse, collapseAll) {
          let sort = null;
          let index = null;
          const title = this.$createElement(components_RShorter, {
            props: {
              text: h.name,
              description: h.description,
              contentClass: 'RTable__name',
              tooltipOptions: {
                isArrow: true
              }
            }
          });
          if (h.sort) {
            index = this.sort.findIndex(el => el.field === h.field);
            sort = this.$createElement('a', {
              staticClass: 'RTable__sort'
            }, [this.$createElement(components_RIcon, {
              props: {
                icon: 'arrow-up',
                fill: index !== -1 && this.sort[index].order === 'desc' ? 'rocky' : 'memento',
                size: '6'
              }
            }), this.$createElement(components_RIcon, {
              props: {
                icon: 'arrow-down',
                fill: index !== -1 && this.sort[index].order === 'asc' ? 'rocky' : 'memento',
                size: '6'
              }
            })]);
          }
          return this.$createElement('th', {
            style: h.style
          }, [this.$createElement('div', {
            staticClass: 'RTable__th',
            class: [{
              interactive: !!sort,
              active: index !== null && index >= 0
            }],
            style: {
              // eslint-disable-next-line no-nested-ternary
              justifyContent: h.alignPosition ? h.alignPosition === 'center' ? h.alignPosition : `flex-${h.alignPosition}` : 'flex-start'
            },
            on: sort ? {
              click: () => {
                this.openCollapse = [];
                let sort = [...this.sort];
                if (index === -1) {
                  // this.$emit('update:sort', [...this.sort, { field: h.field, order: 'asc' }]);
                  if (this.isMultiSort) {
                    sort.push({
                      field: h.field,
                      order: 'asc'
                    });
                  } else {
                    sort = [{
                      field: h.field,
                      order: 'asc'
                    }];
                  }
                } else if (this.sort[index].order === 'asc') {
                  sort[index].order = 'desc';
                } else {
                  sort.splice(index, 1);
                }
                this.$emit('update:sort', sort);
              }
            } : {}
          }, [isCollapse && collapseAll, title, sort])]);
        }
        genSelectableColumn(model, value) {
          return this.$createElement(model !== 'selectAll' ? 'td' : 'th', {
            staticClass: 'RTable__select',
            on: {
              click: event => {
                event.stopPropagation();
              }
            }
          }, [this.$createElement(components_RCheckbox, {
            props: {
              value: this[model],
              val: value && value[this.idValue],
              // eslint-disable-next-line no-nested-ternary
              isPartial: model === 'selectAll' ? this.isPartial : this.isSelectChildren ? this.isPartialChildren(value) : false
            },
            on: {
              input: val => {
                this[model] = val;
                if (model !== 'selectAll') {
                  if (this.isSelectChildren && value.children) {
                    const isChecked = val.some(el => el === value[this.idValue]);
                    if (isChecked) {
                      this.selectList = this.selectList.concat(this.selectAllChildren(value.children));
                    } else {
                      this.selectList = this.unSelectAllChildren(value.children);
                    }
                    this.$emit('input', this.selectList);
                  } else {
                    this.$emit('input', val);
                  }
                  this.selectAll = this.selectList.length === this.selectItemsCount.length;
                } else if (model === 'selectAll') {
                  this.selectList = val ? this.selectItemsCount : [];
                  this.$emit('input', this.selectList);
                }
              }
            }
          })]);
        }
        isPartialChildren(val) {
          if (val.children) {
            this.isCheckFullChildrenCheck(val.children, val[this.idValue]);
            let value = this.selectList.some(el => el === val[this.idValue]);
            if (!value) {
              value = this.checkChildrenSelect(val.children);
              return value;
            }
          }
          return false;
        }
        isCheckFullChildrenCheck(itemsList, idParent) {
          let result = false;
          for (const item of itemsList) {
            result = this.selectList.some(el => el === item[this.idValue]);
            if (!result) {
              break;
            }
          }
          const parentIndex = this.selectList.findIndex(el => el === idParent);
          if (result && parentIndex === -1) {
            this.selectList.push(idParent);
          } else if (!result && parentIndex !== -1) {
            this.selectList.splice(parentIndex, 1);
          }
        }
        checkChildrenSelect(itemsList) {
          let values = false;
          for (const item of itemsList) {
            values = this.selectList.some(el => el === item[this.idValue]);
            if (item.children) {
              values = this.checkChildrenSelect(item.children);
            }
            if (values) {
              break;
            }
          }
          return values;
        }
        selectAllChildren(itemsList) {
          let values = [];
          for (const item of itemsList) {
            values.push(item[this.idValue]);
            if (item.children) {
              values = values.concat(this.selectAllChildren(item.children));
            }
          }
          return values;
        }
        unSelectAllChildren(itemsList) {
          let items = [...this.selectList];
          for (const item of itemsList) {
            if (item.children) {
              items = this.unSelectAllChildren(item.children);
            }
            items = items.filter(el => el !== item[this.idValue]);
          }
          return items;
        }
        get selectItemsCount() {
          if (this.isSelectChildren) {
            return this.countSelectElement(this.items);
          }
          return this.items.map(el => el[this.idValue]);
        }
        countSelectElement(itemsList) {
          const items = [...itemsList];
          let values = [];
          for (const item of items) {
            values.push(item[this.idValue]);
            if (item.children) {
              values = values.concat(this.countSelectElement(item.children));
            }
          }
          return values;
        }
        genCollapse(item, level) {
          if (!this.isCollapse) return null;
          if (!item.children && !item.slotCollapse) {
            return this.$createElement('div', {
              class: ['RTable__collapse', 'RTable__collapse--empty'],
              // @TODO 24 перенести в параметр css vars
              style: {
                marginLeft: `${level * 24}px`
              }
            });
          }
          return this.$createElement('span', {
            staticClass: 'RTable__collapse',
            // @TODO 24 перенести в параметр css vars
            style: {
              marginLeft: `${level * 24}px`
            }
          }, [this.$createElement(components_RButtonAction, {
            props: {
              icon: this.isOpenElement(item) ? 'remove' : 'add'
              // size: level === 0 ? 'sulguni' : 'briscola'
            },

            on: {
              click: event => {
                event.stopPropagation();
                if (this.isOpenElement(item)) {
                  const index = this.openCollapse.findIndex(el => el === JSON.stringify(item));
                  this.openCollapse.splice(index, 1);
                } else {
                  this.openCollapse.push(JSON.stringify(item));
                }
              }
            }
          })]);
        }
        isOpenElement(item) {
          return this.openCollapse.some(el => el === JSON.stringify(item));
        }
        genScopedSlot(field, item) {
          if (!this.$scopedSlots[field]) return null;
          // @ts-ignore
          return this.$scopedSlots[field]({
            item
          });
        }
        slotScopedView(header, item) {
          if (!this.$scopedSlots.contentTable) return null;
          return this.$scopedSlots.contentTable({
            header,
            item
          });
        }
        mounted() {
          if (this.value.length) {
            this.selectList = this.value;
          }
        }
        render(h) {
          return h('table', {
            staticClass: 'RTable',
            class: [this.size, {
              'fixed-column': this.isFixedLayout
            }]
          }, [h('thead', {
            class: [this.colorHeader && `${this.colorHeader}--bg`, {
              fixed: this.isFixedHeader
            }],
            style: {
              top: `${this.topOffsetFixed}px`
            }
          }, [this.viewHeader()]), h('tbody', this.isPreview ? [this.viewPreview] : [this.isListView && this.viewRow(), !this.isLoading && !this.items.length && this.viewNoData, this.isLoading && this.viewLoading])]);
        }
      };
      RTable_decorate([Prop({
        type: String,
        validator: val => ['paphia', 'creusa'].includes(val),
        default: 'paphia'
      })], RTable.prototype, "size", void 0);
      RTable_decorate([Prop({
        type: Array,
        default: () => []
      })], RTable.prototype, "value", void 0);
      RTable_decorate([Prop({
        type: Array,
        default: () => []
      })], RTable.prototype, "sort", void 0);
      RTable_decorate([Prop({
        type: Array,
        default: () => []
      })], RTable.prototype, "headers", void 0);
      RTable_decorate([Prop({
        type: Array,
        default: () => []
      })], RTable.prototype, "items", void 0);
      RTable_decorate([Prop({
        type: String,
        default: 'Таких данных нет, попробуйте изменить параметры'
      })], RTable.prototype, "noData", void 0);
      RTable_decorate([Prop({
        type: String,
        default: null
      })], RTable.prototype, "idValue", void 0);
      RTable_decorate([Prop({
        type: Boolean
      })], RTable.prototype, "isMultiSort", void 0);
      RTable_decorate([Prop({
        type: Boolean
      })], RTable.prototype, "isLoading", void 0);
      RTable_decorate([Prop({
        type: Boolean
      })], RTable.prototype, "isPreview", void 0);
      RTable_decorate([Prop({
        type: Boolean
      })], RTable.prototype, "isSelectChildren", void 0);
      RTable_decorate([Prop({
        type: String,
        validator: val => ['amelie', 'trainspotting', null].includes(val),
        default: null
      })], RTable.prototype, "colorHeader", void 0);
      RTable_decorate([Prop({
        type: Boolean
      })], RTable.prototype, "isFixedHeader", void 0);
      RTable_decorate([Prop({
        type: Number,
        default: 0
      })], RTable.prototype, "topOffsetFixed", void 0);
      RTable = RTable_decorate([vue_class_component_esm], RTable);
      /* harmony default export */ var RTable_RTable = (RTable);
      ;// CONCATENATED MODULE: ./src/components/RTable/index.ts


      RTable_RTable.install = vue => {
        vue.component('r-table', RTable_RTable);
      };
      /* harmony default export */ var components_RTable = (RTable_RTable);
      ;// CONCATENATED MODULE: ./src/components/RPaginator/RPaginator.ts


      var RPaginator_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };



      let RPaginator = class RPaginator extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "maxButtons", 0);
          _defineProperty(this, "model", void 0);
          _defineProperty(this, "countPage", void 0);
          _defineProperty(this, "totalPage", void 0);
          _defineProperty(this, "content", void 0);
        }
        viewNumber() {
          const pageArr = [];
          if (this.isArrow) {
            pageArr.push(this.$createElement('a', {
              staticClass: 'RPaginator__arrow',
              class: [{
                disabled: this.model === 1
              }],
              on: {
                click: () => {
                  if (this.model > 1) {
                    this.$emit('input', this.model - 1);
                  }
                }
              }
            }, [this.$createElement(components_RIcon, {
              props: {
                icon: 'arrow-left'
              }
            })]));
          }
          pageArr.push(...this.genPage);
          if (this.isArrow) {
            pageArr.push(this.$createElement('a', {
              staticClass: 'RPaginator__arrow',
              class: [{
                disabled: this.model === this.countPage
              }],
              on: {
                click: () => {
                  if (this.model < this.countPage) {
                    this.$emit('input', this.model + 1);
                  }
                }
              }
            }, [this.$createElement(components_RIcon, {
              props: {
                icon: 'arrow-right'
              }
            })]));
          }
          return pageArr;
        }
        get genPage() {
          return this.pagination().map(el => {
            if (typeof el === 'number') {
              return this.$createElement('a', {
                staticClass: 'RPaginator__page',
                class: {
                  active: this.model === el
                },
                on: {
                  click: () => {
                    this.model = el;
                  }
                }
              }, el.toString());
            }
            return this.$createElement('div', {
              staticClass: 'RPaginator__page'
            }, '...');
          });
        }
        pagination() {
          if (this.totalPage <= 0) {
            return [];
          }
          if (this.countPage <= this.maxLengthView) {
            return this.range(1, this.countPage);
          }
          const even = this.maxLengthView % 2 === 0 ? 1 : 0;
          const left = Math.floor(this.maxLengthView / 2);
          const right = this.countPage - left + 1 + even;
          if (this.model > left && this.model < right) {
            const firstItem = 1;
            const lastItem = this.countPage;
            const start = this.model - left + 2;
            const end = this.model + left - 2 - even;
            const secondItem = start - 1 === firstItem + 1 ? 2 : '...';
            const beforeLastItem = end + 1 === lastItem - 1 ? end + 1 : '...';
            return [1, secondItem, ...this.range(start, end), beforeLastItem, this.countPage];
          }
          if (this.model === left) {
            const end = this.model + left - 1 - even;
            return [...this.range(1, end), '...', this.countPage];
          }
          if (this.model === right) {
            const start = this.model - left + 1;
            return [1, '...', ...this.range(start, this.countPage)];
          }
          return [...this.range(1, left), '...', ...this.range(right, this.countPage)];
        }
        range(from, to) {
          const range = [];
          // eslint-disable-next-line no-param-reassign
          from = from > 0 ? from : 1;
          for (let i = from; i <= to; i++) {
            range.push(i);
          }
          return range;
        }
        get maxLengthView() {
          const totalVisible = this.totalPage;
          let maxLength = Math.min(Math.max(0, totalVisible) || this.totalPage, Math.max(0, this.maxButtons) || this.totalPage, this.totalPage);
          if (maxLength < 7) {
            maxLength = 7;
          }
          return maxLength;
        }
        get isArrow() {
          return this.maxLengthView < this.countPage || this.maxButtons < this.countPage;
        }
        widthChange() {
          const width = this.content && this.content.parentElement ? this.content.parentElement.clientWidth : window.innerWidth;
          this.maxButtons = Math.floor((width - 64) / 50);
        }
        mounted() {
          const width = this.content && this.content.parentElement ? this.content.parentElement.clientWidth : window.innerWidth;
          this.maxButtons = Math.floor((width - 64) / 50);
        }
        render(h) {
          return h('section', {
            ref: 'content',
            staticClass: 'RPaginator'
          }, [this.viewNumber()]);
        }
      };
      RPaginator_decorate([VModel({
        type: Number
      })], RPaginator.prototype, "model", void 0);
      RPaginator_decorate([Prop({
        type: Number,
        required: true
      })], RPaginator.prototype, "countPage", void 0);
      RPaginator_decorate([Prop({
        type: Number,
        required: true
      })], RPaginator.prototype, "totalPage", void 0);
      RPaginator_decorate([Ref('content')], RPaginator.prototype, "content", void 0);
      RPaginator_decorate([Watch('$rir.breakpoints.width')], RPaginator.prototype, "widthChange", null);
      RPaginator = RPaginator_decorate([vue_class_component_esm], RPaginator);
      /* harmony default export */ var RPaginator_RPaginator = (RPaginator);
      ;// CONCATENATED MODULE: ./src/components/RPaginator/index.ts


      RPaginator_RPaginator.install = vue => {
        vue.component('r-paginator', RPaginator_RPaginator);
      };
      /* harmony default export */ var components_RPaginator = (RPaginator_RPaginator);
      ;// CONCATENATED MODULE: ./src/components/RKanban/components/KanbanColumn.ts

      var KanbanColumn_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };



      let KanbanColumn = class KanbanColumn extends component {
        constructor(...args) {
          super(...args);
          // @TODO определить формат интерфейса
          _defineProperty(this, "column", void 0);
        }
        slotScopedCards() {
          if (!this.$scopedSlots.card) return null;
          return this.column.children.map(
            // @ts-ignore
            (item, indexCard) => this.$scopedSlots.card({
              item,
              indexCard
            }));
        }
        render(h) {
          return h('section', {
            staticClass: 'RKanban__column'
          }, [h('div', {
            staticClass: 'RKanban__column-header'
          }, [h('span', {
            staticClass: 'RKanban__column-title'
          }, this.column.title), h(components_RButtonSimple, {
            props: {
              size: 'spelino',
              type: 'transparent',
              icon: 'add'
            },
            on: {
              click: () => {
                this.$emit('add-card', {
                  id: this.column.id
                });
              }
            }
          })]), h('div', {
            staticClass: 'RKanban__column-body',
            attrs: {
              id: this.column.id
            }
          }, [this.slotScopedCards()])]);
        }
      };
      KanbanColumn_decorate([Prop({
        type: Object,
        required: true
      })], KanbanColumn.prototype, "column", void 0);
      KanbanColumn = KanbanColumn_decorate([vue_class_component_esm({
        components: {
          RButtonSimple: components_RButtonSimple
        }
      })], KanbanColumn);
      /* harmony default export */ var components_KanbanColumn = (KanbanColumn);
      ;// CONCATENATED MODULE: ./src/components/RKanban/utils/drag.ts
      const DATA_DRAG = () => ({
        isMoving: false,
        cardId: null,
        cardClone: null,
        columnIndexOld: null,
        positionMouse: {
          shiftX: null,
          shiftY: null
        },
        positionElem: {
          columnIndex: null,
          indexCard: null
        },
        eventStart: {
          clientX: null,
          clientY: null
        },
        scrollEvent: {
          scrollX: null,
          scrollY: {
            event: null,
            boardEvent: null
          }
        }
      });
      ;// CONCATENATED MODULE: ./src/components/RKanban/RKanban.ts

      var RKanban_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };




      let RKanban = class RKanban extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "dragData", DATA_DRAG());
          _defineProperty(this, "elements", []);
          // @TODO определить формат интерфейса
          _defineProperty(this, "list", void 0);
          _defineProperty(this, "kanban", void 0);
        }
        slotScopedCards(item) {
          if (!this.$scopedSlots.card) return null;
          return this.$scopedSlots.card(item);
        }
        genColumns() {
          return this.list.map((column, index) => this.$createElement(components_KanbanColumn, {
            props: {
              column
            },
            on: {
              'add-card': item => {
                this.$emit('add-card', item);
              }
            },
            scopedSlots: {
              card: scoped => this.$createElement('div', {
                attrs: {
                  id: scoped.item.id,
                  'data-column-index': index,
                  'data-index-card': scoped.indexCard
                },
                on: {
                  mousedown: event => {
                    this.mouseDownCard(event, scoped.item);
                  }
                },
                staticClass: 'RKanban__card',
                class: [{
                  'is-moving': scoped.item.id === this.dragData.cardId
                }]
              }, [this.slotScopedCards(scoped.item)])
            }
          }));
        }
        // @TODO определить формат интерфейса
        mouseDownCard(event, element) {
          const card = document.getElementById(element.id);
          if (card) {
            this.dragData.cardClone = card.cloneNode(true);
            this.dragData.cardId = element.id;
            this.dragData.eventStart.clientX = event.clientX;
            this.dragData.eventStart.clientY = event.clientY;
            this.dragData.positionMouse.shiftX = event.clientX - card.getBoundingClientRect().left;
            this.dragData.positionMouse.shiftY = event.clientY - card.getBoundingClientRect().top;
            if (card.dataset.columnIndex && card.dataset.indexCard) {
              this.dragData.columnIndexOld = parseInt(card.dataset.columnIndex, 10);
              this.dragData.positionElem.columnIndex = parseInt(card.dataset.columnIndex, 10);
              this.dragData.positionElem.indexCard = parseInt(card.dataset.indexCard, 10);
              document.body.append(this.dragData.cardClone);
              this.dragData.cardClone.classList.add('clone');
              this.positionElemCard(event);
              document.addEventListener('mousemove', this.changeElemCard);
              this.dragData.cardClone.onmouseup = () => this.mouseUpCard(element);
            }
          }
        }
        positionElemCard(event) {
          this.dragData.cardClone.style.left = `${event.pageX - this.dragData.positionMouse.shiftX}px`;
          this.dragData.cardClone.style.top = `${event.pageY - this.dragData.positionMouse.shiftY}px`;
        }
        changeElemCard(event) {
          // @TODO подумать по сдвигу, реализовать диапазон от X и Y координат
          if (this.dragData.eventStart.clientX === event.clientX && this.dragData.eventStart.clientY === event.clientY && !this.dragData.isMoving) {
            return;
          }
          this.dragData.isMoving = true;
          this.dragData.cardClone.classList.add('move');
          this.positionElemCard(event);
          this.dragData.cardClone.hidden = true;
          const elemBelow = document.elementFromPoint(event.clientX, event.clientY);
          this.dragData.cardClone.hidden = false;
          if (!elemBelow) return;
          const cardBlock = elemBelow.closest('.RKanban__card');
          this.scrollContent();
          this.scrollBoard(cardBlock ? cardBlock.parentNode : elemBelow);
          if (this.dragData.cardClone.id === cardBlock?.id) return;
          if (cardBlock) {
            // Если мы наводим в верхнюю часть, то добавляем над карточкой и наооборот
            // position - true: Верхняя часть / false: Нижняя часть
            const position = cardBlock.getBoundingClientRect().height / 2 >= event.clientY - cardBlock.getBoundingClientRect().top;
            this.changeMoveCard(cardBlock.parentNode.id, cardBlock.id, position);
          } else if (!elemBelow.hasChildNodes()) {
            this.changeMoveCard(elemBelow.id, null, true);
          }
        }
        // @TODO определить формат интерфейса
        mouseUpCard(element) {
          this.changeIndexCards();
          document.removeEventListener('mousemove', this.changeElemCard);
          this.dragData.cardClone.onmouseup = () => {};
          document.body.removeChild(this.dragData.cardClone);
          if (this.dragData.isMoving) {
            this.$emit('change', {
              element,
              position: this.dragData.positionElem
            });
          } else {
            this.$emit('click', element);
          }
          clearInterval(this.dragData.scrollEvent.scrollX);
          clearInterval(this.dragData.scrollEvent.scrollY.event);
          this.dragData = DATA_DRAG();
        }
        scrollContent() {
          const cardLeft = this.dragData.cardClone.getBoundingClientRect().left;
          const cardRight = this.dragData.cardClone.getBoundingClientRect().right;
          const contentLeft = this.kanban.getBoundingClientRect().left;
          const contentRight = this.kanban.getBoundingClientRect().right;
          const isIntervalScroll = this.dragData.scrollEvent.scrollX;
          // Двигаем скрол по Х в сторону для показа доски за скролом
          if (cardRight >= contentRight + 10) {
            if (isIntervalScroll) return;
            this.dragData.scrollEvent.scrollX = setInterval(() => {
              this.kanban.scrollLeft += 3;
            }, 10);
          } else if (cardLeft <= contentLeft) {
            if (isIntervalScroll) return;
            this.dragData.scrollEvent.scrollX = setInterval(() => {
              this.kanban.scrollLeft -= 3;
            }, 10);
          } else {
            clearInterval(this.dragData.scrollEvent.scrollX);
            this.dragData.scrollEvent.scrollX = null;
          }
        }
        scrollBoard(board) {
          if (board) {
            if (board !== this.dragData.scrollEvent.scrollY.boardEvent) {
              this.dragData.scrollEvent.scrollY.boardEvent = board;
            }
            const cardTop = this.dragData.cardClone.getBoundingClientRect().top;
            const cardBottom = this.dragData.cardClone.getBoundingClientRect().bottom;
            const boardTop = board.getBoundingClientRect().top;
            const boardBottom = board.getBoundingClientRect().bottom;
            const isIntervalScroll = this.dragData.scrollEvent.scrollY.event;
            if (cardBottom >= boardBottom) {
              if (isIntervalScroll) return;
              this.dragData.scrollEvent.scrollY.event = setInterval(() => {
                this.dragData.scrollEvent.scrollY.boardEvent.scrollTop += 3;
              }, 10);
            } else if (cardTop <= boardTop) {
              if (isIntervalScroll) return;
              this.dragData.scrollEvent.scrollY.event = setInterval(() => {
                this.dragData.scrollEvent.scrollY.boardEvent.scrollTop -= 3;
              }, 10);
            } else {
              clearInterval(this.dragData.scrollEvent.scrollY.event);
              this.dragData.scrollEvent.scrollY.event = null;
            }
            // console.log('top', cardTop, boardTop)
            // console.log('bottom', cardBottom, boardBottom)
          }
        }

        changeMoveCard(columnId, cardId, position) {
          // columnId - id колонки над которой мы перемещаемся
          // cardId - id карточки над котрой будем вставлять переносимую карточку
          const MoveIndexColumn = this.list.findIndex(el => el.id === columnId);
          let MoveIndexCard = cardId ? this.list[MoveIndexColumn].children.findIndex(el => el?.id === cardId) : this.list[MoveIndexColumn].children.length - 1;
          if (!position) {
            MoveIndexCard += 1;
          }
          if (MoveIndexCard === -1) MoveIndexCard = 0;
          const dataElem = this.list[this.dragData.positionElem.columnIndex].children[this.dragData.positionElem.indexCard];
          this.list[this.dragData.positionElem.columnIndex].children.splice(this.dragData.positionElem.indexCard, 1);
          this.list[MoveIndexColumn].children.splice(MoveIndexCard, 0, dataElem);
          this.dragData.positionElem.columnIndex = MoveIndexColumn;
          this.dragData.positionElem.indexCard = MoveIndexCard;
        }
        changeIndexCards() {
          if (this.dragData.columnIndexOld !== this.dragData.positionElem.columnIndex) {
            this.list[this.dragData.columnIndexOld].children.forEach((el, index) => {
              el.index = index;
            });
          }
          this.list[this.dragData.positionElem.columnIndex].children.forEach((el, index) => {
            el.index = index;
          });
        }
        mounted() {
          this.$set(this.$data, 'elements', this.list);
        }
        render(h) {
          return h('section', {
            staticClass: 'RKanban',
            ref: 'kanban'
          }, [this.genColumns()]);
        }
      };
      RKanban_decorate([VModel({
        type: Array,
        default: () => []
      })], RKanban.prototype, "list", void 0);
      RKanban_decorate([Ref('kanban')], RKanban.prototype, "kanban", void 0);
      RKanban = RKanban_decorate([vue_class_component_esm({
        components: {
          KanbanColumn: components_KanbanColumn
        }
      })], RKanban);
      /* harmony default export */ var RKanban_RKanban = (RKanban);
      ;// CONCATENATED MODULE: ./src/components/RKanban/index.ts


      RKanban_RKanban.install = vue => {
        vue.component('r-kanban', RKanban_RKanban);
      };
      /* harmony default export */ var components_RKanban = (RKanban_RKanban);
      ;// CONCATENATED MODULE: ./src/components/RAvatar/RAvatar.ts

      var RAvatar_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };





      let RAvatar = class RAvatar extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "size", void 0);
          _defineProperty(this, "color", void 0);
          _defineProperty(this, "isEdit", void 0);
          _defineProperty(this, "disabled", void 0);
          _defineProperty(this, "img", void 0);
          _defineProperty(this, "title", void 0);
        }
        get contentView() {
          if (this.img) {
            return this.$createElement(components_RImage, {
              staticClass: 'RAvatar__image',
              props: {
                url: this.img,
                ratio: 'rada'
              }
            });
          }
          if (this.title) {
            return this.$createElement('span', {
              staticClass: 'RAvatar__title'
            }, this.title[0].toUpperCase());
          }
          return this.$createElement(components_RIcon, {
            staticClass: 'RAvatar__icon',
            props: {
              icon: 'avatar'
            }
          });
        }
        render(h) {
          return h('section', {
            staticClass: 'RAvatar',
            class: [this.size, !this.img && this.color, {
              disabled: this.disabled,
              active: this.$listeners.click
            }],
            on: {
              click: () => {
                this.$emit('click');
              }
            }
          }, [this.contentView, this.isEdit && h('div', {
            staticClass: 'RAvatar__edit'
          }, [h(components_RButtonSimple, {
            staticClass: 'RAvatar__action',
            props: {
              type: 'light',
              rounded: true,
              icon: 'edit-picture'
            },
            on: {
              click: e => {
                e.stopPropagation();
                this.$emit('click-edit');
              }
            }
          })])]);
        }
      };
      RAvatar_decorate([Prop({
        type: String,
        default: 'acotali',
        validator: val => ['acotali', 'dexane', 'othresise', 'aethelsa', 'themise', 'thesipha'].includes(val)
      })], RAvatar.prototype, "size", void 0);
      RAvatar_decorate([Prop({
        type: String,
        default: 'nixilei',
        validator: val => ['nixilei', 'rhanis'].includes(val)
      })], RAvatar.prototype, "color", void 0);
      RAvatar_decorate([Prop({
        type: Boolean
      })], RAvatar.prototype, "isEdit", void 0);
      RAvatar_decorate([Prop({
        type: Boolean
      })], RAvatar.prototype, "disabled", void 0);
      RAvatar_decorate([Prop({
        type: String
      })], RAvatar.prototype, "img", void 0);
      RAvatar_decorate([Prop({
        type: String
      })], RAvatar.prototype, "title", void 0);
      RAvatar = RAvatar_decorate([vue_class_component_esm], RAvatar);
      /* harmony default export */ var RAvatar_RAvatar = (RAvatar);
      ;// CONCATENATED MODULE: ./src/components/RAvatar/index.ts


      RAvatar_RAvatar.install = vue => {
        vue.component('r-avatar', RAvatar_RAvatar);
      };
      /* harmony default export */ var components_RAvatar = (RAvatar_RAvatar);
      ;// CONCATENATED MODULE: ./src/components/RBreadCrumbs/RBreadCrumbs.ts


      var RBreadCrumbs_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };






      let RBreadCrumbs = class RBreadCrumbs extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "countVisible", 0);
          _defineProperty(this, "cacheWidthElements", []);
          _defineProperty(this, "items", void 0);
          _defineProperty(this, "content", void 0);
        }
        get list() {
          return this.items.slice(1, this.items.length - 1);
        }
        get listItem() {
          if (this.items.length) {
            const hiddenView = this.list.length - this.countVisible;
            return this.list.map((el, index) => this.$createElement(components_RButtonNavigation, {
              style: {
                display: hiddenView > index ? 'none' : 'flex'
              },
              staticClass: 'RBreadCrumbs__item',
              props: {
                size: 'calligenia',
                color: 'metropolis',
                title: el.title,
                to: el.to,
                href: el.href,
                active: el.active
              },
              on: {
                click: () => {
                  this.$emit('click', el);
                }
              }
            }));
          }
          return null;
        }
        get hiddenViewElement() {
          if (this.countVisible === this.items.length - 2) return null;
          const hiddenView = this.list.length - this.countVisible;
          const menuList = this.list.slice(0, hiddenView).map(el => this.$createElement(components_RListItem, {
            slot: 'content',
            props: {
              title: el.title,
              disabled: typeof el.active === 'boolean' && !el.active
            },
            on: {
              click: () => {
                this.$emit('click', el);
              }
            }
          }));
          return this.$createElement(components_RPopover, {
            props: {
              clickClose: true
            },
            scopedSlots: {
              activator: scoped => this.$createElement('div', {
                staticClass: 'RBreadCrumbs__popover',
                on: scoped.on
              }, '...')
            }
          }, [this.$createElement('div', {
            slot: 'content',
            class: ['RBreadCrumbs__popup']
          }, [this.$createElement(components_RListGroup, [menuList])])]);
        }
        checkFullContent() {
          const node = this.content.parentElement;
          if (node) {
            const styleParent = getComputedStyle(node, null);
            const width = node.clientWidth - (parseFloat(styleParent.paddingLeft) + parseFloat(styleParent.paddingRight));
            let widthElements = 40;
            this.countVisible = 0;
            for (const el of this.cacheWidthElements.reverse()) {
              widthElements += el;
              if (widthElements < width) {
                this.countVisible += 1;
              } else {
                break;
              }
            }
            this.countVisible = this.countVisible > 1 ? this.countVisible - 2 : 0;
          }
        }
        setCacheElementsWidth() {
          const elements = this.content.getElementsByClassName('RBreadCrumbs__item');
          for (const el of elements) {
            this.cacheWidthElements.push(el.clientWidth + 10);
          }
        }
        changeWidth() {
          this.checkFullContent();
        }
        changeItems() {
          this.countVisible = this.items.length - 2;
        }
        created() {
          this.countVisible = this.items.length - 2;
        }
        mounted() {
          this.$nextTick(() => {
            this.setCacheElementsWidth();
            this.checkFullContent();
          });
        }
        render(h) {
          return h('div', {
            staticClass: 'RBreadCrumbs',
            ref: 'content'
          }, this.listItem ? [h(components_RButtonNavigation, {
            staticClass: 'RBreadCrumbs__item',
            props: {
              size: 'calligenia',
              color: 'metropolis',
              title: this.items[0].title,
              to: this.items[0].to,
              href: this.items[0].href,
              active: this.items[0].active
            },
            on: {
              click: () => {
                this.$emit('click', this.items[0]);
              }
            }
          }), this.items.length > 2 && this.hiddenViewElement, this.listItem, this.items.length > 1 && h(components_RButtonNavigation, {
            staticClass: 'RBreadCrumbs__item',
            props: {
              size: 'calligenia',
              color: 'metropolis',
              title: this.items[this.items.length - 1].title,
              to: this.items[this.items.length - 1].to,
              href: this.items[this.items.length - 1].href,
              active: this.items[this.items.length - 1].active
            },
            on: {
              click: () => {
                this.$emit('click', this.items[this.items.length - 1]);
              }
            }
          })] : null);
        }
      };
      RBreadCrumbs_decorate([Prop({
        type: Array,
        default: () => []
      })], RBreadCrumbs.prototype, "items", void 0);
      RBreadCrumbs_decorate([Ref('content')], RBreadCrumbs.prototype, "content", void 0);
      RBreadCrumbs_decorate([Watch('$rir.breakpoints.width')], RBreadCrumbs.prototype, "changeWidth", null);
      RBreadCrumbs_decorate([Watch('items')], RBreadCrumbs.prototype, "changeItems", null);
      RBreadCrumbs = RBreadCrumbs_decorate([vue_class_component_esm], RBreadCrumbs);
      /* harmony default export */ var RBreadCrumbs_RBreadCrumbs = (RBreadCrumbs);
      ;// CONCATENATED MODULE: ./src/components/RBreadCrumbs/index.ts


      RBreadCrumbs_RBreadCrumbs.install = vue => {
        vue.component('r-bread-crumbs', RBreadCrumbs_RBreadCrumbs);
      };
      /* harmony default export */ var components_RBreadCrumbs = (RBreadCrumbs_RBreadCrumbs);
      ;// CONCATENATED MODULE: ./src/components/RButtonLink/RButtonLink.ts


      var RButtonLink_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };


      let RButtonLink = class RButtonLink extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "title", void 0);
          _defineProperty(this, "to", void 0);
          _defineProperty(this, "href", void 0);
          _defineProperty(this, "color", void 0);
          _defineProperty(this, "size", void 0);
        }
        render(h) {
          return h('a', {
            staticClass: 'RButtonLink',
            class: [this.color, this.size],
            on: {
              ...this.$listeners,
              click: async () => {
                this.$emit('click');
                if (!!this.to && !!this.$router) {
                  await this.$router.push(this.to);
                } else if (this.href) {
                  window.open(this.href, '_blank');
                }
              }
            }
          }, [h('span', {
            staticClass: 'RButtonLink__title'
          }, this.title)]);
        }
      };
      RButtonLink_decorate([Prop({
        type: String,
        default: null,
        required: true
      })], RButtonLink.prototype, "title", void 0);
      RButtonLink_decorate([Prop({
        type: String,
        default: null
      })], RButtonLink.prototype, "to", void 0);
      RButtonLink_decorate([Prop({
        type: String,
        default: null
      })], RButtonLink.prototype, "href", void 0);
      RButtonLink_decorate([Prop({
        type: String,
        default: 'alien',
        validator: val => ['alien', 'drive', 'indiana', 'snatch', 'pulpfiction', 'seven', 'shershaah', 'mummy', 'inception'].includes(val)
      })], RButtonLink.prototype, "color", void 0);
      RButtonLink_decorate([Prop({
        type: String,
        default: 'salamis',
        validator: val => ['xanthe', 'salamis'].includes(val)
      })], RButtonLink.prototype, "size", void 0);
      RButtonLink = RButtonLink_decorate([vue_class_component_esm], RButtonLink);
      /* harmony default export */ var RButtonLink_RButtonLink = (RButtonLink);
      ;// CONCATENATED MODULE: ./src/components/RButtonLink/index.ts


      RButtonLink_RButtonLink.install = vue => {
        vue.component('r-button-link', RButtonLink_RButtonLink);
      };
      /* harmony default export */ var components_RButtonLink = (RButtonLink_RButtonLink);
      ;// CONCATENATED MODULE: ./src/components/RPlank/RPlank.ts

      var RPlank_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };




      let RPlank = class RPlank extends checked {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "icon", void 0);
          _defineProperty(this, "iconAction", void 0);
          _defineProperty(this, "img", void 0);
          _defineProperty(this, "title", void 0);
          _defineProperty(this, "subTitle", void 0);
          _defineProperty(this, "disabled", void 0);
          _defineProperty(this, "isArrowAction", void 0);
        }
        get viewPreview() {
          let view;
          if (this.img) {
            view = this.$createElement(components_RAvatar, {
              props: {
                size: 'themise',
                img: this.img
              }
            });
          } else if (this.icon) {
            view = this.$createElement(components_RIcon, {
              props: {
                icon: this.icon
              }
            });
          } else {
            return null;
          }
          return this.$createElement('div', {
            staticClass: 'RPlank__preview',
            class: {
              icon: !!this.icon && !this.img
            }
          }, [view]);
        }
        get viewAction() {
          if (!this.iconAction && !this.$slots.action && !this.isArrowAction) {
            return null;
          }
          let view;
          if (this.$slots.action) {
            view = this.$slots.action;
          } else if (this.iconAction) {
            view = this.$createElement(components_RIcon, {
              props: {
                icon: this.iconAction
              }
            });
          } else {
            view = this.$createElement(components_RIcon, {
              props: {
                icon: 'arrow-right',
                size: 12
              }
            });
          }
          return this.$createElement('div', {
            staticClass: 'RPlank__action'
          }, [view]);
        }
        render(h) {
          return h('section', {
            staticClass: 'RPlank',
            class: {
              'RPlank--not-preview': !this.viewPreview,
              'RPlank--not-sub-title': !this.subTitle,
              disabled: this.disabled,
              active: this.isChecked
            },
            on: {
              click: event => {
                this.$emit('click', this.val || event);
                this.value !== undefined && this.emitModel();
              }
            }
          }, [this.viewPreview, h('div', {
            staticClass: 'RPlank__content'
          }, [h('span', {
            staticClass: 'RPlank__title'
          }, this.title), !!this.subTitle && h('span', {
            staticClass: 'RPlank__sub-title'
          }, this.subTitle)]), this.viewAction]);
        }
      };
      RPlank_decorate([Prop({
        type: [Object, String, Number]
      })], RPlank.prototype, "value", void 0);
      RPlank_decorate([Prop({
        type: String,
        default: null
      })], RPlank.prototype, "icon", void 0);
      RPlank_decorate([Prop({
        type: String,
        default: null
      })], RPlank.prototype, "iconAction", void 0);
      RPlank_decorate([Prop({
        type: String,
        default: null
      })], RPlank.prototype, "img", void 0);
      RPlank_decorate([Prop({
        type: String,
        required: true
      })], RPlank.prototype, "title", void 0);
      RPlank_decorate([Prop({
        type: String
      })], RPlank.prototype, "subTitle", void 0);
      RPlank_decorate([Prop({
        type: Boolean
      })], RPlank.prototype, "disabled", void 0);
      RPlank_decorate([Prop({
        type: Boolean
      })], RPlank.prototype, "isArrowAction", void 0);
      RPlank = RPlank_decorate([vue_class_component_esm], RPlank);
      /* harmony default export */ var RPlank_RPlank = (RPlank);
      ;// CONCATENATED MODULE: ./src/components/RPlank/index.ts


      RPlank_RPlank.install = vue => {
        vue.component('r-plank', RPlank_RPlank);
      };
      /* harmony default export */ var components_RPlank = (RPlank_RPlank);
      ;// CONCATENATED MODULE: ./src/components/RButtonPlayer/RButtonPlayer.ts

      var RButtonPlayer_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };



      let RButtonPlayer = class RButtonPlayer extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "type", void 0);
          _defineProperty(this, "size", void 0);
          _defineProperty(this, "disabled", void 0);
        }
        get iconView() {
          switch (this.type) {
            case 'pause':
              return 'pause-solid';
            default:
              return 'play-solid';
          }
        }
        render(h) {
          return h('button', {
            staticClass: 'RButtonPlayer',
            class: ['default', this.size, {
              disabled: this.disabled
            }],
            on: this.$listeners
          }, [h(components_RIcon, {
            staticClass: 'RButtonPlayer__icon',
            props: {
              icon: this.iconView
            }
          })]);
        }
      };
      RButtonPlayer_decorate([Prop({
        type: String,
        default: 'play'
      })], RButtonPlayer.prototype, "type", void 0);
      RButtonPlayer_decorate([Prop({
        type: String,
        default: 'kerleise'
      })], RButtonPlayer.prototype, "size", void 0);
      RButtonPlayer_decorate([Prop({
        type: Boolean
      })], RButtonPlayer.prototype, "disabled", void 0);
      RButtonPlayer = RButtonPlayer_decorate([vue_class_component_esm], RButtonPlayer);
      /* harmony default export */ var RButtonPlayer_RButtonPlayer = (RButtonPlayer);
      ;// CONCATENATED MODULE: ./src/components/RButtonPlayer/index.ts


      RButtonPlayer_RButtonPlayer.install = vue => {
        vue.component('r-button-player', RButtonPlayer_RButtonPlayer);
      };
      /* harmony default export */ var components_RButtonPlayer = (RButtonPlayer_RButtonPlayer);
      ;// CONCATENATED MODULE: ./src/components/RTimer/RTimer.ts

      var RTimer_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };


      let RTimer = class RTimer extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "timer", void 0);
          _defineProperty(this, "seconds", void 0);
          _defineProperty(this, "size", void 0);
          _defineProperty(this, "timerContent", void 0);
        }
        mounted() {
          let countdown = this.seconds;
          this.timer = setInterval(() => {
            countdown = --countdown <= 0 ? 0 : countdown;
            if (!countdown) {
              clearInterval(this.timer);
              this.$emit('end');
            }
            this.timerContent.textContent = countdown.toString();
          }, 1000);
        }
        get dataAttrSpinner() {
          switch (this.size) {
            case 'aethusa':
              return {
                r: 18,
                cx: 24,
                cy: 24
              };
            case 'menolorice':
              return {
                r: 12,
                cx: 16,
                cy: 16
              };
            default:
              return {
                r: 8,
                cx: 10,
                cy: 10
              };
          }
        }
        beforeDestroy() {
          if (this.timer) {
            clearInterval(this.timer);
          }
        }
        render(h) {
          return h('div', {
            staticClass: 'RTimer',
            class: [this.size]
          }, [h('div', {
            ref: 'timer',
            staticClass: 'RTimer__seconds'
          }, this.seconds.toString()), h('svg', {
            staticClass: 'RTimer__svg'
          }, [
            // @ts-ignore
            h('circle', {
              staticClass: 'RTimer__line',
              attrs: this.dataAttrSpinner,
              style: {
                '--duration': this.seconds
              }
            }), h('circle', {
              staticClass: 'RTimer__background',
              attrs: this.dataAttrSpinner
            })])]);
        }
      };
      RTimer_decorate([Prop({
        type: Number,
        default: 10
      })], RTimer.prototype, "seconds", void 0);
      RTimer_decorate([Prop({
        type: String,
        default: 'echemeia'
      })], RTimer.prototype, "size", void 0);
      RTimer_decorate([Ref('timer')], RTimer.prototype, "timerContent", void 0);
      RTimer = RTimer_decorate([vue_class_component_esm], RTimer);
      /* harmony default export */ var RTimer_RTimer = (RTimer);
      ;// CONCATENATED MODULE: ./src/components/RTimer/index.ts


      RTimer_RTimer.install = vue => {
        vue.component('r-timer', RTimer_RTimer);
      };
      /* harmony default export */ var components_RTimer = (RTimer_RTimer);
      ;// CONCATENATED MODULE: ./src/components/RNotification/RNotification.ts


      var RNotification_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };






      let RNotification = class RNotification extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "list", []);
          _defineProperty(this, "notifications", void 0);
        }
        mounted() {
          if (this.$rir) {
            this.$rir.notification = {
              send: this.sendNotification
            };
          }
          document.body.insertBefore(this.notifications, document.body.firstChild);
        }
        sendNotification(props) {
          this.list.push({
            ...props,
            id: uniqueID()
          });
        }
        closeNotification(id) {
          const index = this.list.findIndex(el => el.id === id);
          this.list.splice(index, 1);
        }
        get genViewNotification() {
          const content = this.list.map(el => this.$createElement('div', {
            key: el.id,
            staticClass: 'RNotification'
          }, [this.$createElement('div', {
            staticClass: 'RNotification__content'
          }, [this.$createElement('span', {
            staticClass: 'RNotification__title'
          }, `${el.title}`), !!el.buttonActionOptions && this.$createElement(components_RButtonAction, {
            props: {
              title: el.buttonActionOptions.title
            },
            on: {
              click: () => {
                el.buttonActionOptions && el.buttonActionOptions.clickEvent();
                this.closeNotification(el.id);
              }
            }
          })]), (el.iconOptions && !!el.iconOptions.icon || !!el.seconds) && this.$createElement('div', {
            staticClass: 'RNotification__icon',
            class: [{
              seconds: !!el.seconds
            }]
          }, [!!el.seconds && this.$createElement(components_RTimer, {
            props: {
              seconds: el.seconds
            },
            on: {
              end: () => {
                this.closeNotification(el.id);
              }
            }
          }), !el.seconds && this.$createElement(components_RIcon, {
            props: el.iconOptions
          })]), !el.seconds && this.$createElement('a', {
            staticClass: 'RNotification__close',
            on: {
              click: () => this.closeNotification(el.id)
            }
          }, [this.$createElement(components_RIcon, {
            props: {
              size: 8,
              icon: 'close'
            }
          })])]));
          return this.$createElement('transition-group', {
            props: {
              name: 'RNotification'
            }
          }, content);
        }
        beforeDestroy() {
          this.notifications.remove();
        }
        render(h) {
          return h('section', {
            ref: 'notifications',
            staticClass: 'RNotification__list'
          }, [this.genViewNotification]);
        }
      };
      RNotification_decorate([Ref('notifications')], RNotification.prototype, "notifications", void 0);
      RNotification = RNotification_decorate([vue_class_component_esm], RNotification);
      /* harmony default export */ var RNotification_RNotification = (RNotification);
      ;// CONCATENATED MODULE: ./src/components/RNotification/index.ts


      RNotification_RNotification.install = vue => {
        vue.component('r-notification', RNotification_RNotification);
      };
      /* harmony default export */ var components_RNotification = (RNotification_RNotification);
      ;// CONCATENATED MODULE: ./src/mixins/PlayerComponents.ts

      var PlayerComponents_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };


      let PlayerComponents = class PlayerComponents extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "player", void 0);
          _defineProperty(this, "intervalTimer", 0);
        }
        getTimeCodeFromNum(num) {
          let seconds = parseInt(String(num), 10);
          let minutes = parseInt(String(seconds / 60), 10);
          seconds -= minutes * 60;
          const hours = parseInt(String(minutes / 60), 10);
          minutes -= hours * 60;
          if (hours === 0) return `${minutes}:${String(seconds % 60).padStart(2, '0')}`;
          return `${String(hours).padStart(2, '0')}:${minutes}:${String(seconds % 60).padStart(2, '0')}`;
        }
        beforeDestroy() {
          clearInterval(this.intervalTimer);
          this.player.pause();
        }
      };
      PlayerComponents = PlayerComponents_decorate([vue_class_component_esm], PlayerComponents);
      /* harmony default export */ var mixins_PlayerComponents = (PlayerComponents);
      ;// CONCATENATED MODULE: ./src/components/RPlayerVideo/RPlayerVideo.ts

      var RPlayerVideo_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };





      let RPlayerVideo = class RPlayerVideo extends mixins_PlayerComponents {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "player", document.createElement('video'));
          _defineProperty(this, "controlView", 0);
          _defineProperty(this, "changeTimeValue", '');
          _defineProperty(this, "sizeButtonPlayer", '');
          _defineProperty(this, "isStart", false);
          _defineProperty(this, "isLoadedVideo", false);
          _defineProperty(this, "iconControl", 'pause-solid');
          _defineProperty(this, "isFullscreen", false);
          _defineProperty(this, "url", void 0);
          _defineProperty(this, "screenPreview", void 0);
          _defineProperty(this, "size", void 0);
          _defineProperty(this, "panel", void 0);
          _defineProperty(this, "content", void 0);
          _defineProperty(this, "timeLine", void 0);
          _defineProperty(this, "timeLineChange", void 0);
          _defineProperty(this, "tooltip", void 0);
        }
        get isTouch() {
          return 'ontouchstart' in window;
        }
        playVideo(event) {
          event && event.stopPropagation();
          (this.player.paused || this.player.ended ? this.startVideo : this.pauseVideo)();
        }
        pauseVideo() {
          this.player.pause();
          this.iconControl = 'play-solid';
          clearInterval(this.intervalTimer);
        }
        startVideo() {
          if (!this.isStart) {
            this.player.currentTime = 0;
            this.isStart = true;
          }
          this.iconControl = 'pause-solid';
          this.player.play();
          this.intervalTimer = setInterval(this.checkWidthLineInTime, 100);
        }
        openFullscreen(event) {
          event.stopPropagation();
          const isFullScreen = document.fullscreenElement || document.webkitIsFullScreen;
          if (!isFullScreen) {
            if (document.documentElement?.requestFullscreen) {
              document.documentElement?.requestFullscreen();
            } else {
              // @FIXME: не работает на iPhone
              document.documentElement.webkitRequestFullscreen();
            }
            window.addEventListener('resize', this.detectedFullScreen);
            this.content.classList.add('fullscreen');
            this.isFullscreen = true;
            this.$emit('fullscreen', true);
          } else if (document.exitFullscreen) {
            // @TODO: оптимизировать
            document.exitFullscreen();
            this.$emit('fullscreen', false);
          } else {
            document.webkitExitFullscreen();
            this.content.classList.remove('fullscreen');
            this.isFullscreen = false;
            this.$emit('fullscreen', false);
          }
        }
        detectedFullScreen() {
          // eslint-disable-next-line no-restricted-globals
          if (window.innerHeight !== screen.height) {
            this.content.classList.remove('fullscreen');
            this.isFullscreen = false;
            this.$emit('fullscreen', false);
            window.removeEventListener('resize', this.detectedFullScreen);
          }
        }
        checkWidthLineInTime() {
          this.timeLine.style.width = `${this.player.currentTime / this.player.duration * 100}%`;
          if (this.player.currentTime === this.player.duration) {
            this.player.pause();
            this.iconControl = 'restore';
            clearInterval(this.intervalTimer);
          }
        }
        changeTime(event) {
          const timelineWidth = window.getComputedStyle(this.timeLine.parentElement).width;
          this.timeLineChange.style.width = `${event.offsetX / parseInt(timelineWidth, 10) * 100}%`;
          this.changeTimeValue = this.getTimeCodeFromNum(event.offsetX / parseInt(timelineWidth, 10) * this.player.duration);
          if (!this.isTouch) {
            this.$nextTick(() => {
              this.tooltip.style.left = `${event.offsetX - this.tooltip.clientWidth / 2}px`;
            });
          } else {
            this.tooltip.style.display = 'none';
          }
        }
        setTimeDuration(event) {
          event.stopPropagation();
          const timelineWidth = window.getComputedStyle(this.timeLine.parentElement).width;
          this.player.currentTime = event.offsetX / parseInt(timelineWidth, 10) * this.player.duration;
        }
        changeSize() {
          this.$nextTick(() => {
            const style = getComputedStyle(this.content);
            this.sizeButtonPlayer = style.getPropertyValue('--size-button-player');
          });
        }
        init() {
          this.isLoadedVideo = true;
          this.content.insertBefore(this.player, this.content.firstChild);
        }
        mounted() {
          this.player.src = this.url;
          this.player.setAttribute('playsinline', '');
          this.player.controls = false;
          this.player.loop = false;
          this.player.classList.add('RPlayerVideo__video');
          this.player.currentTime = this.screenPreview;
          this.player.addEventListener('loadeddata', this.init, false);
          if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
            this.player.autoplay = true;
            this.player.pause();
          }
          const style = getComputedStyle(this.content);
          this.sizeButtonPlayer = style.getPropertyValue('--size-button-player');
        }
        beforeDestroy() {
          this.player.removeEventListener('loadeddata', this.init, false);
          clearInterval(this.intervalTimer);
        }
        render(h) {
          return h('div', {
            ref: 'content',
            staticClass: 'RPlayerVideo',
            class: [this.size, {
              loading: !this.isLoadedVideo
            }],
            on: {
              mousemove: () => {
                if (this.controlView) {
                  clearTimeout(this.controlView);
                }
                this.panel && (this.panel.style.opacity = '1');
              },
              mouseleave: () => {
                if (this.panel) {
                  this.controlView = setTimeout(() => {
                    this.panel && (this.panel.style.opacity = '0');
                  }, 1000);
                }
              },
              click: this.playVideo
            }
          }, [!this.isStart && this.isLoadedVideo && h(components_RButtonPlayer, {
            staticClass: 'RPlayerVideo__start',
            props: {
              size: this.sizeButtonPlayer
            },
            on: {
              click: this.playVideo
            }
          }), this.isStart && h('div', {
            ref: 'panel',
            staticClass: 'RPlayerVideo__control-panel'
          }, [h(components_RFader), h('div', {
            staticClass: 'RPlayerVideo__controls'
          }, [h(components_RIcon, {
            staticClass: 'RPlayerVideo__play',
            props: {
              icon: this.iconControl
            },
            nativeOn: {
              click: this.playVideo
            }
          }), h('div', {
            staticClass: 'RPlayerVideo__time-line'
          }, [h('div', {
            staticClass: 'RPlayerVideo__time-block',
            on: {
              mousemove: this.changeTime,
              mouseleave: () => {
                this.timeLineChange.style.width = '0px';
                this.changeTimeValue = '';
              },
              click: this.setTimeDuration
            }
          }, [h('div', {
            staticClass: 'RPlayerVideo__line'
          }), h('div', {
            ref: 'timeLine',
            staticClass: 'RPlayerVideo__line-duration'
          }), h('div', {
            ref: 'timeLineChange',
            staticClass: 'RPlayerVideo__line-change'
          })]), h('div', {
            ref: 'tooltip',
            staticClass: 'RPlayerVideo__tooltip',
            style: {
              display: this.changeTimeValue ? 'block' : 'none'
            }
          }, this.changeTimeValue)]), h(components_RIcon, {
            staticClass: 'RPlayerVideo__fullscreen',
            props: {
              icon: !this.isFullscreen ? 'fullscreen' : 'exit-fullscreen'
            },
            nativeOn: {
              click: this.openFullscreen
            }
          })])])]);
        }
      };
      RPlayerVideo_decorate([Prop({
        type: String,
        required: true
      })], RPlayerVideo.prototype, "url", void 0);
      RPlayerVideo_decorate([Prop({
        type: Number,
        default: 0
      })], RPlayerVideo.prototype, "screenPreview", void 0);
      RPlayerVideo_decorate([Prop({
        type: String,
        default: 'atlentea'
      })], RPlayerVideo.prototype, "size", void 0);
      RPlayerVideo_decorate([Ref('panel')], RPlayerVideo.prototype, "panel", void 0);
      RPlayerVideo_decorate([Ref('content')], RPlayerVideo.prototype, "content", void 0);
      RPlayerVideo_decorate([Ref('timeLine')], RPlayerVideo.prototype, "timeLine", void 0);
      RPlayerVideo_decorate([Ref('timeLineChange')], RPlayerVideo.prototype, "timeLineChange", void 0);
      RPlayerVideo_decorate([Ref('tooltip')], RPlayerVideo.prototype, "tooltip", void 0);
      RPlayerVideo_decorate([Watch('size')], RPlayerVideo.prototype, "changeSize", null);
      RPlayerVideo = RPlayerVideo_decorate([vue_class_component_esm], RPlayerVideo);
      /* harmony default export */ var RPlayerVideo_RPlayerVideo = (RPlayerVideo);
      ;// CONCATENATED MODULE: ./src/components/RPlayerVideo/index.ts


      RPlayerVideo_RPlayerVideo.install = vue => {
        vue.component('r-player-video', RPlayerVideo_RPlayerVideo);
      };
      /* harmony default export */ var components_RPlayerVideo = (RPlayerVideo_RPlayerVideo);
      ;// CONCATENATED MODULE: ./src/components/RSlideshow/RSlideshow.ts

      var RSlideshow_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };








      let RSlideshow = class RSlideshow extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "filePosition", 0);
          _defineProperty(this, "posXStart", 0);
          _defineProperty(this, "isArrowLeftDisabled", true);
          _defineProperty(this, "isArrowRightDisabled", false);
          _defineProperty(this, "RPlayerVideoSize", 'atlentea');
          _defineProperty(this, "videoRefs", {});
          _defineProperty(this, "files", void 0);
          _defineProperty(this, "size", void 0);
          _defineProperty(this, "isPreviewBlock", void 0);
          _defineProperty(this, "isStepBadge", void 0);
          _defineProperty(this, "isFillImage", void 0);
          _defineProperty(this, "previewElements", void 0);
          _defineProperty(this, "contentElement", void 0);
          _defineProperty(this, "galleryBlock", void 0);
        }
        get isTouch() {
          return 'ontouchstart' in window;
        }
        get viewFile() {
          return this.files[this.filePosition];
        }
        get listenerEvents() {
          const listener = {
            ...this.$listeners,
            click: () => {
              this.$emit('click', this.viewFile);
            }
          };
          if (this.isTouch) {
            // @ts-ignore
            listener.touchstart = touchEvent => {
              if (touchEvent.changedTouches.length !== 1) {
                return;
              }
              this.posXStart = touchEvent.changedTouches[0].clientX;
              this.contentElement.style.transition = 'all 0ms ease-out 0s';
            };
            // @ts-ignore
            listener.touchmove = touchEvent => {
              if (touchEvent.changedTouches.length !== 1) {
                return;
              }
              this.touchMove(touchEvent);
            };
            // @ts-ignore
            listener.touchend = touchEvent => {
              if (touchEvent.changedTouches.length !== 1) {
                return;
              }
              this.touchEnd(touchEvent);
            };
          }
          return listener;
        }
        viewFiles() {
          return this.files.map((el, index) => {
            const isImage = el.type.split('/')[0] === 'image';
            if (isImage) {
              return this.$createElement(components_RImage, {
                class: [{
                  event: this.$listeners.click
                }],
                props: {
                  url: el.url,
                  isFill: this.isFillImage
                },
                nativeOn: this.listenerEvents
              });
            }
            return this.$createElement(components_RPlayerVideo, {
              ref: ref => {
                this.setRefVideoBlock(ref, index);
              },
              props: {
                url: el.video,
                size: this.RPlayerVideoSize
              }
            });
          });
        }
        touchMove(touchEvent) {
          const touchDistance = touchEvent.touches[0].clientX - this.posXStart;
          const positionView = (this.contentElement.firstElementChild?.clientWidth || 0) * -1 * this.filePosition;
          this.contentElement.style.left = `${positionView + touchDistance}px`;
        }
        touchEnd(touchEvent) {
          this.contentElement.style.transition = 'transform 0.3s ease-out 0s';
          const posXEnd = touchEvent.changedTouches[0].clientX;
          if (this.posXStart < posXEnd) {
            this.setViewFile(-1);
          } else if (this.posXStart > posXEnd) {
            this.setViewFile(1);
          }
        }
        viewFileList() {
          return this.files.map((el, index) => {
            const isVideo = el.type.split('/')[0] === 'video';
            return this.$createElement('a', {
              staticClass: 'RSlideshow__preview-item',
              class: [{
                active: index === this.filePosition
              }],
              on: {
                click: () => {
                  this.filePosition = index;
                  this.contentElement.style.left = `${(this.contentElement.firstElementChild?.clientWidth || 0) * -1 * index}px`;
                  this.changeScrollPositionActive();
                  isVideo && this.startVideo(index);
                }
              }
            }, [this.$createElement(components_RImage, {
              props: {
                url: el.url
              }
            }), isVideo && this.$createElement(components_RButtonPlayer, {
              staticClass: 'RSlideshow__play',
              props: {
                size: 'samilea'
              }
            })]);
          });
        }
        setViewFile(changePosition) {
          if (!this.filePosition && changePosition < 0) {
            this.filePosition = this.files.length - 1;
          } else if (this.filePosition + changePosition < this.files.length) {
            this.filePosition += changePosition;
          } else {
            this.filePosition = 0;
          }
          this.contentElement.style.left = `${(this.contentElement.firstElementChild?.clientWidth || 0) * -1 * this.filePosition}px`;
          this.isPreviewBlock && this.changeScrollPositionActive();
        }
        changeScrollPositionActive() {
          this.$nextTick(() => {
            const previewContent = this.previewElements;
            const children = this.previewElements.getElementsByClassName('active')[0];
            let childrenActive;
            if (children.offsetLeft - previewContent.scrollLeft + children.clientWidth / 2 > previewContent.clientWidth / 2) {
              childrenActive = children.nextSibling;
            } else {
              childrenActive = children.previousSibling;
            }
            if (!childrenActive) {
              childrenActive = children;
            }
            if (childrenActive.offsetLeft < previewContent.scrollLeft) {
              const offsetLeft = childrenActive.offsetLeft - (this.getFullWidthElement(childrenActive) - childrenActive.offsetWidth) / 2;
              previewContent.scroll({
                left: offsetLeft,
                behavior: 'smooth'
              });
              this.isArrowLeftDisabled = offsetLeft <= 0;
              this.isArrowRightDisabled = false;
            } else if (childrenActive.offsetLeft + childrenActive.clientWidth > previewContent.clientWidth + previewContent.scrollLeft) {
              const offsetLeft = previewContent.scrollLeft + previewContent.clientWidth > this.getFullWidthElement(childrenActive) ? previewContent.scrollLeft + (this.getFullWidthElement(childrenActive) - (previewContent.scrollLeft + previewContent.clientWidth - childrenActive.offsetLeft)) : previewContent.scrollLeft + this.getFullWidthElement(childrenActive);
              previewContent.scroll({
                left: offsetLeft,
                behavior: 'smooth'
              });
              this.isArrowLeftDisabled = false;
              this.isArrowRightDisabled = offsetLeft + previewContent.clientWidth >= previewContent.scrollWidth;
            }
            this.stopVideo();
          });
        }
        changeScrollPosition(type) {
          const previewContent = this.previewElements;
          // @ts-ignore
          let children = [...previewContent.childNodes];
          if (type === 'left') {
            children = children.reverse();
          }
          // @TODO отрефакторить кусок кода for
          // eslint-disable-next-line guard-for-in,no-restricted-syntax
          for (const index in children) {
            const el = children[index];
            switch (type) {
              case 'left':
                if (el.offsetLeft < previewContent.scrollLeft) {
                  const offsetLeft = el.offsetLeft - (this.getFullWidthElement(el) - el.offsetWidth) / 2;
                  previewContent.scroll({
                    left: offsetLeft,
                    behavior: 'smooth'
                  });
                  this.isArrowLeftDisabled = offsetLeft <= 0;
                  this.isArrowRightDisabled = false;
                  return;
                }
                break;
              default:
                if (el.offsetLeft + el.clientWidth > previewContent.clientWidth + previewContent.scrollLeft) {
                  const offsetLeft = previewContent.scrollLeft + previewContent.clientWidth > this.getFullWidthElement(el) ? previewContent.scrollLeft + (this.getFullWidthElement(el) - (previewContent.scrollLeft + previewContent.clientWidth - el.offsetLeft)) : previewContent.scrollLeft + this.getFullWidthElement(el);
                  previewContent.scroll({
                    left: offsetLeft,
                    behavior: 'smooth'
                  });
                  this.isArrowLeftDisabled = false;
                  this.isArrowRightDisabled = offsetLeft + previewContent.clientWidth >= previewContent.scrollWidth;
                  return;
                }
            }
          }
          this.stopVideo();
        }
        getFullWidthElement(el) {
          // @ts-ignore
          const style = el.currentStyle || window.getComputedStyle(el);
          const width = el.offsetWidth; // or use style.width
          const margin = parseFloat(style.marginLeft) + parseFloat(style.marginRight);
          const padding = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
          const border = parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth);
          return width + margin + padding + border;
        }
        changeWidthWindow() {
          this.contentElement.style.left = `${(this.contentElement.firstElementChild?.clientWidth || 0) * -1 * this.filePosition}px`;
          this.getParamsCss();
        }
        getParamsCss() {
          this.$nextTick(() => {
            const style = getComputedStyle(this.galleryBlock);
            this.RPlayerVideoSize = style.getPropertyValue('--r-player-video-size');
          });
        }
        setRefVideoBlock(el, index) {
          if (el) {
            this.videoRefs[index] = el;
          }
        }
        stopVideo() {
          // eslint-disable-next-line guard-for-in
          for (const key in this.videoRefs) {
            this.videoRefs[key].pauseVideo();
          }
        }
        startVideo(index) {
          this.$nextTick(() => {
            this.videoRefs[index].startVideo();
          });
        }
        mounted() {
          this.getParamsCss();
        }
        render(h) {
          return h('section', {
            ref: 'galleryBlock',
            staticClass: 'RSlideshow',
            class: [this.size]
          }, [h('div', {
            staticClass: 'RSlideshow__view'
          }, [!this.isTouch && h('a', {
            staticClass: 'RSlideshow__arrow RSlideshow__arrow--left',
            on: {
              click: () => this.setViewFile(-1)
            }
          }, [h(components_RIcon, {
            props: {
              icon: 'arrow-left'
            }
          })]), h('div', {
            ref: 'content',
            staticClass: 'RSlideshow__content'
          }, this.viewFiles()), !this.isTouch && h('a', {
            staticClass: 'RSlideshow__arrow RSlideshow__arrow--right',
            on: {
              click: () => this.setViewFile(1)
            }
          }, [h(components_RIcon, {
            props: {
              icon: 'arrow-right'
            }
          })]), this.isStepBadge && h(components_RBadge, {
            staticClass: 'RSlideshow__badge',
            props: {
              title: `${this.filePosition + 1} из ${this.files.length}`,
              size: 'psamiaphe',
              color: 'amelie',
              inversion: true
            }
          })]), this.isPreviewBlock && h('div', {
            staticClass: 'RSlideshow__block-list'
          }, [!this.isTouch && h(components_RButtonArrow, {
            staticClass: 'RSlideshow__arrow-preview RSlideshow__arrow-preview--left',
            props: {
              size: 'ileneira'
            },
            style: {
              display: this.isArrowLeftDisabled ? 'none' : 'flex'
            },
            on: {
              click: () => {
                this.changeScrollPosition('left');
              }
            }
          }), h('div', {
            ref: 'previewElements',
            staticClass: 'RSlideshow__list'
          }, this.viewFileList()), !this.isTouch && h(components_RButtonArrow, {
            staticClass: 'RSlideshow__arrow-preview RSlideshow__arrow-preview--right',
            props: {
              direction: 'right',
              size: 'ileneira'
            },
            style: {
              display: this.isArrowRightDisabled ? 'none' : 'flex'
            },
            on: {
              click: () => {
                this.changeScrollPosition('right');
              }
            }
          })])]);
        }
      };
      RSlideshow_decorate([Prop({
        type: Array,
        validator: files => files.every(el => ['image', 'video'].includes(el.type?.split('/')[0])),
        default: () => []
      })], RSlideshow.prototype, "files", void 0);
      RSlideshow_decorate([Prop({
        type: String,
        validator: val => ['caliadne'].includes(val),
        default: 'caliadne'
      })], RSlideshow.prototype, "size", void 0);
      RSlideshow_decorate([Prop({
        type: Boolean,
        default: true
      })], RSlideshow.prototype, "isPreviewBlock", void 0);
      RSlideshow_decorate([Prop({
        type: Boolean,
        default: true
      })], RSlideshow.prototype, "isStepBadge", void 0);
      RSlideshow_decorate([Prop({
        type: Boolean,
        default: true
      })], RSlideshow.prototype, "isFillImage", void 0);
      RSlideshow_decorate([Ref('previewElements')], RSlideshow.prototype, "previewElements", void 0);
      RSlideshow_decorate([Ref('content')], RSlideshow.prototype, "contentElement", void 0);
      RSlideshow_decorate([Ref('galleryBlock')], RSlideshow.prototype, "galleryBlock", void 0);
      RSlideshow_decorate([Watch('$rir.breakpoints.width')], RSlideshow.prototype, "changeWidthWindow", null);
      RSlideshow = RSlideshow_decorate([vue_class_component_esm], RSlideshow);
      /* harmony default export */ var RSlideshow_RSlideshow = (RSlideshow);
      ;// CONCATENATED MODULE: ./src/components/RSlideshow/index.ts


      RSlideshow_RSlideshow.install = vue => {
        vue.component('r-slideshow', RSlideshow_RSlideshow);
      };
      /* harmony default export */ var components_RSlideshow = (RSlideshow_RSlideshow);
      ;// CONCATENATED MODULE: ./src/components/RAccordion/RAccordion.ts

      var RAccordion_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };




      let RAccordion = class RAccordion extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "isShow", false);
          // @ts-ignore
          _defineProperty(this, "resizeObserver", new ResizeObserver(this.onResize));
          _defineProperty(this, "title", void 0);
          _defineProperty(this, "size", void 0);
          _defineProperty(this, "isShape", void 0);
          _defineProperty(this, "isOpening", void 0);
          _defineProperty(this, "color", void 0);
          _defineProperty(this, "header", void 0);
          _defineProperty(this, "content", void 0);
        }
        mounted() {
          this.isShow = this.isOpening;
        }
        onResize() {
          this.$nextTick(() => {
            if (this.content.children.length === 1) {
              this.content.style.height = `${this.content.children[0].clientHeight}px`;
            }
          });
        }
        render(h) {
          return h('section', {
            staticClass: 'RAccordion',
            class: [this.size, this.color, {
              shape: this.isShape
            }]
          }, [h('div', {
            ref: 'header',
            staticClass: 'RAccordion__header',
            on: {
              click: () => {
                this.isShow = !this.isShow;
                if (this.isShow) {
                  this.resizeObserver.observe(this.content.children[0]);
                } else {
                  this.resizeObserver.disconnect();
                }
              }
            }
          }, [h('a', {
            staticClass: 'RAccordion__activator'
          }, [h(components_RShorter, {
            props: {
              text: this.title,
              contentClass: 'RAccordion__text'
            }
          }), h(components_RIcon, {
            staticClass: 'RAccordion__arrow',
            class: [{
              open: this.isShow
            }],
            props: {
              icon: 'arrow-bold-down'
            }
          })]), !!this.$slots.actions && h('div', {
            staticClass: 'RAccordion__actions',
            on: {
              click: event => {
                event.stopPropagation();
              },
              mouseover: () => {
                this.header.classList.toggle('actions');
              },
              mouseout: () => {
                this.header.classList.toggle('actions');
              }
            }
          }, this.$slots.actions)]), h('transition', {
            props: {
              name: 'accordion'
            },
            on: {
              beforeEnter: el => {
                el.style.height = '0';
              },
              enter: el => {
                el.style.height = `${el.scrollHeight}px`;
              },
              beforeLeave: el => {
                el.style.height = `${el.scrollHeight}px`;
              },
              leave: el => {
                el.style.height = '0';
              }
            }
          }, [h('div', {
            staticClass: 'RAccordion__content',
            ref: 'content',
            directives: [{
              name: 'show',
              value: this.isShow
            }]
          }, this.$slots.content)])]);
        }
      };
      RAccordion_decorate([Prop({
        type: String,
        required: true
      })], RAccordion.prototype, "title", void 0);
      RAccordion_decorate([Prop({
        type: String,
        default: 'amphinomis',
        validator: val => ['amphinomis', 'celareino', 'meliphia', 'pasithea', 'criamisa'].includes(val)
      })], RAccordion.prototype, "size", void 0);
      RAccordion_decorate([Prop({
        type: Boolean
      })], RAccordion.prototype, "isShape", void 0);
      RAccordion_decorate([Prop({
        type: Boolean
      })], RAccordion.prototype, "isOpening", void 0);
      RAccordion_decorate([Prop({
        type: String,
        default: 'walle',
        validator: val => ['walle', 'amelie'].includes(val)
      })], RAccordion.prototype, "color", void 0);
      RAccordion_decorate([Ref('header')], RAccordion.prototype, "header", void 0);
      RAccordion_decorate([Ref('content')], RAccordion.prototype, "content", void 0);
      RAccordion = RAccordion_decorate([vue_class_component_esm], RAccordion);
      /* harmony default export */ var RAccordion_RAccordion = (RAccordion);
      ;// CONCATENATED MODULE: ./src/components/RAccordion/index.ts


      RAccordion_RAccordion.install = vue => {
        vue.component('r-accordion', RAccordion_RAccordion);
      };
      /* harmony default export */ var components_RAccordion = (RAccordion_RAccordion);
      ;// CONCATENATED MODULE: ./src/components/RPlayerAudio/RPlayerAudio.ts

      var RPlayerAudio_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };





      let RPlayerAudio = class RPlayerAudio extends mixins_PlayerComponents {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "player", new Audio());
          _defineProperty(this, "isLoadAudio", false);
          _defineProperty(this, "isChangeTime", false);
          _defineProperty(this, "uid", '');
          _defineProperty(this, "isStart", false);
          _defineProperty(this, "isPlay", false);
          _defineProperty(this, "fullTime", '0:00');
          _defineProperty(this, "startTime", '');
          _defineProperty(this, "changeTimeValue", '');
          _defineProperty(this, "url", void 0);
          _defineProperty(this, "label", void 0);
          _defineProperty(this, "timeLine", void 0);
          _defineProperty(this, "tooltip", void 0);
        }
        get isTouch() {
          return 'ontouchstart' in window;
        }
        get viewIconControl() {
          return !this.isPlay ? 'play-solid' : 'pause-solid';
        }
        get viewContent() {
          return {
            title: !this.isLoadAudio ? 'Загрузка...' : this.label,
            duration: !this.isLoadAudio ? '—:—' : this.fullTime
          };
        }
        play() {
          this.isStart = true;
          if (this.player.paused) {
            !this.startTime && (this.startTime = '0:00');
            this.player.play();
            this.isPlay = true;
            this.intervalTimer = setInterval(this.checkWidthLineInTime, 100);
          } else {
            this.player.pause();
            this.isPlay = false;
          }
        }
        checkWidthLineInTime() {
          if (!this.isChangeTime) {
            this.timeLine.firstElementChild.style.width = `${this.player.currentTime / this.player.duration * 100}%`;
          }
          this.startTime = this.getTimeCodeFromNum(this.player.currentTime);
        }
        changeTime(event) {
          this.isChangeTime = true;
          const timelineWidth = window.getComputedStyle(this.timeLine).width;
          this.timeLine.firstElementChild.style.width = `${event.offsetX / parseInt(timelineWidth, 10) * 100}%`;
          this.changeTimeValue = this.getTimeCodeFromNum(event.offsetX / parseInt(timelineWidth, 10) * this.player.duration);
          if (this.tooltip && !this.isTouch) {
            document.body.insertBefore(this.tooltip, document.body.firstChild);
            this.tooltip.style.top = `${event.pageY - 32}px`;
            this.tooltip.style.left = `${event.pageX - this.tooltip.clientWidth / 2}px`;
          } else {
            this.tooltip.style.display = 'none';
          }
        }
        setTimeDuration(event) {
          const timelineWidth = window.getComputedStyle(this.timeLine).width;
          this.player.currentTime = event.offsetX / parseInt(timelineWidth, 10) * this.player.duration;
        }
        mounted() {
          this.uid = uniqueID();
          this.player = new Audio(this.url);
          this.player.addEventListener('loadeddata', this.init, false);
          if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
            this.player.autoplay = true;
            this.player.pause();
          }
        }
        init() {
          this.fullTime = this.getTimeCodeFromNum(this.player.duration);
          this.player.volume = 1;
          this.isLoadAudio = true;
        }
        beforeDestroy() {
          this.player.removeEventListener('loadeddata', this.init, false);
        }
        render(h) {
          return h('div', {
            attrs: {
              id: this.uid
            },
            staticClass: 'RPlayerAudio'
          }, [!this.isLoadAudio ? h('div', {
            staticClass: 'RPlayerAudio__play',
            class: {
              load: !this.isLoadAudio
            }
          }, [h(components_RSpinner, {
            props: {
              size: 'phonia'
            }
          })]) : h(components_RIcon, {
            staticClass: 'RPlayerAudio__play',
            class: [{
              play: this.isStart
            }],
            props: {
              icon: this.viewIconControl
            },
            nativeOn: {
              click: this.play
            }
          }), h('div', {
            staticClass: 'RPlayerAudio__content'
          }, [h('div', {
            staticClass: 'RPlayerAudio__label'
          }, this.viewContent.title), h('div', {
            staticClass: 'RPlayerAudio__timer'
          }, [h('div', {
            staticClass: 'RPlayerAudio__play-time',
            class: [{
              'RPlayerAudio__full-time': !this.isLoadAudio
            }]
          }, this.startTime || this.viewContent.duration), this.isStart && h('div', {
            staticClass: 'RPlayerAudio__full-time'
          }, `/ ${this.viewContent.duration}`)]), this.isStart && h('div', {
            ref: 'timeLine',
            staticClass: 'RPlayerAudio__time-line-block',
            on: {
              mousemove: this.changeTime,
              mouseleave: () => {
                this.isChangeTime = false;
                this.changeTimeValue = '';
              },
              click: this.setTimeDuration
            }
          }, [h('div', {
            staticClass: 'RPlayerAudio__time-line'
          }), !!this.changeTimeValue && h('div', {
            ref: 'tooltip',
            staticClass: 'RPlayerAudio__tooltip'
          }, this.changeTimeValue)])])]);
        }
      };
      RPlayerAudio_decorate([Prop({
        type: String,
        required: true
      })], RPlayerAudio.prototype, "url", void 0);
      RPlayerAudio_decorate([Prop({
        type: String,
        required: true
      })], RPlayerAudio.prototype, "label", void 0);
      RPlayerAudio_decorate([Ref('timeLine')], RPlayerAudio.prototype, "timeLine", void 0);
      RPlayerAudio_decorate([Ref('tooltip')], RPlayerAudio.prototype, "tooltip", void 0);
      RPlayerAudio = RPlayerAudio_decorate([vue_class_component_esm], RPlayerAudio);
      /* harmony default export */ var RPlayerAudio_RPlayerAudio = (RPlayerAudio);
      ;// CONCATENATED MODULE: ./src/components/RPlayerAudio/index.ts


      RPlayerAudio_RPlayerAudio.install = vue => {
        vue.component('r-player-audio', RPlayerAudio_RPlayerAudio);
      };
      /* harmony default export */ var components_RPlayerAudio = (RPlayerAudio_RPlayerAudio);
      ;// CONCATENATED MODULE: ./src/components/RMediaGallery/RMediaGallery.ts

      var RMediaGallery_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };




      let RMediaGallery = class RMediaGallery extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "countView", 0);
          _defineProperty(this, "RButtonPlayerSize", 'kerleise');
          _defineProperty(this, "size", void 0);
          _defineProperty(this, "items", void 0);
          _defineProperty(this, "mediaBlock", void 0);
        }
        get countItemAll() {
          return this.items.length;
        }
        get viewItems() {
          const items = [...this.items].splice(0, this.countView);
          const isFullItems = this.countItemAll === this.countView;
          return items.map((el, index) => {
            const isVideo = el.type.split('/')[0] === 'video';
            const isLast = !isFullItems && index + 1 === this.countView;
            return this.$createElement('div', {
              staticClass: 'RMediaGallery__item',
              class: [{
                last: isLast
              }],
              on: {
                click: () => {
                  this.$emit(isLast ? 'more' : 'click', {
                    item: el,
                    index
                  });
                }
              }
            }, [this.$createElement(components_RImage, {
              props: {
                rounded: 'bana',
                url: el.url
              }
            }), isVideo && !isLast && this.$createElement(components_RButtonPlayer, {
              staticClass: 'RMediaGallery__play',
              props: {
                size: this.RButtonPlayerSize
              }
            }), isLast && this.$createElement('div', {
              staticClass: 'RMediaGallery__more'
            }, `ещё ${this.countItemAll - this.countView + 1}`)]);
          });
        }
        changeSize() {
          this.calculateMaxView();
        }
        breakpointChange() {
          this.calculateMaxView();
        }
        calculateMaxView() {
          this.$nextTick(() => {
            const style = getComputedStyle(this.mediaBlock);
            this.RButtonPlayerSize = style.getPropertyValue('--r-media-gallery-button-player-size');
            const min = parseInt(style.getPropertyValue('--r-media-gallery-min'), 10);
            const gap = parseInt(style.getPropertyValue('--r-media-gallery-gap'), 10);
            const widthBlock = this.mediaBlock.clientWidth;
            const countNoGap = Math.floor(widthBlock / min);
            const widthGap = (countNoGap - 1) * gap;
            if (countNoGap * min + widthGap <= widthBlock) {
              this.countView = countNoGap;
            } else {
              this.countView = countNoGap - 1;
            }
          });
        }
        mounted() {
          this.calculateMaxView();
        }
        render(h) {
          return h('div', {
            ref: 'block',
            staticClass: 'RMediaGallery',
            class: [this.size]
          }, this.viewItems);
        }
      };
      RMediaGallery_decorate([Prop({
        type: String,
        default: 'mellaniphe'
      })], RMediaGallery.prototype, "size", void 0);
      RMediaGallery_decorate([Prop({
        type: Array,
        default: () => []
      })], RMediaGallery.prototype, "items", void 0);
      RMediaGallery_decorate([Ref('block')], RMediaGallery.prototype, "mediaBlock", void 0);
      RMediaGallery_decorate([Watch('size')], RMediaGallery.prototype, "changeSize", null);
      RMediaGallery_decorate([Watch('$rir.breakpoints.width')], RMediaGallery.prototype, "breakpointChange", null);
      RMediaGallery = RMediaGallery_decorate([vue_class_component_esm], RMediaGallery);
      /* harmony default export */ var RMediaGallery_RMediaGallery = (RMediaGallery);
      ;// CONCATENATED MODULE: ./src/components/RMediaGallery/index.ts


      RMediaGallery_RMediaGallery.install = vue => {
        vue.component('r-media-gallery', RMediaGallery_RMediaGallery);
      };
      /* harmony default export */ var components_RMediaGallery = (RMediaGallery_RMediaGallery);
      ;// CONCATENATED MODULE: ./src/components/RLayoutSite/components/MenuItem.ts


      var MenuItem_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };






      let MenuItem = class MenuItem extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "active", false);
          _defineProperty(this, "pathRoute", '');
          _defineProperty(this, "el", void 0);
          _defineProperty(this, "clickClose", void 0);
        }
        async clickEvent(event) {
          event.preventDefault();
          if (this.el.router) {
            await this.$router.push(this.el.router);
            this.$emit('changePath');
          } else if (this.el.children) {
            if (!this.active) {
              eventOpenMenu.$emit('open');
            }
            this.active = !this.active;
          }
        }
        get checkActiveMenu() {
          if (this.el.router) {
            return this.pathRoute.indexOf(this.el.router.path) === 0;
          }
          return false;
        }
        routeChange() {
          this.pathRoute = window.location.pathname;
        }
        mounted() {
          this.pathRoute = window.location.pathname;
          eventOpenMenu.$on('open', () => {
            if (this.active) {
              this.active = false;
            }
          });
        }
        render(h) {
          const attrs = {};
          if (this.el.router) {
            attrs.href = this.el.router?.path || '';
            return h('a', {
              attrs,
              staticClass: 'RLayoutSite__menu-item',
              on: {
                click: this.clickEvent
              }
            }, [h(components_RButtonAction, {
              props: {
                title: this.el.title,
                to: this.el.router,
                color: 'harakiri',
                isArrow: !!this.el.children
              },
              class: [{
                active: this.checkActiveMenu
              }]
            })]);
          }
          return h(components_RPopover, {
            staticClass: 'RLayoutSite__menu-item',
            props: {
              value: this.active,
              clickClose: this.clickClose
            },
            on: {
              input: val => {
                this.active = val;
              }
            },
            scopedSlots: {
              activator: () => h('a', {
                attrs,
                on: {
                  click: this.clickEvent
                }
              }, [h(components_RButtonAction, {
                props: {
                  title: this.el.title,
                  to: this.el.router,
                  color: 'harakiri',
                  isArrow: !!this.el.children,
                  value: this.active
                },
                class: [{
                  active: this.active
                }]
              })])
            }
          }, [h('template', {
            slot: 'content'
          }, [h(RMenu_RMenu, {
            staticClass: 'RLayoutSite__menu-content',
            props: {
              items: this.el.children,
              isIconParent: false
            },
            on: {
              click: () => {
                this.active = false;
              }
            }
          })])]);
        }
      };
      MenuItem_decorate([Prop({
        type: Object,
        required: true
      })], MenuItem.prototype, "el", void 0);
      MenuItem_decorate([Prop({
        type: Boolean,
        default: true
      })], MenuItem.prototype, "clickClose", void 0);
      MenuItem_decorate([Watch('$route')], MenuItem.prototype, "routeChange", null);
      MenuItem = MenuItem_decorate([vue_class_component_esm], MenuItem);
      /* harmony default export */ var components_MenuItem = (MenuItem);
      ;// CONCATENATED MODULE: ./src/components/RLayoutSite/components/Menu.ts


      var Menu_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };



      let Menu = class Menu extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "cacheWidthElements", []);
          _defineProperty(this, "countVisible", null);
          _defineProperty(this, "items", void 0);
          _defineProperty(this, "content", void 0);
        }
        get ItemsView() {
          let menuView = [...this.items];
          if (this.countVisible !== null) {
            menuView = menuView.slice(0, this.countVisible);
          }
          const routers = menuView.map(el => this.$createElement(components_MenuItem, {
            props: {
              el
            }
          }));
          if (this.countVisible !== null && this.countVisible < this.items.length) {
            const menuHidden = [...this.items].slice(this.countVisible);
            routers.push(this.$createElement(components_MenuItem, {
              props: {
                el: {
                  title: 'Ещё',
                  children: menuHidden
                },
                clickClose: false
              }
            }));
          }
          return routers;
        }
        setCacheElementsWidth() {
          const elements = this.content.getElementsByClassName('RLayoutSite__menu-item');
          for (const el of elements) {
            this.cacheWidthElements.push(el.clientWidth + 10);
          }
        }
        checkFullContent() {
          if (this.content) {
            const styleParent = getComputedStyle(this.content, null);
            const width = this.content.clientWidth - (parseFloat(styleParent.paddingLeft) + parseFloat(styleParent.paddingRight));
            let widthElements = 57;
            this.countVisible = 0;
            for (const [index, el] of this.cacheWidthElements.entries()) {
              widthElements += el + (index !== this.items.length ? 32 : 0);
              if (widthElements < width) {
                this.countVisible += 1;
              } else {
                break;
              }
            }
          }
        }
        changeWidth() {
          this.checkFullContent();
        }
        mounted() {
          this.$nextTick(() => {
            this.setCacheElementsWidth();
            this.checkFullContent();
          });
        }
        render(h) {
          return h('div', {
            ref: 'content',
            staticClass: 'RLayoutSite__menu'
          }, this.ItemsView);
        }
      };
      Menu_decorate([Prop({
        type: Array,
        default: () => []
      })], Menu.prototype, "items", void 0);
      Menu_decorate([Ref('content')], Menu.prototype, "content", void 0);
      Menu_decorate([Watch('$rir.breakpoints.width')], Menu.prototype, "changeWidth", null);
      Menu = Menu_decorate([vue_class_component_esm], Menu);
      /* harmony default export */ var components_Menu = (Menu);
      ;// CONCATENATED MODULE: ./src/components/RLayoutSite/RLayoutSite.ts

      var RLayoutSite_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };






      const eventOpenMenu = new (external_commonjs_vue_commonjs2_vue_root_Vue_default())();
      let RLayoutSite = class RLayoutSite extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "openSide", false);
          _defineProperty(this, "scrollState", {
            interval: undefined,
            lastPosition: 0,
            classesLayout: ''
          });
          _defineProperty(this, "items", void 0);
          _defineProperty(this, "header", void 0);
        }
        checkStateHeader() {
          if (this.scrollState.interval) {
            clearTimeout(this.scrollState.interval);
          }
          const st = window.pageYOffset || document.documentElement.scrollTop;
          if (window.scrollY >= 80) {
            const isView = this.scrollState.classesLayout.indexOf('view');
            this.scrollState.classesLayout = 'absolute';
            if (window.scrollY > 240 && (isView !== -1 && this.scrollState.lastPosition > window.scrollY || this.scrollState.lastPosition - 48 > window.scrollY)) {
              this.scrollState.classesLayout += ' view';
            }
            eventOpenMenu.$emit('open');
          } else {
            this.scrollState.classesLayout = '';
          }
          this.scrollState.interval = setTimeout(() => {
            this.scrollState.lastPosition = st <= 0 ? 0 : st;
          }, 50);
        }
        changeWidth(val) {
          if (['wide', 'widest'].includes(val)) {
            this.openSide = false;
          }
        }
        clickOutside(e) {
          const path = e.path || e.composedPath && e.composedPath();
          if (path.indexOf(document.getElementsByClassName('RLayoutSite__hamburger')[0]) < 0) {
            this.openSide = false;
          }
        }
        mounted() {
          window.addEventListener('scroll', this.checkStateHeader, false);
        }
        render(h) {
          return h('section', {
            staticClass: 'RLayoutSite',
            class: [this.scrollState.classesLayout]
          }, [h('div', {
            staticClass: 'RLayoutSite__side-menu',
            class: [{
              active: this.openSide
            }],
            directives: [{
              name: 'click-outside',
              value: this.clickOutside
            }]
          }, [h(components_RButtonSimple, {
            props: {
              icon: 'close',
              color: 'harakiri',
              type: 'transparent'
            },
            on: {
              click: () => {
                this.openSide = false;
              }
            }
          }), h('div', {
            staticClass: 'RLayoutSite__side-menu-list'
          }, [h(RMenu_RMenu, {
            props: {
              items: this.items,
              isIconParent: false
            }
          })])]), h('div', {
            ref: 'header',
            staticClass: 'RLayoutSite__header'
          }, [h('div', {
            staticClass: 'RLayoutSite__header-content'
          }, [h(components_RButtonSimple, {
            props: {
              icon: 'menu',
              color: 'harakiri',
              type: 'transparent',
              size: 'larishae'
            },
            staticClass: 'RLayoutSite__hamburger',
            on: {
              click: () => {
                this.openSide = true;
              }
            }
          }), !!this.$slots.logo && h('div', {
            staticClass: 'RLayoutSite__logo'
          }, this.$slots.logo), h(components_Menu, {
            props: {
              items: this.items
            }
          }), !!this.$slots.actions && h('div', {
            staticClass: 'RLayoutSite__actions'
          }, this.$slots.actions)])]), h('div', {
            staticClass: 'RLayoutSite__content'
          }, this.$slots.content), !!this.$slots.footer && h('div', {
            staticClass: 'RLayoutSite__footer'
          }, [h('div', {
            staticClass: 'RLayoutSite__footer-content'
          }, this.$slots.footer)])]);
        }
      };
      RLayoutSite_decorate([Prop({
        type: Array,
        default: () => []
      })], RLayoutSite.prototype, "items", void 0);
      RLayoutSite_decorate([Ref('header')], RLayoutSite.prototype, "header", void 0);
      RLayoutSite_decorate([Watch('$rir.breakpoints.name')], RLayoutSite.prototype, "changeWidth", null);
      RLayoutSite = RLayoutSite_decorate([vue_class_component_esm({
        directives: {
          ClickOutside: ClickOutside
        }
      })], RLayoutSite);
      /* harmony default export */ var RLayoutSite_RLayoutSite = (RLayoutSite);
      ;// CONCATENATED MODULE: ./src/components/RLayoutSite/index.ts


      RLayoutSite_RLayoutSite.install = vue => {
        vue.component('r-layout-site', RLayoutSite_RLayoutSite);
      };
      /* harmony default export */ var components_RLayoutSite = (RLayoutSite_RLayoutSite);
      ;// CONCATENATED MODULE: ./src/components/RLightBox/RLightBox.ts

      var RLightBox_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
          r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
          d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };







      let RLightBox = class RLightBox extends component {
        constructor(...args) {
          super(...args);
          _defineProperty(this, "filePosition", 0);
          _defineProperty(this, "posXStart", 0);
          _defineProperty(this, "videoRefs", {});
          _defineProperty(this, "visible", void 0);
          _defineProperty(this, "files", void 0);
          _defineProperty(this, "isFillImage", void 0);
          _defineProperty(this, "indexView", void 0);
          _defineProperty(this, "contentElement", void 0);
        }
        changeWidthWindow() {
          this.contentElement.style.left = `${(this.contentElement.firstElementChild?.clientWidth || 0) * -1 * this.filePosition}px`;
        }
        changeVisible() {
          this.$nextTick(() => {
            this.filePosition = this.indexView;
            this.contentElement.style.left = `${(this.contentElement.firstElementChild?.clientWidth || 0) * -1 * this.indexView}px`;
          });
        }
        get isTouch() {
          return 'ontouchstart' in window;
        }
        get viewFile() {
          return this.files[this.filePosition];
        }
        get listenerEvents() {
          const listener = {
            ...this.$listeners,
            click: () => {
              this.$emit('click', this.viewFile);
            }
          };
          if (this.isTouch) {
            // @ts-ignore
            listener.touchstart = touchEvent => {
              if (touchEvent.changedTouches.length !== 1) {
                return;
              }
              this.posXStart = touchEvent.changedTouches[0].clientX;
              this.contentElement.style.transition = 'all 0ms ease-out 0s';
            };
            // @ts-ignore
            listener.touchmove = touchEvent => {
              if (touchEvent.changedTouches.length !== 1) {
                return;
              }
              this.touchMove(touchEvent);
            };
            // @ts-ignore
            listener.touchend = touchEvent => {
              if (touchEvent.changedTouches.length !== 1) {
                return;
              }
              this.touchEnd(touchEvent);
            };
          }
          return listener;
        }
        viewFiles() {
          return this.files.map((el, index) => {
            const isImage = el.type.split('/')[0] === 'image';
            if (isImage) {
              return this.$createElement(components_RImage, {
                class: [{
                  event: this.$listeners.click
                }],
                props: {
                  rounded: 'jade',
                  url: el.url,
                  isFill: this.isFillImage
                },
                nativeOn: this.listenerEvents
              });
            }
            return this.$createElement(components_RPlayerVideo, {
              ref: ref => {
                this.setRefVideoBlock(ref, index);
              },
              props: {
                url: el.video,
                size: 'atlentea'
              }
            });
          });
        }
        setRefVideoBlock(el, index) {
          if (el) {
            this.videoRefs[index] = el;
          }
        }
        touchMove(touchEvent) {
          const touchDistance = touchEvent.touches[0].clientX - this.posXStart;
          const positionView = (this.contentElement.firstElementChild?.clientWidth || 0) * -1 * this.filePosition;
          this.contentElement.style.left = `${positionView + touchDistance}px`;
        }
        touchEnd(touchEvent) {
          this.contentElement.style.transition = 'transform 0.3s ease-out 0s';
          const posXEnd = touchEvent.changedTouches[0].clientX;
          if (this.posXStart < posXEnd) {
            this.setViewFile(-1);
          } else if (this.posXStart > posXEnd) {
            this.setViewFile(1);
          }
        }
        setViewFile(changePosition) {
          if (!this.filePosition && changePosition < 0) {
            this.filePosition = this.files.length - 1;
          } else if (this.filePosition + changePosition < this.files.length) {
            this.filePosition += changePosition;
          } else {
            this.filePosition = 0;
          }
          this.contentElement.style.left = `${(this.contentElement.firstElementChild?.clientWidth || 0) * -1 * this.filePosition}px`;
          this.stopVideo();
        }
        stopVideo() {
          // eslint-disable-next-line guard-for-in
          for (const key in this.videoRefs) {
            this.videoRefs[key].pauseVideo();
          }
        }
        render(h) {
          return h('div', {
            staticClass: 'RLightBox',
            directives: [{
              name: 'show',
              value: this.visible
            }]
          }, [h('div', {
            staticClass: 'RLightBox__header'
          }, [h(components_RBadge, {
            props: {
              inversion: true,
              color: 'amelie',
              title: `${this.filePosition + 1} из ${this.files.length}`
            }
          }), this.$slots.header && h('div', {
            staticClass: 'RLightBox__header-content'
          }, this.$slots.header), h(components_RButtonSimple, {
            props: {
              icon: 'close',
              type: 'transparent',
              size: 'larishae'
            },
            on: {
              click: () => {
                this.stopVideo();
                this.$emit('input', false);
              }
            }
          })]), h('div', {
            staticClass: 'RLightBox__content'
          }, [!this.isTouch && h('div', {
            staticClass: 'RLightBox__arrow'
          }, [h(components_RButtonArrow, {
            props: {
              size: 'samilea',
              type: 'shapeless'
            },
            on: {
              click: () => this.setViewFile(-1)
            }
          })]), h('div', {
            staticClass: 'RLightBox__view',
            ref: 'content'
          }, this.viewFiles()), !this.isTouch && h('div', {
            staticClass: 'RLightBox__arrow'
          }, [h(components_RButtonArrow, {
            props: {
              size: 'samilea',
              type: 'shapeless',
              direction: 'right'
            },
            on: {
              click: () => this.setViewFile(1)
            }
          })])]), h('div', {
            staticClass: 'RLightBox__footer'
          }, this.files[this.filePosition].title || '')]);
        }
      };
      RLightBox_decorate([VModel({
        type: Boolean
      })], RLightBox.prototype, "visible", void 0);
      RLightBox_decorate([Prop({
        type: Array,
        default: () => []
      })], RLightBox.prototype, "files", void 0);
      RLightBox_decorate([Prop({
        type: Boolean,
        default: true
      })], RLightBox.prototype, "isFillImage", void 0);
      RLightBox_decorate([Prop({
        type: Number,
        default: 0
      })], RLightBox.prototype, "indexView", void 0);
      RLightBox_decorate([Ref('content')], RLightBox.prototype, "contentElement", void 0);
      RLightBox_decorate([Watch('$rir.breakpoints.width')], RLightBox.prototype, "changeWidthWindow", null);
      RLightBox_decorate([Watch('visible')], RLightBox.prototype, "changeVisible", null);
      RLightBox = RLightBox_decorate([vue_class_component_esm], RLightBox);
      /* harmony default export */ var RLightBox_RLightBox = (RLightBox);
      ;// CONCATENATED MODULE: ./src/components/RLightBox/index.ts


      RLightBox_RLightBox.install = vue => {
        vue.component('r-light-box', RLightBox_RLightBox);
      };
      /* harmony default export */ var components_RLightBox = (RLightBox_RLightBox);
      ;// CONCATENATED MODULE: ./src/components/index.ts
























































      ;// CONCATENATED MODULE: ./src/util/install.ts





      function install(Vue, options) {
        if (install.installed) return;
        install.installed = true;
        if ((external_commonjs_vue_commonjs2_vue_root_Vue_default()) !== Vue) {
          console.error(`Multiple instances of Vue detected
If you're seeing "$attrs is readonly", it's caused by this`);
        }
        const settings = lodash_merge_default()(util_defaultOptions, options);
        Object.keys(components_namespaceObject).forEach(rirComponent => {
          if (Array.isArray(settings.components) && settings.components.length) {
            if (!settings.components.includes(rirComponent)) {
              return;
            }
          }
          const component = components_namespaceObject[rirComponent];
          Vue.use(component);
        });
        Vue.mixin({
          beforeCreate() {
            const options = this.$options;
            // console.log('beforeCreate Lib', options.$rir, this);
            if (options.$rir) {
              options.$rir.framework.breakpoints.init();
              this.$rir = Vue.observable(options.$rir.framework);
            } else {
              this.$rir = options.parent && options.parent.$rir || this;
            }
            const {
              refs
            } = this.$options;
            if (!refs) return;
            // @ts-ignore
            this.$refs = Vue.observable(refs.reduce(($refs, key) => {
              $refs[key] = undefined;
              return $refs;
            }, {}));
          },
          created() {
            if (!Vue.config.devtools && options) {
              return;
            }
            deprecated(this);
          }
        });
      }
      ;// CONCATENATED MODULE: ./src/util/framework.ts







      class Rir {
        constructor(options) {
          _defineProperty(this, "framework", {});
          const {
            fixPointGrid,
            points,
            gridsName,
            ...opt
          } = lodash_merge_default()(util_defaultOptions, options);
          if (typeof document !== 'undefined') {
            initTheme(util_defaultOptions.theme || 'default');
          }
          this.framework = {
            // @ts-ignore
            theme: 'default',
            ...opt,
            changeTheme(theme) {
              initTheme(theme || 'default');
              this.theme = theme || 'default';
            },
            grids: new Grid(gridsName),
            breakpoints: new Breakpoint(points, fixPointGrid),
            modal: {
              open: () => {},
              close: () => {}
            },
            notification: {
              send: () => {}
            }
          };
        }
      }
      _defineProperty(Rir, "install", install);
      _defineProperty(Rir, "installed", false);
      ;// CONCATENATED MODULE: ./src/index.ts


      /* harmony default export */ var src_0 = (Rir);
      const {
        install: src_install
      } = Rir;
      Rir.install = (Vue, options) => {
        src_install.call(Rir, Vue, options && {
          ...options
        });
      };
      ;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


      /* harmony default export */ var entry_lib = (src_0);


    }();
    /******/ 	return __webpack_exports__;
    /******/ })()
    ;
});
//# sourceMappingURL=RirLib.umd.js.map
